import moment from 'moment'; //eslint-disable-line no-unused-vars
import 'moment/locale/fi';
import 'moment/locale/ru';
import 'moment/locale/uk';
import 'moment/locale/ar';
import 'moment/locale/ku';
import 'moment/locale/da';
import 'moment/locale/nb';
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/sv';
import { getBusinessTypeTag } from './utils/businessType';

const translations = {
  fi: {
    ai_interpreter: 'AI-tulkki',
    ai_cost_center: 'Kustannuspaikka',
    ai_target_language: 'Kohdekieli',
    ai_alt_cost_order: 'Vaihtoeht. kustannus / tilaus',
    invoice_ref: 'Laskutusviite',
    ai_download_transcript: 'Lataa litterointi',
    ai_download_summary: 'Lataa yhteenveto',
    ai_transcription: 'Litterointi',
    ai_summary: 'Yhteenveto',
    ai_send_email: 'Lähetä sähköposti',
    ai_send_email_title: 'Lähetä litterointi sähköpostitse',
    ai_send_email_explanation: 'Syötä sähköpostiosoite, johon litterointi lähetetään.',
    ai_include_summary: 'Sisällytä yhteenveto',
    ai_email_subject_placeholder: 'Viitteesi sähköpostin aiheeseen (valinnainen)',
    ai_search_placeholder: 'Hae AI-tulkkaustehtävää',
    ai_no_sessions: 'Ei AI-tulkkauksia vielä',
    ai_download_retention: 'Litteroinnit ja yhteenvedot ovat ladattavissa 24 tunnin ajan tulkkauksen päättymisestä.',
    ai_download_unavailable: 'Tiedosto ei ole enää saatavilla.',
    ai_download_forbidden: 'Sinulla ei ole oikeutta tähän tiedostoon.',
    ai_download_timeout: 'Tiedostoa luodaan vielä, yritä hetken kuluttua uudelleen.',
    ai_email_sent: 'Sähköposti lähetetty.',
    ai_email_failed: 'Sähköpostin lähetys epäonnistui.',
    ai_email_invalid: 'Virheellinen sähköpostiosoite.',
    ai_email_domain_not_allowed: 'Sähköpostin verkkotunnus ei ole sallittu.',
    ai_allowed_email_domains: 'Sallitut verkkotunnukset:',
    ai_own_email_only: 'Litteroinnin voi lähettää vain omaan sähköpostiosoitteeseesi.',
    please_wait: 'Odota...',
    done: 'Valmis',
    fin: 'Suomi',
    eng: 'Englanti',
    nor: 'Norja',
    swe: 'Ruotsi',
    dan: 'Tanska',
    fra: 'Ranska',
    cze: 'Tsekki',
    hrv: 'Kroatia',
    sqi: 'Albania',
    ben: 'Bengali',
    amh: 'Amhara',
    bul: 'Bulgaria',
    nld: 'Hollanti',
    ara: 'Arabia',
    deu: 'Saksa',
    urd: 'Urdu',
    mya: 'Burma',
    mieli: 'Mieli',
    mainio: 'Mainio',
    ccb2b: '📞 Yhteys asiakaspalveluun',
    testb2b: '📞 Testaa / Yhteys asiakaspalveluun',
    vls: 'Flemish',
    ckb: 'Sorani',
    nep: 'Nepali',
    prs: 'Dari',
    hurja: 'Hurja',
    lao: 'Lao',
    no_language_selected: 'Kieltä ei ole valittu',
    ui_language: 'Käyttöliittymän kieli',
    close: 'Sulje',
    error: 'Virhe',
    missing_data: 'Puuttuvat tiedot',
    // feedback
    failed_to_find_prebooking_data: 'Tätä ennakkovarausta ei löytynyt',
    prebooking_was_cancelled: 'Tämä ennakkovaraus peruttiin',
    feedback_not_open_yet: 'Koska tulkkaus ei ole vielä tapahtunut, palautteen anto ei ole vielä mahdollista.',
    how_did_we_do: 'Miten tulkkaus meni?',
    stars_rating_subtitle: 'Palautteesi auttaa meitä parantamaan palvelua.',
    where_can_we_improve_upon: 'Missä voisimme parantaa?',
    leave_open_feedback: 'Jätä avointa palautetta',
    describe_your_experience_here: 'Kerro omin sanoin kokemuksestasi',
    i_wish_to_be_contacted: 'Ottakaa minuun yhteyttä',
    choose_one_or_more_options: 'Valitse yksi tai useampi vaihtoehto',
    thank_you_for_your_feedback: 'Kiitos palautteesta!',
    // customer guide for od-call (modal)
    order_an_interpreter_by_calling_the_number: 'Tilaa tulkki soittamalla numeroon',
    main_calling_number: '041 400 1234',
    main_calling_number_with_code: '*31# 041 400 1234',
    main_calling_number_with_zero: '0041 400 1234',
    phone_must_be_registered: 'Puhelin, jolla soitat akuuttinumeroomme tulee olla rekisteröity järjestelmäämme.',
    note: 'Huom!',
    number_is_encrypted: ' Jos numerosi on salattu niin kirjoita palvelunumero seuraavassa muodossa:',
    attention_for_hus: 'Huomio HUSin lankaverkossa toimijat!',
    if_neither_number_works: ' Jos kumpikaan numero ei toimi, niin kirjoita palvelunumero seuraavassa muodossa:',
    contact_to_customer_service: 'Ongelmatapauksessa ota yhteyttä asiakaspalveluumme.',
    select_interpreter_language: 'Puhelun yhdistettyä valitse tulkattava kieli seuraavista syöttämällä numero puhelimen numeronäppäimillä',
    accept_incoming_prebookings: 'Hyväksy tai hylkää saapuneet ennalta varatut tulkkaukset',
    accept: 'Hyväksy',
    decline: 'Hylkää',
    accept_all: 'Hyväksy kaikki',
    date_and_time: 'Ajankohta',
    duration: 'Kesto',
    language: 'Kieli',
    presence: 'Tyyppi',
    prebookings_already_checked: 'Varaus on jo valittu',
    username_not_unique: 'Käyttäjätunnus ei ole yksilöllinen.',
    new_username_set: 'Uusi käyttäjätunnus asetettu: ',
    // LUONA signup
    luonaSignupForm: 'Kirjautumislomake',

    label_name: 'Etu- ja sukunimi',
    placeholder_name: 'Nimi latinalaisin kirjaimin',
    validate_name: 'Vähintään neljä kirjainta',

    label_phone: 'Puhelinnumero',
    placeholder_phone: '+3XXXXXXXXXXX',
    validate_phone: 'Puhelinnumero muodossa: +XXXXXXXXXXXX',

    label_email: 'Sähköpostiosoite',
    placeholder_email: 'user@mail.com',
    validate_email: 'Sähköpostiosoite muodossa: user@mail.com',

    label_city: 'Vain numeroita',
    placeholder_city: 'Kaupunki',
    validate_city: 'Kaupunki',
    selectOption: 'Vain latinalaisia kirjaimia',

    agreePrivacyPolicy: 'Hyväksyn ',
    privacyPolicy: 'tietosuojakäytännön',
    luonaSignupButton: 'Lähetä',
    requestErrorMessage: 'Jotain meni pieleen, yritä uudestaan!',
    minimalPrebookingTimeBumperError: 'Tämä aika on liian lähellä nykyistä aikaa. Valitse toinen aika, kiitos.',
    minimalPrebookingOnSiteTimeBumperError: 'Paikan päällä tapahtuvan tulkkauksen alkamisaika on liian aikainen. Valitse toinen aika, kiitos.',
    new_password_success: 'Salasana vaihdettu',
    new_password_wrong: 'Väärä vanha salasana',
    requestErrorMessageUserNotFound: 'Anna rekisteröity puhelinnumero ja sähköpostiosoite.',
    requestErrorMessageUserExist:
      'Antamasi sähköpostiosoite tai puhelinnumero on jo käytössä, ole hyvä ja käytä toista.',
    slot_not_free_anymore: 'Valittu aikaväli ei valitettavasti ole enää käytettävissä',
    no_interpreter_in_prebooking: 'Varauksessa ei ole tulkkia.',
    back_to_telegram: 'Palaa Telegramiin',
    // LUONA
    loginTitle: 'Sisäänkirjautuminen',
    username: 'Käyttäjätunnus',
    password: 'Salasana',
    loginButton: 'Kirjaudu',
    loginFailed: 'Sisäänkirjautuminen epäonnistui.',
    sessionExpired: 'Istunto on vanhentunut. Ole hyvä ja kirjaudu uudelleen.',
    meeting_closed: 'Tapaaminen on päättynyt.',
    signin_code_block_message: 'Tämä sähköpostiosoite on jo käytössä. Lähetimme vahvistuskoodin osoitteeseen: [email]. Kirjoita vahvistuskoodi allaolevaan kenttään.',
    placeholder_signin_code: 'koodi',
    close_meeting_confirmation_message: 'Oletko varma että haluat poistua tapaamisesta? Tapaaminen päättyy tällöin kaikilta osapuolilta',
    internet_connection_lost: 'Verkkoyhteys katkesi',
    internet_connection_exist: 'Verkkoyhteys palautui',
    what_is_your_language: 'Hei, mitä kieltä ymmärrät?',
    what_you_need_help_with: 'Mihin tarvitset apua?',
    selectable_langs: 'Kieli',
    selectable_servises: 'Asiani koskee',
    selectable_time: 'Aika',
    selectable_interpreter: 'Tapaamisen kieli on englanti tai suomi. Tarvitseko tulkin?',
    authtorize: 'Kirjautumislomake',
    choose_time: 'Valitse varattava aika',
    prebook_not_available_message: 'Palvelu ei ole saatavilla tällä hetkellä. Palveluajat ovat ma-pe {SCHEDULE}.',
    //Luona services
    health: 'Terveyttä',
    work_or_study: 'Työtä tai opiskelua',
    money_or_livelihood: 'Rahaa tai toimeentuloa',
    reception_allowance: 'Vastaanottoraha tai PFS-korttia',
    my_money_is_not_enough: 'Rahani eivät riitä',
    copy_email: 'Kopioi sähköpostiosoite',
    successfully_copied: 'Sähköpostiosoite kopioitu',
    copied_to_clipboard: 'Kopioitu leikepöydälle',
    other_practical_matters: 'Muut käytännön asiat',
    thanks_for_booking: 'Kiitos varauksestasi.',
    prebook_created_at: 'Videotapaamisesi on vahvistettu seuraavasti:',
    prebooking_skill: 'Aihe:',
    you_need_high_network: 'Tapaamisen onnistumisen ja laadun varmistamiseksi huolehdithan, että sinulla on vakaa ja nopea verkkoyhteys.',
    you_will_got_accept: 'Saat meiltä varausvahvistuksen sekä kaksi muistutusta tekstiviestitse ja sähköpostitse.',
    message_with_link_to_meeting: 'Viestit sisältävät linkin, joista pääset tapaamiseen sovittuna ajankohtana.',
    dont_forget_decline_prebooking: 'Muistathan perua tapaamisen, mikäli ajankohta ei sovi sinulle.',
    for_decline_need: 'Voit peruuttaa varauksesi osiossa:',
    click_for_decline_prebooking: 'ja napsauta "Poista" -painiketta.',
    best_regards: 'Ystävällisin terveisin,',
    luona_DigiVOK: 'Luona DigiVOK',
    emigration_or_holiday_outside_Finland: 'Maastamuuttoa tai lomaa Suomen ulkopuolella',
    free_time: 'Vapaa-aika',
    housing: 'Asumista',
    child_care: 'Lasta',
    child_health: 'Terveys',
    upbringing_parenting: 'Kasvatus/vanhemmuus',
    kindergarten_or_school: 'Päiväkoti tai koulu',
    reception_centre_info_service: 'Vastaanottokeskuksen neuvonta',
    physical_or_mental_symptoms: 'Fyysiset tai psyykkiset oireet',
    related_to_money_or_livelihood: 'Rahaan tai toimeentuloon liittyvää',
    related_to_your_own_or_family_life_situation:
      'Omaan tai perheen elämäntilanteeseen liittyvää',
    legal_matter: 'Oikeudellista asiaa',
    everyday_practical_things: 'Päivittäiset, arkiset käytännön asiat',
    service_housing: 'Majoitukseen liiittyvät käytännön asiat',
    how_do_you_judge_the_criticality_of_your_case:
      'Kuinka itse arvioi asiaasi kriittisyyden?',
    help_need_today: 'Asiani olisi hyvä saada kuntoon tänään',
    help_need_in_couple_of_days:
      'Asiani olisi hyvä saada kuntoon lähipäivinä',
    help_need_in_week: 'Asiani on saatava hoidettua viikon sisällä',
    help_is_not_urgent: 'Asiani ei ole kiireellinen',
    call_now: 'Soittaa heti',
    book_an_appointment: 'Varata ajan',
    authtorize_yourself: 'Tunnistaudu eli kerro meille kuka olet',
    user_successfully_registered: 'Rekisteröityminen onnistui',
    book_time: 'Varaa aika',
    what_time_works_for_you: 'Mikä aika sinulle sopii?',
    wizard_default_message:
      'Mikäli tilanne on henkeä uhkaava, soita 112.\nMikäli terveysasiasi ei voi odottaa seuraavaan arkipäivään, soita päivystysapu 116117. \nMikäli sinulla on muu akuutti kriisi, soita asuinkuntasi sosiaali- ja kriisipäivystykseen.',
    wizard_welcome_message:
      'Tervetuloa! Teemme yhdessä vaikuttavia sote-palveluja. Voimmeko olla avuksi?',
    wizard_PrebookingStep_header:
      'Pyrimme hoitamaan tilanteet lähtökohtaisesti heti. Mikäli kaikki työntekijämme ovat varattuina, sinulla on mahdollisuus varata aika tätä kautta. Haluaisitko varata ajan vai soittaa heti?',
    wizard_TimeStep_header:
      'Valitettavasti kukaan ei päässyt nyt vastaamaan. Pääset varaamaanajan tästä:',

    errorTitle: 'Hupsista!',
    warnTitle: 'Hmmm...',
    successTitle: 'Mahtavaa!',

    selectLanguage: 'Valitse kieli',
    interpreter: 'Tulkki',
    startInterpreting: 'Aloita tulkkaus',
    requestInterpreting: 'Pyydä tulkkausta',

    interpretationNeeded: 'Tulkkauspyyntö',
    requestForInterpretation: 'Tulkkausta tarvitaan!',
    requestForCall: 'Asiakas tarvitsee apua',
    nothingToInterpret: 'Ei tulkattavaa',
    noInterpretationNeeded: 'Kaikkiin tulkkauspyyntöihin on vastattu.',

    doYouWantToHangUp: 'Haluatko päättää tulkkauksen?',
    oppositeSideHangsUp: 'Vastapuoli katkaisi yhteyden.',
    networkTerminated: 'Yhteys katkesi.',
    review: 'Arvostele tulkkaus',
    customerFeedbackEnjoyingTulka: 'Sujuiko tulkkaus?',
    customerRatingInterpreter: 'Arviosi tulkkauksen laadusta',
    customerInvoiceNotes: 'Laskutusviite',
    deviation: 'Poikkeama',
    deviation_resolution: 'Poikkeaman ratkaisu',
    deviation_must_be_resolved_before_confirming: 'Poikkeama on ratkaistava ennen kuin tämän voi vahvistaa.',
    interpreterRatingInterpreter: 'Sujuiko tulkkaus?',
    interpreterRatingCustomer: 'Kuinka suoriuduin tulkkauksessa',
    ratingQuality: 'Arviosi yhteyden laadusta',
    feedback: 'Palaute',
    feedbackDesc: 'kirjoita kommenttisi tähän',
    feedbackContactMe: 'Ottakaa minuun yhteyttä',
    proceed: 'Lähetä',
    skip: 'Ohita',

    endCall: 'Lopeta puhelu',
    refresh: 'Päivitä',
    logout: 'Kirjaudu ulos',
    toggleCamera: 'Hallitse kameraa',
    toggleAudio: 'Mykistys',

    onlyChromeSupported: 'Selaimesi ei ole tuettu',
    pleaseUseChrome: 'Asenna Google Chrome -selain käyttääksesi Túlkaa',
    downloadChrome: 'Lataa Google Chrome',
    continueInterpretation: 'Jatka tulkkausta',
    roomInfoCallEndedClosed: 'Palvelin sulki keskustelun.',
    feedbackTooLate: 'Tulkkauksen jatkaminen on mahdollista minuutin ajan!',

    noTimeLeft: 'Esittelyaika on loppunut. Olemme pian yhteydessä sinuun!',
    minutesConsumed:
      'Esittelyaika on nyt päättynyt. Olemme pian yhteydessä sinuun!',
    timeLeft: 'Esittelyaikaa jäljellä: {}',
    zeroTimeLeft: 'Esittelyaika on loppunut.\nOlemme pian yhteydessä sinuun!',
    freeUseLeft: 'Aikaa jäljellä',

    failedToSendFeedback: 'Palautteen lähettäminen epäonnistui!',
    failedLogOut: 'Uloskirjautuminen ei onnistunut.',
    failedToConnect: 'Ei yhteyttä palvelimeen.',
    waitingForInterpreter:
      'Pyyntösi tavoittaa tulkkeja parhaillaan. Joku heistä vapautuu pian tulkkaamaan. Odotus kestää yleensä 1-3 minuuttia.',
    waitingForCustomer: 'Odotetaan asiakasta...',
    pleaseWait: 'Hetkinen...',
    youHaveWaitedFor: 'Olet odottanut {}',
    error500: 'Jotain meni vikaan. Yritäthän uudelleen.',
    roomInfoHasAudioPacketLoss: 'Yhteydessä ongelmia!',

    yes: 'Kyllä',
    no: 'En',
    cancel: 'Peruuta',

    // Attachment feature
    attachment_status_pending: 'Käsitellään...',
    attachment_status_converting: 'Muunnetaan PDF-muotoon...',
    attachment_status_conversion_failed: 'Muunnos epäonnistui',
    attachment_fetch_error: 'Liitteen tietojen lataus epäonnistui',
    attachment_conversion_in_progress: 'Tiedostoa muunnetaan. Odota hetki...',
    attachment_conversion_failed_download: 'Lataus ei onnistu - muunnos epäonnistui. Lataa toinen tiedosto.',
    attachment_deleted: 'Liite on poistettu.',
    attachment_download_error: 'Liitteen lataus epäonnistui',
    attachment_delete_forbidden: 'Sinulla ei ole oikeutta poistaa tätä liitettä.',
    attachment_delete_error: 'Liitteen poisto epäonnistui',
    attachment_upload_failed: 'Varaus luotiin, mutta liitteen lataus epäonnistui. Voit yrittää ladata sen myöhemmin.',
    attachment_upload_partial_failed: 'Liite ei tallentunut kaikkiin varauksiin. Yritä uudelleen.',
    attachment_empty_file: 'Tiedosto on tyhjä',
    attachment_invalid_type: 'Tiedostotyyppi ei ole sallittu',
    attachment_file_too_large: 'Tiedosto on liian suuri',
    customer_documents: 'Asiakirjat',
    attachment_select_file: 'Valitse tiedosto',
    attachment_help_text: 'Tuetut muodot: PDF, DOCX, PPTX, TXT, PNG, JPG (enintään 5 Mt). Asiakirja näkyy valitulle tulkille.',
    no_attachment: 'Ei liitettyä asiakirjaa',
    attachment_not_ready: 'Tiedosto ei ole vielä ladattavissa',
    attachment_preview_error: 'Liitteen esikatselun lataus epäonnistui',
    download: 'Lataa',
    delete_attachment: 'Poista liite',
    delete_attachment_title: 'Poista liite?',
    delete_attachment_confirm: 'Haluatko varmasti poistaa tämän tiedoston? Toimintoa ei voi kumota.',
    delete: 'Poista',

    default: 'Oletusarvoinen',
    termsOfUse: 'Käyttöehdot ja tietosuoja',
    options: 'Näytä asetukset',
    hideOptions: 'Piilota asetukset',

    enable_notifications: 'Kytke ilmoitukset',
    disable_notifications: 'Sammuta ilmoitukset',
    disable_duration: 'Sammuta ilmoitukset',
    for_hour: 'tunniksi',
    for_day: 'päiväksi',
    for_week: 'viikoksi',
    for_month: 'kuukaudeksi',
    for_a_day: '1 päivä',
    for_days: '{} päivää',
    for_a_day_an_hour: '1 päivä, 1 tunti',
    for_a_day_hours: '1 päivä, {} tuntia',
    for_days_an_hour: '{} päivää, 1 tunti',
    for_days_hours: '{d} päivää, {h} tuntia',
    notifications_disabled_for: 'Ilmoitukset pois päältä\n{}',
    failed_to_disable_notifications:
      'Ilmoitusten sammutus ei onnistunut. Yritä myöhemmin uudelleen.',
    failed_to_enable_notifications:
      'Ilmoitusten kytkentä ei onnistunut. Yritä myöhemmin uudelleen.',
    forgot_password_link: 'Unohditko salasanan?',
    forgot_password_info:
      'Lähetämme sinulle uuden salasanan tekstiviestinä tai sähköpostina. Jos sinulla ei ole tunnuksia, ota yhteyttä {infoEmail}.',
    placeholder_phone_number: '+35840...',
    phone_number_title: 'Puhelinnumero',
    forgot_password_error:
      'Tekstiviestiä tai sähköpostia ei voitu lähettää. Ota yhteyttä osoitteeseen {infoEmail}',
    forgot_password_duplicate_email_error:
      'Salasanaa ei voida vaihtaa. Ota yhteyttä asiakaspalveluun.',
    forgot_password_success:
      'Saat uuden salasanan kohta tekstiviestinä tai sähköpostiin.',
    skillModalQuestion:
      'Tarvitsetko alla olevaa erityisosaamista? Odotusaika voi olla pidempi.',
    od_type_title: 'Minkä tyyppinen tulkki?',
    od_type_ai: 'Tekoäly',
    od_type_ai_subtitle: 'Tekoälytulkki',
    od_type_human: 'Ihminen',
    od_type_human_subtitle: 'Ihmistulkki',
    select_customer_gender: 'Tarkenna oma sekä asiakkaasi sukupuoli',
    your_gender: 'Oma sukupuolesi',
    customer_gender: 'Asiakkaan sukupuoli',
    male: 'Mies',
    female: 'Nainen',
    male_interpreter: 'Miestulkki',
    female_interpreter: 'Naistulkki',
    invoice_cause_title: 'Laskun jaottelu',
    invoice_cause_subtitle: 'Annatko vielä laskun jaottelun',
    customer_reference_title: 'Lisätiedot tulkkauksesta laskulle',
    targetLanguage: 'Kieli jota ymmärrät',
    openingTimes: '',
    systemAlert: 'Palvelussa teknisiä häiriöitä. Pahoittelemme.',

    chatFailed: 'Tekstichattiin kytkeytyminen epäonnistui.',
    chatTipInterpreter:
      'Täällä voit vaihtaa viestejä asiakkaan kanssa. Viestit tuhotaan välittömästi, kun tulkkaus päättyy.',
    chatTipCustomer:
      'Täällä voit vaihtaa viestejä tulkin kanssa. Viestit tuhotaan välittömästi, kun tulkkaus päättyy.',
    chatSendFailed: 'Viestin lähetys epäonnistui.',
    chatTypeMessage: 'Kirjoita viesti...',
    invoiceRefMandatory: 'Syötä vielä laskutusviite.',
    invoiceRefUserGroupMandatory: 'Valitse vielä laskun saaja.',
    selectInvoiceRefUserGroup: '-- Valitse --',

    show_feedbacks: 'Tähtiarviot',
    show_feedbacks_title: 'Näin minua arvioitiin',
    failedToFetchFeedbacks: 'Failed to fetch the ratings.',
    failedToCreateChatroom: 'Tähtiarvioiden hakeminen epäonnistui',
    statistics: 'Omat tulkkausmäärät',
    no_statistics: 'Tulkkausmääriä ei ole saatavilla.',
    stats_disclaimer:
      'Tulkkausmäärät ovat vain arvioita, eivätkä välttämättä täysin vastaa lopullisen palkkalaskelman määriä.',
    stats_today: 'Tänään',
    stats_yesterday: 'Eilen',
    stats_this_week: 'Tällä viikolla',
    stats_last_week: 'Viime viikolla',
    stats_this_month: 'Tässä kuussa',
    stats_last_month: 'Viime kuussa',
    stats_this_year: 'Tänä vuonna',
    stats_last_year: 'Viime vuonna',

    feedbackButton: 'Paina kirjoittaaksesi palautetta',
    feedback_already_exist: 'Palaute annettu',
    feedback_need_to_leave: 'Palaute antamatta',
    feedback_do_next: 'Voit nyt sulkea tämän ikkunan.',
    chatroom_not_exist: 'Palautteen anto ei vielä mahdollista',

    // Prebooking
    prebook: 'Tee ennakkovaraus',
    prebooking_date_header: 'Milloin tarvitset tulkin?',
    prebooking_date_header_notice: 'Ilmoituksen viimeinen toimituspäivä',
    step: '{step} / {steps}',
    choose_button: 'Valitse',
    prebooking_duration_header: 'Kuinka kauan arvioit tarvitsevasi tulkkia?',
    hours_minutes: '{h}:{m}',
    hour_minutes: '{h}:{m}',
    minutes: '{} min',
    hour: '60 min',
    hours: '{}:00',
    customer_reference: 'Tiedot tulkkauksesta laskulle',
    customer_reference_placeholder: 'Kentän tiedot eivät tule näkyviin tulkille',
    please_provide_customer_reference:
      'Annatko vielä lisätiedot tulkkauksesta laskulle.',
    prebooking_time_header: 'Mihin kellonaikaan tarvitset tulkin?',
    select_language_title: 'Minkä kielisen tulkin tarvitset?',
    fetching_languages: 'Haetaan kieliä...',
    invoice_cause: 'Laskun kohdistaminen',
    invoice_cause_description: 'Valitse maksaja / kustannuspaikka',
    invoice_ref_placeholder: 'HUOM! Asiakaspalvelu ei lue tätä.',
    call_type_video: 'Video',
    call_type_call: 'Puhelu',
    call_type_question: 'Mitä yhteyttä haluat käyttää?',
    additional_order_info: 'Tilauksen lisätiedot',
    confirm_prebooking: 'Tarkista varauksen tiedot',
    comment: 'Välttämätön lisätieto käsittelijälle',
    prebooking_date: 'Päivä',
    prebooking_time: 'Kellonaika',
    prebooking_duration: 'Kesto',
    language_title: 'Kieli',
    presence_title: 'Tulkkauksen tyyppi',
    call_type_title: 'Yhteystyyppi',
    select_target_language_title: 'Mitä kieltä ymmärrät?',
    location_question: 'Missä tulkkaus tapahtuu?',
    location_placeholder_city: 'Kaupunki',
    location_placeholder_address: 'Lähiosoite',
    location_placeholder_postcode: 'Postinumero',
    add_message_to_interpreter: 'Lisää viesti tulkille',
    subject: 'Tulkkauksen aihe',
    url_for_video_meeting: 'URL/linkki videokokoukseen',
    url_for_video_meeting_label: 'URL/linkki',
    interpretation_location_details: 'Saapumisohjeet tulkkauspaikalle (esim. tieto esteettömyydestä, toimipiste, rappu, kerros, huone jne.)',
    address_info: 'Osoitetiedot',
    arrival_instructions: 'Saapumisohjeet',
    addressAndArrivalInstrustions: 'Osoite ja saapumisohjeet',
    preferred_interpreters_question: 'Haluatko valita mieluisan tulkin?',
    search_preferred_interpreter: 'Hae tulkki nimellä',
    not_guarantee: 'Yritämme saada toivotun tulkin, mutta emme pysty takaamaan hänen olevan vapaana.',
    history_is_limited: 'Haun tulos on rajallinen, koska et ole käyttänyt vielä montaakaan tulkkia.',
    presence_question: 'Minkä tyyppinen tulkkaus on kyseessä?',
    presence_remote: 'Etätulkkaus',
    presence_remote_tip: 'Puhelun tai videon välityksellä tapahtuva etätulkkaus',
    presence_on_site: 'Lähitulkkaus',
    presence_on_site_tip: 'Tulkki paikan päällä',
    presence_notice: 'Ilmoitustulkkaus',
    presence_notice_tip:
      'Tekstimuotoinen viesti toimitetaan puhuttuna tulkkauksena',
    select_favorite: 'Haluatko valita mieluisimmat tulkit?',
    any_favorite: 'Kuka tahansa käy',
    call_type_call_tip: 'Vain ääni normaalina puheluna',
    call_type_video_tip: 'Mobiilisovelluksen kautta avattava videoyhteys',
    target_language_title: 'Kieli jolla työskentelet',
    invoice_ref_title: 'Tiedot tulkkauksesta laskulle',
    save_prebooking: 'Lähetä varaus',
    edit_prebooking: 'Tallenna',
    any_gender: 'Ei väliä',
    any_dialect: 'Mikä tahansa käy',
    gender_title: 'Sukupuoli',
    dialect_title: 'Murre',
    select_skill: 'Onko sinulla erityistarpeita tulkille?',
    select_dialect: 'Tarvitsetko jonkin erityisen murteen?',
    select_qualification: 'Tarvitsetko erityispätevyyttä?',
    select_gender: 'Onko tulkin sukupuolella väliä?',
    any_skill: 'Ei erityistarpeita',
    any_qualification: 'Ei erityispätevyyksiä',
    security_cleared: 'Turvallisuusselvitetty',
    skill_title: 'Erityistarpeet',
    unconfirmed_prebooking: 'Odottaa vahvistusta',
    confirmed: 'Vahvistettu',
    delivered: 'Toimitettu',
    not_able_to_reach: 'Ei tavoitettu',
    cancelled: 'Peruutettu',
    ongoing_prebooking: 'Käynnissä',
    report_deviation: 'Ilmoita poikkeamasta',
    active: 'Aktiivinen',
    location_title_city: 'Kaupunki',
    location_title_address: 'Lähiosoite',
    searching_interpreter: 'Etsitään tulkkia',
    please_call_to_this_number: 'Soita tähän numeroon',
    // Help tooltips
    help_prebooking_summary_title: 'Kirjoita tähän ainoastaan välttämätön lisätieto käsittelijälle',
    help_prebooking_summary:
      'Huom! Lisätietokenttään kirjoittaminen pidentää tilauksen käsittelyaikaa.',
    help_call_type_title: 'Tulkkausyhteys',
    help_call_type:
      'Puhelutulkkauksella voit liittää yhteen useamman eri paikassa olevan ihmisen (konferenssipuhelu).\n\nVideotulkkauksessa ihmiset näkevät toisensa ja voit esimerkiksi pyytää tulkkia kääntämään tekstiä. Videotoiminnon voi kytkeä päälle ja pois tulkkauksen aikana.\n\nVoit halutessasi vaihtaa tulkkausmuodon kesken kaiken päättämällä tulkkauksen ja valitsemalla \'Jatka tulkkausta\'.',
    help_gender_title: 'Tulkin sukupuoli',
    help_gender:
      'Voit halutessasi valita tulkin sukupuolen. Huomioithan, että valinta vähentää käytettävissä olevien tulkkien määrää ja voi vaikeuttaa tulkin saatavuutta.',
    help_dialect_title: 'Tulkin osaama murre',
    help_dialect:
      'Voit halutessasi valita tulkin osaaman murteen. Huomioithan, että valinta vähentää käytettävissä olevien tulkkien määrää ja voi vaikeuttaa tulkin saatavuutta.',
    help_confirmation_title: 'Vahvista kotikustannuspaikka',
    help_confirmation:
      'Tekemäsi tilaukset kirjataan oletuksena kotikustannuspaikkaasi, ellet valitse tilaukselle poikkeavaa kustannuspaikkaa.',
    tomorrow: 'Huomenna',
    today: 'Tänään',
    now: 'Nyt',
    help_location_title: 'Sijainti/toimipaikka',
    help_location:
      'Kirjoita paikka, jossa tulkkaus tapahtuu. Esimerkiksi toimipaikka tai osoite.',
    help_favorites_title: 'Mieluisimmat tulkit',
    help_favorites:
      'Voit valita yhden tai useamman suosikkitulkkisi.\n\nHuomaa, että toivotut tulkit eivät välttämättä ole käytettävissä valittuna ajankohtana.',
    on_site_not_available_in_app:
      'Läsnäolotulkkausta ei voi aloittaa sovelluksesta.',
    back: 'Takaisin',
    rejoin_meeting: 'Liity uudestaan tapaamiseen',
    change_language: 'Vaihda kieli',
    prebook_successfully_created: 'Varauksen lisääminen onnistui',
    prebook_successfully_edit: 'Ennaltavaraus päivitetty',
    prebook_successfully_cancelled: 'Varauksen peruuttaminen onnistui',
    prebook_successfully_accepted: 'Varaus hyväksytty',
    prebooking_details: 'Varauksen tiedot',
    select_contract_title: 'Valitse sopimus',
    select_contract_subtitle: 'Valitse sopimus, jota käytetään tässä tilauksessa.',
    prebook_confirmation_message: 'Oletko varma että haluat perua varauksen?',
    cancel_prebook_confirmation_message:
      'Oletko varma että haluat perua varauksen?',
    really_cancel_prebooking_too_late:
      'Oletko varma että haluat perua varauksen? Ilmainen peruminen ei ole enää mahdollista.',
    cancel_reason_selection: 'Mistä syystä haluat peruuttaa?',
    cancel_reason_sickness: 'Oma sairastuminen',
    cancel_sickness_tip: 'Lääkärintodistus vaaditaan',
    cancel_reason_mistake: 'Vahinko',
    cancel_reason_other: 'Muu syy',
    cancel_reason_other_tip: 'Vapaamuotoinen selitys vaaditaan',
    cancel_other_title: 'Selitys',
    cancel_other: 'Kerro mitä tapahtui?',
    cancel_sickness_title: 'Lääkärintodistus',
    cancel_sickness: 'Ole hyvä ja toimita lääkärintodistus sairastumisesta.',
    copy_information: 'Kopioi tiedot',
    my_bookings: 'Varaukset',
    interpreter_now: 'Tulkki heti',
    time: 'Aika',
    status: 'Tila',
    search: 'Haku',
    pre_book: 'Varaa tulkki',
    order: 'Tilaa',
    hero_order_interpretation: 'Tulkkaus',
    hero_order_translation: 'Käännös',
    book_interpretation: 'Varaa tulkkaus',
    details: 'Tiedot',
    preferences: 'Mieltymykset',
    invoicing_and_assignment_details: 'Laskutus- ja toimeksiantotiedot',
    invoicing: 'Laskutus',
    cost_allocation: 'Kustannuspaikka',
    prebooking_vat_question: 'ALV',
    prebooking_vat_applied: 'ALV sisältyy',
    prebooking_vat_exempt: 'ALV-vapaa',
    customer_information: 'Asiakastiedot',
    customer_number: 'Asiakasnumero',
    order_made_by: 'Tilauksen tekijä',
    ordering_unit: 'Tilaava yksikkö',
    contract_label: 'Sopimus',
    additional_invoicing_information: 'Lisätietoja laskutukseen',
    field_not_visible_to_interpreter: 'Kenttä ei ole näkyvissä tulkille',
    customer_name_for_invoice: 'Asiakkaan nimi (laskulle)',
    date_of_birth_for_invoice: 'Syntymäaika (laskulle)',
    recipients_of_confirmation_and_change_notifications: 'Vahvistus- ja muutosilmoitusten vastaanottajat',
    additional_information_for_order_handler: 'Lisätietoja toimeksiantokäsittelijälle',
    note_filling_this_field_will_prolong_processing_time: 'Huom: tämän kentän täyttäminen pidentää tilauksen käsittelyaikaa.',
    at_least_one_email_required: 'Vähintään yksi sähköpostiosoite vaaditaan',
    summary: 'Yhteenveto',
    back_to_edit: 'Takaisin muokkaukseen',
    confirm_order: 'Vahvista tilaus',
    submitting: 'Lähetetään...',
    mode_of_interpretation: 'Tulkkauksen muoto',
    phone_call: 'Puhelintulkkaus',
    phone_call_tip: 'Vain ääni normaalina puheluna',
    video_call: 'Videotulkkaus',
    video_call_tip: 'Ääni ja kuva mobiilidataa käyttäen',
    conference_call: 'Neuvottelu / virtuaalihuone',
    conference_call_tip: 'Esim. Microsoft Teams, Skype, Google Meet, Zoom',
    video_call_made_via_tulka_app: 'Videopuhelu tehdään Tulka-sovelluksella',
    video_call_interpretation: 'Videotulkkaus',
    conference_interpretation: 'Neuvottelutulkkaus',
    Remote: 'Etänä',
    remote: 'Etänä',
    on_site: 'Paikan päällä',
    presence_onsite: 'Paikan päällä',
    announcement: 'Ilmoitus',
    start_time: 'Aloitusaika',
    end_time: 'Lopetusaika',
    add_another: 'Lisää toinen',
    does_not_matter: 'Ei väliä',
    no_choice: 'Ei valintaa',
    highest: 'Korkein',
    delivery_time: 'Toimitus aika',
    date_required: 'Päivämäärä vaaditaan',
    date_too_far_in_future: 'Päivämäärän on oltava alle 5 vuotta tulevaisuudessa',
    time_required: 'Aika vaaditaan',
    duration_required: 'Kesto vaaditaan',
    at_least_one_time_slot_required: 'Vähintään yksi aikavälä vaaditaan',
    // New prebooking form keys
    select: 'Valitse',
    select_notice: 'Mitä tulkin pitäisi välittää tulkin käyttäjälle',
    required: 'Pakollinen',
    language_required: 'Kieli on pakollinen',
    interpreted_and_target_language_must_differ: 'Tulkattava kieli ja kohdekieli eivät voi olla samoja',
    call_type_required: 'Puhelutyyppi on pakollinen',
    street_address_required: 'Lähiosoite on pakollinen',
    city_required: 'Kaupunki on pakollinen',
    post_code_required: 'Postinumero on pakollinen',
    message_content_required: 'Viestin sisältö on pakollinen',
    customer_name_required: 'Asiakkaan nimi on pakollinen',
    date_of_birth_required: 'Syntymäaika on pakollinen',
    phone_number_required: 'Puhelinnumero on pakollinen',
    street_address: 'Lähiosoite',
    post_code: 'Postinumero',
    city: 'Kaupunki',
    arrival_instruction_at_location: 'Saapumisohjeet tulkkauspaikalle',
    message_content: 'Viestin sisältö',
    message_max_length_info: 'Viestin maksimipituus on 1000 merkkiä.',
    last_delivery_date: 'Viimeinen toimituspäivä viestille',
    delivery_date_info: 'Tulkki soittaa ilmoitettuun numeroon valitun päivän loppuun mennessä.',
    interpreter_gender: 'Tulkin sukupuoli',
    competence_level_special_need: 'Pätevyystaso / tulkin erityistarve',
    competence_level_helper_text: 'Kaikki tasot ovat oletuksena mukana. Napsauta poistaaksesi tasot, joita et halua käyttää. Huomaa, että käytettävissä olevien tulkkien valikoima pienenee, jos poistat jonkin pätevyystason valinnan.',
    authorized_interpreter: 'Auktorisoitu tulkki',
    court_legal_interpreter: 'Oikeustulkki',
    healthcare_interpreter: 'Terveydenhuollon tulkki',
    registered_trained_interpreter: 'Rekisteröity koulutettu tulkki',
    other_interpreters: 'Muut tulkit',
    other_interpreter_level: 'Muu tulkki',
    let_system_choose_highest_qualified: 'Anna järjestelmän valita korkeimmin pätevä tulkki',
    experiences: 'Vaatimukset',
    security_cleared_interpreter: 'Turvallisuusselvitetty tulkki',
    additional_preferences: 'Lisävalinnat',
    open: 'Avaa',
    hide: 'Piilota',
    request_preferred_interpreter: 'Pyydä mieluinen tulkki',
    exclude_specific_interpreters: 'Sulje pois tietty tulkki/tulkit',
    interpreters_found_for_your_selections: 'tulkkia löytyi valinnoillesi',
    how_to_handle_no_onsite_interpreter: 'Miten haluaisit toimia, jos tulkkia ei löydy paikan päälle?',
    assign_remote_interpreter: 'Järjestä etätulkki',
    cancel_booking: 'Peruuta varaus',
    // Preferences section keys
    preferences_title: 'Mieltymykset',
    preferences_interpreter_gender: 'Tulkin sukupuoli',
    preferences_onsite_fallback: 'Miten haluaisit toimia, jos tulkkia ei löydy paikan päälle?',
    preferences_accept_beyond_km: 'Hyväksytkö tulkin, joka ylittää sopimuksen {} km rajan yhteen suuntaan?',
    preferences_km_beyond_limit: 'Kuinka monella kilometrillä hyväksyt {} km rajan ylityksen yhteen suuntaan?',
    preferences_total_max_distance_label_one_way: 'Suurin sallittu kokonaisetäisyys: {} km yhteen suuntaan',
    preferences_total_max_distance_unlimited: 'Suurin sallittu kokonaisetäisyys: ei rajaa',
    unlimited: 'Rajaton',
    km_unit: 'km',
    accepts_interpreters_within_km: 'HYVÄKSYY TULKIN ${distance} KM SISÄLLÄ',
    preferences_fallback_assign_remote: 'Järjestä etätulkki',
    preferences_fallback_cancel: 'Peruuta varaus',
    preferences_additional_preferences: 'Lisävalinnat',
    preferences_preferred_interpreter: 'Pyydä mieluinen tulkki',
    preferences_excluded_interpreter: 'Sulje pois tietty tulkki/tulkit',
    preferences_search_placeholder: 'Etsi tulkkia nimellä...',
    preferences_ukrainian_russian_fallback: 'Jos ukrainalaista tulkkia ei ole saatavilla, voimmeko valita venäjänkielisen tulkin?',
    preferences_alternative_language_fallback: 'Jos {0} tulkkia ei ole saatavilla, voimmeko valita {1} tulkin?',
    preferences_accept_lower_level: 'Jos pyydetyn tason tulkki ei ole saatavilla, hyväksytkö alemman tason tulkin?',
    preferences_remote_backup_connection_type: 'Suosittu yhteystyyppi etävaravaihtoehdolle',
    preferences_remote_backup_phone: 'Puhelu',
    preferences_remote_backup_video: 'Videopuhelu',
    preferences_remote_backup_conference: 'Konferenssipuhelu',
    interpreted_language: 'Tulkattava kieli',
    favorite_title: 'Mieluisimmat tulkit',
    no_prebookings: 'Sinulla ei ole varauksia.',
    prebooking_not_active: 'Sopimuksesi ei sisällä ennaltavaraamista.',
    reservation_number: 'Varausnumero',
    external_order_id: 'tilaustunniste',
    email: 'Sähköpostiosoite',
    not_yet_support_interpreter_login:
      'Uusi selainversio ei vielä sisällä tulkin toimintoja. Ole hyvä ja käytä mobiiliappia.',
    please_try_again_later: 'Yritä myöhemmin uudelleen.',
    no_languages: 'Ei kieliä',
    interpreter_phone_number: 'Tulkin puhelinnumero',
    remove: 'Poistaa',
    presence_conference: 'Konferenssi',
    presence_conference_tip: 'esim. Microsoft Teams, Skype, Google Meet, Zoom',
    interpreter_email: 'Tulkin sähköposti',
    all: 'Kaikki',
    invoice_user_group: 'Kustannuspaikka',
    cc_emails: 'Tilausvahvistuksen ja muutosilmoitusten vastaanottajat',
    cc_email: 'Sähköpostiosoite',
    cc_emails_copy: 'Tilausvahvistuksen ja muutosilmoitusten vastaanottajat',
    information_for_interpreter: 'Tiedot tulkille',
    patient_name: 'Tulkattavan nimi',
    reference_document: 'Viiteasiakirja',
    upload_reference_document_optional: 'Lataa viiteasiakirja (valinnainen)',
    browse_files: 'Selaa tiedostoja',
    only_pdf_format_file_visible_to_interpreter: 'Vain PDF-muoto. Tiedosto näkyy vain määrätylle tulkille.',
    field_information_not_visible_on_bill: 'Kenttätieto ei näy laskulla',
    patient_name_description: 'Tämä tieto ei tule laskulle vaan menee tulkille tiedoksi esim. jääviystilanteita varten.',
    customer: 'Asiakas',
    customer_unit: 'Yksikkö',
    personal: 'Omat',
    search_for: 'Hae yksiköllä, kielellä, kustannuspaikalla tai asiakkaalla',
    failed_to_create_prebooking:
      'Varauksen luominen epäonnistui. Yritä myöhemmin uudelleen.',
    failed_to_create_all_prebookings: 'Kaikkien varausten luominen epäonnistui',
    slot: 'Aikavälä',
    succeeded: 'onnistui',
    failed: 'epäonnistui',
    to_start_interpretation: 'Aloita tulkkaus soittamalla numeroon:',
    start_interpretation: 'Aloita tulkkaus',
    hey_username: 'Hei {username},',
    confirm_your_account_information: 'Vahvista käyttäjätilisi perustiedot',
    confirm_your_account_information_description:
      'Mahdollisimman sujuvan palvelun toimittamiseksi pyydämme sinua vahvistamaan tai korjaamaan käyttäjätunnukseesi liittyvät alla olevat tiedot',
    other: 'Muu',
    no_options: 'Ei hakutuloksia',
    search_message: 'Hae...',
    i_confirm_the_information: 'VAHVISTAN TIETONI OIKEIKSI',
    billing: 'Laskutus',
    translations: 'Käännökset',
    order_translation: 'Tilaa käännös',
    translation_order_number: 'Tilausnro',
    translation_order_date: 'Tilauspäivä',
    translation_from: 'Kielestä',
    translation_to: 'Kieleen',
    translation_username: 'Käyttäjä',
    translation_delivery: 'Toimitus',
    translation_user_group: 'Kustannuspaikka',
    translation_customer: 'Asiakas',
    translation_status: 'Tila',
    translation_status_new_order: 'Uusi tilaus',
    translation_status_in_progress: 'Käsittelyssä',
    translation_status_assigned: 'Osoitettu',
    translation_status_completed: 'Valmis',
    translation_status_cancelled: 'Peruutettu',
    translation_status_delivered: 'Toimitettu',
    translation_customer_id: 'Asiakasnro',
    translation_file_name: 'Tiedostonimi',
    translation_estimated_count: 'Arvioitu m\u00e4\u00e4r\u00e4',
    translation_due_date: 'Er\u00e4p\u00e4iv\u00e4',
    translation_assigned_jobs: 'Osoitetut k\u00e4\u00e4nn\u00f6steht\u00e4v\u00e4t',
    translation_order: 'K\u00e4\u00e4nn\u00f6stilaus',
    translation_details: 'Tiedot',
    translation_customer_information: 'Asiakastiedot',
    translation_invoicing: 'Laskutus',
    translation_from_language: 'Kielest\u00e4',
    translation_to_language: 'Kieleen',
    translation_desired_delivery_date: 'Toivottu toimituspäivä',
    translation_instructions: 'Ohjeet kääntäjälle',
    translation_estimated_total: 'Arvioitu kokonaismäärä',
    translation_estimated_scope: 'Arvioitu laajuus',
    translation_materials: 'Käännettävät materiaalit',
    translation_customer_number: 'Asiakasnumero',
    translation_order_made_by: 'Tilaaja',
    translation_ordering_unit: 'Tilaava yksikkö',
    checking_your_billing_information: 'Laskutustietojen tarkistus',
    billing_page_main_sub_header:
      'Tarkista että tulkkaus kohdistuu oikeaan kustannuspaikkaan/yksikköön ja että laskutusviitetiedot ovat ohjeistuksen mukaiset',
    interpreter_reported_duration: 'Tulkin ilmoittama kesto',
    update: 'Päivitä',
    update_prebook: 'Päivitä varaus',
    your_changes_will_be_lost:
      'Haluatko varmasti keskeyttää? Kaikki muutokset menetetään.',
    settings: 'Asetukset',
    user_home_group_header: 'Oma toimipaikka',
    app_country: 'Maa',
    address: 'Osoite',
    country_placeholder: 'Valitse maa',
    update_settings: 'Tallenna asetukset',
    has_car: 'Minulla on auto',
    profile_options: 'Profiiliasetukset',
    no_invoice_reference: 'Ei laskutusviitettä',
    no_user_group_selected: 'Kustannuspaikkaa ei valittu',
    prebook_successfully_updated: 'Laskutustiedot onnistuneesti vahvistettu',
    type_search_term_here: 'Kirjoita haettavan kustannuspaikan nimen osa tähän',
    verify: 'Vahvista',
    prebookings_successfully_updated:
      'Laskutustiedot onnistuneesti vahvistettu',
    alternative_cost_center: 'Tilaus- tai poikkeava kustannuspaikkanumero',
    alternative_cost_center_edit:
      'Muokkaa tilaus- tai poikkeavaa kustannuspaikkanumeroa',
    choose_default_cost_center: 'Valitse kotikustannuspaikka',
    enter_or_confirm_username: 'Anna tai vahvista kirjautumiseen käytettävä sähköpostiosoite.',
    enter_or_confirm_email: 'Anna tai vahvista sähköpostiosoite, johon lähetetään automaattisesti varausvahvistukset ja muutosilmoitukset varatuista tulkkauksista',
    you_can_change_this_information_at_any_time:
      'Voit koska tahansa muuttaa näitä tietoja ”Asetukset” -valikosta',
    edit: 'Muokkaa',
    change_reservation: 'Muokkaa',
    copy_reservation: 'Kopioi',
    change_reservation_description: 'Muokkaa varausta',
    copy_reservation_description: 'Kopioi varaus',
    cancel_prebook_description: 'Peruuta varaus',
    additional_cost_will_be_charged:
      'Tämä muokkaus on maksullinen. Alkuperäinen varaus alkaa 24 tunnin sisällä, joten veloitamme tästä muutoksesta hinnaston mukaisesti viime hetken peruutuksen verran.',
    we_will_cancel_this_booking_and_make_a_new_one:
      'Peruutamme tämän varauksen ja teemme sinulle uuden, jos muutat - aikaa, päiväystä, tyyppiä, kieltä tai kestoa.',
    preview: 'Esikatsele',
    edit_prebooking_details: 'Muokkaa varauksen laskutustietoja',
    no_invoices: 'Sinulla ei ole laskutukseen lähteviä tulkkausvarauksia.',
    add: 'Lisää',
    add_email: 'Lisää sähköposti',
    invite_success: 'Kutsu onnistuneesti lähetetty',
    invite_to_the_group: 'Kutsu uusi käyttäjä omaan yksikköösi',
    invite_to_the_group_explanation:
      'Tiedätkö kollegan jonka tehtäviin kuuluu tulkkivarausten tekeminen? Kutsu hänet Túlkaan.',
    invite: 'Lähetä kutsu',
    invite_to_group: 'Kutsu uusi käyttäjä',
    collaborators_header: 'Varausten yhteishallinnointi',
    add_collaborators: 'Jaa kollegalle hallinnointioikeus varauksiin',
    please_enter_email: 'Ole hyvä ja kirjoita sähköpostiosoite',
    collaborators_header_description:
      'Jaa kollegalle hallinnointioikeus varauksiisi. \nHuomioi, että hallinnointioikeuden voi jakaa vain jo olemassaolevan käyttäjän kanssa.',
    name: 'Etunimi ja Sukunimi',
    user_does_not_exist:
      'Käyttäjää ei löydy, voit jakaa oikeuden vain olemassaolevan käyttäjän kanssa.',
    invite_to_collaborate_success: 'Hallinnointioikeuden jako onnistui.',
    collaborator_successfully_removed:
      'Hallinnointioikeus onnistuneesti peruutettu.',
    invalid_email_address: 'Virheellinen sähköpostiosoite',
    invalid_phone_number: 'Virheellinen puhelinnumero',
    invalid_phone_number_error: 'Virheellinen puhelinnumero',
    already_registered_phone: 'Tämä numero on rekisteröity jo olemassa olevalle käyttäjälle. Ota yhteyttä asiakaspalveluun p. ',
    phone_number_cannot_start_with_0: 'Puhelinnumero ei voi alkaa 0:lla kansainvälisessä muodossa',
    email_address_from_different_organisation_domain:
      'Sähköpostiosoite kuuluu eri organisaatiolle.',
    this_user_already_added_to_collaborators:
      'Tällä käyttäjällä on jo hallinnointioikeus varauksiisi.',
    prebooked: 'Ennaltavarattu tulkkaus',
    ondemand: 'Pikatulkkaus',
    reset_user_password: 'Salasanan vaihto',
    reset_user_email: 'Vaihda sähköpostiosoite varausvahvistuksia varten',
    reset_user_email_note_for_interpreter: 'Huom: Tämä ei muuta kirjautumiseen käytettävää käyttäjätunnusta, vaan ainoastaan sähköpostiosoitetteen johon varausvahvistukset ja muutosilmoitukset lähetetään.',
    reset_user_email_for_login: 'Vaihda kirjautumiseen käytettävä sähköpostiosoite',
    please_enter_password: 'Salasana',
    please_enter_new_password: 'Uusi salasana',
    please_enter_current_password: 'Nykyinen salasana',
    please_repeat_password: 'Toista salasana',
    please_repeat_new_password: 'Uusi salasana uudestaan',
    passwords_do_not_match: 'Salasanat eivät täsmää',
    old_password_is_required: 'Nykyinen salasana on pakollinen',
    enter_new_password: 'Syötä uusi salasana',
    repeat_new_password: 'Uusi salasana uudestaan',
    password_requirement:
      'Salasanan tulee olla vähintään 8 merkkiä pitkä ja sisältää pieniä ja isoja kirjaimia sekä numero.',
    all_day: 'Koko päivä',
    previous: 'Edellinen',
    next: 'Seuraava',
    month: 'Kuukausi',
    week: 'Viikko',
    day: 'Päivä',
    agenda: 'Agenda',
    date: 'Pvm',
    event: 'Tapahtuma',
    no_events_in_range: 'Ei tapahtumia jaksolla',
    show_more: 'Näytä lisää',
    reports: 'Raportointi',
    number_of_interpretations: 'Tulkkausmäärä',
    interpretation_breakdown_previous_month:
      'Tulkkauserittely - edellinen kuukausi',
    your_browser_is_not_supported: 'Käyttämäsi selain ei ole tuettu.',
    edge_browser_is_not_supported: 'EDGE-selain ei ole tuettu. Käytä Google Chrome -selainta.',
    we_recommend_using_the_latest_version_of_chrome_or_firefox_in_order_to_continue_using_this_service:
      'Suosittelemme käyttämään uusinta versiota Chrome tai Firefox selaimista jatkaaksesi tämän palvelun käyttämistä.',
    use_of_interpretation_report: 'Tulkkauksen Käyttö',
    billing_report: 'Laskutus',
    customer_reporting_report: 'Asiakasraportointi',
    data_export_report: 'Tiedon Vienti',
    monetra_billing_report: 'Monetra Laskutus',
    monetra_payroll_report: 'Monetra Palkanlasku',
    copy_data_to_new_booking: 'Käytä varausta uuden pohjana',
    update_at_least_date_or_time_fields_to_create_a_booking:
      'Luodaksesi varauksen muokkaa vähintään Päivä tai Kellonaika kenttiä',
    cancel_prebook: 'Peruuta varaus',
    newButton: 'Uusi',
    announcement_interpretation: 'Ilmoitustulkkaus',
    customer_name_and_date_of_birth: 'Asiakkaan nimi ja syntymäaika (laskulle)',
    customer_name: 'Asiakkaan nimi (laskulle)',
    date_of_birth: 'Asiakkaan syntymäaika (laskulle)',
    to_whom_the_message_is_forwarded_if_not_to_the_customer:
      'Kenelle viesti välitetään, jos ei asiakkaalle',
    telephone_number_to_which_the_interpreter_will_call:
      'Puhelinnumero(t), johon tulkki soittaa',
    main_telephone_number_to_which_the_interpreter_will_call:
      'Puhelinnumero, johon tulkki ensisijaisesti soittaa',
    additional_telephone_number_to_which_the_interpreter_will_call:
      'Muut puhelinnumero(t), joista asiakasta yritetään tavoittaa',
    message_to_customer_service_or_interpreter:
      'Viesti asiakaspalveluun tai tulkille',
    mandatory_information: 'Pakollinen tieto',
    optional_information: 'Vapaaehtoinen tieto',
    customer_data: 'Asiakkaan tiedot',
    write_the_content: 'Viestin sisältö',
    write_the_content_of_the_matter_to_be_reported_below:
      'Kirjoita ilmoitettavan asian sisältö alle',
    content_data_tooltip:
      'Ilmoitustulkkaus on yksisuuntainen, puhuttuna tarjottu viestin tulkkaus. Viestin pituus on maksimissaan 1000 merkkiä.',
    content_data_second_tooltip:
      'Tulkki ottaa yhteyttä ilmoitettuun puhelinnumeroon vähintään 5 kertaa. Ilmoitustulkkaus lasketaan suoritetuksi siitä huolimatta, ettei viesti saavuta asiakasta.',
    calendar_tooltip_notice_interpretation:
      'Tulkki soittaa ilmoitettuun numeroon valitun päivän loppuun mennessä.',
    calendars: 'Kalenterit',
    please_select_language: 'Valitse kieli',
    please_select_interpreter: 'Valitse tulkki',
    please_select_language_and_interpreter_to_see_the_calendar:
      'Valitse kieli ja tulkki ensin.',
    please_select_time: 'Valitse ajankohta poissaololle',
    block_time: 'Vahvistan poissaolon',
    block_time_description: 'Estetty aika - tänä aikana tulkki ei vastaanota soittoja eikä ennaltavarauksia',
    reservations_od: 'Varattu OD:lle',
    reservations_od_description: 'Varattu OD:lle - tänä aikana tulkki ei vastaanota ennaltavarauksia, ainoastaan OD soittoja',
    unavailable_time: 'Poissaolo',
    unavailability_type: 'Tyyppi',
    pick_start_time: 'Valitse aloitusaika',
    pick_end_time: 'Valitse lopetusaika',
    time_successfuly_blocked: 'Poissaolo onnistuneesti kirjattu',
    time_successfuly_unblocked: 'Poissaolo onnistuneesti peruutettu',
    time_successfuly_updated: 'Poissaolo onnistuneesti päivitetty',
    overlaping_information_dialog_mesage:
      'Valittu ajankohta osuu osittain päällekkäin olemassaolevan varauksen tai aiemman poissaolomerkinnän kanssa. Valitse uusi ajankohta tai peruuta aiempi varaus tai merkintä.',
    ok: 'ok',
    cancel_blocked_time_confirmation_message:
      'Oletko varma että haluat peruuttaa poissaoloilmoituksen?',
    cancel_interpreter_blocked_time: 'Poista sulku',
    relay_the_message_to_person: 'Viesti välitetään henkilölle:',
    birthday: 'Asiakkaan syntymäaika:',
    numbers_to_be_called: 'Numero(t) johon tulkki soittaa:',
    message: 'Viesti:',
    to_whom_message_forwarded_if_not_customer: 'Kenelle viesti välitetään, jos ei asiakas',
    write_here: 'Kirjoita tähän...',
    main_telephone_number_interpreter_will_call: 'Puhelinnumero johon tulkki soittaa',
    additional_telephone_numbers_interpreter_will_call: 'Lisäpuhelinnumerot johon tulkki soittaa',
    phone_required: 'Puhelinnumero vaaditaan',
    phone_already_added: 'Puhelinnumero on jo lisätty',
    enter_phone_number: 'Syötä puhelinnumero',
    has_to_be_a_phone_number: 'Täytyy olla muotoa puhelinnumero',
    other_information_relevant_to_the_invoicing_such_as_information_about_the_customer:
      'Muu laskuntarkastajalle olennainen tieto, kuten tieto palvelunkäyttäjästä',
    this_invoice_needs_additional_information:
      'Ole hyvä ja täytä vähintään pakolliset laskutustiedot',
    cancelled_by: 'Peruuttaja',
    cancel_reason: 'Peruutuksen syy',
    join_to_meeting: 'Liity kokoukseen',
    ready_to_join: 'Valmis liittymään?',
    what_is_your_name: 'Mikä on nimesi?',
    your_name: 'Nimesi',
    waiting_for_luona_worker_and_interpreter:
      'Odotetaan Luonan työntekijää ja tulkkia…',
    waiting_label: 'Odotetaan…',
    type_message: 'Kirjoita viesti',
    looking_for: 'Hyvän palvelun takaaminen vaatii joskus aikaa. Odota hetki. Etsitään',
    luona_worker_persone: 'Luonan työntekijä',
    interpreter_persone: 'Tulkki',
    interpreter_status: 'Käytettävissä nyt',
    availability_yes: 'Käytettävissä nyt',
    availability_no: 'Et ole käytettävissä.',
    // prebooking luona
    prebooking_page_title: 'Varaukset',
    defaultPrebookingPageMessage: 'Sinulla ei ole varauksia',
    go_to_prebookings_list: 'Siirry varauslistaan',
    luona_feedback_title: 'Laatukysely',
    luona_feedback_description: 'Olet hyödyntänyt Luonan uuttaa teknistä etäpalvelualustaa. Keräämme palautetta palvelusta ja olisimme kiitollisia, jos vastaisit lyhyeen kyselyyn.',
    luona_feedback_score: 'Kuinka todennäköisesti suosittelisit tätä etäpalvelualustaa ystävällesi?',
    luona_feedback: 'Palaute',
    feedback_sent: 'Kiitos palautteesta!',
    luona_prefer: 'Etuudet',
    Luona_lead: 'Ryhmänvetäjä',
    luona_social: 'Sosiaali',
    luona_nurses: 'Terveys',
    go_to_services: 'Siirry palveluun',
    start_prebook: 'Aloita',
    prebooking_is_gone: 'Varausta ei enää ole',
    prebooking_not_answered: 'Emme valitettavasti pysty toimittamaan ennakkovaraustasi. Varaa uusi tapaaminen asiantuntijan kanssa.',
    prebooking_is_not_found: 'Aktiivista varausta ei löytynyt. Varaa uusi tapaaminen asiantuntijan kanssa.',
    prebooking_is_cancelled: 'Aktiivista varausta ei löytynyt. Varaus on mahdollisesti peruttu. Varaa uusi tapaaminen asiantuntijan kanssa.',
    prebooking_is_too_late: 'Varatusta ajasta on jo niin kauan, että tulkki on siirtynyt toiseen puheluun. Varaa uusi tapaaminen asiantuntijan kanssa.',
    prebooking_will_start_in: 'Ajanvarauksesi alkuun on:',
    early_preview_intro: ' Arvoisa Luonan asiakas!',
    you_can_close_tab_for_now: 'Voit sulkea tämän välilehden toistaiseksi.',
    my_prebooking_list: 'Omat varaukseni',
    waiting_time: 'Odotusaika on',
    connecting_to_meeting: 'Yhdistetään tapaamiseen',
    connecting_to_meeting_for_interpreter: 'Odota hetki, yhdistämme kaikki osallistujat.',
    no_access_to_your_camera_or_microphone: 'Et ole antanut lupaa käyttää laitteesi kameraa tai mikrofonia',
    remote_backup_to_onsite: 'Kuinka toimitaan, jos tulkkia ei löydy paikan päälle?',
    use_remote_interpretation_option: 'Käytetään etätulkkausta',
    cancel_prebooking_option: 'Perutaan tulkkaus',
    which_remote_interpretation_type_do_you_choose: 'Kumman etätulkkausmuodon valitset?',
    phone_interpretation: 'Puhelintulkkaus',
    conference_virtual_room: 'Neuvottelu / Virtuaalihuone (esim. Google Meet, Teams, Zoom)',
    confirm_you_are_online: 'Oletko poistunut? Jos haluat jatkaa puhelujen vastaanottoa, ole ystävällinen ja klikkaa "Liity takaisin" -painiketta.',
    join_back: 'Liity takaisin',
    requestErrorMessageReasonPoorInternet: 'Hupsista! Jotain meni pieleen. Syy saattaa olla huonossa nettiyhteydessä. Tarkasta yhteysasetukset!',
    networkDisconnectedMessage: 'Nettiyhteytesi ei ole riittävän nopea video-puheluille. Tarkasta yhteysasetukset!',
    interpreter_name: 'Tulkki',
    meeting_disconnected: 'Yhteys katkesi',
    meeting_reconnecting: 'Yhdistetään uudelleen',
    meeting_reconnected: 'Yhteys palautettu',
    browser_does_not_support_video_effects: 'Selaimesi ei tue videotehosteita',

    // Self-selfRegistration
    user_group_not_found: 'Emme voi suorittaa rekisteröintiäsi tällä hetkellä, koska organisaatioltasi puuttuu vaaditut asetukset. Ota yhteyttä asiakaspalveluumme saadaksesi apua tämän ongelman ratkaisemisessa.',
    log_in: 'Kirjaudu sisään',
    sign_up: 'Rekisteröidy',
    create_an_account: 'Luo käyttäjätunnus',
    contact_information: 'Yhteystiedot',
    first_name: 'Etunimi',
    last_name: 'Sukunimi',
    contact_info_email: 'Sähköposti',
    contact_info_phone: 'Puhelinnumero',
    continue: 'Seuraava',
    is_personal_email: 'Sähköpostiosoitetta käytetään henkilöllisyytesi vahvistamiseen. Vahvista onko tämä sähköposti vain henkilökohtaiseen viestintääsi vai jaettu työtovereiden kanssa:',
    email_for_personal: 'Sähköposti on vain henkilökohtaiseen viestintääni',
    email_shared_with_colleagues: 'Sähköposti on jaettu työtoverien kanssa',
    check_email_again: 'Syötä sähköpostiosoite uudelleen vahvistussähköpostin lähettämistä varten.',
    is_personal_phone: 'Puhelinnumeroa käytetään henkilöllisyytesi vahvistamiseen. Vahvista onko tämä puhelinnumero vain henkilökohtaisessa käytössä vai jaettu työtovereiden kanssa:',
    phone_for_personal: 'Puhelinnumero on vain henkilökohtaisessa käytössä',
    phone_shared_with_colleagues: 'Puhelinnumero on jaettu työtoverien kanssa',
    check_phone_again_by_sms: 'Syötä puhelinnumero uudelleen vahvistustekstiviestin lähettämistä varten.',
    check_phone_again_by_call: 'Syötä puhelinnumero uudelleen automaattista soittoa varten.',
    already_have_an_account_part1: 'Onko sinulla jo tili? ',
    already_have_an_account_part2: 'Kirjaudu sisään ',
    confirm_your_email: 'Vahvista sähköpostiosoitteesi',
    confirm_your_email_message: 'Rekisteröinnin vahvistamiseksi olemme lähettäneen rekisteröityyn sähköpostiin vahvistusviestin. Vahvista sähköpostiosoite viestissä annettujen ohjeiden mukaan.',
    confirm_your_phone: 'Vahvista puhelinnumero',
    confirm_your_mobile_phone_message: 'Rekisteröinnin viimeistelemiseksi olemme lähettäneet vahvistusviestin rekisteröityyn puhelinnumeroon. Vahvista puhelinnumero noudattamalla tekstiviestissä olevia ohjeita.',
    confirm_your_phone_message: 'Automaatti soittaa sinulle pian lankapuhelinnumeron omistajuuden vahvistamiseksi. Kuulet puhelussa koodin, joka sinun tulee syöttää tälle rekisteröintilomakkeelle.',
    confirmation_code: 'Vahvistuskoodi',
    didnt_receive_an_email: 'Etkö saanut sähköpostia?',
    didnt_receive_a_call: 'Etkö saanut puhelua?',
    didnt_receive_sms: 'Etkö saanut vahvistusviestiä?',
    send_email_again: 'Lähetä sähköposti uudelleen',
    send_phone_again_for_sms: 'Lähetä uusi vahvistustekstiviesti',
    send_phone_again_for_call: 'Pyydä uutta soittoa',
    verification_page: 'Vahvistus',
    verification_link_expired: 'Jotain meni pieleen. Vahvistuslinkki on mahdollisesti päässyt vanhentumaan. Yritä uudelleen.',
    waiting_for_verification: 'Odotetaan vahvistusta',
    select_the_correct_cost_center_regarding_invoicing: 'Valitse alla olevasta listasta oikea laskutusyksikkö tai kustannuspaikka. Mikäli et löydä oikeaa laskutusyksikköä valitse “En löytänyt oikeaa laskutusyksikköä” -valinta',
    how_often_do_you_predict_to_utilize_interpretation_services: 'Kuinka usein arvioit keskimäärin tarvitsevasi tulkkauspalveluita?',
    daily: 'Päivittäin',
    weekly: 'Viikottain',
    more_than_weekly: 'Harvemmin',
    periodically: 'Tarve on jaksottaista',
    cost_center: 'Laskutusyksikkö',
    i_could_not_find_the_correct_cost_center: 'En löytänyt oikeaa laskutusyksikköä',
    information_regarding_cost_center: 'Tiedot laskutusyksiköstä (toimiala sekä osastosi / yksikkösi, jolla työskentelet):',
    please_tell_us_where_you_work_in_which_unit_etc: ' Syötä kenttään toimiala sekä osastosi / yksikkösi, jolla työskentelet.',
    update_user_home_group_failed: 'Laskutusyksikön päivitys epäonnistui',
    set_up_your_password: 'Luo salasana',
    repeat_password: 'Vahvista salasana',
    submit: 'Rekisteröidy',
    set_password_failed: 'Salasanan päivitys epäonnistui',
    account_created: 'Käyttäjätunnus luotu!',
    you_can_now_login_to_the_tulka_application_using_your_credentials: 'Voit nyt kirjautua Túlkaan käyttäjätunnuksellasi. Sivun alareunasta löytyvällä painikkeella pääset suoraan Túlkan selainversioon.',
    we_have_also_sent_you_instructions_for_use_by_email: 'Olemme myös lähettäneet sinulle käyttöohjeet sähköpostiin.',
    open_mobile_app: 'Avaa mobiilisovellus',
    login_to_web: 'Kirjaudu sisään selainversioon',
    account_found: 'Olemassa oleva tunnus löytynyt',
    please_log_in_or_request_a_new_password: 'Kirjaudu sisään tai pyydä uusi salasana.',
    forgot_password: 'Unohdin salasanan',
    no_contract_found: 'Sopimusta ei löytynyt',
    it_seems_like_you_dont_have_an_contract_with_tulka_based_on_your_email_address: 'Emme löytäneet olemassa olevaa sopimusta antamallasi sähköpostiosoitteella.',
    please_contact_our_sales_to_begin_using_tulka: 'Mikäli haluat Túlkan käyttöön ota yhteyttä asiakaspalveluumme sivun oikeasta alareunasta olevan chatin kautta, puhelimitse {customerServicePhoneNumber} tai sähköpostitse {infoEmail}',
    email_already_registered: 'Antamallasi sähköpostiosoitteella on jo olemassa oleva tunnus.',
    contact_service_with_chat: 'Ota yhteyttä asiakaspalveluumme sivun oikeasta alareunasta löytyvän chatin kautta tai soittamalla numeroon ',
    contact_service_without_chat: 'Ota yhteyttä asiakaspalveluumme p. ',
    contact_sales: 'Ota yhteyttä myyntiin',
    invalid_code: 'Virheellinen koodi',
    invalid_field_value: 'Tämä kenttä on pakollinen, eikä se voi olla tyhjä.',
    fistName_requirement: 'Etunimi pakollinen',
    lastName_requirement: 'Sukunimi pakollinen',
    contact_service_contacts: 'puhelimitse 030 660 6400 tai sähköpostitse info@tulka.com',
    backup_option: 'Varavaihtoehto',
    no_backup_option_selected: 'varavaihtoehtoa ei ole valittu',
    od_details_title: 'Tarkenna halutessasi tulkkauksen aihetta ja kestoa',
    od_details_subject_subtitle: 'Tulkkauksen aihe',
    subject_placeholder: 'Jaamme tämän tulkeille',
    estimated_duration: 'Arvio kestosta',
    interpreter_level_label: 'Taso',
    translation_order_title: 'Käännöstilaus',
    translation_order_step_details: 'Tilauksen tiedot',
    translation_order_step_invoicing: 'Laskutus ja toimeksiannon tiedot',
    translation_order_details: 'Tiedot',
    translation_order_language_from: 'Kielestä',
    translation_order_language_to: 'Kieleen',
    translation_order_upload_reference: 'Lataa viiteasiakirja',
    translation_order_browse_files: 'Selaa tiedostoja',
    translation_order_accepted_types: 'Hyväksytyt tiedostotyypit',
    translation_order_estimated_scope: 'Arvioitu laajuus',
    translation_order_select_type: 'Valitse tyyppi',
    translation_order_scope_words: 'Sanaa',
    translation_order_scope_pages: 'Sivua',
    translation_order_scope_minutes: 'Minuuttia',
    translation_order_scope_help_text: 'Käännöksen arvioitu laajuus käytetään vain sopivan kääntäjän löytämiseksi, eikä sillä ole suoraa vaikutusta laskutettavaan summaan.',
    translation_order_instructions: 'Ohjeet tai huomautukset kääntäjälle',
    translation_order_instructions_placeholder: 'esim. "Kiinnitä huomiota lääketieteelliseen terminologiaan," "Kohderyhmä on lapset"',
    translation_order_message_to_translator: 'Viesti kääntäjälle',
    translation_order_customer_service_instructions: 'Asiakaspalvelun ohjeet',
    translation_order_delivery_date: 'Toivottu toimituspäivä',
    translation_order_delivery_date_help: 'Toivottu toimituspäivä on ohjeellinen, eikä se sido kääntäjää.',
    translation_order_specifying_invoicing_details: 'Laskutustietojen määrittely',
    translation_order_invoice_references: 'Laskutusviitteet',
    translation_order_additional_invoicing_placeholder: 'Kenttätieto ei näy tulkille',
    translation_order_notifications: 'Ilmoitukset',
    translation_order_notification_emails: 'Ilmoitussähköpostit',
    translation_order_materials: 'Materiaalit',
    translation_order_show_all: 'Näytä kaikki',
    translation_order_preview_not_available: 'Esikatselu ei ole saatavilla tälle tiedostotyypille',
    translation_order_customer_info: 'Asiakastiedot',
    translation_order_customer_number: 'Asiakasnumero',
    translation_order_order_number: 'Tilausnumero',
    translation_order_ordered_by: 'Tilaaja',
    translation_order_ordering_unit: 'Tilaava yksikkö',
    translation_order_estimated_total: 'Arvioitu kokonaislaajuus',
    translation_order_confirmation: 'Tilausvahvistus',
    translation_order_cancel_order: 'Peruuta tilaus',
    translation_order_cancel_not_possible: 'Käännös on aloitettu, eikä sitä voi peruuttaa täällä. Ota yhteyttä asiakaspalveluun.',
    translation_download_material: 'Lataa materiaali',
    translation_upload_material: 'Lataa käännös',
    uploading: 'Lähetetään…',
    uploaded: 'Lähetetty',
    downloading: 'Ladataan…',
    transfer_failed: 'Siirto epäonnistui',
    translation_translated_materials: 'Käännetyt materiaalit',
    translation_materials_for_translation: 'Käännettävät materiaalit',
    translation_order_created_successfully: 'Käännöstilaus luotu onnistuneesti',
    translation_order_uploading_attachments_notice: 'Odotetaan liitteiden lähetystä. Pidä tämä sivu auki, kunnes lähetys on valmis.',
    translation_order_wait_for_upload: 'Odota, kunnes liitteet on lähetetty.',
    translation_order_cancelled_successfully: 'Käännöstilaus peruutettu onnistuneesti',
    translation_order_attachment_upload_failed: 'Liitteen lataus epäonnistui',
    translation_order_submit_failed: 'Tilauksen luonti epäonnistui',
    translation_order_cancel_failed: 'Tilauksen peruutus epäonnistui',
    translation_mark_completed: 'Merkitse valmiiksi',
    translation_mark_completed_success: 'Käännös merkitty valmiiksi',
    translation_mark_completed_failed: 'Käännöksen merkitseminen valmiiksi epäonnistui',
    translation_change_status: 'Muuta',
    translation_task_completed: 'Tehtävä valmis',
    translation_revert_completed_failed: 'Tilan palautus epäonnistui',
    translation_order_from_language_required: 'Lähdekieli on pakollinen',
    translation_order_to_language_required: 'Kohdekieli on pakollinen',
    translation_order_languages_must_differ: 'Lähde- ja kohdekielen tulee olla eri',
    translation_order_files_required: 'Lataa vähintään yksi tiedosto',
    translation_order_scope_required: 'Arvioitu laajuus on pakollinen',
    translation_order_scope_type_required: 'Laajuuden tyyppi on pakollinen',
    translation_order_delivery_date_required: 'Toivottu toimituspäivä on pakollinen',
    translation_order_delivery_date_too_far: 'Toivotun toimituspäivän on oltava alle 5 vuotta tulevaisuudessa',
    translation_order_translator_type: 'Millaisen kääntäjän tarvitset?',
    translation_order_translator_type_required: 'Valitse vähintään yksi kääntäjätyyppi',
  },

  en: {
    no_orderable_contract: 'No contract is available for your languages. Please contact support.',
    no_translation_contract: 'None of your contracts allow translation orders. Please contact support.',
    ai_interpreter: 'AI Interpreter',
    ai_cost_center: 'Cost center',
    ai_target_language: 'Target language',
    ai_alt_cost_order: 'Alt. cost / order',
    invoice_ref: 'Invoice ref',
    ai_download_transcript: 'Download transcript',
    ai_download_summary: 'Download summary',
    ai_transcription: 'Transcription',
    ai_summary: 'Summary',
    ai_send_email: 'Send email',
    ai_send_email_title: 'Send transcript by email',
    ai_send_email_explanation: 'Enter the email address the transcript will be sent to.',
    ai_include_summary: 'Include summary',
    ai_email_subject_placeholder: 'Your reference for email subject (optional)',
    ai_search_placeholder: 'Search AI interpretation assignment',
    ai_no_sessions: 'No AI interpretation sessions yet',
    ai_download_retention: 'Transcripts and summaries are available to download for 24 hours after the interpretation ends.',
    ai_download_unavailable: 'This file is no longer available.',
    ai_download_forbidden: 'You do not have permission to access this file.',
    ai_download_timeout: 'The file is still being generated, please try again shortly.',
    ai_email_sent: 'Email sent.',
    ai_email_failed: 'Failed to send the email.',
    ai_email_invalid: 'Invalid email address.',
    ai_email_domain_not_allowed: 'This email domain is not allowed.',
    ai_allowed_email_domains: 'Allowed email domains:',
    ai_own_email_only: 'The transcript can only be sent to your own email address.',
    please_wait: 'Please wait...',
    done: 'Done',
    fin: 'Finnish',
    eng: 'English',
    nor: 'Norwegian',
    swe: 'Swedish',
    dan: 'Danish',
    fra: 'French',
    cze: 'Czech',
    hrv: 'Croatian',
    sqi: 'Albanian',
    ben: 'Bengali',
    amh: 'Amharic',
    bul: 'Bulgarian',
    nld: 'Dutch',
    ara: 'Arabic',
    deu: 'German',
    urd: 'Urdu',
    mya: 'Burmese',
    mieli: 'Mieli',
    mainio: 'Mainio',
    ccb2b: '📞 Contact customer service',
    testb2b: '📞 Testaa / Yhteys asiakaspalveluun',
    vls: 'Flemish',
    ckb: 'Sorani',
    nep: 'Nepali',
    prs: 'Dari',
    hurja: 'Hurja',
    lao: 'Lao',
    no_language_selected: 'No language selected',
    ui_language: 'User interface language',
    close: 'Close',
    error: 'Error',
    missing_data: 'Missing data',
    // feedback
    failed_to_find_prebooking_data: 'Failed to find this prebooking',
    prebooking_was_cancelled: 'This prebooking was cancelled',
    feedback_not_open_yet: 'As the interpretation hasn\'t taken place yet, you are unable to leave us feedback at this time.',
    how_did_we_do: 'How was your experience?',
    stars_rating_subtitle: 'Your feedback helps us to improve our service.',
    where_can_we_improve_upon: 'How could we improve?',
    leave_open_feedback: 'Give free text feedback',
    describe_your_experience_here: 'Tell what happened in your own words',
    i_wish_to_be_contacted: 'Please contact me',
    choose_one_or_more_options: 'Choose one or more options',
    thank_you_for_your_feedback: 'Thank you for your feedback!',
    // customer guide for od-call (modal)
    if_neither_number_works: ' If neither number works, enter the service number in the following format:',
    order_an_interpreter_by_calling_the_number: 'Order an interpreter by calling the number',
    main_calling_number: '041 400 1234',
    main_calling_number_with_code: '*31# 041 400 1234',
    main_calling_number_with_zero: '0041 400 1234',
    phone_must_be_registered: 'The phone you use to call our emergency number must be registered in our system.',
    note: 'Note!',
    number_is_encrypted: ' If your number is encrypted, enter the service number in the following format:',
    attention_for_hus: 'Attention HUS wired network operators!',
    contact_to_customer_service: 'In case of problems, contact our customer service.',
    select_interpreter_language: 'After the call is connected, select the language to be interpreted from the following by entering the number using the phone\'s number keys',
    accept_incoming_prebookings: 'Accept or decline incoming prebookings',
    accept: 'Accept',
    decline: 'Decline',
    accept_all: 'Accept all',
    date_and_time: 'Date and time',
    duration: 'Duration',
    language: 'Language',
    presence: 'Presence',
    prebookings_already_checked: 'Prebookings already checked',
    username_not_unique: 'Login email is not unique.',
    new_username_set: 'New username set: ',
    // LUONA
    luonaSignupForm: 'Signup form',

    label_name: 'First name and last name',
    placeholder_name: 'Latin letters only',
    validate_name: 'More than 3 characters',

    label_phone: 'Phone',
    placeholder_phone: '+3XXXXXXXXXXX',
    validate_phone: 'mobile phone number in format: +XXXXXXXXXXXX',

    label_email: 'Email',
    placeholder_email: 'user@mail.com',
    validate_email: 'email in format: user@mail.com',

    label_city: 'City',
    placeholder_city: 'City name',
    validate_city: 'Only latin letters',
    selectOption: 'Select city',

    agreePrivacyPolicy: 'I agree with ',
    privacyPolicy: 'privacy policy',
    luonaSignupButton: 'Send',
    requestErrorMessage: 'Something went wrong, please try again!',
    minimalPrebookingTimeBumperError: 'Prebooking time is too soon. Please select another time.',
    minimalPrebookingOnSiteTimeBumperError: 'On-site interpretation start time is too soon. Please select another date and time.',
    new_password_success: 'New password successfully added',
    new_password_wrong: 'Old password not found',
    requestErrorMessageUserNotFound: 'Enter the registered phone number and email address.',
    requestErrorMessageUserExist:
      'Provided email or phone number is already in use, please try another one.',
    slot_not_free_anymore: 'Sorry, selected time slot is unavailable anymore',
    no_interpreter_in_prebooking: 'No interpreter in prebooking',
    back_to_telegram: 'Back to Telegram',
    what_is_your_language: 'Hello, What is your language',
    what_you_need_help_with: 'What do you need help for?',
    selectable_langs: 'Language',
    selectable_servises: 'Services',
    selectable_time: 'Time',
    selectable_interpreter: 'The consultation language is English or Finish. Do you need an interpreter?',
    authtorize: 'Authorization',
    choose_time: 'Please choose the time for your prebooking',
    prebook_not_available_message: 'Unfortunately, this service is unavailable right now. The working time:  Monday to Friday {SCHEDULE}',
    health: 'Health',
    work_or_study: 'Work or studying',
    money_or_livelihood: 'Money or livelihood',
    reception_allowance: 'Reception allowance / PFS card',
    my_money_is_not_enough: 'Running out of money',
    copy_email: 'Copy email',
    successfully_copied: 'E-mail successfully copied',
    copied_to_clipboard: 'Copied to clipboard',
    other_practical_matters: 'Other practical topic',
    thanks_for_booking: 'Thank you for your reservation.',
    prebook_created_at: 'Your video meeting has been confirmed as following:',
    prebooking_skill: 'Issue:',
    you_need_high_network: 'To ensure the quality of the meeting, please make sure you have a stable and fast network connection, enough for video conference.',
    you_will_got_accept: 'You will receive a booking confirmation and two reminders by text message and email.',
    message_with_link_to_meeting: 'The messages contain a link from which you can get to the meeting at the agreed time.',
    dont_forget_decline_prebooking: 'Remember to cancel the meeting if you are not able to participate.',
    for_decline_need: 'You can do it in:',
    click_for_decline_prebooking: 'and then click on DELETE button on your pre-booking.',
    best_regards: 'Kindest wishes,',
    luona_DigiVOK: 'Luona DigiVOK',
    emigration_or_holiday_outside_Finland:
      'Emigration or vacation outside Finland',
    free_time: 'Leisure time',
    housing: 'Living',
    child_care: 'Child',
    child_health: 'Health',
    upbringing_parenting: 'Upbringing/Parenthood',
    kindergarten_or_school: 'Daycare or school',
    reception_centre_info_service: 'Reception centre info service',
    physical_or_mental_symptoms: 'Health',
    related_to_money_or_livelihood: 'Financial security',
    related_to_your_own_or_family_life_situation:
      'Circumstances related to myself or my family',
    legal_matter: 'Legal affair',
    everyday_practical_things: 'Daily, everyday practical things',
    service_housing: 'Living',
    how_do_you_judge_the_criticality_of_your_case:
      'How do you rate the criticality of your case?',
    help_need_today: 'Urgent, should be taken care of during today',
    help_need_in_couple_of_days: 'Urgent, but can wait for few days',
    help_is_not_urgent: 'Not urgent',
    call_now: 'Call now',
    book_an_appointment: 'Book an appointment',

    help_need_in_week: 'Help need during week',
    authtorize_yourself: 'Authtorize yourself',
    user_successfully_registered: 'Authorization is successful',
    book_time: 'Book Time',
    what_time_works_for_you: 'What time works for you?',
    wizard_default_message:
      'If the situation is life threatening, call 112. If your health concern cannot wait till the next working day, call 116117 for advice. If you have another acute crisis, call the social crisis service of your municipality.',
    wizard_welcome_message:
      'Welcome to Luona service! We are going to do everything that we can to help you. How we can help you?',
    wizard_PrebookingStep_header:
      'We strive to deal with situations immediately. If all our employees are booked, you will have the opportunity to book an appointment through this. Would you like to book an appointment or call right now?',
    wizard_TimeStep_header:
      'Unfortunately, no one was able to answer now. You can book time from here.',
    // LUONA

    loginTitle: 'Sign in',
    username: 'Username',
    password: 'Password',
    loginButton: 'Sign in',
    loginFailed: 'Signin failed',
    sessionExpired: 'Session has expired. Please sign in again.',
    meeting_closed: 'Meeting was closed.',
    signin_code_block_message: 'This e-mail is already used before. We sent the verification code to your e-mail address: [email]. Please enter the verification code in the field below. ',
    placeholder_signin_code: 'code',
    close_meeting_confirmation_message: 'Are you sure that you want to leave the call? For all participants, this call will be closed too',
    internet_connection_lost: 'Lost internet connection',
    internet_connection_exist: 'Restored internet connection',
    errorTitle: 'Oops!',
    warnTitle: 'Hmmm...',
    successTitle: 'Great!',

    selectLanguage: 'Choose language',
    interpreter: 'Interpreter',
    startInterpreting: 'Interpret',
    requestInterpreting: 'Request interpretation',

    interpretationNeeded: 'Interpretation needed',
    requestForInterpretation: 'Interpretation is needed!',
    requestForCall: 'Customer is contacting',
    nothingToInterpret: 'All requests have been answered.',
    noInterpretationNeeded: 'All requests have been answered.',

    doYouWantToHangUp: 'Do you really want to hang up?',
    oppositeSideHangsUp: 'The other person has left the conversation.',
    networkTerminated: 'The conversation was disconnected.',
    review: 'Review',
    customerFeedbackEnjoyingTulka: 'Satisfied with the service?',
    customerRatingInterpreter: 'My feedback about interpreter',
    customerInvoiceNotes: 'Invoice reference',
    deviation: 'Deviation',
    deviation_resolution: 'Deviation resolution',
    deviation_must_be_resolved_before_confirming: 'The deviation must be resolved before this can be confirmed.',
    interpreterRatingInterpreter: 'How did it go?',
    interpreterRatingCustomer: 'How well did I do?',
    ratingQuality: 'Technical quality',
    feedback: 'Feedback',
    feedbackDesc: 'Write your comments here',
    feedbackContactMe: 'Please contact me',
    proceed: 'Send',
    skip: 'Skip',

    endCall: 'End call',
    refresh: 'Refresh',
    logout: 'Log out',
    toggleCamera: 'Toggle camera',
    toggleAudio: 'Toggle audio',

    onlyChromeSupported: 'Browser not supported',
    pleaseUseChrome: 'Please install Google Chrome to use Túlka Web App',
    downloadChrome: 'Click here to install',
    continueInterpretation: 'Continue interpretation',
    roomInfoCallEndedClosed: 'Server closed the conversation.',
    feedbackTooLate: 'Continue option no longer available!',

    noTimeLeft: 'The demo use has ended. We`ll contact you soon!',
    minutesConsumed: 'The demo use has now ended. We`ll contact you soon!',
    timeLeft: 'Interpretation time left: {}',
    zeroTimeLeft: 'The demo use has ended.\nWe`ll contact you soon!',
    freeUseLeft: 'Time left',

    failedToSendFeedback: 'Failed to send feedback!',
    failedLogOut: 'Failed to log out.',
    failedToCreateChatroom: 'Failed to start an interpretation!',
    failedToConnect: 'Failed to connect to server.',
    waitingForInterpreter:
      'Your request was sent to the interpreters. The waiting time is usually 1 to 3 minutes.',
    waitingForCustomer: 'Waiting for customer...',
    waiting_time: 'Waiting time is',
    pleaseWait: 'Please wait...',
    youHaveWaitedFor: 'You`ve waited {}',
    error500: 'Something went wrong. Please try again.',
    roomInfoHasAudioPacketLoss: 'Bad Connection!',

    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',

    // Attachment feature
    attachment_status_pending: 'Processing...',
    attachment_status_converting: 'Converting to PDF...',
    attachment_status_conversion_failed: 'Conversion failed',
    attachment_fetch_error: 'Failed to load attachment info',
    attachment_conversion_in_progress: 'File is being converted. Please wait...',
    attachment_conversion_failed_download: 'Cannot download - conversion failed. Please upload a different file.',
    attachment_deleted: 'Attachment has been deleted.',
    attachment_download_error: 'Failed to download attachment',
    attachment_delete_forbidden: 'You do not have permission to delete this attachment.',
    attachment_delete_error: 'Failed to delete attachment',
    attachment_upload_failed: 'Prebooking created but attachment upload failed. You can try uploading again later.',
    attachment_upload_partial_failed: 'Attachment upload failed for some bookings. Please retry.',
    attachment_empty_file: 'File is empty',
    attachment_invalid_type: 'Invalid file type. Allowed: PDF, DOCX, PPTX, TXT, PNG, JPG.',
    attachment_file_too_large: 'File is too large',
    customer_documents: 'Customer Documents',
    attachment_select_file: 'Select document',
    attachment_help_text: 'Supported formats: PDF, DOCX, PPTX, TXT, PNG, JPG (max 5MB). Document will be visible to the assigned interpreter.',
    no_attachment: 'No document attached',
    attachment_not_ready: 'File not ready for download',
    attachment_preview_error: 'Failed to load attachment preview',
    download: 'Download',
    delete_attachment: 'Delete attachment',
    delete_attachment_title: 'Delete Attachment?',
    delete_attachment_confirm: 'Are you sure you want to delete this file? This action cannot be undone.',
    delete: 'Delete',

    default: 'Default',
    termsOfUse: 'Terms of use & Privacy policy',
    options: 'Show options',
    hideOptions: 'Hide options',

    enable_notifications: 'Enable notifications',
    disable_notifications: 'Disable notifications',
    disable_duration: 'Disable notifications for',
    for_hour: '1 hour',
    for_day: '1 day',
    for_week: '1 week',
    for_month: '1 month',
    for_a_day: '1 day',
    for_days: '{} days',
    for_a_day_an_hour: '1 day, 1 hour',
    for_a_day_hours: '1 day, {} hours',
    for_days_an_hour: '{} days, 1 hour',
    for_days_hours: '{d} days, {h} hours',
    notifications_disabled_for: 'Notifications disabled for\n{}',
    failed_to_disable_notifications:
      'Failed to disable notifications. Please try again later.',
    failed_to_enable_notifications:
      'Failed to enable notifications. Please try again later.',
    forgot_password_link: 'Forgot your password?',
    forgot_password_info:
      'If you have an account, we can send you a new password via SMS or email. In other cases contact {infoEmail}.',
    placeholder_phone_number: '+35840...',
    phone_number_title: 'Phone number',
    forgot_password_error:
      'The SMS or e-mail could not be sent. Please contact {infoEmail}',
    forgot_password_duplicate_email_error:
      'Your password cannot be reset. Please contact customer service.',
    forgot_password_success:
      'Thank you. You should receive your password via SMS or e-mail shortly.',
    skillModalQuestion:
      'Do you need this experience? The waiting time may be longer.',
    od_type_title: 'What type of interpreter?',
    od_type_ai: 'AI',
    od_type_ai_subtitle: 'AI interpreter',
    od_type_human: 'Human',
    od_type_human_subtitle: 'Human interpreter',
    select_customer_gender: 'Specify gender for youself and your customer',
    your_gender: 'Your gender',
    customer_gender: 'Customer’s gender',
    male: 'Male',
    female: 'Female',
    male_interpreter: 'Male interpreter',
    female_interpreter: 'Female interpreter',
    invoice_cause_title: 'Invoice breakdown',
    invoice_cause_subtitle: 'Please select the invoice breakdown value.',
    customer_reference_title: 'Additional invoicing information',
    targetLanguage: 'Language you understand',
    openingTimes: '',
    systemAlert: 'Technical issues with the service. Our apologies.',

    chatFailed: 'Failed to connect to text chat.',
    chatTipInterpreter:
      'Here you can chat with the customer. All messages are destroyed immediately when the interpretation ends.',
    chatTipCustomer:
      'Here you can chat with the interpreter. All messages are destroyed immediately when the interpretation ends.',
    chatSendFailed: 'Failed to send the message.',
    chatTypeMessage: 'Type a message...',
    invoiceRefMandatory: 'Invoice reference is a mandatory field.',
    invoiceRefUserGroupMandatory: 'Please select a recipient for the invoice.',
    selectInvoiceRefUserGroup: '-- Select --',

    show_feedbacks: 'Ratings',
    show_feedbacks_title: 'How I was rated',
    failedToFetchFeedbacks: 'Failed to fetch the ratings.',
    statistics: 'My interpretations',
    no_statistics: 'No statistics available.',
    stats_disclaimer:
      'The numbers are only estimates and may not exactly match the final pay slip.',
    stats_today: 'Today',
    stats_yesterday: 'Yesterday',
    stats_this_week: 'This week',
    stats_last_week: 'Last week',
    stats_this_month: 'This month',
    stats_last_month: 'Last month',
    stats_this_year: 'This year',
    stats_last_year: 'Last year',

    feedbackButton: 'Tap to write comments',
    feedback_already_exist: 'Feedback is closed',
    feedback_need_to_leave: 'Feedback is open',
    feedback_do_next: 'You may now close this tab.',
    chatroom_not_exist: 'Feedback not yet open',

    // Prebooking
    prebook: 'Prebooked Interpretation',
    prebooking_date_header: 'When do you need an interpreter?',
    prebooking_date_header_notice: 'Last date for the message to be delivered',
    step: '{step} of {steps}',
    choose_button: 'Select',
    prebooking_duration_header:
      'How long do you think you need an interpreter?',
    hours_minutes: '{h}:{m}',
    hour_minutes: '{h}:{m}',
    minutes: '{} min',
    hour: '60 min',
    hours: '{}:00',
    customer_reference: 'Additional invoicing information',
    customer_reference_placeholder: 'The field information is not visible to the interpreter',
    please_provide_customer_reference: 'Please provide additional information.',
    prebooking_time_header: 'At what time do you need an interpreter?',
    select_language_title: 'What should be the interpreter language?',
    fetching_languages: 'Fetching languages...',
    invoice_cause: 'Cost Allocation',
    invoice_cause_description: 'Please select appropriate cost center',
    invoice_ref_placeholder: 'NOTE! Customer service does not read this.',
    call_type_video: 'Video',
    call_type_call: 'Call',
    call_type_question: 'Please choose the connection type',
    additional_order_info: 'Additional order information',
    confirm_prebooking: 'Please check the booking details.',
    comment: 'Necessary additional information for order handler',
    prebooking_date: 'Date',
    prebooking_time: 'Time',
    prebooking_duration: 'Duration',
    language_title: 'Language',
    presence_title: 'Presence',
    call_type_title: 'Call type',
    select_target_language_title: 'What is your language?',
    location_question: 'What is the location?',
    location_placeholder_city: 'City',
    location_placeholder_address: 'Street address',
    location_placeholder_postcode: 'Postcode',
    add_message_to_interpreter: 'Add message to interpreter',
    subject: 'Subject',
    url_for_video_meeting: 'URL/link to video meeting',
    url_for_video_meeting_label: 'URL/link',
    interpretation_location_details: 'Arrival instructions at the location (e.g. accessibility information, office, stairs, floor, room, etc.)',
    address_info: 'Address information',
    arrival_instructions: 'Arrival instructions',
    addressAndArrivalInstrustions: 'Address and arrival instructions',
    preferred_interpreters_question: 'Would you like to select a preferred interpreter?',
    search_preferred_interpreter: 'Find interpreter by name',
    not_guarantee: 'We do our best to get the wished interpreter, but cannot guarantee that he/she is available.',
    history_is_limited: 'The search result is limited because you haven\'t used many interpreters yet.',
    presence_question: 'What type of interpretation?',
    presence_remote: 'Remote',
    presence_remote_tip: 'Via video or call using the app',
    presence_on_site: 'On-site',
    presence_on_site_tip: 'Interpreter physically present',
    presence_notice: 'Announcement interpretation',
    presence_notice_tip: 'Written message delivered as spoken interpretation',
    select_favorite: 'Want to select preferred interpreters?',
    any_favorite: 'No preference',
    call_type_call_tip: 'Voice only using a phone call',
    call_type_video_tip: 'Voice and image using mobile data',
    target_language_title: 'Your working language',
    invoice_ref_title: 'Invoice tag',
    save_prebooking: 'Book',
    edit_prebooking: 'Save',
    any_gender: 'Does not matter',
    any_dialect: 'No specific needs',
    gender_title: 'Gender',
    dialect_title: 'Dialect',
    select_skill: 'Any special needs for the interpreter?',
    select_dialect: 'Do you need a specific dialect?',
    select_qualification: 'Do you need special qualifications?',
    select_gender: 'Does the interpreter gender matter?',
    any_skill: 'No special needs',
    any_qualification: 'No special qualifications',
    security_cleared: 'Security cleared',
    skill_title: 'Special needs',
    unconfirmed_prebooking: 'Pending confirmation',
    confirmed: 'Confirmed',
    delivered: 'Delivered',
    not_able_to_reach: 'Not able to reach',
    cancelled: 'Cancelled',
    ongoing_prebooking: 'Ongoing',
    report_deviation: 'Report deviation',
    active: 'Active',
    location_title_city: 'City',
    location_title_address: 'Street address',
    // Help tooltips
    help_prebooking_summary_title: 'Write here only necessary additional information for order handler',
    help_prebooking_summary:
      'Note that filling this field will prolong processing time of the order.',
    help_call_type_title: 'Interpretation connection',
    help_call_type:
      'With a telephone interpretation you are able to join people who are in different locations (conference call).\n\nIn a video interpretation, people can see each others, and you can also show some text to the interpreter to translate. Video can be enabled or disabled any time during the interpretation.\n\nYou can change the interpretation connection by ending the interpretation and selecting \'Continue interpreration\'.',
    help_gender_title: 'Interpreter gender',
    help_gender:
      'You can request an interpreter of a specific gender. Please note that the selection may result a smaller number of available interpreters and make it less likely to get one.',
    help_dialect_title: 'Interpreter dialect',
    help_dialect:
      'You can request an interpreter who knows a specific dialect of the selected language. Please note that the selection may result a smaller number of available interpreters and make it less likely to get one.',
    help_confirmation_title: 'Confirm your default cost center',
    help_confirmation:
      'Your orders will be allocated by default to your default cost center, unless you specify an alternative cost center while placing the order.',
    tomorrow: 'Tomorrow',
    today: 'Today',
    now: 'Now',
    help_location_title: 'Location',
    help_location:
      'Type the location of the interpretation. This can be an address or other identifier.',
    help_favorites_title: 'Preferred interpreters',
    help_favorites:
      'You can select one or more of you favorite interpreters as the preferred interpreters. If one of the favorites is available he/she will be assigned to the interpretation.',
    on_site_not_available_in_app:
      'On-site interpretation cannot be started from the app.',
    searching_interpreter: 'Looking for interpreter',
    please_call_to_this_number: 'Please, call to this number',
    back: 'Back',
    rejoin_meeting: 'Rejoin meeting',
    change_language: 'Change language',
    prebook_successfully_created: 'Prebooking successfully created',
    prebook_successfully_edit: 'Prebooking successfully updated',
    prebook_successfully_cancelled: 'Prebooking successfully cancelled',
    prebook_successfully_accepted: 'Prebooking successfully accepted',
    prebooking_details: 'Prebooking details',
    select_contract_title: 'Select contract',
    select_contract_subtitle: 'Choose the contract to use for this order.',
    prebook_confirmation_message:
      'Are you sure that you want to abort prebooking?',
    cancel_prebook_confirmation_message:
      'Are you sure that you want to cancel prebooking?',
    really_cancel_prebooking_too_late:
      'Are you sure that you want to cancel prebooking? At this stage, cancelling is not free.',
    cancel_reason_selection: 'What is the reason for cancelling?',
    cancel_reason_sickness: 'Own sickness',
    cancel_sickness_tip: 'Medical certificate required',
    cancel_reason_mistake: 'Mistake',
    cancel_reason_other: 'Other',
    cancel_reason_other_tip: 'A free text explanation required.',
    cancel_other_title: 'Explanation',
    cancel_other: 'Tell us what happened?',
    cancel_sickness_title: 'Medical certificate',
    cancel_sickness: 'Please send a medical certificate of the sickness.',
    copy_information: 'Copy Information',
    my_bookings: 'Bookings',
    interpreter_now: 'Interpreter now',
    pre_book: 'Prebooked Interpretation',
    order: 'Order',
    hero_order_interpretation: 'Interpretation',
    hero_order_translation: 'Translation',
    book_interpretation: 'Book interpretation',
    time: 'Time',
    status: 'Status',
    search: 'Search',
    // Prebooking section titles and mode of interpretation
    details: 'Details',
    preferences: 'Preferences',
    invoicing_and_assignment_details: 'Invoicing and assignment details',
    invoicing: 'Invoicing',
    cost_allocation: 'Cost allocation',
    prebooking_vat_question: 'VAT',
    prebooking_vat_applied: 'VAT applied',
    prebooking_vat_exempt: 'VAT exempt',
    customer_information: 'Customer information',
    customer_number: 'Customer number',
    order_made_by: 'Order made by',
    ordering_unit: 'Ordering unit',
    contract_label: 'Contract',
    additional_invoicing_information: 'Additional invoicing information',
    field_not_visible_to_interpreter: 'The field information is not visible to the interpreter',
    customer_name_for_invoice: 'Customer name (for invoice)',
    date_of_birth_for_invoice: 'Date of birth(for invoice)',
    recipients_of_confirmation_and_change_notifications: 'Recipients of confirmation and change notifications',
    additional_information_for_order_handler: 'Additional information for order handler',
    note_filling_this_field_will_prolong_processing_time: 'Note that filling this field will prolong processing time of the order.',
    at_least_one_email_required: 'At least one email is required',
    summary: 'Summary',
    back_to_edit: 'Back to edit',
    confirm_order: 'Confirm order',
    submitting: 'Submitting...',
    mode_of_interpretation: 'Mode of interpretation',
    phone_call: 'Phone call',
    phone_call_tip: 'Voice only using a phone call',
    video_call: 'Video call',
    video_call_tip: 'Voice and image using mobile data',
    conference_call: 'Conference call',
    conference_call_tip: 'e.g. Microsoft Teams, Skype, Google Meet, Zoom. The video link may be entered in the "Information to the Interpreter" field, or it can be sent to the interpreter later. Please note that timely delivery is your responsibility.',
    video_call_made_via_tulka_app: 'Video call made via Tulká app',
    video_call_interpretation: 'Video call interpretation',
    conference_interpretation: 'Conference interpretation',
    Remote: 'Remote',
    remote: 'Remote',
    on_site: 'On-site',
    presence_onsite: 'On-site',
    announcement: 'Announcement',
    start_time: 'Start time',
    end_time: 'End time',
    add_another: 'Add another',
    does_not_matter: 'Does not matter',
    no_choice: 'No choice',
    highest: 'Highest',
    // New prebooking form keys
    select: 'Select',
    select_notice: 'What the interpreter should convey to the user',
    required: 'Required',
    language_required: 'Language is required',
    interpreted_and_target_language_must_differ: 'Interpreted language and target language must be different',
    call_type_required: 'Call type is required',
    street_address_required: 'Street address is required',
    city_required: 'City is required',
    post_code_required: 'Postal code is required',
    message_content_required: 'Message content is required',
    customer_name_required: 'Customer name is required',
    date_of_birth_required: 'Date of birth is required',
    phone_number_required: 'Phone number is required',
    delivery_time: 'Delivery time',
    date_required: 'Date is required',
    date_too_far_in_future: 'The date must be less than 5 years in the future',
    time_required: 'Time is required',
    duration_required: 'Duration is required',
    at_least_one_time_slot_required: 'At least one time slot is required',
    street_address: 'Street address',
    post_code: 'Post code',
    city: 'City',
    arrival_instruction_at_location: 'Arrival instructions at the location',
    message_content: 'Message content',
    message_max_length_info: 'The maximum length of the message is 1000 characters.',
    last_delivery_date: 'Last date for the message to be delivered',
    delivery_date_info: 'The interpreter will call the provided number by the end of the selected day.',
    interpreter_gender: 'Interpreter gender',
    competence_level_special_need: 'Competence level / special need for interpreter',
    competence_level_helper_text: 'All levels are included by default. Click to deselect levels you do not wish to use. Please note that the selection of available interpreters will be reduced if you deselect any competency levels.',
    authorized_interpreter: 'Authorized interpreter',
    court_legal_interpreter: 'Court/legal interpreter',
    healthcare_interpreter: 'Healthcare interpreter',
    registered_trained_interpreter: 'Registered trained interpreter',
    other_interpreters: 'Other interpreters',
    other_interpreter_level: 'Unqualified interpreter',
    let_system_choose_highest_qualified: 'Let the system choose the highest qualified interpreter',
    experiences: 'Requirements',
    security_cleared_interpreter: 'Security cleared interpreter',
    additional_preferences: 'Additional preferences',
    open: 'Open',
    hide: 'Hide',
    request_preferred_interpreter: 'Request preferred interpreter',
    exclude_specific_interpreters: 'Exclude specific interpreter(s)',
    interpreters_found_for_your_selections: 'interpreters found for your selections',
    how_to_handle_no_onsite_interpreter: 'How would you like us to handle case interpreter is not found for on-site?',
    assign_remote_interpreter: 'Assign remote interpreter',
    cancel_booking: 'Cancel booking',
    // Preferences section keys
    preferences_title: 'Preferences',
    preferences_interpreter_gender: 'Interpreter gender',
    preferences_onsite_fallback: 'How would you like us to handle case interpreter is not found for on-site?',
    preferences_accept_beyond_km: 'Do you accept an interpreter beyond contractual limit of {} km one way?',
    preferences_km_beyond_limit: 'By how many kilometers would you accept to go beyond the limit of {} km one way?',
    preferences_total_max_distance_label_one_way: 'Total maximum distance: {} km one way',
    preferences_total_max_distance_unlimited: 'Total maximum distance: unlimited',
    unlimited: 'Unlimited',
    km_unit: 'km',
    accepts_interpreters_within_km: 'ACCEPTS INTERPRETERS WITHIN ${distance} KM',
    preferences_fallback_assign_remote: 'Assign remote interpreter',
    preferences_fallback_cancel: 'Cancel booking',
    preferences_additional_preferences: 'Additional preferences',
    preferences_preferred_interpreter: 'Request preferred interpreter',
    preferences_excluded_interpreter: 'Exclude specific interpreter(s)',
    preferences_search_placeholder: 'Search interpreter by name...',
    preferences_ukrainian_russian_fallback: 'If a Ukrainian speaking interpreter is not available, can we assign a Russian speaking interpreter?',
    preferences_alternative_language_fallback: 'If a {0} speaking interpreter is not available, can we assign a {1} speaking interpreter?',
    preferences_accept_lower_level: 'If interpreter at requested level is not available, accept lower level?',
    preferences_remote_backup_connection_type: 'Preferred connection type for remote backup',
    preferences_remote_backup_phone: 'Phone call',
    preferences_remote_backup_video: 'Video call',
    preferences_remote_backup_conference: 'Conference call',
    interpreted_language: 'Interpreted language',
    favorite_title: 'Preferred interpreters',
    no_prebookings: 'You don`t have any prebookings.',
    prebooking_not_active: 'Your contract does not include prebooking.',
    reservation_number: 'Order number',
    external_order_id: 'order identifier',
    email: 'E-mail',
    not_yet_support_interpreter_login:
      'The new web app does not yet support interpreter login. Please use the mobile app.',
    please_try_again_later: 'Please try again later.',
    no_languages: 'No languages',
    interpreter_phone_number: 'Interpreter phone number',
    remove: 'Delete',
    presence_conference: 'Conference / virtual room',
    presence_conference_tip: 'e.g. Microsoft Teams, Skype, Google Meet, Zoom',
    interpreter_email: 'Interpreter email',
    all: 'All',
    invoice_user_group: 'Cost center',
    cc_emails: 'Confirmation and change notifications recipients',
    cc_email: 'E-mail address',
    cc_emails_copy: 'Сonfirmation and change notification recipients',
    information_for_interpreter: 'Information for interpreter',
    patient_name: 'Your client\'s name who needs the interpreter',
    reference_document: 'Reference document',
    upload_reference_document_optional: 'Upload reference document (optional)',
    browse_files: 'Browse files',
    only_pdf_format_file_visible_to_interpreter: 'Only PDF format. File is visible only to the assigned interpreter.',
    field_information_not_visible_on_bill: 'The field information is not visible on the bill',
    patient_name_description: 'This information does not appear on the bill, but goes to the interpreter for information, e.g. in case of detention.',
    customer: 'Customer',
    customer_unit: 'Unit',
    personal: 'Personal',
    search_for: 'Search for unit, language, cost center or customer',
    failed_to_create_prebooking:
      'Failed to create a new prebooking. Please try again later.',
    failed_to_create_all_prebookings: 'Failed to create all prebookings',
    slot: 'Slot',
    succeeded: 'succeeded',
    failed: 'failed',
    to_start_interpretation:
      'To start interpretation please call to this number:',
    start_interpretation: 'Start Interpretation',
    hey_username: 'Hey {username},',
    confirm_your_account_information: 'Confirm your account information',
    confirm_your_account_information_description:
      'In order to provide the smoothest possible service, we ask you to confirm or correct the information below regarding your profile',
    other: 'Other',
    no_options: 'No search results',
    search_message: 'Search...',
    i_confirm_the_information: 'I CONFIRM THE INFORMATION',
    billing: 'Invoicing',
    translations: 'Translations',
    order_translation: 'Order translation',
    translation_order_number: 'Order #',
    translation_order_date: 'Order Date',
    translation_from: 'From',
    translation_to: 'To',
    translation_username: 'Translator',
    translation_delivery: 'Delivery',
    translation_user_group: 'User group',
    translation_customer: 'Customer',
    translation_status: 'Status',
    translation_status_new_order: 'New order',
    translation_status_in_progress: 'In progress',
    translation_status_assigned: 'Assigned',
    translation_status_completed: 'Completed',
    translation_status_cancelled: 'Cancelled',
    translation_status_delivered: 'Delivered',
    translation_customer_id: 'Customer ID',
    translation_file_name: 'File name',
    translation_estimated_count: 'Estimated count',
    translation_due_date: 'Due date',
    translation_assigned_jobs: 'List of Assigned Jobs Due',
    translation_order: 'Translation order',
    translation_details: 'Details',
    translation_customer_information: 'Customer information',
    translation_invoicing: 'Invoicing',
    translation_from_language: 'From',
    translation_to_language: 'To',
    translation_desired_delivery_date: 'Desired delivery date',
    translation_instructions: 'Instructions/notes for translator',
    translation_estimated_total: 'Estimated total (words)',
    translation_estimated_scope: 'Estimated scope',
    translation_materials: 'Materials for translation',
    translation_customer_number: 'Customer number',
    translation_order_made_by: 'Order made by',
    translation_ordering_unit: 'Ordering unit',
    checking_your_billing_information: 'Checking your billing information',
    billing_page_main_sub_header:
      'Check that the interpretation is for the correct cost center / unit and that the billing reference information is in accordance with the instructions',
    interpreter_reported_duration: 'Interpreter Reported duration',
    update: 'Update',
    update_prebook: 'Update prebooking',
    your_changes_will_be_lost:
      'Are you sure you want to cancel? Your changes will be discarded.',
    settings: 'Settings',
    user_home_group_header: 'Home user group',
    app_country: 'Country',
    address: 'Address',
    country_placeholder: 'Select country',
    update_settings: 'Save settings',
    has_car: 'I have a car',
    profile_options: 'Profile options',
    no_invoice_reference: 'No invoice reference',
    no_user_group_selected: 'No user group selected',
    prebook_successfully_updated: 'Invoicing information confirmed',
    type_search_term_here: 'Type search term here',
    verify: 'Confirm',
    prebookings_successfully_updated: 'Invoicing information confirmed',
    alternative_cost_center: 'Alternative cost center or order number',
    alternative_cost_center_edit:
      'Edit alternative cost center or order number',
    choose_default_cost_center: 'Choose default cost center',
    enter_or_confirm_username: 'Enter or confirm the email used for login',
    enter_or_confirm_email: 'Enter or confirm an e-mail address to which booking confirmations and change notifications for booked interpretations are automatically sent',
    you_can_change_this_information_at_any_time:
      'You can change this information at any time from the “Settings” menu',
    edit: 'Edit',
    change_reservation: 'Change',
    copy_reservation: 'Copy',
    change_reservation_description: 'Change reservation',
    copy_reservation_description: 'Copy reservation',
    cancel_prebook_description: 'Cancel reservation',
    additional_cost_will_be_charged:
      'Additional cost will be charged. Original scheduled time takes place within 24 hours, so this change will incur an additional charge as per last minute cancellation in the price list',
    we_will_cancel_this_booking_and_make_a_new_one:
      'We will cancel this booking and make a new one if you change - time, date, type, language, duration',
    preview: 'Preview',
    edit_prebooking_details: 'Edit Prebooking details',
    no_invoices: 'You don`t have any bookings to process for invoicing.',
    add: 'Add',
    add_email: 'Add email',
    invite_to_the_group: 'Invite to the group',
    invite_to_the_group_explanation:
      'Do you know a colleague who uses interpretation services in their profession? Invite her to Túlka',
    invite: 'Invite',
    invite_success: 'Invite successfully sent.',
    invite_to_group: 'Invite new people',
    collaborators_header: 'Your collaborators',
    add_collaborators: 'Add collaborators',
    please_enter_email: 'Please enter email',
    name: 'Name',
    collaborators_header_description:
      'Invite a collaborator to co-manage your bookings. \nNote: You can invite an existing user only.',
    user_does_not_exist:
      'User does not exist, you can invite only existing user',
    invite_to_collaborate_success: 'User successfully invited to collaborate.',
    collaborator_successfully_removed: 'Collaborator successfully removed.',
    invalid_email_address: 'Invalid email address',
    invalid_phone_number: 'Invalid phone number',
    invalid_phone_number_error: 'Invalid phone number',
    already_registered_phone: 'This phone number is already registered to another user. Please contact customer service ',
    phone_number_cannot_start_with_0: 'Phone number cannot start with 0 in international format',
    email_address_from_different_organisation_domain:
      'Email address from different domain',
    this_user_already_added_to_collaborators:
      'This user already added to collaborators',
    prebooked: 'Prebooked',
    ondemand: 'On demand',
    reset_user_password: 'Change password',
    reset_user_email: 'Change email for booking confirmations',
    reset_user_email_note_for_interpreter: 'Please note that this will not affect the username used for login, only the email address to which booking confirmations and change notifications are sent.',
    reset_user_email_for_login: 'Change email for login',
    please_enter_password: 'Password',
    please_enter_new_password: 'New password',
    please_enter_current_password: 'Current password',
    please_repeat_password: 'Repeat password',
    please_repeat_new_password: 'New password again',
    passwords_do_not_match: 'Passwords do not match',
    old_password_is_required: 'Old password is required',
    enter_new_password: 'Enter new password',
    repeat_new_password: 'Repeat new password',
    password_requirement:
      'Password must be aleast 8 characters, including an uppercase and lowercase letter, a number',
    all_day: 'All day',
    previous: 'Previous',
    next: 'Next',
    // today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    agenda: 'Agenda',
    date: 'Date',
    // time: 'Time',
    event: 'Event',
    no_events_in_range: 'No events in range',
    show_more: 'Show more',
    reports: 'Reports',
    number_of_interpretations: 'Tulkkausmäärä',
    interpretation_breakdown_previous_month:
      'Tulkkauserittely - edellinen kuukausi',
    your_browser_is_not_supported: 'Your Browser is not Supported.',
    edge_browser_is_not_supported: 'EDGE browser is not supported. Please use Google Chrome.',
    we_recommend_using_the_latest_version_of_chrome_or_firefox_in_order_to_continue_using_this_service:
      'We recommend using the latest version of Chrome or Firefox in order to continue using this service.',
    use_of_interpretation_report: 'Tulkkauksen Käyttö',
    billing_report: 'Laskutus',
    customer_reporting_report: 'Asiakasraportointi',
    data_export_report: 'Tiedon Vienti',
    monetra_billing_report: 'Monetra Laskutus',
    monetra_payroll_report: 'Monetra Palkanlasku',
    copy_data_to_new_booking: 'Copy data to new booking',
    replace_with_new_one: 'Replace with new one',
    update_at_least_date_or_time_fields_to_create_a_booking:
      'Update at least Date or Time fields to create a booking',
    cancel_prebook: 'Cancel',
    newButton: 'New',
    announcement_interpretation: 'Announcement interpretation',
    customer_name_and_date_of_birth:
      'Customer name and date of birth (for invoice)',
    customer_name: 'Customer name (for invoice)',
    date_of_birth: 'Date of birth (for invoice)',
    to_whom_the_message_is_forwarded_if_not_to_the_customer:
      'To whom the message is forwarded, if not to the customer',
    telephone_number_to_which_the_interpreter_will_call:
      'Telephone number (s) to which the interpreter will call',
    main_telephone_number_to_which_the_interpreter_will_call:
      'Main telephone number to which the interpreter will call',
    additional_telephone_number_to_which_the_interpreter_will_call:
      'Additional telephone number(s) to which the interpreter will call',
    message_to_customer_service_or_interpreter:
      'Message to customer service or interpreter',
    mandatory_information: 'Mandatory information',
    optional_information: 'Optional information',
    customer_data: 'Customer data',
    write_the_content: 'Message content',
    write_the_content_of_the_matter_to_be_reported_below:
      'Write the content of the matter to be reported below',
    content_data_tooltip:
      'Message interpretation is a one-way, spoken interpretation of a message. The maximum length of the message is 1000 characters.',
    content_data_second_tooltip:
      'The interpreter will call the given phone number at least 5 times. The interpretation of the message will be considered completed even when the message does not reach the customer.',
    calendar_tooltip_notice_interpretation:
      'The interpreter will call the number provided by the end of the selected day.',
    calendars: 'Calendars',
    please_select_language: 'Choose language',
    please_select_interpreter: 'Please select interpreter',
    please_select_language_and_interpreter_to_see_the_calendar:
      'Please select language and interpreter to see the calendar',
    please_select_time: 'Please select time',
    block_time: 'Blocked time',
    block_time_description: 'Blocked time - During this time the interpreter will not receive any calls or prebookings.',
    reservations_od: 'Reservation for OD',
    reservations_od_description: 'Reservation for OD - During this time interpreter will not receive prebookings, but will be targeted only to OD',
    unavailable_time: 'Unavailable time',
    unavailability_type: 'Unavailability type',
    pick_start_time: 'Pick a start time',
    pick_end_time: 'Pick an end time',
    time_successfuly_blocked: 'Time successfully blocked',
    time_successfuly_unblocked: 'Blocked time successfully canceled',
    time_successfuly_updated: 'Blocked time successfully updated',
    overlaping_information_dialog_mesage:
      'The dates are overlapping with an existing prebooking or another unavailability. Please remove overlapping unavailabilities, cancel the overlapping prebookings or use different dates.',
    ok: 'ok',
    cancel_blocked_time_confirmation_message:
      'Are you sure that you want to cancel the blocked time?',
    cancel_interpreter_blocked_time: 'Unblock',
    relay_the_message_to_person: 'Relay the message to person:',
    birthday: 'Date of birth:',
    numbers_to_be_called: 'Numbers to be called:',
    message: 'Message:',
    to_whom_message_forwarded_if_not_customer: 'To whom the message is forwarded, if not customer',
    write_here: 'Write here...',
    main_telephone_number_interpreter_will_call: 'Main telephone number to which the interpreter will call',
    additional_telephone_numbers_interpreter_will_call: 'Additional telephone number(s) to which the interpreter will call',
    phone_required: 'Phone number is required',
    phone_already_added: 'Phone number already added',
    enter_phone_number: 'Enter phone number',
    has_to_be_a_phone_number: 'Has to be a phone number',
    other_information_relevant_to_the_invoicing_such_as_information_about_the_customer:
      'Other information relevant to the invoicing, such as information about the customer',
    this_invoice_needs_additional_information:
      'This invoice needs additional information. Please fill in the required fields to confirm your order',
    cancelled_by: 'Cancelled by',
    cancel_reason: 'Cancel reason',
    join_to_meeting: 'Join to meeting',
    ready_to_join: 'Ready to join?',
    what_is_your_name: 'What\'s your name?',
    your_name: 'Your name',
    waiting_for_luona_worker_and_interpreter:
      'Waiting for Luona worker and interpreter...',
    waiting_label: 'Waiting...',
    type_message: 'Type a message',
    looking_for: 'We are trying to provide the best service but sometimes it takes time. Please hold on, we are looking for',
    luona_worker_persone: 'Luona worker',
    interpreter_persone: 'Interpreter',
    interpreter_status: 'On-demand interpretations',
    availability_yes: 'Available now',
    availability_no: 'You are not available.',
    // prebooking luona
    prebooking_page_title: 'Prebooking',
    defaultPrebookingPageMessage: 'You don\'t have any prebookings',
    go_to_prebookings_list: 'Go to prebookings list',
    luona_feedback_title: 'Quality survey',
    luona_feedback_description: 'You have taken advantage of Luona\'s new technological remote service platform. We collect feedback about the service, and we would be grateful if you answer our short survey.',
    luona_feedback_score: 'How likely is it that you would recommend this remote service platform to a friend?',
    luona_feedback: 'Feedback',
    feedback_sent: 'Thank you for your feedback!',
    luona_prefer: 'Preferential',
    Luona_lead: 'Lead team',
    luona_social: 'Social',
    luona_nurses: 'Medical',
    go_to_services: 'Go to services',
    start_prebook: 'Start',
    prebooking_is_gone: 'Prebooking is gone',
    prebooking_not_answered: 'Unfortunately we cannot deliver the prebooking. Book a consultation with a specialist again',
    prebooking_is_not_found: 'Unfortunately, we cannot find a matching active prebooking. Please try to make an emergency call or book a consultation with a specialist again.',
    prebooking_is_cancelled: 'Unfortunately, we cannot find a matching active prebooking. Maybe It was cancelled. Please try to make an emergency call or book a consultation with a specialist again.',
    prebooking_is_too_late: 'Unfortunately, the prebooking start time has passed. After waiting, the interpreters were redirected to handle urgent calls. Please try to make an emergency call or book a consultation with a specialist again.',
    prebooking_will_start_in: 'The start of your appointment is in:',
    early_preview_intro: 'Dear Luona customer!',
    you_can_close_tab_for_now: 'You can close this tab for now.',
    my_prebooking_list: 'My reservations',
    connecting_to_meeting: 'Connecting to meeting',
    connecting_to_meeting_for_interpreter: 'Please hold on to the line, we are connecting all the parties',
    no_access_to_your_camera_or_microphone: 'No access to your camera or microphone',
    remote_backup_to_onsite: 'What to do if no interpreter is found on-site?',
    use_remote_interpretation_option: 'Use remote interpretation',
    cancel_prebooking_option: 'Cancel prebooking',
    which_remote_interpretation_type_do_you_choose: 'Which remote interpretation type do you choose?',
    phone_interpretation: 'Phone interpretation',
    conference_virtual_room: 'Conference / Virtual room (e.g. Google meet, Teams, Zoom)',
    confirm_you_are_online: 'Did you leave? If you want to keep accepting calls please click the button "Join back".',
    join_back: 'Join back',
    requestErrorMessageReasonPoorInternet: 'Oops! Something went wrong. One of the reasons might be poor internet. Please check your internet settings!',
    networkDisconnectedMessage: 'Your internet connection is not fast enough for video calls. Please check your internet settings!',
    interpreter_name: 'Interpreter',
    meeting_disconnected: 'You have been disconnected',
    meeting_reconnecting: 'You are being reconnected',
    meeting_reconnected: 'You have been reconnected',
    browser_does_not_support_video_effects: 'Browser does not support video effects',
    // Self-selfRegistration
    user_group_not_found: 'We are unable to complete your registration at this time because your organization is missing a required configuration. Please contact our customer service team for assistance in resolving this issue.',
    log_in: 'log in',
    sign_up: 'sign up',
    create_an_account: 'Create an account',
    contact_information: 'Contact information',
    first_name: 'First name',
    last_name: 'Last name',
    is_personal_email: 'This email address is being used to verify your identity. Please specify whether this email address is solely for personal communication or shared with colleagues:',
    email_for_personal: 'Email is solely for personal communication',
    email_shared_with_colleagues: 'Email is shared with colleagues',
    check_email_again: 'Please enter email address again for sending verification email.',
    is_personal_phone: 'This phone number is used to verify your identity. Please specify whether this phone number is solely for personal communication or shared with colleagues:',
    phone_for_personal: 'Phone number is solely for personal communication',
    phone_shared_with_colleagues: 'Phone number is shared with colleagues',
    check_phone_again_by_sms: 'Please enter phone number again for sending verification sms.',
    check_phone_again_by_call: 'Please enter landline number again for receiving an automated call.',
    already_have_an_account_part1: 'Already have an account? ',
    already_have_an_account_part2: 'Log in ',
    contact_info_email: 'Email',
    contact_info_phone: 'Phone number',
    continue: 'Continue',
    confirm_your_email: 'Confirm your email',
    confirm_your_email_message: 'To complete registration, we have sent a verification email to the registered email. Please verify email by following instructions on the email.',
    confirm_your_phone: 'Confirm your phone',
    confirm_your_mobile_phone_message: 'To complete registration, we have sent a verification SMS to the registered phone number. Please verify the phone number by following instructions on the SMS.',
    confirm_your_phone_message: 'You will receive an automated call for verifying ownership of a landline number. During the call you will hear a code, which you need to type here.',
    confirmation_code: 'Confirmation code',
    didnt_receive_an_email: 'Didn\'t receive an email?',
    didnt_receive_a_call: 'Didn\'t receive a call?',
    didnt_receive_sms: 'Didn\'t receive sms?',
    send_email_again: 'Send email again',
    send_phone_again_for_sms: 'Send SMS again',
    send_phone_again_for_call: 'Request another callback',
    verification_page: 'Verification page',
    verification_link_expired: 'Something went wrong. Verification link might have expired. Please try again.',
    waiting_for_verification: 'Waiting for verification',
    select_the_correct_cost_center_regarding_invoicing: 'Select the correct cost center regarding invoicing. If you can\'t find the correct cost center select "I couldn’t find the correct cost center" -option.',
    how_often_do_you_predict_to_utilize_interpretation_services: 'How often do you predict to utilize interpretation services?',
    daily: 'Daily',
    weekly: 'Weekly',
    more_than_weekly: 'More seldom than weekly',
    periodically: 'Periodically',
    cost_center: 'Cost center',
    i_could_not_find_the_correct_cost_center: 'I couldn\'t find the correct cost center',
    information_regarding_cost_center: 'Information regarding cost center (Industry / department where you work)',
    please_tell_us_where_you_work_in_which_unit_etc: 'Please tell us where you work, in which unit etc.',
    update_user_home_group_failed: 'Update user home group failed',
    set_up_your_password: 'Set up your password',
    repeat_password: 'Repeat password',
    set_password_failed: 'Set password failed',
    submit: 'submit',
    account_created: 'Account created!',
    you_can_now_login_to_the_tulka_application_using_your_credentials: 'You can now log in to Túlka. The button at the bottom of the page takes you directly to the browser version of Túlka.',
    we_have_also_sent_you_instructions_for_use_by_email: 'We have also sent you the instructions by email.',
    open_mobile_app: 'Open mobile app',
    login_to_web: 'Login to WEB',
    account_found: 'Account found',
    please_log_in_or_request_a_new_password: 'Please log in or request a new password.',
    forgot_password: 'Forgot password',
    no_contract_found: 'No contract found',
    it_seems_like_you_dont_have_an_contract_with_tulka_based_on_your_email_address: 'It seems like you don\'t have an contract with Túlka based on your email address.',
    please_contact_our_sales_to_begin_using_tulka: 'If you want to use Túlka, contact our customer service via the chat at the bottom right of the page, by phone on {customerServicePhoneNumber} or by email at {infoEmail}',
    email_already_registered: 'Email is already registered with another account.',
    contact_service_with_chat: 'Please contact customer service with chat or by calling number ',
    contact_service_without_chat: 'Please contact customer service by calling number ',
    contact_sales: 'by phone on 030 660 6400 or by email at info@tulka.com',
    invalid_code: 'Invalid code',
    invalid_field_value: 'This field is required and it can not be empty.',
    fistName_requirement: 'First name required',
    lastName_requirement: 'Last name required',
    contact_service_contacts: 'tel. 030 660 6400 | info@tulka.com',
    backup_option: 'Backup option',
    no_backup_option_selected: 'No backup option selected',
    od_details_title: 'Specify duration and subject (optional)',
    od_details_subject_subtitle: 'Subject of the interpretation',
    subject_placeholder: 'Shared with interpreters',
    estimated_duration: 'Estimated duration',
    interpreter_level_label: 'Level',

    // Translation Order Wizard
    translation_order_title: 'Translation order',
    translation_order_step_details: 'Order details',
    translation_order_step_invoicing: 'Invoicing and assignment details',
    translation_order_details: 'Details',
    translation_order_language_from: 'Language from',
    translation_order_language_to: 'Language to',
    translation_order_dialect: 'Dialect',
    translation_order_upload_reference: 'Upload reference document',
    translation_order_browse_files: 'Browse files',
    translation_order_accepted_types: 'Accepted file types',
    translation_order_total_scope: 'Total scope',
    translation_order_estimated_scope: 'Estimated scope',
    translation_order_select_type: 'Select type',
    translation_order_scope_words: 'Words',
    translation_order_scope_pages: 'Pages',
    translation_order_scope_minutes: 'Minutes',
    translation_order_scope_help_text: 'The estimated scope of the translation is used only to find a suitable translator and has no direct impact on the amount to be invoiced.',
    translation_order_preferences: 'Preferences',
    translation_order_instructions: 'Instructions or notes for the translator',
    translation_order_instructions_placeholder: 'e.g. "Please pay attention to medical terminology," "Target audience is children"',
    translation_order_message_to_translator: 'Message to translator',
    translation_order_customer_service_instructions: 'Customer service instructions',
    translation_order_delivery_date: 'Desired delivery date',
    translation_order_delivery_date_help: 'The desired delivery date is indicative and does not bind the translator.',
    translation_order_specifying_invoicing_details: 'Specifying invoicing details',
    translation_order_invoice_references: 'Invoice references',
    translation_order_additional_invoicing_placeholder: 'The field information is not visible to the interpreter',
    translation_order_notifications: 'Notifications',
    translation_order_notification_emails: 'Notification emails',
    translation_order_add_email: 'Add email',
    translation_order_materials: 'Materials for translation',
    translation_order_show_all: 'Show all',
    translation_order_preview_not_available: 'Preview is not available for this file type',
    translation_order_customer_info: 'Customer information',
    translation_order_customer_number: 'Customer number',
    translation_order_order_number: 'Order number',
    translation_order_ordered_by: 'Order made by',
    translation_order_ordering_unit: 'Ordering unit',
    translation_order_estimated_total: 'Estimated total',
    translation_order_confirmation: 'Order confirmation',
    translation_order_cancel_order: 'Cancel order',
    translation_order_cancel_not_possible: 'The translation has begun and cannot be canceled here, please contact customer service.',
    translation_download_material: 'Download material',
    translation_upload_material: 'Upload material',
    uploading: 'Uploading…',
    uploaded: 'Uploaded',
    downloading: 'Downloading…',
    transfer_failed: 'Transfer failed',
    translation_translated_materials: 'Translated materials',
    translation_materials_for_translation: 'Materials for translation',
    translation_order_created_successfully: 'Translation order created successfully',
    translation_order_uploading_attachments_notice: 'Waiting for attachments to be uploaded. Please keep this page open until the upload has finished.',
    translation_order_wait_for_upload: 'Please wait until the attachments have been uploaded.',
    translation_order_cancelled_successfully: 'Translation order cancelled successfully',
    translation_order_attachment_upload_failed: 'Failed to upload attachment',
    translation_order_submit_failed: 'Failed to create translation order',
    translation_order_cancel_failed: 'Failed to cancel translation order',
    translation_mark_completed: 'Mark as completed',
    translation_mark_completed_success: 'Translation marked as completed',
    translation_mark_completed_failed: 'Failed to mark translation as completed',
    translation_change_status: 'Change',
    translation_task_completed: 'Task completed',
    translation_revert_completed_failed: 'Failed to revert completion status',
    translation_order_from_language_required: 'Source language is required',
    translation_order_to_language_required: 'Target language is required',
    translation_order_languages_must_differ: 'Source and target languages must be different',
    translation_order_files_required: 'Please upload at least one file',
    translation_order_scope_required: 'Estimated scope is required',
    translation_order_scope_type_required: 'Scope type is required',
    translation_order_delivery_date_required: 'Desired delivery date is required',
    translation_order_delivery_date_too_far: 'Desired delivery date must be less than 5 years in the future',
    translation_order_translator_type: 'What type of translator do you need?',
    translation_order_translator_type_required: 'Please select at least one translator type',
  },

  da: {
    ai_interpreter: 'AI-tolk',
    ai_cost_center: 'Omkostningscenter',
    ai_target_language: 'Målsprog',
    ai_alt_cost_order: 'Alt. omkostning / ordre',
    invoice_ref: 'Fakturaref.',
    ai_download_transcript: 'Download transskription',
    ai_download_summary: 'Download resumé',
    ai_transcription: 'Transskription',
    ai_summary: 'Resumé',
    ai_send_email: 'Send e-mail',
    ai_send_email_title: 'Send transskription via e-mail',
    ai_send_email_explanation: 'Indtast den e-mailadresse, transskriptionen skal sendes til.',
    ai_include_summary: 'Inkluder resumé',
    ai_email_subject_placeholder: 'Din reference til e-mailens emne (valgfrit)',
    ai_search_placeholder: 'Søg AI-tolkeopgave',
    ai_no_sessions: 'Ingen AI-tolkesessioner endnu',
    ai_download_retention: 'Transskriptioner og resuméer kan downloades i 24 timer efter, at tolkningen er afsluttet.',
    ai_download_unavailable: 'Denne fil er ikke længere tilgængelig.',
    ai_download_forbidden: 'Du har ikke tilladelse til at få adgang til denne fil.',
    ai_download_timeout: 'Filen genereres stadig, prøv venligst igen om lidt.',
    ai_email_sent: 'E-mail sendt.',
    ai_email_failed: 'Det lykkedes ikke at sende e-mailen.',
    ai_email_invalid: 'Ugyldig e-mailadresse.',
    ai_email_domain_not_allowed: 'Dette e-maildomæne er ikke tilladt.',
    ai_allowed_email_domains: 'Tilladte e-maildomæner:',
    ai_own_email_only: 'Transskriptionen kan kun sendes til din egen e-mailadresse.',
    please_wait: 'Vent venligst...',
    done: 'Done',
    fin: 'Finsk',
    eng: 'Engelsk',
    nor: 'Norsk',
    swe: 'Svensk',
    dan: 'Dansk',
    fra: 'Fransk',
    cze: 'Tjekkisk',
    hrv: 'Kroatisk',
    sqi: 'Albansk',
    ben: 'Bengalsk',
    amh: 'Amharisk',
    bul: 'Bulgarsk',
    nld: 'Hollandsk',
    ara: 'Arabisk',
    deu: 'Tysk',
    urd: 'Urdu',
    mya: 'Burmesisk',
    mieli: 'Sind',
    mainio: 'Fantastisk',
    ccb2b: '📞 Kontakt kundeservice',
    testb2b: '📞 Test / Kontakt kundeservice',
    vls: 'Flamsk',
    ckb: 'Sorani',
    nep: 'Nepalesisk',
    prs: 'Dari',
    hurja: 'Vild',
    lao: 'Laotisk',
    no_language_selected: 'Intet sprog valgt',
    ui_language: 'Brugerfladesprog',
    close: 'Luk',
    // feedback
    failed_to_find_prebooking_data: 'Kunne ikke finde denne forhåndsbestilling',
    prebooking_was_cancelled: 'Denne forhåndsbestilling blev annulleret',
    feedback_not_open_yet: 'Da tolkningen endnu ikke har fundet sted, er du ikke i stand til at give os feedback på dette tidspunkt.',
    how_did_we_do: 'Hvordan var din oplevelse?',
    stars_rating_subtitle: 'Din feedback hjælper os med at forbedre vores service.',
    where_can_we_improve_upon: 'Hvordan kunne vi forbedre os?',
    leave_open_feedback: 'Giv fritekst feedback',
    describe_your_experience_here: 'Fortæl hvad der skete med dine egne ord',
    i_wish_to_be_contacted: 'Kontakt mig venligst',
    choose_one_or_more_options: 'Vælg en eller flere muligheder',
    thank_you_for_your_feedback: 'Tak for din feedback!',
    // customer guide for od-call (modal)
    if_neither_number_works: ' Hvis ingen af numrene virker, indtast servicenummeret i følgende format:',
    order_an_interpreter_by_calling_the_number: 'Bestil en tolk ved at ringe til nummeret',
    main_calling_number: '041 400 1234',
    main_calling_number_with_code: '*31# 041 400 1234',
    main_calling_number_with_zero: '0041 400 1234',
    phone_must_be_registered: 'Den telefon du bruger til at ringe til vores alarmnummer skal være registreret i vores system.',
    note: 'Bemærk!',
    number_is_encrypted: ' Hvis dit nummer er krypteret, indtast servicenummeret i følgende format:',
    attention_for_hus: 'Bemærk HUS kablede netværksoperatører!',
    contact_to_customer_service: 'I tilfælde af problemer, kontakt vores kundeservice.',
    select_interpreter_language: 'Efter at opkaldet er forbundet, vælg det sprog der skal tolkes fra følgende ved at indtaste nummeret ved hjælp af telefonens nummertaster',
    accept_incoming_prebookings: 'Acceptér eller afvis indkommende forhåndsbestillinger',
    accept: 'Acceptér',
    decline: 'Afvis',
    accept_all: 'Acceptér alle',
    date_and_time: 'Dato og tid',
    duration: 'Varighed',
    language: 'Sprog',
    presence: 'Tilstedeværelse',
    prebookings_already_checked: 'Forhåndsbestillinger allerede tjekket',
    username_not_unique: 'Login e-mail er ikke unik.',
    new_username_set: 'Nyt brugernavn indstillet: ',
    // LUONA
    luonaSignupForm: 'Tilmeldingsformular',

    label_name: 'Fornavn og efternavn',
    placeholder_name: 'Kun latinske bogstaver',
    validate_name: 'Mere end 3 tegn',

    label_phone: 'Telefon',
    placeholder_phone: '+3XXXXXXXXXXX',
    validate_phone: 'mobiltelefonnummer i format: +XXXXXXXXXXXX',

    label_email: 'E-mail',
    placeholder_email: 'bruger@mail.com',
    validate_email: 'e-mail i format: bruger@mail.com',

    label_city: 'By',
    placeholder_city: 'Bynavn',
    validate_city: 'Kun latinske bogstaver',
    selectOption: 'Vælg by',

    agreePrivacyPolicy: 'Jeg accepterer ',
    privacyPolicy: 'privatlivspolitik',
    luonaSignupButton: 'Send',
    requestErrorMessage: 'Noget gik galt, prøv igen!',
    minimalPrebookingTimeBumperError: 'Forhåndsbestillingstidspunktet er for tidligt. Vælg venligst et andet tidspunkt.',
    minimalPrebookingOnSiteTimeBumperError: 'Starttidspunktet for tolkning på stedet er for tidligt. Vælg venligst en anden dato og tid.',
    new_password_success: 'Ny adgangskode er blevet tilføjet med succes',
    new_password_wrong: 'Gammel adgangskode ikke fundet',
    requestErrorMessageUserNotFound: 'Indtast det registrerede telefonnummer og e-mailadresse.',
    requestErrorMessageUserExist:
      'Den angivne e-mail eller telefonnummer er allerede i brug, prøv venligst et andet.',
    slot_not_free_anymore: 'Beklager, det valgte tidslot er ikke længere ledigt',
    no_interpreter_in_prebooking: 'Ingen tolk i forhåndsbestilling',
    back_to_telegram: 'Tilbage til Telegram',
    what_is_your_language: 'Hej, hvilket er dit sprog',
    what_you_need_help_with: 'Hvad har du brug for hjælp til?',
    selectable_langs: 'Sprog',
    selectable_servises: 'Tjenester',
    selectable_time: 'Tid',
    selectable_interpreter: 'Konsultationssproget er engelsk eller finsk. Har du brug for en tolk?',
    authtorize: 'Autorisation',
    choose_time: 'Vælg venligst tidspunktet for din forhåndsbestilling',
    prebook_not_available_message: 'Desværre er denne tjeneste ikke tilgængelig lige nu. Arbejdstid: mandag til fredag {SCHEDULE}',
    health: 'Sundhed',
    work_or_study: 'Arbejde eller studier',
    money_or_livelihood: 'Penge eller levevilkår',
    reception_allowance: 'Modtagelsesydelse / PFS-kort',
    my_money_is_not_enough: 'Penge er ved at løbe tør',
    copy_email: 'Kopier e-mail',
    successfully_copied: 'E-mail kopieret med succes',
    copied_to_clipboard: 'Kopieret til udklipsholderen',
    other_practical_matters: 'Andre praktiske emner',
    thanks_for_booking: 'Tak for din reservation.',
    prebook_created_at: 'Dit videomøde er bekræftet som følgende:',
    prebooking_skill: 'Problem:',
    you_need_high_network: 'For at sikre kvaliteten af mødet, sørg venligst for at du har en stabil og hurtig netværksforbindelse, som er tilstrækkelig til videokonferencer.',
    you_will_got_accept: 'Du vil modtage en bookingbekræftelse og to påmindelser via SMS og e-mail.',
    message_with_link_to_meeting: 'Beskederne indeholder et link hvorfra du kan komme til mødet på det aftalte tidspunkt.',
    dont_forget_decline_prebooking: 'Husk at aflyse mødet hvis du ikke er i stand til at deltage.',
    for_decline_need: 'Du kan gøre det i:',
    click_for_decline_prebooking: 'og så klik på SLET-knappen på din forhåndsbestilling.',
    best_regards: 'Venlige hilsner,',
    luona_DigiVOK: 'LUONA DigiVOK',
    emigration_or_holiday_outside_Finland:
      'Emigration eller ferie uden for Finland',
    free_time: 'Fritid',
    housing: 'Bolig',
    child_care: 'Barn',
    child_health: 'Sundhed',
    upbringing_parenting: 'Opdragelse/Forældreskab',
    kindergarten_or_school: 'Daginstitution eller skole',
    reception_centre_info_service: 'Modtagelsescenter informationstjeneste',
    physical_or_mental_symptoms: 'Sundhed',
    related_to_money_or_livelihood: 'Økonomisk sikkerhed',
    related_to_your_own_or_family_life_situation:
      'Omstændigheder relateret til mig selv eller min familie',
    legal_matter: 'Juridisk sag',
    everyday_practical_things: 'Daglige, praktiske ting',
    service_housing: 'Bolig',
    how_do_you_judge_the_criticality_of_your_case:
      'Hvordan vurderer du kritikaliteten af din sag?',
    help_need_today: 'Akut, bør tages hånd om i dag',
    help_need_in_couple_of_days: 'Akut, men kan vente et par dage',
    help_is_not_urgent: 'Ikke akut',
    call_now: 'Ring nu',
    book_an_appointment: 'Book en aftale',

    help_need_in_week: 'Behov for hjælp i løbet af ugen',
    authtorize_yourself: 'Autoriser dig selv',
    user_successfully_registered: 'Autorisation lykkedes',
    book_time: 'Book tid',
    what_time_works_for_you: 'Hvilket tidspunkt passer dig?',
    wizard_default_message:
      'Hvis situationen er livstruende, ring 112. Hvis din sundhedsbekymring ikke kan vente til næste arbejdsdag, ring 116117 for rådgivning. Hvis du har en anden akut krise, ring den sociale krise-service i din kommune.',
    wizard_welcome_message:
      'Velkommen til LUONA tjeneste! Vi vil gøre alt hvad vi kan for at hjælpe dig. Hvordan kan vi hjælpe dig?',
    wizard_PrebookingStep_header:
      'Vi bestræber os på at håndtere situationer med det samme. Hvis alle vores medarbejdere er optaget, vil du have mulighed for at booke en aftale gennem dette. Vil du gerne booke en aftale eller ringe lige nu?',
    wizard_TimeStep_header:
      'Desværre var ingen i stand til at svare nu. Du kan booke tid herfra.',
    // LUONA

    loginTitle: 'Log ind',
    username: 'Brugernavn',
    password: 'Adgangskode',
    loginButton: 'Log ind',
    loginFailed: 'Login mislykkedes',
    sessionExpired: 'Sessionen er udløbet. Log venligst ind igen.',
    meeting_closed: 'Mødet blev lukket.',
    signin_code_block_message: 'Denne e-mail er allerede brugt før. Vi sendte verifikationskoden til din e-mailadresse: [email]. Indtast venligst verifikationskoden i feltet nedenfor. ',
    placeholder_signin_code: 'kode',
    close_meeting_confirmation_message: 'Er du sikker på at du vil forlade opkaldet? For alle deltagere vil dette opkald også blive lukket',
    internet_connection_lost: 'Internetforbindelse tabt',
    internet_connection_exist: 'Internetforbindelse genoprettet',
    errorTitle: 'Ups!',
    warnTitle: 'Hmm...',
    successTitle: 'Fantastisk!',

    selectLanguage: 'Vælg sprog',
    interpreter: 'Tolk',
    startInterpreting: 'Tolk',
    requestInterpreting: 'Anmod om tolkning',

    interpretationNeeded: 'Tolking nødvendig',
    requestForInterpretation: 'Tolking er nødvendig!',
    requestForCall: 'Kunde kontakter',
    nothingToInterpret: 'Alle forespørgsler er blevet besvaret.',
    noInterpretationNeeded: 'Alle forespørgsler er blevet besvaret.',

    doYouWantToHangUp: 'Vil du virkelig lægge på?',
    oppositeSideHangsUp: 'Den anden person har forladt samtalen.',
    networkTerminated: 'Samtalen blev afbrudt.',
    review: 'Gennemgang',
    customerFeedbackEnjoyingTulka: 'Tilfreds med tjenesten?',
    customerRatingInterpreter: 'Min feedback om tolken',
    customerInvoiceNotes: 'Fakturareference',
    deviation: 'Afvigelse',
    deviation_resolution: 'Afvigelsesløsning',
    deviation_must_be_resolved_before_confirming: 'Afvigelsen skal løses, før dette kan bekræftes.',
    interpreterRatingInterpreter: 'Hvordan gik det?',
    interpreterRatingCustomer: 'Hvor godt klarede jeg mig?',
    ratingQuality: 'Teknisk kvalitet',
    feedback: 'Feedback',
    feedbackDesc: 'Skriv dine kommentarer her',
    feedbackContactMe: 'Kontakt mig venligst',
    proceed: 'Send',
    skip: 'Spring over',

    endCall: 'Afslut opkald',
    refresh: 'Opdater',
    logout: 'Log ud',
    toggleCamera: 'Skift kamera',
    toggleAudio: 'Skift lyd',

    onlyChromeSupported: 'Browser ikke understøttet',
    pleaseUseChrome: 'Installer venligst Google Chrome for at bruge Túlka Web App',
    downloadChrome: 'Klik her for at installere',
    continueInterpretation: 'Fortsæt tolkning',
    roomInfoCallEndedClosed: 'Serveren lukkede samtalen.',
    feedbackTooLate: 'Fortsæt-muligheden er ikke længere tilgængelig!',

    noTimeLeft: 'Demobrug er afsluttet. Vi kontakter dig snart!',
    minutesConsumed: 'Demobrug er nu afsluttet. Vi kontakter dig snart!',
    timeLeft: 'Tolkningstid tilbage: {}',
    zeroTimeLeft: 'Demobrug er afsluttet.\nVi kontakter dig snart!',
    freeUseLeft: 'Tid tilbage',

    failedToSendFeedback: 'Kunne ikke sende feedback!',
    failedLogOut: 'Kunne ikke logge ud.',
    failedToCreateChatroom: 'Kunne ikke starte en tolkning!',
    failedToConnect: 'Kunne ikke forbinde til server.',
    waitingForInterpreter:
      'Din forespørgsel blev sendt til tolkene. Ventetiden er normalt 1 til 3 minutter.',
    waitingForCustomer: 'Venter på kunde...',
    waiting_time: 'Ventetid er',
    pleaseWait: 'Vent venligst...',
    youHaveWaitedFor: 'Du har ventet {}',
    error500: 'Noget gik galt. Prøv igen.',
    roomInfoHasAudioPacketLoss: 'Dårlig forbindelse!',

    yes: 'Ja',
    no: 'Nej',
    cancel: 'Annullér',

    // Attachment feature
    attachment_status_pending: 'Behandler...',
    attachment_status_converting: 'Konverterer til PDF...',
    attachment_status_conversion_failed: 'Konvertering mislykkedes',
    attachment_fetch_error: 'Kunne ikke indlæse vedhæftningsinfo',
    attachment_conversion_in_progress: 'Filen konverteres. Vent venligst...',
    attachment_conversion_failed_download: 'Kan ikke downloade - konvertering mislykkedes. Upload venligst en anden fil.',
    attachment_deleted: 'Vedhæftningen er blevet slettet.',
    attachment_download_error: 'Kunne ikke downloade vedhæftning',
    attachment_delete_forbidden: 'Du har ikke tilladelse til at slette denne vedhæftning.',
    attachment_delete_error: 'Kunne ikke slette vedhæftning',
    attachment_upload_failed: 'Reservation oprettet, men upload af vedhæftning mislykkedes. Du kan prøve at uploade igen senere.',
    attachment_upload_partial_failed: 'Nogle vedhæftninger kunne ikke uploades. Prøv igen.',
    attachment_empty_file: 'Filen er tom',
    attachment_invalid_type: 'Filtypen er ikke tilladt',
    attachment_file_too_large: 'Filen er for stor',
    customer_documents: 'Kundedokumenter',
    attachment_select_file: 'Vælg dokument',
    attachment_help_text: 'Understøttede formater: PDF, DOCX, PPTX, TXT, PNG, JPG (maks. 5MB). Dokumentet bliver synligt for den tildelte tolk.',
    no_attachment: 'Intet dokument vedhæftet',
    attachment_not_ready: 'Filen er ikke klar til download',
    attachment_preview_error: 'Kunne ikke indlæse forhåndsvisning af vedhæftning',
    download: 'Download',
    delete_attachment: 'Slet vedhæftning',
    delete_attachment_title: 'Slet vedhæftning?',
    delete_attachment_confirm: 'Er du sikker på, at du vil slette denne fil? Denne handling kan ikke fortrydes.',
    delete: 'Slet',

    default: 'Standard',
    termsOfUse: 'Brugsbetingelser og privatlivspolitik',
    options: 'Vis indstillinger',
    hideOptions: 'Skjul indstillinger',

    enable_notifications: 'Aktivér notifikationer',
    disable_notifications: 'Deaktivér notifikationer',
    disable_duration: 'Deaktivér notifikationer i',
    for_hour: '1 time',
    for_day: '1 dag',
    for_week: '1 uge',
    for_month: '1 måned',
    for_a_day: '1 dag',
    for_days: '{} dage',
    for_a_day_an_hour: '1 dag, 1 time',
    for_a_day_hours: '1 dag, {} timer',
    for_days_an_hour: '{} dage, 1 time',
    for_days_hours: '{d} dage, {h} timer',
    notifications_disabled_for: 'Notifikationer deaktiveret i\n{}',
    failed_to_disable_notifications:
      'Kunne ikke deaktivere notifikationer. Prøv igen senere.',
    failed_to_enable_notifications:
      'Kunne ikke aktivere notifikationer. Prøv igen senere.',
    forgot_password_link: 'Glemt din adgangskode?',
    forgot_password_info:
      'Hvis du har en konto, kan vi sende dig en ny adgangskode via SMS eller e-mail. Ellers kontakt {infoEmail}.',
    placeholder_phone_number: '+35840...',
    phone_number_title: 'Telefonnummer',
    forgot_password_error:
      'SMS\'en eller e-mailen kunne ikke sendes. Kontakt venligst {infoEmail}',
    forgot_password_duplicate_email_error:
      'Din adgangskode kan ikke nulstilles. Kontakt venligst kundeservice.',
    forgot_password_success:
      'Tak. Du skulle modtage din adgangskode via SMS eller e-mail snart.',
    skillModalQuestion:
      'Har du brug for denne erfaring? Ventetiden kan være længere.',
    od_type_title: 'Hvilken type tolk?',
    od_type_ai: 'AI',
    od_type_ai_subtitle: 'AI-tolk',
    od_type_human: 'Menneske',
    od_type_human_subtitle: 'Mennesketolk',
    select_customer_gender: 'Angiv køn for dig selv og din kunde',
    your_gender: 'Dit køn',
    customer_gender: 'Kundens køn',
    male: 'Mand',
    female: 'Kvinde',
    invoice_cause_title: 'Fakturaopgørelse',
    invoice_cause_subtitle: 'Vælg venligst fakturaopgørelsesværdien.',
    customer_reference_title: 'Yderligere faktureringsinformation',
    targetLanguage: 'Sprog du forstår',
    openingTimes: '',
    systemAlert: 'Tekniske problemer med tjenesten. Vi undskylder.',

    chatFailed: 'Kunne ikke forbinde til tekstchat.',
    chatTipInterpreter:
      'Her kan du chatte med kunden. Alle beskeder ødelægges med det samme når tolkningen slutter.',
    chatTipCustomer:
      'Her kan du chatte med tolken. Alle beskeder ødelægges med det samme når tolkningen slutter.',
    chatSendFailed: 'Kunne ikke sende beskeden.',
    chatTypeMessage: 'Skriv en besked...',
    invoiceRefMandatory: 'Fakturareference er et obligatorisk felt.',
    invoiceRefUserGroupMandatory: 'Vælg venligst en modtager af fakturaen.',
    selectInvoiceRefUserGroup: '-- Vælg --',

    show_feedbacks: 'Bedømmelser',
    show_feedbacks_title: 'Hvordan jeg blev bedømt',
    failedToFetchFeedbacks: 'Kunne ikke hente bedømmelserne.',
    statistics: 'Mine tolkninger',
    no_statistics: 'Ingen statistikker tilgængelige.',
    stats_disclaimer:
      'Tallene er kun estimater og stemmer muligvis ikke nøjagtigt overens med den endelige lønseddel.',
    stats_today: 'I dag',
    stats_yesterday: 'I går',
    stats_this_week: 'Denne uge',
    stats_last_week: 'Sidste uge',
    stats_this_month: 'Denne måned',
    stats_last_month: 'Sidste måned',
    stats_this_year: 'Dette år',
    stats_last_year: 'Sidste år',

    feedbackButton: 'Tryk for at skrive kommentarer',
    feedback_already_exist: 'Feedback er lukket',
    feedback_need_to_leave: 'Feedback er åben',
    feedback_do_next: 'Du kan nu lukke denne fane.',
    chatroom_not_exist: 'Feedback endnu ikke åben',

    // Prebooking
    prebook: 'Forhåndsbestilt tolkning',
    prebooking_date_header: 'Hvornår har du brug for en tolk?',
    prebooking_date_header_notice: 'Sidste dato for at beskeden bliver leveret',
    step: '{step} af {steps}',
    choose_button: 'Vælg',
    prebooking_duration_header:
      'Hvor længe tror du, at du har brug for en tolk?',
    hours_minutes: '{h}:{m}',
    hour_minutes: '{h}:{m}',
    minutes: '{} min',
    hour: '60 min',
    hours: '{}:00',
    customer_reference: 'Yderligere faktureringsinformation',
    customer_reference_placeholder: 'Feltoplysningerne er ikke synlige for tolken',
    please_provide_customer_reference: 'Giv venligst yderligere information.',
    prebooking_time_header: 'Hvilket tidspunkt har du brug for en tolk?',
    select_language_title: 'Hvilket skal tolkesproget være?',
    fetching_languages: 'Henter sprog...',
    invoice_cause: 'Omkostningsfordeling',
    invoice_cause_description: 'Vælg venligst passende omkostningscenter',
    invoice_ref_placeholder: 'BEMÆRK! Kundeservice læser ikke dette.',
    call_type_video: 'Video',
    call_type_call: 'Opkald',
    call_type_question: 'Vælg venligst forbindelsestypen',
    additional_order_info: 'Yderligere bestillingsoplysninger',
    confirm_prebooking: 'Tjek venligst bookingdetaljerne.',
    comment: 'Nødvendige yderligere oplysninger til ordrehåndtering',
    prebooking_date: 'Dato',
    prebooking_time: 'Tid',
    prebooking_duration: 'Varighed',
    language_title: 'Sprog',
    presence_title: 'Tilstedeværelse',
    call_type_title: 'Opkaldstype',
    select_target_language_title: 'Hvad er dit sprog?',
    location_question: 'Hvad er stedet?',
    location_placeholder_city: 'By',
    location_placeholder_address: 'Gadeadresse',
    location_placeholder_postcode: 'Postnummer',
    add_message_to_interpreter: 'Tilføj besked til tolk',
    subject: 'Emne',
    url_for_video_meeting: 'URL/link til videomøde',
    url_for_video_meeting_label: 'URL/link',
    interpretation_location_details: 'Ankomstinstruktioner til stedet (f.eks. oplysninger om tilgængelighed, kontor, trappe, etage, rum osv.)',
    address_info: 'Adresseoplysninger',
    arrival_instructions: 'Ankomstinstruktioner',
    addressAndArrivalInstrustions: 'Adresse og ankomstinstruktioner',
    preferred_interpreters_question: 'Vil du gerne vælge en foretrukken tolk?',
    search_preferred_interpreter: 'Find tolk efter navn',
    not_guarantee: 'Vi gør vores bedste for at få den ønskede tolk, men kan ikke garantere at han/hun er tilgængelig.',
    history_is_limited: 'Søgeresultatet er begrænset fordi du endnu ikke har brugt mange tolke.',
    presence_question: 'Hvilken type tolkning?',
    presence_remote: 'Fjern',
    presence_remote_tip: 'Via video eller opkald med app\'en',
    presence_on_site: 'På stedet',
    presence_on_site_tip: 'Tolk fysisk til stede',
    presence_notice: 'Meddelelsestolkning',
    presence_notice_tip: 'Skriftlig besked leveret som talt tolkning',
    select_favorite: 'Vil vælge foretrukne tolke?',
    any_favorite: 'Ingen præference',
    call_type_call_tip: 'Kun lyd med telefonopkald',
    call_type_video_tip: 'Lyd og billede med mobildata',
    target_language_title: 'Dit arbejdssprog',
    invoice_ref_title: 'Fakturamærke',
    save_prebooking: 'Book',
    edit_prebooking: 'Gem',
    any_gender: 'Betyder ikke noget',
    any_dialect: 'Ingen specifikke behov',
    gender_title: 'Køn',
    dialect_title: 'Dialekt',
    select_skill: 'Nogen særlige behov til tolken?',
    select_dialect: 'Har du brug for en specifik dialekt?',
    select_qualification: 'Har du brug for særlige kvalifikationer?',
    select_gender: 'Betyder tolkens køn noget?',
    any_skill: 'Ingen særlige behov',
    any_qualification: 'Ingen særlige kvalifikationer',
    skill_title: 'Særlige behov',
    unconfirmed_prebooking: 'Afventer bekræftelse',
    confirmed: 'Bekræftet',
    delivered: 'Leveret',
    not_able_to_reach: 'Ikke i stand til at nå',
    cancelled: 'Annulleret',
    ongoing_prebooking: 'Igangværende',
    report_deviation: 'Rapportér afvigelse',
    active: 'Aktiv',
    location_title_city: 'By',
    location_title_address: 'Gadeadresse',
    // Help tooltips
    help_prebooking_summary_title: 'Skriv her kun nødvendige yderligere oplysninger til ordrehåndtering',
    help_prebooking_summary:
      'Bemærk at udfyldning af dette felt vil forlænge behandlingstiden af ordren.',
    help_call_type_title: 'Tolkningsforbindelse',
    help_call_type:
      'Med telefontolkning kan du forbinde personer som befinder sig på forskellige steder (konferenceopkald).\n\nI en videotolkning kan personer se hinanden, og du kan også vise tekst til tolken for oversættelse. Video kan aktiveres eller deaktiveres når som helst under tolkningen.\n\nDu kan ændre tolkningsforbindelsen ved at afslutte tolkningen og vælge \'Fortsæt tolkning\'.',
    help_gender_title: 'Tolkens køn',
    help_gender:
      'Du kan anmode om en tolk af et specifikt køn. Bemærk at valget kan resultere i et mindre antal tilgængelige tolke og gøre det mindre sandsynligt at få en.',
    help_dialect_title: 'Tolkens dialekt',
    help_dialect:
      'Du kan anmode om en tolk som kender en specifik dialekt af det valgte sprog. Bemærk at valget kan resultere i et mindre antal tilgængelige tolke og gøre det mindre sandsynligt at få en.',
    help_confirmation_title: 'Bekræft dit standard omkostningscenter',
    help_confirmation:
      'Dine ordrer vil som standard blive allokeret til dit standard omkostningscenter, medmindre du specificerer et alternativt omkostningscenter mens du afgiver ordren.',
    tomorrow: 'I morgen',
    today: 'I dag',
    now: 'Nu',
    help_location_title: 'Sted',
    help_location:
      'Indtast stedet for tolkningen. Dette kan være en adresse eller anden identifikator.',
    help_favorites_title: 'Foretrukne tolke',
    help_favorites:
      'Du kan vælge en eller flere af dine favorit tolke som de foretrukne tolke. Hvis en af favoritterne er tilgængelig vil han/hun blive tildelt tolkningen.',
    on_site_not_available_in_app:
      'På stedet-tolkning kan ikke startes fra app\'en.',
    searching_interpreter: 'Leder efter tolk',
    please_call_to_this_number: 'Ring venligst til dette nummer',
    back: 'Tilbage',
    rejoin_meeting: 'Genindtræd i møde',
    change_language: 'Skift sprog',
    prebook_successfully_created: 'Forhåndsbestilling oprettet med succes',
    prebook_successfully_edit: 'Forhåndsbestilling opdateret med succes',
    prebook_successfully_cancelled: 'Forhåndsbestilling annulleret med succes',
    prebook_successfully_accepted: 'Forhåndsbestilling accepteret med succes',
    prebooking_details: 'Forhåndsbestillingsdetaljer',
    select_contract_title: 'Vælg kontrakt',
    select_contract_subtitle: 'Vælg den kontrakt, der skal bruges til denne bestilling.',
    prebook_confirmation_message:
      'Er du sikker på at du vil afbryde forhåndsbestilling?',
    cancel_prebook_confirmation_message:
      'Er du sikker på at du vil annullere forhåndsbestilling?',
    really_cancel_prebooking_too_late:
      'Er du sikker på at du vil annullere forhåndsbestilling? På dette stadium er annullering ikke gratis.',
    cancel_reason_selection: 'Hvad er årsagen til annullering?',
    cancel_reason_sickness: 'Egen sygdom',
    cancel_sickness_tip: 'Lægeerklæring påkrævet',
    cancel_reason_mistake: 'Fejl',
    cancel_reason_other: 'Andet',
    cancel_reason_other_tip: 'En fritekstforklaring påkrævet.',
    cancel_other_title: 'Forklaring',
    cancel_other: 'Fortæl os hvad der skete?',
    cancel_sickness_title: 'Lægeerklæring',
    cancel_sickness: 'Send venligst en lægeerklæring for sygdommen.',
    copy_information: 'Kopier information',
    my_bookings: 'Bookinger',
    interpreter_now: 'Tolk nu',
    pre_book: 'Forhåndsbestilt tolkning',
    order: 'Bestil',
    hero_order_interpretation: 'Tolkning',
    hero_order_translation: 'Oversættelse',
    book_interpretation: 'Book tolkning',
    time: 'Tid',
    status: 'Status',
    search: 'Søg',
    // Prebooking section titles and mode of interpretation
    details: 'Detaljer',
    preferences: 'Præferencer',
    invoicing_and_assignment_details: 'Fakturering og opgavedetaljer',
    invoicing: 'Fakturering',
    cost_allocation: 'Omkostningssted',
    contract_label: 'Kontrakt',
    prebooking_vat_question: 'Moms',
    prebooking_vat_applied: 'Moms inkluderet',
    prebooking_vat_exempt: 'Momsfri',
    additional_invoicing_information: 'Yderligere faktureringsinformation',
    field_not_visible_to_interpreter: 'Feltoplysningerne er ikke synlige for tolken',
    customer_name_for_invoice: 'Kundenavn (til faktura)',
    date_of_birth_for_invoice: 'Fødselsdato (til faktura)',
    recipients_of_confirmation_and_change_notifications: 'Modtagere af bekræftelse og ændringsmeddelelser',
    additional_information_for_order_handler: 'Yderligere oplysninger til ordrebehandler',
    note_filling_this_field_will_prolong_processing_time: 'Bemærk, at udfyldning af dette felt vil forlænge behandlingstiden for ordren.',
    at_least_one_email_required: 'Mindst én e-mailadresse er påkrævet',
    summary: 'Resumé',
    back_to_edit: 'Tilbage til redigering',
    confirm_order: 'Bekræft ordre',
    submitting: 'Sender...',
    mode_of_interpretation: 'Tolkningsform',
    phone_call: 'Telefonopkald',
    phone_call_tip: 'Kun stemme via et telefonopkald',
    video_call: 'Videoopkald',
    video_call_tip: 'Stemme og billede via mobildata',
    conference_call: 'Konferenceopkald',
    conference_call_tip: 'f.eks. Microsoft Teams, Skype, Google Meet, Zoom',
    video_call_made_via_tulka_app: 'Videoopkald foretages via Tulká-appen',
    Remote: 'Fjern',
    presence_onsite: 'På stedet',
    announcement: 'Meddelelse',
    start_time: 'Starttid',
    end_time: 'Sluttid',
    add_another: 'Tilføj en anden',
    does_not_matter: 'Det gør ikke noget',
    no_choice: 'Intet valg',
    highest: 'Højeste',
    // New prebooking form keys
    select: 'Vælg',
    select_notice: 'Hvad tolken skal formidle til brugeren',
    required: 'Påkrævet',
    language_required: 'Sprog er påkrævet',
    interpreted_and_target_language_must_differ: 'Tolket sprog og målsprog kan ikke være det samme',
    delivery_time: 'Leveringstid',
    date_required: 'Dato er påkrævet',
    date_too_far_in_future: 'Datoen skal være mindre end 5 år ude i fremtiden',
    time_required: 'Tid er påkrævet',
    duration_required: 'Varighed er påkrævet',
    at_least_one_time_slot_required: 'Mindst én tidsluke er påkrævet',
    street_address: 'Gadeadresse',
    post_code: 'Postnummer',
    city: 'By',
    arrival_instruction_at_location: 'Ankomstvejledning på stedet',
    message_content: 'Beskedindhold',
    message_max_length_info: 'Den maksimale længde af beskeden er 1000 tegn.',
    last_delivery_date: 'Sidste dato for beskedens levering',
    delivery_date_info: 'Tolken vil ringe til det angivne nummer inden udgangen af den valgte dag.',
    interpreter_gender: 'Tolkes køn',
    competence_level_special_need: 'Kompetenceniveau / særligt behov for tolk',
    competence_level_helper_text: 'Alle niveauer er inkluderet som standard. Klik for at fravælge niveauer, du ikke ønsker at bruge. Bemærk, at udvalget af tilgængelige tolke reduceres, hvis du fravælger nogen kompetenceniveauer.',
    authorized_interpreter: 'Autoriseret tolk',
    court_legal_interpreter: 'Rets-/juridisk tolk',
    healthcare_interpreter: 'Sundhedstolk',
    registered_trained_interpreter: 'Registreret uddannet tolk',
    other_interpreters: 'Andre tolke',
    other_interpreter_level: 'Øvrig tolk',
    let_system_choose_highest_qualified: 'Lad systemet vælge den højest kvalificerede tolk',
    experiences: 'Krav',
    security_cleared_interpreter: 'Sikkerhedsgodkendt tolk',
    additional_preferences: 'Yderligere præferencer',
    open: 'Åbn',
    hide: 'Skjul',
    request_preferred_interpreter: 'Anmod om foretrukken tolk',
    exclude_specific_interpreters: 'Udeluk specifikke tolke',
    interpreters_found_for_your_selections: 'tolke fundet til dine valg',
    how_to_handle_no_onsite_interpreter: 'Hvordan vil du håndtere, hvis der ikke findes en tolk på stedet?',
    assign_remote_interpreter: 'Tildel fjerntolk',
    cancel_booking: 'Annuller booking',
    // Preferences section keys
    preferences_title: 'Præferencer',
    preferences_interpreter_gender: 'Tolkens køn',
    preferences_onsite_fallback: 'Hvordan vil du have os til at håndtere tilfælde, hvor tolk ikke findes på stedet?',
    preferences_accept_beyond_km: 'Accepterer du en tolk ud over den kontraktlige grænse på {} km én vej?',
    preferences_km_beyond_limit: 'Med hvor mange km vil du acceptere at gå ud over grænsen på {} km én vej?',
    preferences_total_max_distance_label_one_way: 'Samlet maksimal afstand: {} km én vej',
    preferences_total_max_distance_unlimited: 'Samlet maksimal afstand: ubegrænset',
    unlimited: 'Ubegrænset',
    km_unit: 'km',
    accepts_interpreters_within_km: 'ACCEPTERER TOLKE INDEN FOR ${distance} KM',
    preferences_fallback_assign_remote: 'Tildel fjerntolk',
    preferences_fallback_cancel: 'Annuller booking',
    preferences_additional_preferences: 'Yderligere præferencer',
    preferences_preferred_interpreter: 'Anmod om foretrukken tolk',
    preferences_excluded_interpreter: 'Udeluk specifik tolk(e)',
    preferences_search_placeholder: 'Søg tolk efter navn...',
    preferences_ukrainian_russian_fallback: 'Hvis en ukrainsktalende tolk ikke er tilgængelig, kan vi tildele en russisktalende tolk?',
    preferences_accept_lower_level: 'Hvis en tolk på det ønskede niveau ikke er tilgængelig, accepterer du et lavere niveau?',
    preferences_remote_backup_connection_type: 'Foretrukken forbindelsestype for fjernbackup',
    preferences_remote_backup_phone: 'Telefonopkald',
    preferences_remote_backup_video: 'Videoopkald',
    preferences_remote_backup_conference: 'Konferenceopkald',
    interpreted_language: 'Tolket sprog',
    favorite_title: 'Foretrukne tolke',
    no_prebookings: 'Du har ikke nogen forhåndsbestillinger.',
    prebooking_not_active: 'Din kontrakt inkluderer ikke forhåndsbestilling.',
    reservation_number: 'Reservationsnummer',
    external_order_id: 'Ordre-id',
    email: 'E-mail',
    not_yet_support_interpreter_login:
      'Den nye webapp understøtter endnu ikke tolk-login. Brug venligst mobil-app\'en.',
    please_try_again_later: 'Prøv igen senere.',
    no_languages: 'Ingen sprog',
    interpreter_phone_number: 'Telefonnummer',
    remove: 'Slet',
    presence_conference: 'Konference / virtuelt rum',
    presence_conference_tip: 'f.eks. Microsoft Teams, Skype, Google Meet, Zoom',
    interpreter_email: 'Tolkens e-mail',
    all: 'Alle',
    invoice_user_group: 'Omkostningscenter',
    cc_emails: 'Bekræftelses- og ændringsnotifikationsmodtagere',
    cc_email: 'E-mailadresse',
    cc_emails_copy: 'Bekræftelses- og ændringsnotifikationsmodtagere',
    information_for_interpreter: 'Information til tolk',
    patient_name: 'Din klients navn som har brug for tolken',
    upload_reference_document_optional: 'Upload referencedokument (valgfrit)',
    browse_files: 'Gennemse filer',
    only_pdf_format_file_visible_to_interpreter: 'Kun PDF-format. Filen er kun synlig for den tildelte tolk.',
    field_information_not_visible_on_bill: 'Feltoplysningerne er ikke synlige på regningen',
    patient_name_description: 'Denne information vises ikke på regningen, men går til tolken som information, f.eks. i tilfælde af tilbageholdelse.',
    customer: 'Kunde',
    customer_unit: 'Enhed',
    personal: 'Personlig',
    search_for: 'Søg efter enhed, sprog, omkostningscenter eller kunde',
    failed_to_create_prebooking:
      'Kunne ikke oprette en ny forhåndsbestilling. Prøv igen senere.',
    failed_to_create_all_prebookings: 'Kunne ikke oprette alle forhåndsbestillinger',
    slot: 'Tidsrum',
    succeeded: 'lykkedes',
    failed: 'mislykkedes',
    to_start_interpretation:
      'For at starte tolkning ring venligst til dette nummer:',
    start_interpretation: 'Start tolkning',
    hey_username: 'Hej {username},',
    confirm_your_account_information: 'Bekræft dine kontooplysninger',
    confirm_your_account_information_description:
      'For at yde den mest problemfri service muligt, beder vi dig om at bekræfte eller rette oplysningerne nedenfor vedrørende din profil',
    other: 'Andet',
    no_options: 'Ingen søgeresultater',
    search_message: 'Søg...',
    i_confirm_the_information: 'JEG BEKRÆFTER OPLYSNINGERNE',
    billing: 'Fakturering',
    translations: 'Oversættelser',
    order_translation: 'Bestil oversættelse',
    translation_order_number: 'Ordre #',
    translation_order_date: 'Ordredato',
    translation_from: 'Fra',
    translation_to: 'Til',
    translation_username: 'Brugernavn',
    translation_delivery: 'Levering',
    translation_user_group: 'Brugergruppe',
    translation_customer: 'Kunde',
    translation_status: 'Status',
    translation_status_new_order: 'Ny ordre',
    translation_status_in_progress: 'I gang',
    translation_status_assigned: 'Tildelt',
    translation_status_completed: 'Afsluttet',
    translation_status_cancelled: 'Annulleret',
    translation_status_delivered: 'Leveret',
    translation_customer_id: 'Kunde-ID',
    translation_file_name: 'Filnavn',
    translation_estimated_count: 'Estimeret antal',
    translation_due_date: 'Forfaldsdato',
    translation_assigned_jobs: 'Liste over tildelte opgaver',
    translation_order: 'Oversættelsesordre',
    translation_details: 'Detaljer',
    translation_customer_information: 'Kundeinformation',
    translation_invoicing: 'Fakturering',
    translation_from_language: 'Fra',
    translation_to_language: 'Til',
    translation_desired_delivery_date: 'Ønsket leveringsdato',
    translation_instructions: 'Instruktioner/noter til oversætter',
    translation_estimated_total: 'Estimeret total (ord)',
    translation_estimated_scope: 'Estimeret omfang',
    translation_materials: 'Materialer til oversættelse',
    translation_customer_number: 'Kundenummer',
    translation_order_made_by: 'Bestilt af',
    translation_ordering_unit: 'Bestillende enhed',
    checking_your_billing_information: 'Tjekker dine faktureringsoplysninger',
    billing_page_main_sub_header:
      'Tjek at tolkningen er for det korrekte omkostningscenter / enhed og at faktureringens referenceoplysninger er i overensstemmelse med instruktionerne',
    interpreter_reported_duration: 'Tolkerapporteret varighed',
    update: 'Opdater',
    update_prebook: 'Opdater forhåndsbestilling',
    your_changes_will_be_lost:
      'Er du sikker på at du vil annullere? Dine ændringer vil blive slettet.',
    settings: 'Indstillinger',
    user_home_group_header: 'Hjemme brugergruppe',
    app_country: 'Land',
    address: 'Adresse',
    country_placeholder: 'Vælg land',
    update_settings: 'Gem indstillinger',
    has_car: 'Jeg har en bil',
    profile_options: 'Profilindstillinger',
    no_invoice_reference: 'Ingen fakturareference',
    no_user_group_selected: 'Ingen brugergruppe valgt',
    prebook_successfully_updated: 'Faktureringsoplysninger bekræftet',
    type_search_term_here: 'Indtast søgeterm her',
    verify: 'Bekræft',
    prebookings_successfully_updated: 'Faktureringsoplysninger bekræftet',
    alternative_cost_center: 'Alternativt omkostningscenter eller ordrenummer',
    alternative_cost_center_edit:
      'Rediger alternativt omkostningscenter eller ordrenummer',
    choose_default_cost_center: 'Vælg standard omkostningscenter',
    enter_or_confirm_username: 'Indtast eller bekræft e-mailen brugt til login',
    enter_or_confirm_email: 'Indtast eller bekræft en e-mailadresse som bookingbekræftelser og ændringsnotifikationer for bookede tolkninger automatisk sendes til',
    you_can_change_this_information_at_any_time:
      'Du kan ændre denne information til enhver tid fra "Indstillinger" menuen',
    edit: 'Rediger',
    change_reservation: 'Ændr',
    copy_reservation: 'Kopier',
    change_reservation_description: 'Ændr reservation',
    copy_reservation_description: 'Kopier reservation',
    cancel_prebook_description: 'Annuller reservation',
    additional_cost_will_be_charged:
      'Yderligere omkostning vil blive opkrævet. Oprindeligt planlagt tid finder sted inden for 24 timer, så denne ændring vil medføre en ekstra afgift som per sidste øjebliks annullering i prislisten',
    we_will_cancel_this_booking_and_make_a_new_one:
      'Vi vil annullere denne booking og lave en ny hvis du ændrer - tid, dato, type, sprog, varighed',
    preview: 'Forhåndsvisning',
    edit_prebooking_details: 'Rediger forhåndsbestillingsdetaljer',
    no_invoices: 'Du har ikke nogen bookinger at behandle til fakturering.',
    add: 'Tilføj',
    add_email: 'Tilføj e-mail',
    invite_to_the_group: 'Inviter til gruppen',
    invite_to_the_group_explanation:
      'Kender du en kollega som bruger tolkningstjenester i deres profession? Inviter hende til Túlka',
    invite: 'Inviter',
    invite_success: 'Invitation sendt med succes.',
    invite_to_group: 'Inviter nye personer',
    collaborators_header: 'Dine samarbejdspartnere',
    add_collaborators: 'Tilføj samarbejdspartnere',
    please_enter_email: 'Indtast venligst e-mail',
    name: 'Navn',
    collaborators_header_description:
      'Inviter en samarbejdspartner til at medhåndtere dine bookinger. \nBemærk: Du kan kun invitere en eksisterende bruger.',
    user_does_not_exist:
      'Bruger eksisterer ikke, du kan kun invitere eksisterende bruger',
    invite_to_collaborate_success: 'Bruger inviteret til samarbejde med succes.',
    collaborator_successfully_removed: 'Samarbejdspartner fjernet med succes.',
    invalid_email_address: 'Ugyldig e-mailadresse',
    invalid_phone_number: 'Ugyldigt telefonnummer',
    invalid_phone_number_error: 'Ugyldigt telefonnummer',
    already_registered_phone: 'Dette telefonnummer er allerede registreret til en anden bruger. Kontakt venligst kundeservice ',
    phone_number_cannot_start_with_0: 'Telefonnummer kan ikke starte med 0 i internationalt format',
    email_address_from_different_organisation_domain:
      'E-mailadresse fra andet domæne',
    this_user_already_added_to_collaborators:
      'Denne bruger allerede tilføjet til samarbejdspartnere',
    prebooked: 'Forhåndsbestilt',
    ondemand: 'På efterspørgsel',
    reset_user_password: 'Ændr adgangskode',
    reset_user_email: 'Ændr e-mail til bookingbekræftelser',
    reset_user_email_note_for_interpreter: 'Bemærk: Dette ændrer ikke brugernavnet til login, kun e-mailadressen som bookingbekræftelser og ændringsmeddelelser sendes til.',
    reset_user_email_for_login: 'Ændr e-mail til login',
    please_enter_password: 'Adgangskode',
    please_enter_new_password: 'Ny adgangskode',
    please_enter_current_password: 'Nuværende adgangskode',
    please_repeat_password: 'Gentag adgangskode',
    please_repeat_new_password: 'Ny adgangskode igen',
    passwords_do_not_match: 'Adgangskoder matcher ikke',
    old_password_is_required: 'Gammel adgangskode er påkrævet',
    enter_new_password: 'Indtast ny adgangskode',
    repeat_new_password: 'Gentag ny adgangskode',
    password_requirement:
      'Adgangskode skal være mindst 8 tegn, inklusive et stort og lille bogstav, et tal',
    all_day: 'Hele dagen',
    previous: 'Forrige',
    next: 'Næste',
    // today: 'Today',
    month: 'Måned',
    week: 'Uge',
    day: 'Dag',
    agenda: 'Dagsorden',
    date: 'Dato',
    // time: 'Time',
    event: 'Begivenhed',
    no_events_in_range: 'Ingen begivenheder i området',
    show_more: 'Vis mere',
    reports: 'Rapporter',
    number_of_interpretations: 'Antal tolkninger',
    interpretation_breakdown_previous_month:
      'Tolkningsopdeling - forrige måned',
    your_browser_is_not_supported: 'Din browser understøttes ikke.',
    edge_browser_is_not_supported: 'EDGE browser understøttes ikke. Brug venligst Google Chrome.',
    we_recommend_using_the_latest_version_of_chrome_or_firefox_in_order_to_continue_using_this_service:
      'Vi anbefaler at bruge den seneste version af Chrome eller Firefox for at fortsætte med at bruge denne tjeneste.',
    use_of_interpretation_report: 'Brug af tolkning',
    billing_report: 'Fakturering',
    customer_reporting_report: 'Kunderapportering',
    data_export_report: 'Dataeksport',
    monetra_billing_report: 'Monetra Fakturering',
    monetra_payroll_report: 'Monetra Lønafregning',
    copy_data_to_new_booking: 'Kopier data til ny booking',
    replace_with_new_one: 'Erstat med ny',
    update_at_least_date_or_time_fields_to_create_a_booking:
      'Opdater mindst dato- eller tidsfelter for at oprette en booking',
    cancel_prebook: 'Annuller',
    newButton: 'Ny',
    announcement_interpretation: 'Meddelelsestolkning',
    customer_name_and_date_of_birth:
      'Kundens navn og fødselsdato (til faktura)',
    customer_name: 'Kundens navn (til faktura)',
    date_of_birth: 'Fødselsdato (til faktura)',
    to_whom_the_message_is_forwarded_if_not_to_the_customer:
      'Til hvem beskeden videresends, hvis ikke til kunden',
    telephone_number_to_which_the_interpreter_will_call:
      'Telefonnummer som tolken vil ringe til',
    main_telephone_number_to_which_the_interpreter_will_call:
      'Hoved telefonnummer som tolken vil ringe til',
    additional_telephone_number_to_which_the_interpreter_will_call:
      'Yderligere telefonnummer som tolken vil ringe til',
    message_to_customer_service_or_interpreter:
      'Besked til kundeservice eller tolk',
    mandatory_information: 'Obligatorisk information',
    optional_information: 'Valgfri information',
    customer_data: 'Kundedata',
    write_the_content: 'Beskedindhold',
    write_the_content_of_the_matter_to_be_reported_below:
      'Skriv indholdet af sagen der skal rapporteres nedenfor',
    content_data_tooltip:
      'Beskedtolkning er en envejs, talt tolkning af en besked. Beskedens maksimale længde er 1000 tegn.',
    content_data_second_tooltip:
      'Tolken vil ringe til det angivne telefonnummer mindst 5 gange. Tolkningen af beskeden vil blive betragtet som afsluttet selv når beskeden ikke når kunden.',
    calendar_tooltip_notice_interpretation:
      'Tolken vil ringe til det angivne nummer senest ved slutningen af den valgte dag.',
    calendars: 'Kalendere',
    please_select_language: 'Vælg sprog',
    please_select_interpreter: 'Vælg venligst tolk',
    please_select_language_and_interpreter_to_see_the_calendar:
      'Vælg venligst sprog og tolk for at se kalenderen',
    please_select_time: 'Vælg venligst tid',
    block_time: 'Blokeret tid',
    block_time_description: 'Blokeret tid - I denne tid vil tolken ikke modtage opkald eller forhåndsbestillinger.',
    reservations_od: 'Reservation for OD',
    reservations_od_description: 'Reservation for OD - I denne tid vil tolk ikke modtage forhåndsbestillinger, men vil kun blive målrettet til OD',
    unavailable_time: 'Utilgængelig tid',
    unavailability_type: 'Utilgængelighedstype',
    pick_start_time: 'Vælg starttid',
    pick_end_time: 'Vælg sluttid',
    time_successfuly_blocked: 'Tid blokeret med succes',
    time_successfuly_unblocked: 'Blokeret tid annulleret med succes',
    time_successfuly_updated: 'Blokeret tid opdateret med succes',
    overlaping_information_dialog_mesage:
      'Datoerne overlapper med en eksisterende forhåndsbestilling eller anden utilgængelighed. Fjern venligst overlappende utilgængeligheder, annuller de overlappende forhåndsbestillinger eller brug andre datoer.',
    ok: 'ok',
    cancel_blocked_time_confirmation_message:
      'Er du sikker på at du vil annullere den blokerede tid?',
    cancel_interpreter_blocked_time: 'Fjern blokering',
    relay_the_message_to_person: 'Videresend beskeden til person:',
    birthday: 'Fødselsdato:',
    numbers_to_be_called: 'Numre der skal ringes til:',
    message: 'Besked:',
    to_whom_message_forwarded_if_not_customer: 'Til hvem beskeden videresendes, hvis ikke kunde',
    write_here: 'Skriv her...',
    main_telephone_number_interpreter_will_call: 'Hovedtelefonnummer som tolken ringer til',
    additional_telephone_numbers_interpreter_will_call: 'Yderligere telefonnummer(e) som tolken ringer til',
    phone_required: 'Telefonnummer er påkrævet',
    phone_already_added: 'Telefonnummer er allerede tilføjet',
    enter_phone_number: 'Indtast telefonnummer',
    has_to_be_a_phone_number: 'Skal være et telefonnummer',
    other_information_relevant_to_the_invoicing_such_as_information_about_the_customer:
      'Andre oplysninger relevante for faktureringen, såsom oplysninger om kunden',
    this_invoice_needs_additional_information:
      'Denne faktura har brug for yderligere information. Udfyld venligst de påkrævede felter for at bekræfte din ordre',
    cancelled_by: 'Annulleret af',
    cancel_reason: 'Annulleringsårsag',
    join_to_meeting: 'Deltag i møde',
    ready_to_join: 'Klar til at deltage?',
    what_is_your_name: 'Hvad hedder du?',
    your_name: 'Dit navn',
    waiting_for_luona_worker_and_interpreter:
      'Venter på LUONA medarbejder og tolk...',
    waiting_label: 'Venter...',
    type_message: 'Skriv en besked',
    looking_for: 'Vi forsøger at yde den bedste service men nogle gange tager det tid. Hold venligst ud, vi leder efter',
    luona_worker_persone: 'LUONA medarbejder',
    interpreter_persone: 'Tolk',
    interpreter_status: 'På efterspørgsel-tolkninger',
    availability_yes: 'Tilgængelig nu',
    availability_no: 'Du er ikke tilgængelig.',
    // prebooking luona
    prebooking_page_title: 'Forhåndsbestilling',
    defaultPrebookingPageMessage: 'Du har ikke nogen forhåndsbestillinger',
    go_to_prebookings_list: 'Gå til forhåndsbestillingsliste',
    luona_feedback_title: 'Kvalitetsundersøgelse',
    luona_feedback_description: 'Du har benyttet dig af LUONA\'s nye teknologiske fjernbetjeningsplatform. Vi indsamler feedback om tjenesten, og vi ville være taknemmelige hvis du besvarer vores korte undersøgelse.',
    luona_feedback_score: 'Hvor sandsynligt er det at du vil anbefale denne fjernbetjeningsplatform til en ven?',
    luona_feedback: 'Feedback',
    feedback_sent: 'Tak for din feedback!',
    luona_prefer: 'Foretrukken',
    Luona_lead: 'Lederteam',
    luona_social: 'Social',
    luona_nurses: 'Medicinsk',
    go_to_services: 'Gå til tjenester',
    start_prebook: 'Start',
    prebooking_is_gone: 'Forhåndsbestilling er væk',
    prebooking_not_answered: 'Desværre kan vi ikke levere forhåndsbestillingen. Book en konsultation med en specialist igen',
    prebooking_is_not_found: 'Desværre kan vi ikke finde en matchende aktiv forhåndsbestilling. Prøv venligst at foretage et nødopkald eller book en konsultation med en specialist igen.',
    prebooking_is_cancelled: 'Desværre kan vi ikke finde en matchende aktiv forhåndsbestilling. Måske blev den annulleret. Prøv venligst at foretage et nødopkald eller book en konsultation med en specialist igen.',
    prebooking_is_too_late: 'Desværre er starttidspunktet for forhåndsbestillingen passeret. Efter at have ventet blev tolkene omdirigeret til at håndtere akutte opkald. Prøv venligst at foretage et nødopkald eller book en konsultation med en specialist igen.',
    prebooking_will_start_in: 'Starten af din aftale er om:',
    early_preview_intro: 'Kære LUONA kunde!',
    you_can_close_tab_for_now: 'Du kan lukke denne fane indtil videre.',
    my_prebooking_list: 'Mine reservationer',
    connecting_to_meeting: 'Forbinder til møde',
    connecting_to_meeting_for_interpreter: 'Hold venligst på linjen, vi forbinder alle parter',
    no_access_to_your_camera_or_microphone: 'Ingen adgang til dit kamera eller mikrofon',
    remote_backup_to_onsite: 'Hvad skal du gøre hvis ingen tolk findes på stedet?',
    use_remote_interpretation_option: 'Brug fjerntolkning',
    cancel_prebooking_option: 'Annuller forhåndsbestilling',
    which_remote_interpretation_type_do_you_choose: 'Hvilken fjerntolkningstype vælger du?',
    phone_interpretation: 'Telefontolkning',
    conference_virtual_room: 'Konference / Virtuelt rum (f.eks. Google meet, Teams, Zoom)',
    confirm_you_are_online: 'Gik du? Hvis du vil blive ved med at acceptere opkald klik venligst på knappen "Deltag igen".',
    join_back: 'Deltag igen',
    requestErrorMessageReasonPoorInternet: 'Ups! Noget gik galt. En af årsagerne kan være dårligt internet. Tjek venligst dine internetindstillinger!',
    networkDisconnectedMessage: 'Din internetforbindelse er ikke hurtig nok til videoopkald. Tjek venligst dine internetindstillinger!',
    interpreter_name: 'Tolk',
    meeting_disconnected: 'Du er blevet afbrudt',
    meeting_reconnecting: 'Du bliver genopsat',
    meeting_reconnected: 'Du er blevet genopsat',
    browser_does_not_support_video_effects: 'Browser understøtter ikke videoeffekter',
    // Self-selfRegistration
    user_group_not_found: 'Vi er ikke i stand til at fuldføre din registrering på dette tidspunkt fordi din organisation mangler en påkrævet konfiguration. Kontakt venligst vores kundeservice-team for hjælp til at løse dette problem.',
    log_in: 'log ind',
    sign_up: 'tilmeld dig',
    create_an_account: 'Opret en konto',
    contact_information: 'Kontaktoplysninger',
    first_name: 'Fornavn',
    last_name: 'Efternavn',
    is_personal_email: 'Denne e-mailadresse bruges til at verificere din identitet. Angiv venligst om denne e-mailadresse udelukkende er til personlig kommunikation eller deles med kolleger:',
    email_for_personal: 'E-mail er udelukkende til personlig kommunikation',
    email_shared_with_colleagues: 'E-mail deles med kolleger',
    check_email_again: 'Indtast venligst e-mailadresse igen for at sende verifikations-e-mail.',
    is_personal_phone: 'Dette telefonnummer bruges til at verificere din identitet. Angiv venligst om dette telefonnummer udelukkende er til personlig kommunikation eller deles med kolleger:',
    phone_for_personal: 'Telefonnummer er udelukkende til personlig kommunikation',
    phone_shared_with_colleagues: 'Telefonnummer deles med kolleger',
    check_phone_again_by_sms: 'Indtast venligst telefonnummer igen for at sende verifikations-SMS.',
    check_phone_again_by_call: 'Indtast venligst fastnetnummer igen for at modtage et automatisk opkald.',
    already_have_an_account_part1: 'Har du allerede en konto? ',
    already_have_an_account_part2: 'Log ind ',
    contact_info_email: 'E-mail',
    contact_info_phone: 'Telefonnummer',
    continue: 'Fortsæt',
    confirm_your_email: 'Bekræft din e-mail',
    confirm_your_email_message: 'For at fuldføre registreringen har vi sendt en verifikations-e-mail til den registrerede e-mail. Bekræft venligst e-mail ved at følge instruktionerne i e-mailen.',
    confirm_your_phone: 'Bekræft din telefon',
    confirm_your_mobile_phone_message: 'For at fuldføre registreringen har vi sendt en verifikations-SMS til det registrerede telefonnummer. Bekræft venligst telefonnummeret ved at følge instruktionerne i SMS\'en.',
    confirm_your_phone_message: 'Du vil modtage et automatisk opkald for at verificere ejerskabet af et fastnetnummer. Under opkaldet vil du høre en kode som du skal skrive her.',
    confirmation_code: 'Bekræftelseskode',
    didnt_receive_an_email: 'Modtog du ikke en e-mail?',
    didnt_receive_a_call: 'Modtog du ikke et opkald?',
    didnt_receive_sms: 'Modtog du ikke en SMS?',
    send_email_again: 'Send e-mail igen',
    send_phone_again_for_sms: 'Send SMS igen',
    send_phone_again_for_call: 'Anmod om endnu et tilbageopkald',
    verification_page: 'Verifikationsside',
    verification_link_expired: 'Noget gik galt. Verifikationslinket kan være udløbet. Prøv igen.',
    waiting_for_verification: 'Venter på verifikation',
    select_the_correct_cost_center_regarding_invoicing: 'Vælg det korrekte omkostningscenter vedrørende fakturering. Hvis du ikke kan finde det korrekte omkostningscenter vælg "Jeg kunne ikke finde det korrekte omkostningscenter" mulighed.',
    how_often_do_you_predict_to_utilize_interpretation_services: 'Hvor ofte forudser du at bruge tolkningstjenester?',
    daily: 'Dagligt',
    weekly: 'Ugentligt',
    more_than_weekly: 'Sjældnere end ugentligt',
    periodically: 'Periodisk',
    cost_center: 'Omkostningscenter',
    i_could_not_find_the_correct_cost_center: 'Jeg kunne ikke finde det korrekte omkostningscenter',
    information_regarding_cost_center: 'Information vedrørende omkostningscenter (Industri / afdeling hvor du arbejder)',
    please_tell_us_where_you_work_in_which_unit_etc: 'Fortæl os venligst hvor du arbejder, i hvilken enhed osv.',
    update_user_home_group_failed: 'Opdatering af brugerens hjemmegruppe mislykkedes',
    set_up_your_password: 'Indstil din adgangskode',
    repeat_password: 'Gentag adgangskode',
    set_password_failed: 'Indstilling af adgangskode mislykkedes',
    submit: 'indsend',
    account_created: 'Konto oprettet!',
    you_can_now_login_to_the_tulka_application_using_your_credentials: 'Du kan nu logge ind på Túlka. Knappen nederst på siden tager dig direkte til browserversionen af Túlka.',
    we_have_also_sent_you_instructions_for_use_by_email: 'Vi har også sendt dig instruktionerne via e-mail.',
    open_mobile_app: 'Åbn mobil-app',
    login_to_web: 'Log ind på WEB',
    account_found: 'Konto fundet',
    please_log_in_or_request_a_new_password: 'Log venligst ind eller anmod om en ny adgangskode.',
    forgot_password: 'Glemt adgangskode',
    no_contract_found: 'Ingen kontrakt fundet',
    it_seems_like_you_dont_have_an_contract_with_tulka_based_on_your_email_address: 'Det lader til at du ikke har en kontrakt med Túlka baseret på din e-mailadresse.',
    please_contact_our_sales_to_begin_using_tulka: 'Hvis du vil bruge Túlka, kontakt vores kundeservice via chatten nederst til højre på siden, på telefon {customerServicePhoneNumber} eller via e-mail på {infoEmail}',
    email_already_registered: 'E-mail er allerede registreret med en anden konto.',
    contact_service_with_chat: 'Kontakt venligst kundeservice med chat eller ved at ringe til nummer ',
    contact_service_without_chat: 'Kontakt venligst kundeservice ved at ringe til nummer ',
    contact_sales: 'på telefon 030 660 6400 eller via e-mail på info@tulka.com',
    invalid_code: 'Ugyldig kode',
    invalid_field_value: 'Dette felt er påkrævet og kan ikke være tomt.',
    fistName_requirement: 'Fornavn påkrævet',
    lastName_requirement: 'Efternavn påkrævet',
    contact_service_contacts: 'tlf. 030 660 6400 | info@tulka.com',
    backup_option: 'Backup mulighed',
    no_backup_option_selected: 'Ingen backup mulighed valgt',
    od_details_title: 'Angiv fortolkningens emne og varighed (valgfrit)',
    od_details_subject_subtitle: 'Fortolkningens emne',
    subject_placeholder: 'Deles med tolke',
    estimated_duration: 'Anslået varighed',
    interpreter_level_label: 'Niveau',

    // Translation Order Wizard
    translation_order_title: 'Oversættelsesordre',
    translation_order_step_details: 'Ordredetaljer',
    translation_order_step_invoicing: 'Fakturering og opgavedetaljer',
    translation_order_details: 'Detaljer',
    translation_order_language_from: 'Sprog fra',
    translation_order_language_to: 'Sprog til',
    translation_order_upload_reference: 'Upload referencedokument',
    translation_order_browse_files: 'Gennemse filer',
    translation_order_accepted_types: 'Accepterede filtyper',
    translation_order_estimated_scope: 'Estimeret omfang',
    translation_order_select_type: 'Vælg type',
    translation_order_scope_words: 'Ord',
    translation_order_scope_pages: 'Sider',
    translation_order_scope_minutes: 'Minutter',
    translation_order_scope_help_text: 'Det estimerede omfang af oversættelsen bruges kun til at finde en egnet oversætter og har ingen direkte indvirkning på det fakturerede beløb.',
    translation_order_instructions: 'Instruktioner til oversætter',
    translation_order_instructions_placeholder: 'Tilføj instruktioner til oversætteren...',
    translation_order_message_to_translator: 'Besked til oversætter',
    translation_order_customer_service_instructions: 'Kundeserviceinstruktioner',
    translation_order_delivery_date: 'Ønsket leveringsdato',
    translation_order_delivery_date_help: 'Den ønskede leveringsdato er vejledende og binder ikke oversætteren.',
    translation_order_specifying_invoicing_details: 'Angivelse af faktureringsdetaljer',
    translation_order_invoice_references: 'Faktureringsreferencer',
    translation_order_additional_invoicing_placeholder: 'Feltoplysningerne er ikke synlige for tolken',
    translation_order_notifications: 'Notifikationer',
    translation_order_notification_emails: 'Notifikationsmails',
    translation_order_materials: 'Materialer',
    translation_order_show_all: 'Vis alle',
    translation_order_preview_not_available: 'Forhåndsvisning er ikke tilgængelig for denne filtype',
    translation_order_customer_info: 'Kundeoplysninger',
    translation_order_customer_number: 'Kundenummer',
    translation_order_order_number: 'Ordrenummer',
    translation_order_ordered_by: 'Bestilt af',
    translation_order_ordering_unit: 'Bestillende enhed',
    translation_order_estimated_total: 'Estimeret samlet omfang',
    translation_order_confirmation: 'Ordrebekræftelse',
    translation_order_cancel_order: 'Annuller ordre',
    translation_order_cancel_not_possible: 'Oversættelsen er påbegyndt og kan ikke annulleres her. Kontakt venligst kundeservice.',
    translation_download_material: 'Download materiale',
    translation_upload_material: 'Upload oversættelse',
    uploading: 'Uploader…',
    uploaded: 'Uploadet',
    downloading: 'Downloader…',
    transfer_failed: 'Overførsel mislykkedes',
    translation_translated_materials: 'Oversatte materialer',
    translation_materials_for_translation: 'Materialer til oversættelse',
    translation_order_created_successfully: 'Oversættelsesordre oprettet',
    translation_order_uploading_attachments_notice: 'Venter på, at vedhæftede filer uploades. Hold denne side åben, indtil upload er afsluttet.',
    translation_order_wait_for_upload: 'Vent venligst, indtil de vedhæftede filer er blevet uploadet.',
    translation_order_cancelled_successfully: 'Oversættelsesordre annulleret',
    translation_order_attachment_upload_failed: 'Upload af vedhæftet fil mislykkedes',
    translation_order_submit_failed: 'Oprettelse af oversættelsesordre mislykkedes',
    translation_order_cancel_failed: 'Annullering af oversættelsesordre mislykkedes',
    translation_mark_completed: 'Markér som fuldført',
    translation_mark_completed_success: 'Oversættelse markeret som fuldført',
    translation_mark_completed_failed: 'Kunne ikke markere oversættelse som fuldført',
    translation_change_status: 'Skift',
    translation_task_completed: 'Opgave fuldført',
    translation_revert_completed_failed: 'Kunne ikke fortryde fuldførelsesstatus',
    translation_order_from_language_required: 'Kildesprog er påkrævet',
    translation_order_to_language_required: 'Målsprog er påkrævet',
    translation_order_languages_must_differ: 'Kilde- og målsprog skal være forskellige',
    translation_order_files_required: 'Upload mindst én fil',
    translation_order_scope_required: 'Estimeret omfang er påkrævet',
    translation_order_scope_type_required: 'Omfangstype er påkrævet',
    translation_order_delivery_date_required: 'Ønsket leveringsdato er påkrævet',
    translation_order_delivery_date_too_far: 'Ønsket leveringsdato skal være mindre end 5 år ude i fremtiden',
    translation_order_translator_type: 'Hvilken type oversætter har du brug for?',
    translation_order_translator_type_required: 'Vælg mindst én oversættertype',
  },

  no: {
    no_orderable_contract: 'Ingen kontrakt er tilgjengelig for språkene dine. Ta kontakt med kundeservice.',
    no_translation_contract: 'Ingen av kontraktene dine tillater oversettelsesbestillinger. Ta kontakt med kundeservice.',
    ai_interpreter: 'KI-tolk',
    ai_cost_center: 'Kostnadssenter',
    ai_target_language: 'Målspråk',
    ai_alt_cost_order: 'Alt. kostnad / ordre',
    invoice_ref: 'Fakturaref.',
    ai_download_transcript: 'Last ned transkripsjon',
    ai_download_summary: 'Last ned sammendrag',
    ai_transcription: 'Transkripsjon',
    ai_summary: 'Sammendrag',
    ai_send_email: 'Send e-post',
    ai_send_email_title: 'Send transkripsjon på e-post',
    ai_send_email_explanation: 'Skriv inn e-postadressen transkripsjonen skal sendes til.',
    ai_include_summary: 'Inkluder sammendrag',
    ai_email_subject_placeholder: 'Din referanse for e-postemnet (valgfritt)',
    ai_search_placeholder: 'Søk KI-tolkeoppdrag',
    ai_no_sessions: 'Ingen KI-tolkeøkter ennå',
    ai_download_retention: 'Transkripsjoner og sammendrag kan lastes ned i 24 timer etter at tolkingen er avsluttet.',
    ai_download_unavailable: 'Denne filen er ikke lenger tilgjengelig.',
    ai_download_forbidden: 'Du har ikke tillatelse til å få tilgang til denne filen.',
    ai_download_timeout: 'Filen genereres fortsatt. Vennligst prøv igjen om litt.',
    ai_email_sent: 'E-post sendt.',
    ai_email_failed: 'Kunne ikke sende e-posten.',
    ai_email_invalid: 'Ugyldig e-postadresse.',
    ai_email_domain_not_allowed: 'Dette e-postdomenet er ikke tillatt.',
    ai_allowed_email_domains: 'Tillatte e-postdomener:',
    ai_own_email_only: 'Transkripsjonen kan bare sendes til din egen e-postadresse.',
    please_wait: 'Vennligst vent...',
    done: 'Done',
    fin: 'Finsk',
    eng: 'Engelsk',
    nor: 'Norsk',
    swe: 'Svensk',
    dan: 'Dansk',
    fra: 'Fransk',
    cze: 'Tsjekkisk',
    hrv: 'Kroatisk',
    sqi: 'Albansk',
    ben: 'Bengali',
    amh: 'Amharisk',
    bul: 'Bulgarsk',
    nld: 'Nederlandsk',
    ara: 'Arabisk',
    deu: 'Tysk',
    urd: 'Urdu',
    mya: 'Burmesisk',
    mieli: 'Sinn',
    mainio: 'Flott',
    ccb2b: '📞 Kontakt kundeservice',
    testb2b: '📞 Test / Kontakt kundeservice',
    vls: 'Flamsk',
    ckb: 'Sorani',
    nep: 'Nepalsk',
    prs: 'Dari',
    hurja: 'Vill',
    lao: 'Laotisk',
    no_language_selected: 'Velg språk',
    ui_language: 'Velg språk',
    close: 'Lukk',
    error: 'Feil',
    missing_data: 'Manglende data',
    failed_to_find_prebooking_data: 'Finner ikke denne bestillingen',
    prebooking_was_cancelled: 'Denne bestillingen er kansellert',
    feedback_not_open_yet: 'Oppdraget har ikke startet. Du kan gi oss tilbakemelding når oppdraget er utført.',
    how_did_we_do: 'Hva var din opplevelse av oppdraget?',
    stars_rating_subtitle: 'Din tilbakemelding hjelper oss å forbedre våre tjenester.',
    where_can_we_improve_upon: 'Hva kan bli bedre?',
    leave_open_feedback: 'Gi oss din tilbakemelding',
    describe_your_experience_here: 'Beskriv avviket så konkret som mulig, og gi eksempler på situasjoner der språket, taushetsplikt, tolkeskikk, fagkompetanse eller annet ikke var tilstrekkelig',
    i_wish_to_be_contacted: 'Vennligst kontakt meg',
    choose_one_or_more_options: 'Velg alternativer',
    thank_you_for_your_feedback: 'Takk for tilbakemeldingen!',
    // customer guide for od-call (modal)
    if_neither_number_works: 'Hvis telefonnummeret ikke fungerer, tast inn telefonnummeret slik:',
    order_an_interpreter_by_calling_the_number: 'Bestill en tolk ved å ringe nummer',
    main_calling_number: '02541',
    main_calling_number_with_code: '*47# 02541',
    main_calling_number_with_zero: '0047 02541',
    phone_must_be_registered: 'Telefonnummeret du benytter må være registrert som bestiller i vårt bestillingssystem.',
    note: 'Merk!',
    number_is_encrypted: ' Hvis nummeret ditt er kryptert eller skjult, skriv inn telefonnummeret slik:',
    attention_for_hus: 'Oppmerksomhet HUS kablet nettverksoperatører!',
    contact_to_customer_service: 'Hvis du får problemer, kontakt vår kundeservice direkte.',
    select_interpreter_language: 'Velg fra språk',
    accept_incoming_prebookings: 'Godta eller avslå oppdrag',
    accept: 'Godta',
    decline: 'Avslå',
    accept_all: 'Godta alle',
    date_and_time: 'Dato og tid',
    duration: 'Varighet',
    language: 'Språk',
    presence: 'Oppdragstype',
    prebookings_already_checked: 'Bestilling er allerede sjekket',
    username_not_unique: 'Din mailadresse er allerede i bruk.',
    new_username_set: 'Nytt brukernavn: ',
    luonaSignupForm: 'Registrering',
    label_name: 'Fornavn og etternavn',
    placeholder_name: 'Skriv inn navnet',
    validate_name: 'Mer enn 3 tegn',
    label_phone: 'Telefon',
    placeholder_phone: '+47XXXXXXXX',
    validate_phone: 'telefonnummer i format: +47XXXXXXXX',
    label_email: 'E-post',
    placeholder_email: 'bruker@mail.no',
    validate_email: 'e-post i format: bruker@mail.no',
    label_city: 'By',
    placeholder_city: 'Navn på by',
    validate_city: 'Skriv inn navnet på byen/sted',
    selectOption: 'Velg by',
    agreePrivacyPolicy: 'Jeg godtar ',
    privacyPolicy: 'personvernerklæring',
    luonaSignupButton: 'Send',
    requestErrorMessage: 'Noe gikk galt, vennligst prøv igjen!',
    minimalPrebookingTimeBumperError: 'Starttidspunktet på ditt oppdrag er for tidlig. Vennligst velg et annet tidspunkt.',
    minimalPrebookingOnSiteTimeBumperError: 'Starttiden for tolkning på stedet er for tidlig. Vennligst velg en annen dato og tid.',
    new_password_success: 'Nytt passord er endret',
    new_password_wrong: 'Gammelt passord ikke funnet',
    requestErrorMessageUserNotFound: 'Skriv inn ditt telefonnummer og e-postadresse.',
    requestErrorMessageUserExist: 'Oppgitt e-post eller telefonnummer er allerede i bruk, vennligst prøv et annet.',
    slot_not_free_anymore: 'Beklager, valgt tidsrom er ikke lenger tilgjengelig',
    no_interpreter_in_prebooking: 'Ingen tolk i bestilling',
    back_to_telegram: 'Tilbake til Appen',
    what_is_your_language: 'Hei, hva er ditt språk',
    what_you_need_help_with: 'Hva trenger du hjelp til?',
    selectable_langs: 'Språk',
    selectable_servises: 'Tjenester',
    selectable_time: 'Tid',
    selectable_interpreter: 'Språk er norsk. Trenger du en tolk?',
    authtorize: 'Godkjenning',
    choose_time: 'Velg tidspunkt',
    prebook_not_available_message: 'Dessverre er tjenesten ikke tilgjengelig akkurat nå. Åpningstider: Mandag til fredag {SCHEDULE}',
    health: 'Helse',
    work_or_study: 'Arbeid eller studier',
    money_or_livelihood: 'Penger eller livsopphold',
    reception_allowance: 'Tilskudd / PFS-kort',
    my_money_is_not_enough: 'Går tom for penger',
    copy_email: 'Kopier e-post',
    successfully_copied: 'E-post kopiert',
    copied_to_clipboard: 'Kopiert til utklippstavlen',
    other_practical_matters: 'Andre praktiske saker',
    thanks_for_booking: 'Takk for din bestilling.',
    prebook_created_at: 'Ditt skjermoppdrag har blitt bekreftet:',
    prebooking_skill: 'Sak:',
    you_need_high_network: 'Vennligst sørg for at du har en stabil og rask nettverkstilkobling.',
    you_will_got_accept: 'Du vil motta en bestillingsbekreftelse og påminnelser via SMS og e-post.',
    message_with_link_to_meeting: 'Du vil motta link til skjermoppdraget. Trykk på denne for å komme inn i møtet til avtalt tidspunkt.',
    dont_forget_decline_prebooking: 'Husk å avlyse oppdraget hvis du ikke kan utføre dette.',
    for_decline_need: 'Du kan gjøre det i:',
    click_for_decline_prebooking: 'og klikk deretter på AVLYS-knappen på ditt oppdrag.',
    best_regards: 'Vennlig hilsen,',
    luona_DigiVOK: 'Luona DigiVOK',
    emigration_or_holiday_outside_Finland: 'Emigrasjon eller ferie utenfor Finland',
    free_time: 'Fritid',
    housing: 'Bolig',
    child_care: 'Barn',
    child_health: 'Helse',
    upbringing_parenting: 'Oppdragelse/Foreldre',
    kindergarten_or_school: 'Barnehage eller skole',
    reception_centre_info_service: 'Mottaksenter informasjonstjeneste',
    physical_or_mental_symptoms: 'Helse',
    related_to_money_or_livelihood: 'Økonomisk sikkerhet',
    related_to_your_own_or_family_life_situation: 'Livssituasjon til min egen eller min familie',
    legal_matter: 'Juridisk prosess',
    everyday_practical_things: 'Daglige gjøremål',
    service_housing: 'Bolig',
    how_do_you_judge_the_criticality_of_your_case: 'Hvordan vil du vurdere din sak?',
    help_need_today: 'Haster, bør håndteres i dag',
    help_need_in_couple_of_days: 'Haster, men kan vente noen dager',
    help_is_not_urgent: 'Haster ikke',
    call_now: 'Ring nå',
    book_an_appointment: 'Bestill et oppdrag',
    help_need_in_week: 'Ønsker bistand i løpet av uken',
    authtorize_yourself: 'Bekreft din identitet',
    user_successfully_registered: 'Autorisasjonen var vellykket',
    book_time: 'Bestill tid',
    what_time_works_for_you: 'Hvilken tid passer for deg?',
    wizard_default_message: 'Hvis situasjonen er livstruende, ring 112. Dersom du har helseproblemer som ikke kan vente til neste dag, ring 112 for råd. Dersom det gjelder annen akutt krise, ta kontakt med hjelpetjenesten i din kommune.',
    wizard_welcome_message: 'Velkommen til Hero Tolk! Vi skal gjøre det vi kan for å hjelpe deg. Hvordan kan vi hjelpe deg?',
    wizard_PrebookingStep_header: 'Vi jobber med å håndtere situasjonen. Hvis alle våre ansatte er opptatt, vil du ha muligheten til å bestille en time. Ønsker du å bestille en time eller komme i kontakt med oss nå?',
    wizard_TimeStep_header: 'Dessverre er ingen av våre konsulenter ledige. Du kan bestille tid herfra.',
    loginTitle: 'Logg inn',
    username: 'Brukernavn',
    password: 'Passord',
    loginButton: 'Logg inn',
    loginFailed: 'Innlogging mislyktes',
    sessionExpired: 'Økten er utløpt. Vennligst logg inn igjen.',
    meeting_closed: 'Møtet er avsluttet.',
    signin_code_block_message: 'Denne e-posten er benyttet tidligere. Vi sendte verifikasjonskoden til din e-postadresse: [email]. Vennligst skriv inn verifikasjonskoden i feltet nedenfor. ',
    placeholder_signin_code: 'kode',
    close_meeting_confirmation_message: 'Er du sikker på at du vil avslutte samtalen? For alle deltakere vil denne samtalen bli avsluttet',
    internet_connection_lost: 'Mistet internettforbindelse',
    internet_connection_exist: 'Gjenopprettet internettforbindelse',
    errorTitle: 'Oops!',
    warnTitle: 'Hmm...',
    successTitle: 'Flott!',
    selectLanguage: 'Velg språk',
    interpreter: 'Tolk',
    startInterpreting: 'Tolk',
    requestInterpreting: 'Bestill tolkeoppdrag',
    interpretationNeeded: 'Må ha tolk',
    requestForInterpretation: 'Må ha tolk!',
    requestForCall: 'Kunde tar kontakt',
    nothingToInterpret: 'All forespørsler har blitt besvart.',
    noInterpretationNeeded: 'All forespørsler har blitt besvart.',
    doYouWantToHangUp: 'Vil du virkelig legge på?',
    oppositeSideHangsUp: 'Den andre personen har forlatt samtalen.',
    networkTerminated: 'Samtalen ble koblet fra.',
    review: 'Vurdering',
    customerFeedbackEnjoyingTulka: 'Fornøyd med tjenesten?',
    customerRatingInterpreter: 'Min tilbakemelding om tolken',
    customerInvoiceNotes: 'Referanse',
    deviation: 'Avvik',
    deviation_resolution: 'Avvik status',
    deviation_must_be_resolved_before_confirming: 'Avviket må løses før dette kan bekreftes.',
    interpreterRatingInterpreter: 'Hvordan gikk det?',
    interpreterRatingCustomer: 'Hvor godt gjorde jeg det?',
    ratingQuality: 'Teknisk kvalitet',
    feedback: 'Tilbakemelding',
    feedbackDesc: 'Skriv dine kommentarer her',
    feedbackContactMe: 'Vennligst kontakt meg',
    proceed: 'Send',
    skip: 'Hopp over',
    endCall: 'Avslutt samtale',
    refresh: 'Oppdater',
    logout: 'Logg ut',
    toggleCamera: 'Skru av/på kamera',
    toggleAudio: 'Skru av/på lyd',
    onlyChromeSupported: 'Nettleseren støttes ikke',
    pleaseUseChrome: 'Vennligst installer Google Chrome for å bruke Túlka Web App',
    downloadChrome: 'Klikk her for å installere',
    continueInterpretation: 'Fortsett tolking',
    roomInfoCallEndedClosed: 'Serveren lukket samtalen.',
    feedbackTooLate: 'Fortsett-alternativet er ikke lenger tilgjengelig!',
    noTimeLeft: 'Demoen er avsluttet. Vi kontakter deg snart!',
    minutesConsumed: 'Demoen er nå avsluttet. Vi kontakter deg snart!',
    timeLeft: 'Tolkingstid igjen: {}',
    zeroTimeLeft: 'Demoen er avsluttet.\nVi kontakter deg snart!',
    freeUseLeft: 'Tid igjen',
    failedToSendFeedback: 'Klarte ikke å sende tilbakemelding!',
    failedLogOut: 'Klarte ikke å logge ut.',
    failedToCreateChatroom: 'Klarte ikke å starte en tolking!',
    failedToConnect: 'Klarte ikke å koble til server.',
    waitingForInterpreter: 'Din forespørsel ble sendt til tolkene. Ventetiden er vanligvis 1 til 3 minutter.',
    waitingForCustomer: 'Venter på kunde...',
    waiting_time: 'Ventetiden er',
    pleaseWait: 'Vennligst vent...',
    youHaveWaitedFor: 'Du har ventet {}',
    error500: 'Noe gikk galt. Vennligst prøv igjen.',
    roomInfoHasAudioPacketLoss: 'Dårlig forbindelse!',
    yes: 'Ja',
    no: 'Nei',
    cancel: 'Kanseller',

    // Attachment feature
    attachment_status_pending: 'Behandler...',
    attachment_status_converting: 'Konverterer til PDF...',
    attachment_status_conversion_failed: 'Konvertering mislyktes',
    attachment_fetch_error: 'Kunne ikke laste vedleggsinformasjon',
    attachment_conversion_in_progress: 'Filen konverteres. Vennligst vent...',
    attachment_conversion_failed_download: 'Kan ikke laste ned - konvertering mislyktes. Last opp en annen fil.',
    attachment_deleted: 'Vedlegget er slettet.',
    attachment_download_error: 'Kunne ikke laste ned vedlegg',
    attachment_delete_forbidden: 'Du har ikke tillatelse til å slette dette vedlegget.',
    attachment_delete_error: 'Kunne ikke slette vedlegg',
    attachment_upload_failed: 'Reservasjon opprettet, men opplasting av vedlegg mislyktes. Du kan prøve å laste opp igjen senere.',
    attachment_upload_partial_failed: 'Noen vedlegg ble ikke lastet opp. Prøv igjen.',
    attachment_empty_file: 'Filen er tom',
    attachment_invalid_type: 'Filtypen er ikke tillatt',
    attachment_file_too_large: 'Filen er for stor',
    customer_documents: 'Kundedokumenter',
    attachment_select_file: 'Velg dokument',
    attachment_help_text: 'Støttede formater: PDF, DOCX, PPTX, TXT, PNG, JPG (maks 5MB). Dokumentet blir synlig for den tildelte tolken.',
    no_attachment: 'Ingen dokumenter vedlagt',
    attachment_not_ready: 'Filen er ikke klar for nedlasting',
    attachment_preview_error: 'Kunne ikke laste forhåndsvisning av vedlegg',
    download: 'Last ned',
    delete_attachment: 'Slett vedlegg',
    delete_attachment_title: 'Slette vedlegg?',
    delete_attachment_confirm: 'Er du sikker på at du vil slette denne filen? Denne handlingen kan ikke angres.',
    delete: 'Slette',

    default: 'Standard',
    termsOfUse: 'Bruksvilkår og personvernpolitikk',
    options: 'Vis alternativer',
    hideOptions: 'Skjul alternativer',
    enable_notifications: 'Aktiver varslinger',
    disable_notifications: 'Deaktiver varslinger',
    disable_duration: 'Deaktiver varslinger i',
    for_hour: '1 time',
    for_day: '1 dag',
    for_week: '1 uke',
    for_month: '1 måned',
    for_a_day: '1 dag',
    for_days: '{} dager',
    for_a_day_an_hour: '1 dag, 1 time',
    for_a_day_hours: '1 dag, {} timer',
    for_days_an_hour: '{} dager, 1 time',
    for_days_hours: '{d} dager, {h} timer',
    notifications_disabled_for: 'Varslinger deaktivert i\n{}',
    failed_to_disable_notifications: 'Klarte ikke å deaktivere varslinger. Vennligst prøv igjen senere.',
    failed_to_enable_notifications: 'Klarte ikke å aktivere varslinger. Vennligst prøv igjen senere.',
    forgot_password_link: 'Glemt passordet ditt?',
    forgot_password_info: 'Hvis du har en konto, kan vi sende deg et nytt passord via SMS eller e-post. I andre tilfeller kontakt {infoEmail}.',
    placeholder_phone_number: '+35840...',
    phone_number_title: 'Telefonnummer',
    forgot_password_error: 'SMS-en eller e-posten kunne ikke sendes. Vennligst kontakt {infoEmail}',
    forgot_password_duplicate_email_error: 'Passordet ditt kan ikke tilbakestilles. Vennligst kontakt kundeservice.',
    forgot_password_success: 'Takk. Du skal motta passordet ditt via SMS eller e-post snart.',
    skillModalQuestion: 'Trenger du denne erfaringen? Ventetiden kan bli lengre.',
    od_type_title: 'Hvilken type tolk?',
    od_type_ai: 'AI',
    od_type_ai_subtitle: 'KI-tolk',
    od_type_human: 'Menneske',
    od_type_human_subtitle: 'Menneskelig tolk',
    select_customer_gender: 'Spesifiser kjønn for deg selv og din kunde',
    your_gender: 'Ditt kjønn',
    customer_gender: 'Kundens kjønn',
    male: 'Mann',
    female: 'Kvinne',
    male_interpreter: 'Mannlig tolk',
    female_interpreter: 'Kvinnelig tolk',
    invoice_cause_title: 'Fakturafordeling',
    invoice_cause_subtitle: 'Vennligst velg fakturafordelingsverdien.',
    customer_reference_title: 'Ytterligere faktureringsinformasjon',
    targetLanguage: 'Språk du forstår',
    openingTimes: '',
    systemAlert: 'Tekniske problemer med tjenesten. Beklager.',
    chatFailed: 'Klarte ikke å koble til tekstchat.',
    chatTipInterpreter: 'Her kan du chatte med kunden. Alle meldinger blir ødelagt umiddelbart når tolkingen avsluttes.',
    chatTipCustomer: 'Her kan du chatte med tolken. Alle meldinger blir ødelagt umiddelbart når tolkingen avsluttes.',
    chatSendFailed: 'Klarte ikke å sende meldingen.',
    chatTypeMessage: 'Skriv en melding...',
    invoiceRefMandatory: 'Fakturareferanse er et obligatorisk felt.',
    invoiceRefUserGroupMandatory: 'Vennligst velg en mottaker for fakturaen.',
    selectInvoiceRefUserGroup: '-- Velg --',
    show_feedbacks: 'Vurderinger',
    show_feedbacks_title: 'Hvordan ble jeg vurdert',
    failedToFetchFeedbacks: 'Klarte ikke å hente vurderingene.',
    statistics: 'Mine tolkinger',
    no_statistics: 'Ingen statistikk tilgjengelig.',
    stats_disclaimer: 'Tallene er kun estimater og stemmer ikke nødvendigvis med den endelige lønnslippen.',
    stats_today: 'I dag',
    stats_yesterday: 'I går',
    stats_this_week: 'Denne uken',
    stats_last_week: 'Forrige uke',
    stats_this_month: 'Denne måneden',
    stats_last_month: 'Forrige måned',
    stats_this_year: 'I år',
    stats_last_year: 'I fjor',
    feedbackButton: 'Trykk for å skrive kommentarer',
    feedback_already_exist: 'Tilbakemelding er lukket',
    feedback_need_to_leave: 'Tilbakemelding er åpen',
    feedback_do_next: 'Du kan nå lukke denne fanen.',
    chatroom_not_exist: 'Tilbakemelding ikke åpnet ennå',

    // Prebooking
    prebook: 'Bestill tolk',
    prebooking_date_header: 'Når trenger du en tolk?',
    prebooking_date_header_notice: 'Seneste dato for levering av meldingen',
    step: '{step} av {steps}',
    choose_button: 'Velg',
    prebooking_duration_header: 'Hvor lenge tror du at du trenger en tolk?',
    hours_minutes: '{h}:{m}',
    hour_minutes: '{h}:{m}',
    minutes: '{} min',
    hour: '60 min',
    hours: '{}:00',
    customer_reference: 'Ytterligere faktureringsinformasjon',
    customer_reference_placeholder: 'Denne informasjonen er ikke synlig for tolken',
    please_provide_customer_reference: 'Vennligst oppgi ytterligere informasjon.',
    prebooking_time_header: 'Når trenger du en tolk?',
    select_language_title: 'Hvilket språk skal tolken bruke?',
    fetching_languages: 'Henter språk...',
    invoice_cause: 'Kostnadsfordeling',
    invoice_cause_description: 'Vennligst velg passende kostnadssenter',
    invoice_ref_placeholder: 'NB! Kundeservice leser ikke dette.',
    call_type_video: 'Skjermtolk',
    call_type_call: 'Telefontolk',
    call_type_question: 'Vennligst velg tilkoblingstype',
    additional_order_info: 'Ytterligere bestillingsinformasjon',
    confirm_prebooking: 'Vennligst sjekk bestillingsdetaljene.',
    comment: 'Nødvendig tilleggsinformasjon til bestillingsbehandler',
    prebooking_date: 'Dato',
    prebooking_time: 'Tid',
    prebooking_duration: 'Varighet',
    language_title: 'Språk',
    presence_title: 'Oppdragstype',
    call_type_title: 'Oppdragstype',
    select_target_language_title: 'Hva er språket ditt?',
    location_question: 'Hvor er stedet?',
    location_placeholder_city: 'By',
    location_placeholder_address: 'Gateadresse',
    location_placeholder_postcode: 'Postnummer',
    add_message_to_interpreter: 'Legg til melding til tolk',
    subject: 'Her kan du gi informasjon til tolk om samtalens tema',
    url_for_video_meeting: 'URL/lenke til videomøte',
    url_for_video_meeting_label: 'URL/lenke',
    interpretation_location_details: 'Instruksjoner ved ankomst (f.eks. informasjon om tilgjengelighet, kontor, trapper, etasje, rom, osv.)',
    address_info: 'Adresseinformasjon',
    arrival_instructions: 'Ankomstinstruksjoner',
    addressAndArrivalInstrustions: 'Adresse og ankomstinstruksjoner',
    preferred_interpreters_question: 'Vil du velge en foretrukket tolk?',
    search_preferred_interpreter: 'Finn tolk etter navn',
    not_guarantee: 'Vi gjør vårt beste for å få ønsket tolk, men kan ikke garantere at vedkommende er tilgjengelig.',
    history_is_limited: 'Søkeresultatet er begrenset fordi du ikke har brukt mange tolker ennå.',
    presence_question: 'Hvilken type tolking?',
    presence_remote: 'Fjerntolking',
    presence_remote_tip: 'Via video eller samtale med appen',
    presence_on_site: 'Fremmøtetolk',
    presence_on_site_tip: 'Tolk fysisk tilstede',
    presence_notice: 'Telefonbeskjed',
    presence_notice_tip: 'Skriftlig melding levert som talt tolking',
    remote: 'Ekstern',
    on_site: 'Fremmøtetolk',
    select_favorite: 'Vil du velge foretrukne tolker?',
    any_favorite: 'Ingen preferanse',
    call_type_call_tip: 'Bare stemme ved hjelp av telefonsamtale',
    call_type_video_tip: 'Stemme og bilde ved hjelp av mobildata',
    target_language_title: 'Ditt arbeidsspråk',
    invoice_ref_title: 'Fakturamerke',
    save_prebooking: 'Bestill',
    edit_prebooking: 'Lagre',
    any_gender: 'Spiller ingen rolle',
    any_dialect: 'Ingen spesifikke behov',
    gender_title: 'Kjønn',
    dialect_title: 'Dialekt',
    select_skill: 'Har tolken noen spesielle behov?',
    select_dialect: 'Trenger du en spesifikk dialekt?',
    select_qualification: 'Trenger du spesielle kvalifikasjoner?',
    select_gender: 'Spiller tolkens kjønn en rolle?',
    any_skill: 'Ingen spesielle behov',
    any_qualification: 'Ingen spesifikke kvalifikasjoner',
    skill_title: 'Spesielle behov',
    unconfirmed_prebooking: 'Venter på bekreftelse',
    confirmed: 'Bekreftet',
    delivered: 'Levert',
    not_able_to_reach: 'Ikke i stand til å nå',
    cancelled: 'Kansellert',
    ongoing_prebooking: 'Pågående',
    report_deviation: 'Rapporter avvik',
    active: 'Aktiv',
    location_title_city: 'By',
    location_title_address: 'Gateadresse',
    help_prebooking_summary_title: 'Skriv her kun nødvendig tilleggsinformasjon til bestillingsbehandler',
    help_prebooking_summary: 'Merk at utfylling av dette feltet vil forlenge behandlingstiden for bestillingen.',
    help_call_type_title: 'Tolkingstilkobling',
    help_call_type: 'Med telefontolking kan du inkludere personer som er på forskjellige steder (konferansesamtale).\n\nI videotolking kan personer se hverandre, og du kan også vise tekst til tolken for oversettelse. Video kan aktiveres eller deaktiveres når som helst under tolkingen.\n\nDu kan endre tolkingstilkoblingen ved å avslutte tolkingen og velge "Fortsett tolking".',
    help_gender_title: 'Tolkens kjønn',
    help_gender: 'Du kan be om en tolk av et spesifikt kjønn. Vær oppmerksom på at valget kan resultere i et mindre antall tilgjengelige tolker og gjøre det mindre sannsynlig å få en.',
    help_dialect_title: 'Tolkens dialekt',
    help_dialect: 'Du kan be om en tolk som kjenner en spesifikk dialekt av det valgte språket. Vær oppmerksom på at valget kan resultere i et mindre antall tilgjengelige tolker og gjøre det mindre sannsynlig å få en.',
    help_confirmation_title: 'Bekreft ditt standard kostnadssenter',
    help_confirmation: 'Dine bestillinger vil som standard bli tildelt til ditt standard kostnadssenter, med mindre du spesifiserer et alternativt kostnadssenter når du legger inn bestillingen.',
    tomorrow: 'I morgen',
    today: 'I dag',
    now: 'Nå',
    help_location_title: 'Sted',
    help_location: 'Skriv inn stedet for tolkingen. Dette kan være en adresse eller annen identifikator.',
    help_favorites_title: 'Foretrukne tolker',
    help_favorites: 'Du kan velge en eller flere av dine favoritttolker som de foretrukne tolkene. Hvis en av favorittene er tilgjengelig vil vedkommende bli tildelt tolkingen.',
    on_site_not_available_in_app: 'Tolking på stedet kan ikke startes fra appen.',
    searching_interpreter: 'Leter etter tolk',
    please_call_to_this_number: 'Vennligst ring til dette nummeret',
    back: 'Tilbake',
    back_to_edit: 'Tilbake til redigering',
    confirm_order: 'Bekreft bestilling',
    submitting: 'Sender inn...',
    rejoin_meeting: 'Bli med i møtet igjen',
    change_language: 'Bytt språk',
    prebook_successfully_created: 'Forhåndsbestilling vellykket opprettet',
    prebooking_created_successfully: 'Forhåndsbestilling opprettet vellykket',
    prebookings_created_successfully: '{count} forhåndsbestillinger opprettet vellykket',
    prebook_successfully_edit: 'Forhåndsbestilling vellykket oppdatert',
    prebook_successfully_cancelled: 'Forhåndsbestilling vellykket kansellert',
    prebook_successfully_accepted: 'Forhåndsbestilling vellykket godtatt',
    prebooking_details: 'Bestillingsinformasjon',
    select_contract_title: 'Velg kontrakt',
    select_contract_subtitle: 'Velg kontrakten som skal brukes for denne bestillingen.',
    prebook_confirmation_message: 'Er du sikker på at du vil kansellere oppdraget?',
    cancel_prebook_confirmation_message: 'Er du sikker på at du vil kansellere oppdraget?',
    really_cancel_prebooking_too_late: 'Er du sikker på at du vil kansellere oppdraget? På dette stadiet er ikke kansellering gratis.',
    cancel_reason_selection: 'Hva er årsaken til kanselleringen?',
    cancel_reason_sickness: 'Egen sykdom',
    cancel_sickness_tip: 'Legeerklæring kreves',
    cancel_reason_mistake: 'Feil',
    cancel_reason_other: 'Annet',
    cancel_reason_other_tip: 'En fritekstforklaring kreves.',
    cancel_other_title: 'Forklaring',
    cancel_other: 'Fortell oss hva som skjedde?',
    cancel_sickness_title: 'Legeerklæring',
    cancel_sickness: 'Vennligst send en legeerklæring for sykdommen.',
    copy_information: 'Kopier informasjon',
    my_bookings: 'Bestillinger',
    interpreter_now: 'Tolk nå',
    pre_book: 'Bestill tolk',
    order: 'Bestill',
    hero_order_interpretation: 'Tolking',
    hero_order_translation: 'Oversettelse',
    book_interpretation: 'Bestill tolk',
    time: 'Tid',
    status: 'Status',
    search: 'Søk',
    // Prebooking section titles and mode of interpretation
    details: 'Detaljer',
    preferences: 'Tilleggsinformasjon',
    invoicing_and_assignment_details: 'Oppdragsinformasjon',
    invoicing: 'Fakturering',
    cost_allocation: 'Kostnadssted',
    prebooking_vat_question: 'MVA',
    prebooking_vat_applied: 'MVA inkludert',
    prebooking_vat_exempt: 'MVA-fritatt',
    additional_invoicing_information: 'Referanse',
    field_not_visible_to_interpreter: 'F.eks. PO, fakturareferanse',
    customer_name_for_invoice: 'Kundenavn (for faktura)',
    date_of_birth_for_invoice: 'Fødselsdato (for faktura)',
    recipients_of_confirmation_and_change_notifications: 'Mottakere for bekreftelse- og endringsmeldinger',
    additional_information_for_order_handler: 'Tilleggsinformasjon til Hero Tolk',
    note_filling_this_field_will_prolong_processing_time: 'Merk at utfylling av dette feltet vil forlenge behandlingstiden for ordren.',
    at_least_one_email_required: 'Minst én e-postadresse er påkrevd',
    summary: 'Oppsummering',
    mode_of_interpretation: 'Oppdragstype',
    phone_call: 'Telefontolk',
    phone_call_tip: 'Kun stemme via en telefonsamtale',
    video_call: 'Videosamtale',
    video_call_tip: 'Tale og bilde via mobildata',
    conference_call: 'Skjermtolk via annen løsning',
    conference_call_tip: 'f.eks. Microsoft Teams, Skype, Google Meet, Zoom. Videolenken kan legges inn i feltet "Informasjon til tolken" eller sendes senere på eget ansvar til tolken.',
    video_call_made_via_tulka_app: 'Videosamtale gjøres via Tulká-appen',
    Remote: 'Ekstern',
    presence_onsite: 'På stedet',
    announcement: 'Telefonbeskjed',
    start_time: 'Starttid',
    end_time: 'Sluttid',
    add_another: 'Legg til en annen',
    does_not_matter: 'Spiller ingen rolle',
    no_choice: 'Ingen valg',
    highest: 'Høyest',
    // New prebooking form keys
    select: 'Velg',
    select_notice: 'Skriv kort melding som skal tolkes over telefon',
    required: 'Obligatorisk',
    language_required: 'Språk er obligatorisk',
    interpreted_and_target_language_must_differ: 'Tolket språk og målspråk kan ikke være det samme',
    call_type_required: 'Samtaletype er obligatorisk',
    street_address_required: 'Gateadresse er obligatorisk',
    city_required: 'By er obligatorisk',
    post_code_required: 'Postnummer er obligatorisk',
    message_content_required: 'Meldingsinnhold er obligatorisk',
    customer_name_required: 'Kundenavn er obligatorisk',
    date_of_birth_required: 'Fødselsdato er obligatorisk',
    phone_number_required: 'Telefonnummer er obligatorisk',
    delivery_time: 'Leveringstid',
    date_required: 'Dato er obligatorisk',
    date_too_far_in_future: 'Datoen må være mindre enn 5 år fram i tiden',
    time_required: 'Tid er obligatorisk',
    duration_required: 'Varighet er obligatorisk',
    at_least_one_time_slot_required: 'Minst én tidsluke er obligatorisk',
    street_address: 'Gateadresse',
    post_code: 'Postnummer',
    city: 'By',
    arrival_instruction_at_location: 'Ankomstinstruksjoner på stedet',
    message_content: 'Meldingsinnhold',
    message_max_length_info: 'Maksimal lengde på meldingen er 1000 tegn.',
    last_delivery_date: 'Siste dato for levering av melding',
    delivery_date_info: 'Tolken vil ringe det oppgitte nummeret innen slutten av den valgte dagen.',
    interpreter_gender: 'Tolkes kjønn',
    competence_level_special_need: 'Kompetansenivå',
    competence_level_helper_text: 'Alle nivåer er inkludert som standard. Klikk for å velge bort nivåer du ikke ønsker å bruke. Merk at utvalget av tilgjengelige tolker reduseres om du velger bort noen kompetansenivåer.',
    authorized_interpreter: 'Autorisert tolk',
    court_legal_interpreter: 'Rettshjelp/juridisk tolk',
    healthcare_interpreter: 'Helsetolk',
    registered_trained_interpreter: 'Registrert utdannet tolk',
    other_interpreters: 'Andre tolker',
    other_interpreter_level: 'Øvrig tolk',
    let_system_choose_highest_qualified: 'La systemet velge høyest kvalifiserte tolk',
    experiences: 'Krav',
    security_cleared_interpreter: 'Sikkerhetsgodkjent tolk',
    security_cleared: 'Sikkerhetsgodkjent',
    additional_preferences: 'Ytterligere preferanser',
    open: 'Åpen',
    hide: 'Skjul',
    request_preferred_interpreter: 'Be om foretrukket tolk',
    exclude_specific_interpreters: 'Ekskluder spesifikke tolker',
    interpreters_found_for_your_selections: 'tolker funnet for dine valg',
    how_to_handle_no_onsite_interpreter: 'Hvordan vil du håndtere hvis det ikke finnes en tolk på stedet?',
    assign_remote_interpreter: 'Tildel fjerntolk',
    cancel_booking: 'Avbestill booking',
    // Preferences section keys
    preferences_title: 'Preferanser',
    preferences_interpreter_gender: 'Tolkens kjønn',
    preferences_onsite_fallback: 'Hvordan vil du at vi skal håndtere tilfeller hvor tolk ikke finnes på stedet?',
    preferences_accept_beyond_km: 'Godtar dere tolk utover den kontraktsmessige grensen på {} km én vei?',
    preferences_km_beyond_limit: 'Med hvor mange km vil du godta å gå utover grensen på {} km én vei?',
    preferences_total_max_distance_label_one_way: 'Total maksimal avstand: {} km én vei',
    preferences_total_max_distance_unlimited: 'Total maksimal avstand: ubegrenset',
    unlimited: 'Ubegrenset',
    km_unit: 'km',
    accepts_interpreters_within_km: 'AKSEPTERER TOLKER INNEN ${distance} KM',
    preferences_fallback_assign_remote: 'Tildel fjerntolk',
    preferences_fallback_cancel: 'Avlys bestilling',
    preferences_additional_preferences: 'Be om ønsket tolk',
    preferences_preferred_interpreter: 'Søk etter navngitt tolk',
    preferences_excluded_interpreter: 'Ekskluder spesifikk tolk(er)',
    preferences_search_placeholder: 'Søk tolk etter navn...',
    preferences_ukrainian_russian_fallback: 'Hvis en ukrainsktalende tolk ikke er tilgjengelig, kan vi tildele en russisktalende tolk?',
    preferences_accept_lower_level: 'Hvis tolk på ønsket nivå ikke er tilgjengelig, godtar du et lavere nivå?',
    preferences_remote_backup_connection_type: 'Foretrukket tilkoblingstype for ekstern backup',
    preferences_remote_backup_phone: 'Telefonsamtale',
    preferences_remote_backup_video: 'Videosamtale',
    preferences_remote_backup_conference: 'Konferansesamtale',
    interpreted_language: 'Tolket språk',
    favorite_title: 'Foretrukne tolker',
    no_prebookings: 'Du har ingen forhåndsbestillinger.',
    prebooking_not_active: 'Kontrakten din inkluderer ikke forhåndsbestilling.',
    reservation_number: 'Oppdragsnummer',
    external_order_id: 'Bestillings-ID',
    email: 'E-post',
    not_yet_support_interpreter_login: 'Den nye web-appen støtter ikke tolkepålogging ennå. Vennligst bruk mobilappen.',
    please_try_again_later: 'Vennligst prøv igjen senere.',
    no_languages: 'Ingen språk',
    interpreter_phone_number: 'Telefonnummer',
    remove: 'Slett',
    presence_conference: 'Skjermtolk',
    presence_conference_tip: 'f.eks. Microsoft Teams, Skype, Google Meet, Zoom',
    interpreter_email: 'Tolke e-post',
    all: 'Alle',
    invoice_user_group: 'Firma',
    cc_emails: 'Mottakere av bekreftelse og endringsvarslinger',
    cc_email: 'E-postadresse',
    cc_emails_copy: 'Mottakere av bekreftelse og endringsvarslinger',
    information_for_interpreter: 'Informasjon til tolk',
    patient_name: 'Din klients navn som trenger tolken',
    upload_reference_document_optional: 'Last opp vedlegg (valgfritt)',
    browse_files: 'Bla gjennom filer',
    only_pdf_format_file_visible_to_interpreter: 'Kun PDF-format. Filen er kun synlig for den tildelte tolken.',
    only_pdf_format: 'Kun PDF-format',
    reference_document: 'Referansedokument',
    field_information_not_visible_on_bill: 'Her kan du gi tolk informasjon om oppdraget',
    patient_name_description: 'Denne informasjonen vises ikke på regningen, men går til tolken for informasjon, f.eks. ved arrestasjon.',
    customer: 'Bestiller',
    customer_unit: 'Enhet',
    personal: 'Personlig',
    search_for: 'Søk etter enhet, språk, referanse eller kunde',
    failed_to_create_prebooking: 'Klarte ikke å opprette en ny forhåndsbestilling. Vennligst prøv igjen senere.',
    failed_to_create_all_prebookings: 'Klarte ikke å opprette alle forhåndsbestillinger',
    slot: 'Tidsluke',
    succeeded: 'lyktes',
    failed: 'mislyktes',
    to_start_interpretation: 'For å starte tolking, vennligst ring til dette nummeret:',
    start_interpretation: 'Start tolking',
    hey_username: 'Hei {username},',
    confirm_your_account_information: 'Bekreft din kontoinformasjon',
    confirm_your_account_information_description: 'For å gi den smidigste mulige tjenesten, ber vi deg bekrefte eller korrigere informasjonen nedenfor angående din profil',
    other: 'Annet',
    no_options: 'Ingen søkeresultater',
    search_message: 'Søk...',
    i_confirm_the_information: 'JEG BEKREFTER INFORMASJONEN',
    billing: 'Fakturering',
    translations: 'Oversettelser',
    order_translation: 'Bestill oversettelse',
    translation_order_number: 'Oppdragsnummer',
    translation_order_date: 'Bestillingsdato',
    translation_from: 'Fra språk',
    translation_to: 'Til språk',
    translation_username: 'Brukernavn',
    translation_delivery: 'Leveringsdato',
    translation_user_group: 'Brukergruppe',
    translation_customer: 'Bestiller',
    translation_status: 'Status',
    translation_status_new_order: 'Ny bestilling',
    translation_status_in_progress: 'Pågående',
    translation_status_assigned: 'Tildelt',
    translation_status_completed: 'Fullført',
    translation_status_cancelled: 'Kansellert',
    translation_status_delivered: 'Levert',
    translation_customer_id: 'Oppdragsnummer',
    translation_file_name: 'Filnavn',
    translation_estimated_count: 'Estimert antall',
    translation_due_date: 'Frist oversetter',
    translation_assigned_jobs: 'Oversettelser',
    translation_order: 'Oversettelsesordre',
    translation_details: 'Oppdragsinformasjon',
    translation_customer_information: 'Kundeinformasjon',
    translation_invoicing: 'Fakturering',
    translation_from_language: 'Fra språk',
    translation_to_language: 'Til språk',
    translation_desired_delivery_date: 'Leveringsdato',
    translation_instructions: 'Informasjon til oversetter',
    translation_estimated_total: 'Estimert antall',
    translation_estimated_scope: 'Estimert omfang',
    translation_materials: 'Vedlegg for oversettelse',
    translation_customer_number: 'Kundenummer',
    translation_order_made_by: 'Bestilt av',
    translation_ordering_unit: 'Bestillende enhet',
    checking_your_billing_information: 'Sjekker din faktureringsinformasjon',
    billing_page_main_sub_header: 'Sjekk at tolkingen er for riktig kostnadssenter / enhet og at fakturatreferanseinformasjonen er i samsvar med instruksjonene',
    interpreter_reported_duration: 'Tolkemeldt varighet',
    update: 'Oppdater',
    update_prebook: 'Oppdater forhåndsbestilling',
    your_changes_will_be_lost: 'Er du sikker på at du vil kansellere? Endringene dine vil bli forkastet.',
    settings: 'Innstillinger',
    user_home_group_header: 'Firma/avdeling du har tilgang til',
    app_country: 'Land',
    address: 'Adresse',
    country_placeholder: 'Velg land',
    update_settings: 'Lagre innstillinger',
    has_car: 'Jeg har en bil',
    profile_options: 'Profilalternativer',
    no_invoice_reference: 'Ingen fakturareferanse',
    no_user_group_selected: 'Ingen brukergruppe valgt',
    prebook_successfully_updated: 'Faktureringsinformasjon bekreftet',
    type_search_term_here: 'Skriv søkeord her',
    verify: 'Bekreft',
    prebookings_successfully_updated: 'Faktureringsinformasjon bekreftet',
    alternative_cost_center: 'Referanse 2',
    alternative_cost_center_edit: 'Rediger alternativt kostnadssenter eller ordrenummer',
    choose_default_cost_center: 'Velg standard kostnadssenter',
    enter_or_confirm_username: 'Skriv inn eller bekreft e-posten som brukes til pålogging',
    enter_or_confirm_email: 'Skriv inn eller bekreft en e-postadresse som bestillingsbekreftelser og endringsvarslinger for bestilte tolkinger automatisk sendes til',
    you_can_change_this_information_at_any_time: 'Du kan endre denne informasjonen når som helst fra "Innstillinger"-menyen',
    edit: 'Rediger',
    change_reservation: 'Endre',
    copy_reservation: 'Kopier',
    change_reservation_description: 'Endre reservasjon',
    copy_reservation_description: 'Kopier reservasjon',
    cancel_prebook_description: 'Kanseller reservasjon',
    additional_cost_will_be_charged: 'Tilleggskostnad vil bli belastet. Opprinnelig planlagt tid finner sted innen 24 timer, så denne endringen vil medføre en tilleggsavgift som ved siste minutts kansellering i henhold til prislisten',
    we_will_cancel_this_booking_and_make_a_new_one: 'Vi vil kansellere denne bestillingen og lage en ny hvis du endrer - tid, dato, type, språk, varighet',
    preview: 'Forhåndsvisning',
    edit_prebooking_details: 'Rediger forhåndsbestillingsdetaljer',
    no_invoices: 'Du har ingen bestillinger å behandle for fakturering.',
    add: 'Legg til',
    add_email: 'Legg til e-post',
    invite_to_the_group: 'Inviter til gruppen',
    invite_to_the_group_explanation: 'Kjenner du en kollega som bruker tolketjenester i sitt yrke? Inviter henne til Túlka',
    invite: 'Inviter',
    invite_success: 'Invitasjon vellykket sendt.',
    invite_to_group: 'Inviter nye personer',
    collaborators_header: 'Dine samarbeidspartnere',
    add_collaborators: 'Legg til samarbeidspartnere',
    please_enter_email: 'Vennligst skriv inn e-post',
    name: 'Navn',
    collaborators_header_description: 'Inviter en samarbeidspartner til å administrere bestillingene dine sammen med deg. \nNB: Du kan bare invitere en eksisterende bruker.',
    user_does_not_exist: 'Brukeren finnes ikke, du kan bare invitere eksisterende bruker',
    invite_to_collaborate_success: 'Brukeren er vellykket invitert til å samarbeide.',
    collaborator_successfully_removed: 'Samarbeidspartner vellykket fjernet.',
    invalid_email_address: 'Ugyldig e-postadresse',
    invalid_phone_number: 'Ugyldig telefonnummer',
    invalid_phone_number_error: 'Ugyldig telefonnummer',
    already_registered_phone: 'Dette telefonnummeret er allerede registrert til en annen bruker. Vennligst kontakt kundeservice ',
    phone_number_cannot_start_with_0: 'Telefonnummeret kan ikke starte med 0 i internasjonalt format',
    email_address_from_different_organisation_domain: 'E-postadresse fra annet domene',
    this_user_already_added_to_collaborators: 'Denne brukeren er allerede lagt til samarbeidspartnere',
    prebooked: 'Forhåndsbestilt',
    ondemand: 'Akutt bestilling',
    reset_user_password: 'Endre passord',
    reset_user_email: 'Endre e-post for bestillingsbekreftelser',
    reset_user_email_note_for_interpreter: 'Merk: Dette endrer ikke brukernavnet for innlogging, kun e-postadressen som bookingbekreftelser og endringsvarsler sendes til.',
    reset_user_email_for_login: 'Endre e-post for pålogging',
    please_enter_password: 'Passord',
    please_enter_new_password: 'Nytt passord',
    please_enter_current_password: 'Nåværende passord',
    please_repeat_password: 'Gjenta passord',
    please_repeat_new_password: 'Nytt passord igjen',
    passwords_do_not_match: 'Passordene stemmer ikke overens',
    old_password_is_required: 'Gammelt passord kreves',
    enter_new_password: 'Skriv inn nytt passord',
    repeat_new_password: 'Gjenta nytt passord',
    password_requirement: 'Passordet må ha minst 8 tegn, inkludert én stor og én liten bokstav, og ett tall',
    all_day: 'Hele dagen',
    previous: 'Forrige',
    next: 'Neste',
    month: 'Måned',
    week: 'Uke',
    day: 'Dag',
    agenda: 'Agenda',
    date: 'Dato',
    event: 'Hendelse',
    no_events_in_range: 'Ingen hendelser i området',
    show_more: 'Vis mer',
    reports: 'Rapporter',
    number_of_interpretations: 'Antall tolkinger',
    interpretation_breakdown_previous_month: 'Tolkingsoversikt - forrige måned',
    your_browser_is_not_supported: 'Din nettleser støttes ikke.',
    edge_browser_is_not_supported: 'Edge-nettleseren støttes ikke. Vennligst bruk Google Chrome.',
    we_recommend_using_the_latest_version_of_chrome_or_firefox_in_order_to_continue_using_this_service: 'Vi anbefaler å bruke den nyeste versjonen av Chrome eller Firefox for å fortsette å bruke denne tjenesten.',
    use_of_interpretation_report: 'Tolkeforbruk',
    billing_report: 'Fakturering',
    customer_reporting_report: 'Kunderapportering',
    data_export_report: 'Dataeksport',
    monetra_billing_report: 'Monetra Fakturering',
    monetra_payroll_report: 'Monetra Lønn',
    copy_data_to_new_booking: 'Kopier data til ny bestilling',
    replace_with_new_one: 'Erstatt med ny',
    update_at_least_date_or_time_fields_to_create_a_booking: 'Oppdater minst dato- eller tidsfelt for å opprette en bestilling',
    cancel_prebook: 'Kanseller',
    newButton: 'Ny',
    announcement_interpretation: 'Kunngjøring tolking',
    customer_name_and_date_of_birth: 'Kundens navn og fødselsdato (for faktura)',
    customer_name: 'Kundens navn (for faktura)',
    date_of_birth: 'Fødselsdato (for faktura)',
    to_whom_the_message_is_forwarded_if_not_to_the_customer: 'Til hvem meldingen videresendes, hvis ikke til kunden',
    telephone_number_to_which_the_interpreter_will_call: 'Telefonnummer(e) som tolken vil ringe til',
    main_telephone_number_to_which_the_interpreter_will_call: 'Hovedtelefonnummer som tolken vil ringe til',
    additional_telephone_number_to_which_the_interpreter_will_call: 'Ytterligere telefonnummer som tolken vil ringe til',
    message_to_customer_service_or_interpreter: 'Melding til kundeservice eller tolk',
    mandatory_information: 'Obligatorisk informasjon',
    optional_information: 'Valgfri informasjon',
    customer_data: 'Kundedata',
    customer_information: 'Kundeinformasjon',
    customer_number: 'Kundenummer',
    order_made_by: 'Bestilling utført av',
    ordering_unit: 'Bestillende enhet',
    contract_label: 'Kontrakt',
    write_the_content: 'Meldingsinnhold',
    write_the_content_of_the_matter_to_be_reported_below: 'Skriv innholdet i saken som skal rapporteres nedenfor',
    content_data_tooltip: 'Meldingstolking er en enveis tolking av en muntlig melding. Maksimal lengde på meldingen er 1000 tegn.',
    content_data_second_tooltip: 'Tolken vil ringe det oppgitte telefonnummeret inntil 5 ganger. Tolkingen av meldingen vil bli ansett som fullført selv når meldingen ikke når kunden.',
    calendar_tooltip_notice_interpretation: 'Tolken vil ringe nummeret som er oppgitt innen slutten av den valgte dagen.',
    calendars: 'Kalendere',
    please_select_language: 'Velg språk',
    please_select_interpreter: 'Vennligst velg tolk',
    please_select_language_and_interpreter_to_see_the_calendar: 'Vennligst velg språk og tolk for å se kalenderen',
    please_select_time: 'Vennligst velg tid',
    block_time: 'Blokkert tid',
    block_time_description: 'Blokkert tid - I løpet av denne tiden vil tolken ikke motta noen samtaler eller forhåndsbestillinger.',
    reservations_od: 'Reservasjon for OD',
    reservations_od_description: 'Reservasjon for OD - I løpet av denne tiden vil tolken ikke motta forhåndsbestillinger, men vil kun være målrettet mot OD',
    unavailable_time: 'Utilgjengelig tid',
    unavailability_type: 'Utilgjengeligshetstype',
    pick_start_time: 'Velg starttid',
    pick_end_time: 'Velg sluttid',
    time_successfuly_blocked: 'Tid vellykket blokkert',
    time_successfuly_unblocked: 'Blokkert tid vellykket kansellert',
    time_successfuly_updated: 'Blokkert tid vellykket oppdatert',
    overlaping_information_dialog_mesage: 'Datoene overlapper med en eksisterende forhåndsbestilling eller annen utilgjengelighet. Vennligst fjern overlappende utilgjengeligheter, kanseller overlappende forhåndsbestillinger eller bruk andre datoer.',
    ok: 'ok',
    cancel_blocked_time_confirmation_message: 'Er du sikker på at du vil kansellere den blokkerte tiden?',
    cancel_interpreter_blocked_time: 'Opphev blokkering',
    relay_the_message_to_person: 'Videresend meldingen til person:',
    birthday: 'Fødselsdato:',
    numbers_to_be_called: 'Numre som skal ringes:',
    message: 'Melding:',
    to_whom_message_forwarded_if_not_customer: 'Til hvem meldingen videresendes, hvis ikke kunde',
    write_here: 'Skriv her...',
    main_telephone_number_interpreter_will_call: 'Hoved telefonnummer som tolken ringer',
    additional_telephone_numbers_interpreter_will_call: 'Ekstra telefonnummer(e) som tolken ringer',
    phone_required: 'Telefonnummer er påkrevd',
    phone_already_added: 'Telefonnummer er allerede lagt til',
    enter_phone_number: 'Skriv inn telefonnummer',
    has_to_be_a_phone_number: 'Må være et gyldig telefonnummer',
    other_information_relevant_to_the_invoicing_such_as_information_about_the_customer: 'Annen informasjon relevant for faktureringen, som informasjon om kunden',
    this_invoice_needs_additional_information: 'Denne fakturaen trenger ytterligere informasjon. Vennligst fyll ut de nødvendige feltene for å bekrefte bestillingen din',
    cancelled_by: 'Kansellert av',
    cancel_reason: 'Kanselleringsårsak',
    join_to_meeting: 'Bli med i møtet',
    ready_to_join: 'Klar til å bli med?',
    what_is_your_name: 'Hva heter du?',
    your_name: 'Navnet ditt',
    waiting_for_luona_worker_and_interpreter: 'Venter på Luona-ansatt og tolk...',
    waiting_label: 'Venter...',
    type_message: 'Skriv en melding',
    looking_for: 'Vi prøver å gi den beste tjenesten, men noen ganger tar det tid. Vennligst hold ut, vi leter etter',
    luona_worker_persone: 'Luona-ansatt',
    interpreter_persone: 'Tolk',
    interpreter_status: 'Tolkinger på forespørsel',
    availability_yes: 'Tilgjengelig nå',
    availability_no: 'Du er ikke tilgjengelig.',
    prebooking_page_title: 'Forhåndsbestilling',
    defaultPrebookingPageMessage: 'Du har ingen forhåndsbestillinger',
    go_to_prebookings_list: 'Gå til forhåndsbestillingslisten',
    luona_feedback_title: 'Kvalitetsundersøkelse',
    luona_feedback_description: 'Du har benyttet deg av Luona sitt nye teknologiske fjernserviceplattform. Vi samler tilbakemeldinger om tjenesten, og vi ville være takknemlige hvis du svarer på vår korte undersøkelse.',
    luona_feedback_score: 'Hvor sannsynlig er det at du ville anbefale denne fjernserviceplattformen til en venn?',
    luona_feedback: 'Tilbakemelding',
    feedback_sent: 'Takk for tilbakemeldingen!',
    luona_prefer: 'Foretrukket',
    Luona_lead: 'Lederteam',
    luona_social: 'Sosial',
    luona_nurses: 'Medisinsk',
    go_to_services: 'Gå til tjenester',
    start_prebook: 'Start',
    prebooking_is_gone: 'Forhåndsbestilling er borte',
    prebooking_not_answered: 'Dessverre kan vi ikke levere forhåndsbestillingen. Bestill en konsultasjon med en spesialist igjen',
    prebooking_is_not_found: 'Dessverre kan vi ikke finne en matchende aktiv forhåndsbestilling. Vennligst prøv å foreta et nødanrop eller bestill en konsultasjon med en spesialist igjen.',
    prebooking_is_cancelled: 'Dessverre kan vi ikke finne en matchende aktiv forhåndsbestilling. Kanskje den ble kansellert. Vennligst prøv å foreta et nødanrop eller bestill en konsultasjon med en spesialist igjen.',
    prebooking_is_too_late: 'Dessverre har starttiden for forhåndsbestillingen passert. Etter å ha ventet ble tolkene omdirigert til å håndtere hastesaker. Vennligst prøv å foreta et nødanrop eller bestill en konsultasjon med en spesialist igjen.',
    prebooking_will_start_in: 'Starten på avtalen din er om:',
    early_preview_intro: 'Kjære Luona-kunde!',
    you_can_close_tab_for_now: 'Du kan lukke denne fanen for nå.',
    my_prebooking_list: 'Mine reservasjoner',
    connecting_to_meeting: 'Kobler til møte',
    connecting_to_meeting_for_interpreter: 'Vennligst hold linjen, vi kobler til alle partene',
    no_access_to_your_camera_or_microphone: 'Ingen tilgang til kameraet eller mikrofonen din',
    remote_backup_to_onsite: 'Hva gjør du hvis ingen tolk finnes på stedet?',
    use_remote_interpretation_option: 'Bruk fjerntolking',
    cancel_prebooking_option: 'Kanseller forhåndsbestilling',
    which_remote_interpretation_type_do_you_choose: 'Hvilken fjerntolkingstype velger du?',
    phone_interpretation: 'Telefontolking',
    video_call_interpretation: 'Skjermtolking',
    conference_interpretation: 'Skjermtolking',
    conference_virtual_room: 'Konferanse / virtuelt rom (f.eks. Google meet, Teams, Zoom)',
    confirm_you_are_online: 'Dro du? Hvis du vil fortsette å ta imot samtaler, vennligst klikk knappen "Bli med igjen".',
    join_back: 'Bli med igjen',
    requestErrorMessageReasonPoorInternet: 'Oops! Noe gikk galt. En av årsakene kan være dårlig internettforbindelse. Vennligst sjekk internettinnstillingene dine!',
    networkDisconnectedMessage: 'Internettforbindelsen din er ikke rask nok for videosamtaler. Vennligst sjekk internettinnstillingene dine!',
    interpreter_name: 'Tolk',
    meeting_disconnected: 'Du har blitt koblet fra',
    meeting_reconnecting: 'Du blir tilkoblet på nytt',
    meeting_reconnected: 'Du har blitt tilkoblet på nytt',
    browser_does_not_support_video_effects: 'Nettleseren støtter ikke videoeffekter',
    user_group_not_found: 'Vi kan ikke fullføre registreringen din på dette tidspunktet fordi organisasjonen din mangler nødvendig konfigurasjon. Vennligst kontakt vår kundeservice for hjelp til å løse dette problemet.',
    log_in: 'logg inn',
    sign_up: 'registrer deg',
    create_an_account: 'Opprett en konto',
    contact_information: 'Kontaktinformasjon',
    first_name: 'Fornavn',
    last_name: 'Etternavn',
    is_personal_email: 'Denne e-postadressen brukes til å verifisere identiteten din. Vennligst spesifiser om denne e-postadressen kun er for personlig kommunikasjon eller delt med kolleger:',
    email_for_personal: 'E-post er kun for personlig kommunikasjon',
    email_shared_with_colleagues: 'E-post er delt med kolleger',
    check_email_again: 'Vennligst skriv inn e-postadresse igjen for å sende verifikasjonse-post.',
    is_personal_phone: 'Dette telefonnummeret brukes til å verifisere identiteten din. Vennligst spesifiser om dette telefonnummeret kun er for personlig kommunikasjon eller delt med kolleger:',
    phone_for_personal: 'Telefonnummeret er kun for personlig kommunikasjon',
    phone_shared_with_colleagues: 'Telefonnummeret er delt med kolleger',
    check_phone_again_by_sms: 'Vennligst skriv inn telefonnummer igjen for å sende verifikasjons-SMS.',
    check_phone_again_by_call: 'Vennligst skriv inn fasttelefonnummer igjen for å motta et automatisk anrop.',
    already_have_an_account_part1: 'Har du allerede en konto? ',
    already_have_an_account_part2: 'Logg inn ',
    contact_info_email: 'E-post',
    contact_info_phone: 'Telefonnummer',
    continue: 'Fortsett',
    confirm_your_email: 'Bekreft din e-post',
    confirm_your_email_message: 'For å fullføre registreringen har vi sendt en verifikasjons-e-post til den registrerte e-posten. Vennligst verifiser e-post ved å følge instruksjonene i e-posten.',
    confirm_your_phone: 'Bekreft din telefon',
    confirm_your_mobile_phone_message: 'For å fullføre registreringen har vi sendt en verifikasjons-SMS til det registrerte telefonnummeret. Vennligst verifiser telefonnummeret ved å følge instruksjonene i SMS-en.',
    confirm_your_phone_message: 'Du vil motta et automatisk anrop for å verifisere eierskap av et fasttelefonnummer. Under samtalen vil du høre en kode som du må skrive inn her.',
    confirmation_code: 'Bekreftelseskode',
    didnt_receive_an_email: 'Mottok du ikke en e-post?',
    didnt_receive_a_call: 'Mottok du ikke et anrop?',
    didnt_receive_sms: 'Mottok du ikke SMS?',
    send_email_again: 'Send e-post igjen',
    send_phone_again_for_sms: 'Send SMS igjen',
    send_phone_again_for_call: 'Be om et nytt tilbakering',
    verification_page: 'Verifikasjonsside',
    verification_link_expired: 'Noe gikk galt. Verifikasjonslenken kan ha utløpt. Vennligst prøv igjen.',
    waiting_for_verification: 'Venter på verifisering',
    select_the_correct_cost_center_regarding_invoicing: 'Velg riktig kostnadssenter angående fakturering. Hvis du ikke kan finne riktig kostnadssenter, velg "Jeg kunne ikke finne riktig kostnadssenter"-alternativet.',
    how_often_do_you_predict_to_utilize_interpretation_services: 'Hvor ofte forventer du å bruke tolketjenester?',
    daily: 'Daglig',
    weekly: 'Ukentlig',
    more_than_weekly: 'Sjeldnere enn ukentlig',
    periodically: 'Periodisk',
    cost_center: 'Kostnadssenter',
    i_could_not_find_the_correct_cost_center: 'Jeg kunne ikke finne riktig kostnadssenter',
    information_regarding_cost_center: 'Informasjon angående kostnadssenter (Bransje / avdeling hvor du arbeider)',
    please_tell_us_where_you_work_in_which_unit_etc: 'Vennligst fortell oss hvor du arbeider, i hvilken enhet osv.',
    update_user_home_group_failed: 'Oppdatering av brukerhjemmegruppe mislyktes',
    set_up_your_password: 'Sett opp passordet ditt',
    repeat_password: 'Gjenta passord',
    set_password_failed: 'Innstilling av passord mislyktes',
    submit: 'send inn',
    account_created: 'Konto opprettet!',
    you_can_now_login_to_the_tulka_application_using_your_credentials: 'Du kan nå logge inn på Túlka. Knappen nederst på siden tar deg direkte til nettleserversjonen av Túlka.',
    we_have_also_sent_you_instructions_for_use_by_email: 'Vi har også sendt deg instruksjonene på e-post.',
    open_mobile_app: 'Åpne mobilapp',
    login_to_web: 'Logg inn på WEB',
    account_found: 'Konto funnet',
    please_log_in_or_request_a_new_password: 'Vennligst logg inn eller be om et nytt passord.',
    forgot_password: 'Glemt passord',
    no_contract_found: 'Ingen kontrakt funnet',
    it_seems_like_you_dont_have_an_contract_with_tulka_based_on_your_email_address: 'Det ser ut til at du ikke har en kontrakt med Túlka basert på e-postadressen din.',
    please_contact_our_sales_to_begin_using_tulka: 'Hvis du vil bruke Túlka, kontakt vår kundeservice via chatten nederst til høyre på siden, på telefon {customerServicePhoneNumber} eller via e-post på {infoEmail}',
    email_already_registered: 'E-post er allerede registrert med en annen konto.',
    contact_service_with_chat: 'Vennligst kontakt kundeservice med chat eller ved å ringe nummeret ',
    contact_service_without_chat: 'Vennligst kontakt kundeservice ved å ringe nummeret ',
    contact_sales: 'på telefon 030 660 6400 eller via e-post på info@tulka.com',
    invalid_code: 'Ugyldig kode',
    invalid_field_value: 'Dette feltet er obligatorisk og kan ikke være tomt.',
    fistName_requirement: 'Fornavn kreves',
    lastName_requirement: 'Etternavn kreves',
    contact_service_contacts: 'tlf. 030 660 6400 | info@tulka.com',
    backup_option: 'Backup-alternativ',
    no_backup_option_selected: 'Ingen backup-alternativ valgt',
    od_details_title: 'Angi tolkingens tema og varighet (valgfritt)',
    od_details_subject_subtitle: 'Tolkingens tema',
    subject_placeholder: 'Deles med tolker',
    estimated_duration: 'Anslått varighet',
    interpreter_level_label: 'Nivå',

    // Translation Order Wizard
    translation_order_title: 'Oversettelsesbestilling',
    translation_order_step_details: 'Oppdragsdetaljer',
    translation_order_step_invoicing: 'Fakturainformasjon og oppdragsdetaljer',
    translation_order_details: 'Oppdragsinformasjon',
    translation_order_language_from: 'Fra språk',
    translation_order_language_to: 'Til språk',
    translation_order_dialect: 'Dialekt',
    translation_order_upload_reference: 'Last opp vedlegg',
    translation_order_browse_files: 'Søk i filer',
    translation_order_accepted_types: 'Godkjente filtyper',
    translation_order_total_scope: 'Totalt antall',
    translation_order_estimated_scope: 'Estimert antall',
    translation_order_select_type: 'Velg type',
    translation_order_scope_words: 'Ord',
    translation_order_scope_pages: 'Sider',
    translation_order_scope_minutes: 'Minutter',
    translation_order_scope_help_text: 'Det estimerte omfanget av oversettelsen brukes kun til å finne en egnet oversetter og har ingen direkte innvirkning på fakturabeløpet.',
    translation_order_preferences: 'Tilleggsinformasjon',
    translation_order_instructions: 'Informasjon til oversetter',
    translation_order_instructions_placeholder: 'Legg til instruksjoner til oversetteren...',
    translation_order_message_to_translator: 'Melding til oversetter',
    translation_order_customer_service_instructions: 'Kundeserviceinstruksjoner',
    translation_order_delivery_date: 'Leveringsdato',
    translation_order_delivery_date_help: 'Vennligst vær oppmerksom på at vi ikke kan garantere leveranse til ønsket dato, men skal gjøre vårt beste for å levere innen ønsket frist',
    translation_order_specifying_invoicing_details: 'Faktureringsdetaljer',
    translation_order_invoice_references: 'Fakturareferanser',
    translation_order_additional_invoicing_placeholder: 'Tilleggsinformasjon faktura',
    translation_order_notifications: 'Varsler',
    translation_order_notification_emails: 'Mottakere for bekreftelse- og endringsmeldinger',
    translation_order_add_email: 'Legg til e-post',
    translation_order_materials: 'Vedlegg for oversettelse',
    translation_order_show_all: 'Vis alle',
    translation_order_preview_not_available: 'Forhåndsvisning er ikke tilgjengelig for denne filtypen',
    translation_order_customer_info: 'Kundeinformasjon',
    translation_order_customer_number: 'Kundenummer',
    translation_order_order_number: 'Ordrenummer',
    translation_order_ordered_by: 'Bestiller',
    translation_order_ordering_unit: 'Avdeling',
    translation_order_estimated_total: 'Estimert antall',
    translation_order_confirmation: 'Bekreft bestilling',
    translation_order_cancel_order: 'Kanseller bestilling',
    translation_order_cancel_not_possible: 'Oversettelsen er påbegynt og kan ikke kanselleres her, ta kontakt med kundesenteret',
    translation_download_material: 'Last ned vedlegg',
    translation_upload_material: 'Last opp vedlegg',
    uploading: 'Laster opp…',
    uploaded: 'Lastet opp',
    downloading: 'Laster ned…',
    transfer_failed: 'Overføringen mislyktes',
    translation_translated_materials: 'Ferdig oversettelse',
    translation_materials_for_translation: 'Vedlegg for oversettelse',
    translation_order_created_successfully: 'Oversettelsesbestilling opprettet',
    translation_order_uploading_attachments_notice: 'Venter på at vedlegg blir lastet opp. Vennligst hold denne siden åpen til opplastingen er fullført.',
    translation_order_wait_for_upload: 'Vennligst vent til vedleggene er lastet opp.',
    translation_order_cancelled_successfully: 'Oversettelsesbestilling avbestilt',
    translation_order_attachment_upload_failed: 'Opplasting av vedlegg mislyktes',
    translation_order_submit_failed: 'Opprettelse av oversettelsesbestilling mislyktes',
    translation_order_cancel_failed: 'Avbestilling av oversettelsesbestilling mislyktes',
    translation_mark_completed: 'Merk som utført',
    translation_mark_completed_success: 'Oversettelse merket som fullført',
    translation_mark_completed_failed: 'Kunne ikke merke oversettelse som fullført',
    translation_change_status: 'Endre',
    translation_task_completed: 'Avslutt',
    translation_revert_completed_failed: 'Kunne ikke tilbakestille fullføringsstatus',
    translation_order_from_language_required: 'Kildespråk er påkrevd',
    translation_order_to_language_required: 'Målspråk er påkrevd',
    translation_order_languages_must_differ: 'Kilde- og målspråk må være forskjellige',
    translation_order_files_required: 'Last opp minst én fil',
    translation_order_scope_required: 'Estimert omfang er påkrevd',
    translation_order_scope_type_required: 'Omfangstype er påkrevd',
    translation_order_delivery_date_required: 'Ønsket leveringsdato er påkrevd',
    translation_order_delivery_date_too_far: 'Ønsket leveringsdato må være mindre enn 5 år fram i tiden',
    translation_order_translator_type: 'Hvilken type oversetter trenger du?',
    translation_order_translator_type_required: 'Velg minst én oversettertype',
  },

  de: {
    ai_interpreter: 'KI-Dolmetscher',
    ai_cost_center: 'Kostenstelle',
    ai_target_language: 'Zielsprache',
    ai_alt_cost_order: 'Alt. Kosten / Auftrag',
    invoice_ref: 'Rechnungsref.',
    ai_download_transcript: 'Transkript herunterladen',
    ai_download_summary: 'Zusammenfassung herunterladen',
    ai_transcription: 'Transkript',
    ai_summary: 'Zusammenfassung',
    ai_send_email: 'E-Mail senden',
    ai_send_email_title: 'Transkript per E-Mail senden',
    ai_send_email_explanation: 'Geben Sie die E-Mail-Adresse ein, an die das Transkript gesendet werden soll.',
    ai_include_summary: 'Zusammenfassung einschließen',
    ai_email_subject_placeholder: 'Ihre Referenz für den E-Mail-Betreff (optional)',
    ai_search_placeholder: 'KI-Dolmetschauftrag suchen',
    ai_no_sessions: 'Noch keine KI-Dolmetschsitzungen',
    ai_download_retention: 'Transkripte und Zusammenfassungen können bis zu 24 Stunden nach Ende der Dolmetschung heruntergeladen werden.',
    ai_download_unavailable: 'Diese Datei ist nicht mehr verfügbar.',
    ai_download_forbidden: 'Sie haben keine Berechtigung, auf diese Datei zuzugreifen.',
    ai_download_timeout: 'Die Datei wird noch generiert. Bitte versuchen Sie es in Kürze erneut.',
    ai_email_sent: 'E-Mail gesendet.',
    ai_email_failed: 'E-Mail konnte nicht gesendet werden.',
    ai_email_invalid: 'Ungültige E-Mail-Adresse.',
    ai_email_domain_not_allowed: 'Diese E-Mail-Domain ist nicht zulässig.',
    ai_allowed_email_domains: 'Zulässige E-Mail-Domains:',
    ai_own_email_only: 'Das Transkript kann nur an Ihre eigene E-Mail-Adresse gesendet werden.',
    please_wait: 'Bitte warten...',
    done: 'Done',
    fin: 'Finnisch',
    eng: 'Englisch',
    nor: 'Norwegisch',
    swe: 'Schwedisch',
    dan: 'Dänisch',
    fra: 'Französisch',
    cze: 'Tschechisch',
    hrv: 'Kroatisch',
    sqi: 'Albanisch',
    ben: 'Bengali',
    amh: 'Amharisch',
    bul: 'Bulgarisch',
    nld: 'Niederländisch',
    ara: 'Arabisch',
    deu: 'Deutsch',
    urd: 'Urdu',
    mya: 'Birmanisch',
    mieli: 'Mieli',
    mainio: 'Mainio',
    ccb2b: '📞 Kundendienst kontaktieren',
    testb2b: '📞 Testen / Kontakt zum Kundendienst',
    vls: 'Flämisch',
    ckb: 'Sorani',
    nep: 'Nepalesisch',
    prs: 'Dari',
    hurja: 'Hurja',
    lao: 'Laotisch',
    no_language_selected: 'Keine Sprache ausgewählt',
    ui_language: 'Sprache der Benutzeroberfläche',
    close: 'Schließen',
    // feedback
    failed_to_find_prebooking_data: 'Diese Vorabbuchung konnte nicht gefunden werden',
    prebooking_was_cancelled: 'Diese Vorabbuchung wurde storniert',
    feedback_not_open_yet: 'Da die Dolmetschleistung noch nicht stattgefunden hat, können Sie uns zu diesem Zeitpunkt kein Feedback geben.',
    how_did_we_do: 'Wie war Ihre Erfahrung?',
    stars_rating_subtitle: 'Ihr Feedback hilft uns, unseren Service zu verbessern.',
    where_can_we_improve_upon: 'Wie können wir uns verbessern?',
    leave_open_feedback: 'Feedback als Freitext geben',
    describe_your_experience_here: 'Erzählen Sie uns in Ihren eigenen Worten, was passiert ist',
    i_wish_to_be_contacted: 'Ich möchte kontaktiert werden',
    choose_one_or_more_options: 'Wählen Sie eine oder mehrere Optionen',
    thank_you_for_your_feedback: 'Vielen Dank für Ihr Feedback!',
    // customer guide for od-call (modal)
    if_neither_number_works: 'Wenn beide Nummern nicht funktionieren, geben Sie die Servicenummer im folgenden Format ein:',
    order_an_interpreter_by_calling_the_number: 'Bestellen Sie einen Dolmetscher unter der folgenden Telefonnummer',
    main_calling_number: '041 400 1234',
    main_calling_number_with_code: '*31# 041 400 1234',
    main_calling_number_with_zero: '0041 400 1234',
    phone_must_be_registered: 'Das Telefon, mit dem Sie unsere Notrufnummer anrufen, muss in unserem System registriert sein.',
    note: 'Hinweis!',
    number_is_encrypted: ' Wenn Ihre Nummer verschlüsselt ist, geben Sie die Servicenummer im folgenden Format ein:',
    attention_for_hus: 'Achtung HUS-Betreiber für kabelgebundene Netzwerke!',
    contact_to_customer_service: 'Bei Problemen wenden Sie sich an unseren Kundendienst.',
    select_interpreter_language: 'Nachdem die Verbindung hergestellt wurde, wählen Sie die zu dolmetschende Sprache aus der folgenden Liste aus, indem Sie die Nummer über die Zifferntasten des Telefons eingeben',
    accept_incoming_prebookings: 'Eingehende Vorabbuchungen annehmen oder ablehnen',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    accept_all: 'Alle annehmen',
    date_and_time: 'Datum und Uhrzeit',
    duration: 'Dauer',
    language: 'Sprache',
    presence: 'Präsenz',
    prebookings_already_checked: 'Vorabbuchungen bereits überprüft',
    username_not_unique: 'Die E-Mail-Adresse für die Anmeldung ist nicht eindeutig.',
    new_username_set: 'Neuer Benutzername festgelegt: ',
    // LUONA
    luonaSignupForm: 'Anmeldeformular',

    label_name: 'Vor- und Nachname',
    placeholder_name: 'Nur lateinische Buchstaben',
    validate_name: 'Mehr als 3 Zeichen',

    label_phone: 'Telefon',
    placeholder_phone: '+3XXXXXXXXXXX',
    validate_phone: 'Mobiltelefonnummer im Format: +XXXXXXXXXXXX',

    label_email: 'E-Mail-Adresse',
    placeholder_email: 'benutzer@mail.com',
    validate_email: 'E-Mail-Adresse im Format: benutzer@mail.com',

    label_city: 'Stadt',
    placeholder_city: 'Stadtname',
    validate_city: 'Nur lateinische Buchstaben',
    selectOption: 'Stadt auswählen',

    agreePrivacyPolicy: 'Ich stimme zu ',
    privacyPolicy: 'Datenschutzrichtlinie',
    luonaSignupButton: 'Senden',
    requestErrorMessage: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut!',
    minimalPrebookingTimeBumperError: 'Der gewünschte Vorabbuchungszeitraum ist zu früh. Bitte wählen Sie einen anderen Zeitraum aus.',
    minimalPrebookingOnSiteTimeBumperError: 'Die Startzeit für die Dolmetschung vor Ort ist zu früh. Bitte wählen Sie ein anderes Datum und eine andere Uhrzeit.',
    new_password_success: 'Neues Passwort erfolgreich hinzugefügt',
    new_password_wrong: 'Altes Passwort nicht gefunden',
    requestErrorMessageUserNotFound: 'Geben Sie die registrierte Telefonnummer und E-Mail-Adresse ein.',
    requestErrorMessageUserExist:
      'Die angegebene E-Mail-Adresse oder Telefonnummer wird bereits verwendet. Bitte versuchen Sie eine andere.',
    slot_not_free_anymore: 'Der gewählte Zeitraum ist nicht mehr verfügbar',
    no_interpreter_in_prebooking: 'Kein Dolmetscher zur Vorabbuchung',
    back_to_telegram: 'Zurück zu Telegram',
    what_is_your_language: 'Hallo, welche Sprache sprechen Sie',
    what_you_need_help_with: 'Wobei benötigen Sie Hilfe?',
    selectable_langs: 'Sprache',
    selectable_servises: 'Dienste',
    selectable_time: 'Zeit',
    selectable_interpreter: 'Die Beratungsgespräche finden auf Englisch oder Finnisch statt. Benötigen Sie einen Dolmetscher?',
    authtorize: 'Autorisierung',
    choose_time: 'Bitte wählen Sie den Zeitpunkt für Ihre Vorabbuchung aus.',
    prebook_not_available_message: 'Leider ist dieser Service derzeit nicht verfügbar. Arbeitszeit: Montag bis Freitag {SCHEDULE}',
    health: 'Gesundheit',
    work_or_study: 'Arbeit oder Studium',
    money_or_livelihood: 'Geld oder Lebensunterhalt',
    reception_allowance: 'Aufnahmebeihilfe/PFS-Karte',
    my_money_is_not_enough: 'Das Geld geht zur Neige',
    copy_email: 'E-Mail kopieren',
    successfully_copied: 'E-Mail erfolgreich kopiert',
    copied_to_clipboard: 'In die Zwischenablage kopiert',
    other_practical_matters: 'Andere praktische Inhalte',
    thanks_for_booking: 'Vielen Dank für Ihre Reservierung!',
    prebook_created_at: 'Ihre Videokonferenz wurde wie folgt bestätigt:',
    prebooking_skill: 'Problem:',
    you_need_high_network: 'Um die Qualität des Meetings zu gewährleisten, stellen Sie bitte sicher, dass Sie über eine stabile und schnelle Netzwerkverbindung verfügen, die für Videokonferenzen ausreicht.',
    you_will_got_accept: 'Sie erhalten eine Buchungsbestätigung und zwei Erinnerungen per SMS und E-Mail.',
    message_with_link_to_meeting: 'Die Nachrichten enthalten einen Link, über den Sie zur vereinbarten Zeit am Meeting teilnehmen können.',
    dont_forget_decline_prebooking: 'Denken Sie daran, das Meeting abzusagen, wenn Sie nicht teilnehmen können.',
    for_decline_need: 'Sie können dies wie folgt tun:',
    click_for_decline_prebooking: 'und klicken Sie dann auf die Schaltfläche LÖSCHEN in Ihrer Vorabbuchung.',
    best_regards: 'Mit freundlichen Grüßen',
    luona_DigiVOK: 'Luona DigiVOK',
    emigration_or_holiday_outside_Finland:
      'Auswanderung oder Urlaub außerhalb Finnlands',
    free_time: 'Freizeit',
    housing: 'Wohnen',
    child_care: 'Kind',
    child_health: 'Gesundheit',
    upbringing_parenting: 'Erziehung/Elternschaft',
    kindergarten_or_school: 'Kindergarten oder Schule',
    reception_centre_info_service: 'Informationsdienst des Aufnahmezentrums',
    physical_or_mental_symptoms: 'Gesundheit',
    related_to_money_or_livelihood: 'Finanzielle Sicherheit',
    related_to_your_own_or_family_life_situation:
      'Umstände in Bezug auf mich oder meine Familie',
    legal_matter: 'Rechtsangelegenheit',
    everyday_practical_things: 'Tägliche, alltägliche praktische Dinge',
    service_housing: 'Wohnen',
    how_do_you_judge_the_criticality_of_your_case:
      'Wie bewerten Sie die Dringlichkeit Ihres Falls?',
    help_need_today: 'Dringend, sollte heute erledigt werden',
    help_need_in_couple_of_days: 'Dringend, kann aber einige Tage warten',
    help_is_not_urgent: 'Nicht dringend',
    call_now: 'Jetzt anrufen',
    book_an_appointment: 'Termin buchen',

    help_need_in_week: 'Hilfe innerhalb einer Woche benötigt',
    authtorize_yourself: 'Autorisieren Sie sich',
    user_successfully_registered: 'Autorisierung erfolgreich',
    book_time: 'Zeit buchen',
    what_time_works_for_you: 'Welche Zeit passt Ihnen?',
    wizard_default_message:
      'Wenn die Situation lebensbedrohlich ist, rufen Sie die 112 an. Wenn Ihr Gesundheitsproblem nicht bis zum nächsten Werktag warten kann, rufen Sie die 116117 an, um sich beraten zu lassen. Bei anderen akuten Krisen wenden Sie sich bitte an den sozialen Krisendienst Ihrer Gemeinde.',
    wizard_welcome_message:
      'Willkommen beim Luona-Service! Wir werden alles tun, was wir können, um Ihnen zu helfen. Was können wir für Sie tun?',
    wizard_PrebookingStep_header:
      'Wir bemühen uns, Anliegen umgehend zu bearbeiten. Sollten alle unsere Mitarbeiter bereits ausgebucht sein, haben Sie die Möglichkeit, über diese Seite einen Termin zu vereinbaren. Möchten Sie einen Termin vereinbaren oder uns gleich anrufen?',
    wizard_TimeStep_header:
      'Leider konnte Ihnen derzeit niemand antworten. Sie können hier einen Termin vereinbaren.',
    // LUONA

    loginTitle: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    loginButton: 'Anmelden',
    loginFailed: 'Anmeldung fehlgeschlagen',
    sessionExpired: 'Die Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    meeting_closed: 'Das Meeting wurde geschlossen.',
    signin_code_block_message: 'Diese E-Mail-Adresse wurde bereits zuvor verwendet. Wir haben den Bestätigungscode an Ihre E-Mail-Adresse [email] gesendet. Bitte geben Sie den Bestätigungscode in das Feld unten ein. ',
    placeholder_signin_code: 'Code',
    close_meeting_confirmation_message: 'Sind Sie sicher, dass Sie den Anruf beenden möchten? Für alle Teilnehmer wird dieser Anruf ebenfalls beendet',
    internet_connection_lost: 'Internetverbindung verloren',
    internet_connection_exist: 'Internetverbindung wiederhergestellt',
    errorTitle: 'Hoppla!',
    warnTitle: 'Hmm ...',
    successTitle: 'Super!',

    selectLanguage: 'Sprache wählen',
    interpreter: 'Dolmetscher',
    startInterpreting: 'Dolmetschen',
    requestInterpreting: 'Dolmetschleistung anfordern',

    interpretationNeeded: 'Dolmetschleistung erforderlich',
    requestForInterpretation: 'Dolmetschleistung wird benötigt!',
    requestForCall: 'Kunde nimmt Kontakt auf',
    nothingToInterpret: 'Alle Anfragen wurden beantwortet.',
    noInterpretationNeeded: 'Alle Anfragen wurden beantwortet.',

    doYouWantToHangUp: 'Möchten Sie das Gespräch wirklich beenden?',
    oppositeSideHangsUp: 'Die andere Person hat das Gespräch verlassen.',
    networkTerminated: 'Die Verbindung wurde getrennt.',
    review: 'Bewertung',
    customerFeedbackEnjoyingTulka: 'Sind Sie mit dem Service zufrieden?',
    customerRatingInterpreter: 'Mein Feedback zum Dolmetscher',
    customerInvoiceNotes: 'Rechnungsreferenz',
    deviation: 'Abweichung',
    deviation_resolution: 'Abweichungslösung',
    deviation_must_be_resolved_before_confirming: 'Die Abweichung muss gelöst werden, bevor dies bestätigt werden kann.',
    interpreterRatingInterpreter: 'Wie ist es gelaufen?',
    interpreterRatingCustomer: 'Wie gut habe ich es gemacht?',
    ratingQuality: 'Technische Qualität',
    feedback: 'Feedback',
    feedbackDesc: 'Schreiben Sie hier Ihre Kommentare',
    feedbackContactMe: 'Bitte kontaktieren Sie mich',
    proceed: 'Senden',
    skip: 'Überspringen',

    endCall: 'Anruf beenden',
    refresh: 'Aktualisieren',
    logout: 'Abmelden',
    toggleCamera: 'Kamera umschalten',
    toggleAudio: 'Audio umschalten',

    onlyChromeSupported: 'Browser wird nicht unterstützt',
    pleaseUseChrome: 'Bitte installieren Sie Google Chrome, um die Túlka Web App zu verwenden',
    downloadChrome: 'Hier klicken zum Installieren',
    continueInterpretation: 'Dolmetschleistung fortsetzen',
    roomInfoCallEndedClosed: 'Der Server hat das Gespräch beendet.',
    feedbackTooLate: 'Option zum Fortsetzen nicht mehr verfügbar!',

    noTimeLeft: 'Die Demo-Nutzung ist beendet. Wir werden Sie bald kontaktieren!',
    minutesConsumed: 'Die Demo-Nutzung ist nun beendet. Wir werden Sie bald kontaktieren!',
    timeLeft: 'Verbleibende Dolmetschzeit: {}',
    zeroTimeLeft: 'Die Demo-Nutzung ist beendet.\nWir werden Sie bald kontaktieren!',
    freeUseLeft: 'Verbleibende Zeit',

    failedToSendFeedback: 'Das Feedback konnte nicht gesendet werden!',
    failedLogOut: 'Abmeldung fehlgeschlagen.',
    failedToCreateChatroom: 'Die Dolmetschleistung konnte nicht gestartet werden!',
    failedToConnect: 'Verbindung zum Server fehlgeschlagen.',
    waitingForInterpreter:
      'Ihre Anfrage wurde an die Dolmetscher gesendet. Die Wartezeit beträgt normalerweise 1 bis 3 Minuten.',
    waitingForCustomer: 'Warten auf Kunden ...',
    waiting_time: 'Die Wartezeit beträgt',
    pleaseWait: 'Bitte warten ...',
    youHaveWaitedFor: 'Sie haben {} gewartet',
    error500: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    roomInfoHasAudioPacketLoss: 'Schlechte Verbindung!',

    yes: 'Ja',
    no: 'Nein',
    cancel: 'Abbrechen',

    // Attachment feature
    attachment_status_pending: 'Wird verarbeitet ...',
    attachment_status_converting: 'Wird in PDF konvertiert ...',
    attachment_status_conversion_failed: 'Konvertierung fehlgeschlagen',
    attachment_fetch_error: 'Die Informationen zum Anhang konnten nicht geladen werden',
    attachment_conversion_in_progress: 'Datei wird konvertiert. Bitte warten ...',
    attachment_conversion_failed_download: 'Download nicht möglich – Konvertierung fehlgeschlagen. Bitte laden Sie eine andere Datei hoch.',
    attachment_deleted: 'Anhang wurde gelöscht.',
    attachment_download_error: 'Anhang konnte nicht heruntergeladen werden',
    attachment_delete_forbidden: 'Sie haben keine Berechtigung, diesen Anhang zu löschen.',
    attachment_delete_error: 'Anhang konnte nicht gelöscht werden',
    attachment_upload_failed: 'Reservierung erstellt, aber Anhang-Upload fehlgeschlagen. Sie können es später erneut versuchen.',
    attachment_upload_partial_failed: 'Bei einigen Buchungen ist das Hochladen der Anhänge fehlgeschlagen. Bitte versuchen Sie es erneut.',
    attachment_empty_file: 'Datei ist leer',
    attachment_invalid_type: 'Der Dateityp ist nicht erlaubt. Erlaubte Formate: PDF, DOCX, PPTX, TXT, PNG, JPG.',
    attachment_file_too_large: 'Datei ist zu groß',
    customer_documents: 'Kundendokumente',
    attachment_select_file: 'Dokument auswählen',
    attachment_help_text: 'Unterstützte Formate: PDF, DOCX, PPTX, TXT, PNG, JPG (max. 5 MB). Das Dokument ist für den zugewiesenen Dolmetscher sichtbar.',
    no_attachment: 'Kein Dokument angehängt',
    attachment_not_ready: 'Datei ist noch nicht zum Download bereit',
    attachment_preview_error: 'Vorschau des Anhangs konnte nicht geladen werden',
    download: 'Herunterladen',
    delete_attachment: 'Anhang löschen',
    delete_attachment_title: 'Möchten Sie den Anhang löschen?',
    delete_attachment_confirm: 'Sind Sie sicher, dass Sie diese Datei löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    delete: 'Löschen',

    default: 'Standard',
    termsOfUse: 'Nutzungsbedingungen und Datenschutzrichtlinie',
    options: 'Optionen anzeigen',
    hideOptions: 'Optionen ausblenden',

    enable_notifications: 'Benachrichtigungen aktivieren',
    disable_notifications: 'Benachrichtigungen deaktivieren',
    disable_duration: 'Benachrichtigungen deaktivieren für',
    for_hour: '1 Stunde',
    for_day: '1 Tag',
    for_week: '1 Woche',
    for_month: '1 Monat',
    for_a_day: '1 Tag',
    for_days: '{} Tage',
    for_a_day_an_hour: '1 Tag, 1 Stunde',
    for_a_day_hours: '1 Tag, {} Stunden',
    for_days_an_hour: '{} Tage, 1 Stunde',
    for_days_hours: '{d} Tage, {h} Stunden',
    notifications_disabled_for: 'Benachrichtigungen deaktiviert für\n{}',
    failed_to_disable_notifications:
      'Die Benachrichtigungen konnten nicht deaktiviert werden. Bitte versuchen Sie es später erneut.',
    failed_to_enable_notifications:
      'Die Benachrichtigungen konnten nicht aktiviert werden. Bitte versuchen Sie es später erneut.',
    forgot_password_link: 'Passwort vergessen?',
    forgot_password_info:
      'Wenn Sie ein Konto haben, können wir Ihnen ein neues Passwort per SMS oder E-Mail senden. Andernfalls wenden Sie sich an {infoEmail}.',
    placeholder_phone_number: '+35840...',
    phone_number_title: 'Telefonnummer',
    forgot_password_error:
      'Die SMS oder E-Mail konnte nicht gesendet werden. Bitte wenden Sie sich an {infoEmail}',
    forgot_password_duplicate_email_error:
      'Ihr Passwort kann nicht zurückgesetzt werden. Bitte wenden Sie sich an unseren Kundendienst.',
    forgot_password_success:
      'Vielen Dank! Sie sollten Ihr Passwort in Kürze per SMS oder E-Mail erhalten.',
    skillModalQuestion:
      'Benötigen Sie diesen Service? Die Wartezeit kann länger sein.',
    od_type_title: 'Welche Art von Dolmetscher?',
    od_type_ai: 'KI',
    od_type_ai_subtitle: 'KI-Dolmetscher',
    od_type_human: 'Mensch',
    od_type_human_subtitle: 'Menschlicher Dolmetscher',
    select_customer_gender: 'Geben Sie Ihr Geschlecht und das Ihres Kunden an',
    your_gender: 'Ihr Geschlecht',
    customer_gender: 'Geschlecht des Kunden',
    male: 'Männlich',
    female: 'Weiblich',
    invoice_cause_title: 'Rechnungsaufschlüsselung',
    invoice_cause_subtitle: 'Bitte wählen Sie den Wert für die Rechnungsaufschlüsselung.',
    customer_reference_title: 'Zusätzliche Rechnungsinformationen',
    targetLanguage: 'Sprache, die Sie verstehen',
    openingTimes: '',
    systemAlert: 'Es sind technische Probleme mit dem Service aufgetreten. Wir bitten um Entschuldigung.',

    chatFailed: 'Verbindung zum Text-Chat fehlgeschlagen.',
    chatTipInterpreter:
      'Hier können Sie mit dem Kunden chatten. Alle Nachrichten werden sofort gelöscht, wenn die Dolmetschleistung endet.',
    chatTipCustomer:
      'Hier können Sie mit dem Dolmetscher chatten. Alle Nachrichten werden sofort gelöscht, wenn die Dolmetschleistung endet.',
    chatSendFailed: 'Die Nachricht konnte nicht gesendet werden.',
    chatTypeMessage: 'Nachricht eingeben ...',
    invoiceRefMandatory: 'Rechnungsreferenz ist ein Pflichtfeld.',
    invoiceRefUserGroupMandatory: 'Bitte wählen Sie einen Empfänger für die Rechnung.',
    selectInvoiceRefUserGroup: '-- Auswählen --',

    show_feedbacks: 'Bewertungen',
    show_feedbacks_title: 'Wie ich bewertet wurde',
    failedToFetchFeedbacks: 'Die Bewertungen konnten nicht abgerufen werden.',
    statistics: 'Meine Dolmetschleistung',
    no_statistics: 'Keine Statistiken verfügbar.',
    stats_disclaimer:
      'Die Zahlen sind nur Schätzungen und stimmen möglicherweise nicht genau mit der endgültigen Gehaltsabrechnung überein.',
    stats_today: 'Heute',
    stats_yesterday: 'Gestern',
    stats_this_week: 'Diese Woche',
    stats_last_week: 'Letzte Woche',
    stats_this_month: 'Diesen Monat',
    stats_last_month: 'Letzten Monat',
    stats_this_year: 'Dieses Jahr',
    stats_last_year: 'Letztes Jahr',

    feedbackButton: 'Tippen, um Kommentare zu schreiben',
    feedback_already_exist: 'Feedback ist geschlossen',
    feedback_need_to_leave: 'Feedback ist offen',
    feedback_do_next: 'Sie können diesen Tab jetzt schließen.',
    chatroom_not_exist: 'Feedback noch nicht offen',

    // Prebooking
    prebook: 'Vorgebuchte Dolmetschleistung',
    prebooking_date_header: 'Wann benötigen Sie einen Dolmetscher?',
    prebooking_date_header_notice: 'Letztes Datum für die Zustellung der Nachricht',
    step: '{step} von {steps}',
    choose_button: 'Auswählen',
    prebooking_duration_header:
      'Wie lange werden Sie voraussichtlich einen Dolmetscher benötigen?',
    hours_minutes: '{h}:{m}',
    hour_minutes: '{h}:{m}',
    minutes: '{} Min.',
    hour: '60 Min.',
    hours: '{}:00',
    customer_reference: 'Zusätzliche Rechnungsinformationen',
    customer_reference_placeholder: 'Die Feldinformationen sind für den Dolmetscher nicht sichtbar',
    please_provide_customer_reference: 'Bitte geben Sie zusätzliche Informationen an.',
    prebooking_time_header: 'Wann benötigen Sie einen Dolmetscher?',
    select_language_title: 'Welche Sprache sollte der Dolmetscher sprechen?',
    fetching_languages: 'Sprachen werden abgerufen ...',
    invoice_cause: 'Kostenzuordnung',
    invoice_cause_description: 'Bitte wählen Sie die entsprechende Kostenstelle',
    invoice_ref_placeholder: 'HINWEIS! Der Kundendienst liest dies nicht.',
    call_type_video: 'Video',
    call_type_call: 'Anruf',
    call_type_question: 'Bitte wählen Sie den Verbindungstyp',
    additional_order_info: 'Zusätzliche Bestellinformationen',
    confirm_prebooking: 'Bitte überprüfen Sie die Buchungsdetails.',
    comment: 'Notwendige zusätzliche Informationen für den Auftragsbearbeiter',
    prebooking_date: 'Datum',
    prebooking_time: 'Uhrzeit',
    prebooking_duration: 'Dauer',
    language_title: 'Sprache',
    presence_title: 'Präsenz',
    call_type_title: 'Anruftyp',
    select_target_language_title: 'Was ist Ihre Sprache?',
    location_question: 'Wo ist der Standort?',
    location_placeholder_city: 'Stadt',
    location_placeholder_address: 'Straße und Hausnummer',
    location_placeholder_postcode: 'Postleitzahl',
    add_message_to_interpreter: 'Nachricht an Dolmetscher hinzufügen',
    subject: 'Betreff',
    url_for_video_meeting: 'URL/Link zum Videomeeting',
    url_for_video_meeting_label: 'URL/Link',
    interpretation_location_details: 'Anweisungen zur Ankunft am Standort (z. B. Informationen zur Barrierefreiheit, Büro, Treppen, Etage, Raum usw.)',
    address_info: 'Adressdaten',
    arrival_instructions: 'Ankunftsanweisungen',
    addressAndArrivalInstrustions: 'Adresse und Ankunftsanweisungen',
    preferred_interpreters_question: 'Möchten Sie einen bevorzugten Dolmetscher auswählen?',
    search_preferred_interpreter: 'Dolmetscher nach Namen suchen',
    not_guarantee: 'Wir bemühen uns, den gewünschten Dolmetscher zu organisieren, können jedoch nicht garantieren, dass dieser verfügbar ist.',
    history_is_limited: 'Die Suchergebnisse sind begrenzt, da Sie bisher noch nicht viele Dolmetscher in Anspruch genommen haben.',
    presence_question: 'Welche Art von Dolmetschleistung?',
    presence_remote: 'Remote',
    presence_remote_tip: 'Per Video oder Anruf über die App',
    presence_on_site: 'Vor Ort',
    presence_on_site_tip: 'Dolmetscher physisch anwesend',
    presence_notice: 'Dolmetschleistung für eine Ankündigung',
    presence_notice_tip: 'Schriftliche Mitteilung, die als Dolmetschleistung übermittelt wurde',
    select_favorite: 'Möchten Sie bestimmte Dolmetscher auswählen?',
    any_favorite: 'Keine Präferenz',
    call_type_call_tip: 'Nur Sprache über einen Telefonanruf',
    call_type_video_tip: 'Sprache und Bild über mobile Daten',
    target_language_title: 'Ihre Arbeitssprache',
    invoice_ref_title: 'Rechnungskennung',
    save_prebooking: 'Buchen',
    edit_prebooking: 'Speichern',
    any_gender: 'Egal',
    any_dialect: 'Keine besonderen Bedürfnisse',
    gender_title: 'Geschlecht',
    dialect_title: 'Dialekt',
    select_skill: 'Haben Sie besondere Anforderungen an den Dolmetscher?',
    select_dialect: 'Benötigen Sie einen bestimmten Dialekt?',
    select_qualification: 'Benötigen Sie besondere Qualifikationen?',
    select_gender: 'Ist das Geschlecht des Dolmetschers wichtig?',
    any_skill: 'Keine besonderen Anforderungen',
    any_qualification: 'Keine besonderen Qualifikationen',
    skill_title: 'Besondere Anforderungen',
    unconfirmed_prebooking: 'Bestätigung ausstehend',
    confirmed: 'Bestätigt',
    delivered: 'Zugestellt',
    not_able_to_reach: 'Nicht erreichbar',
    cancelled: 'Storniert',
    ongoing_prebooking: 'Laufend',
    report_deviation: 'Abweichung melden',
    active: 'Aktiv',
    location_title_city: 'Stadt',
    location_title_address: 'Straße und Hausnummer',
    // Help tooltips
    help_prebooking_summary_title: 'Schreiben Sie hier nur notwendige zusätzliche Informationen für den Auftragsbearbeiter',
    help_prebooking_summary:
      'Beachten Sie, dass das Ausfüllen dieses Feldes die Bearbeitungszeit der Bestellung verlängert.',
    help_call_type_title: 'Dolmetschverbindung',
    help_call_type:
      'Mit einer Dolmetschleistung per Telefon können Sie Personen an verschiedenen Orten miteinander verbinden (Telefonkonferenz).\n\nBei einer Dolmetschleistung per Video können sich die Teilnehmenden gegenseitig sehen, und Sie können dem Dolmetscher auch Text zur Übersetzung zeigen. Die Videofunktion kann während der Dolmetschleistung jederzeit ein- oder ausgeschaltet werden.\n\nSie können die Dolmetschverbindung ändern, indem Sie die Dolmetschleistung beenden und „Dolmetschleistung fortsetzen“ auswählen.',
    help_gender_title: 'Geschlecht des Dolmetschers',
    help_gender:
      'Sie können einen Dolmetscher eines bestimmten Geschlechts anfordern. Bitte beachten Sie, dass diese Auswahl zu einer geringeren Anzahl verfügbarer Dolmetscher führen und die Wahrscheinlichkeit verringern kann, einen solchen zu erhalten.',
    help_dialect_title: 'Dialekt des Dolmetschers',
    help_dialect:
      'Sie können einen Dolmetscher anfordern, der einen bestimmten Dialekt der gewählten Sprache beherrscht. Bitte beachten Sie, dass diese Auswahl zu einer geringeren Anzahl verfügbarer Dolmetscher führen und die Wahrscheinlichkeit verringern kann, einen solchen zu erhalten.',
    help_confirmation_title: 'Bestätigen Sie Ihre Standard-Kostenstelle',
    help_confirmation:
      'Ihre Bestellungen werden standardmäßig Ihrer Standard-Kostenstelle zugeordnet, es sei denn, Sie geben bei der Bestellung eine alternative Kostenstelle an.',
    tomorrow: 'Morgen',
    today: 'Heute',
    now: 'Jetzt',
    help_location_title: 'Standort',
    help_location:
      'Geben Sie den Ort der Dolmetschleistung ein. Dies kann eine Adresse oder eine andere Kennung sein.',
    help_favorites_title: 'Bevorzugte Dolmetscher',
    help_favorites:
      'Sie können einen oder mehrere Ihrer bevorzugten Dolmetscher als bevorzugte Dolmetscher auswählen. Ist einer der Favoriten verfügbar, wird er oder sie der Dolmetschleistung zugewiesen.',
    on_site_not_available_in_app:
      'Die Dolmetschleistung vor Ort kann nicht über die App gestartet werden.',
    searching_interpreter: 'Suche nach Dolmetscher',
    please_call_to_this_number: 'Bitte rufen Sie diese Nummer an',
    back: 'Zurück',
    rejoin_meeting: 'Erneut am Meeting teilnehmen',
    change_language: 'Sprache ändern',
    prebook_successfully_created: 'Vorabbuchung erfolgreich erstellt',
    prebook_successfully_edit: 'Vorabbuchung erfolgreich aktualisiert',
    prebook_successfully_cancelled: 'Vorabbuchung erfolgreich storniert',
    prebook_successfully_accepted: 'Vorabbuchung erfolgreich angenommen',
    prebooking_details: 'Vorabbuchungsdetails',
    select_contract_title: 'Vertrag auswählen',
    select_contract_subtitle: 'Wählen Sie den Vertrag aus, der für diese Bestellung verwendet werden soll.',
    prebook_confirmation_message:
      'Sind Sie sicher, dass Sie die Vorabbuchung abbrechen möchten?',
    cancel_prebook_confirmation_message:
      'Sind Sie sicher, dass Sie die Vorabbuchung stornieren möchten?',
    really_cancel_prebooking_too_late:
      'Sind Sie sicher, dass Sie die Vorabbuchung stornieren möchten? In dieser Phase ist die Stornierung nicht kostenlos.',
    cancel_reason_selection: 'Was ist der Grund für die Stornierung?',
    cancel_reason_sickness: 'Persönliche Erkrankung',
    cancel_sickness_tip: 'Ärztliches Attest erforderlich',
    cancel_reason_mistake: 'Fehler',
    cancel_reason_other: 'Sonstiges',
    cancel_reason_other_tip: 'Bitte geben Sie eine Erklärung in Textform an.',
    cancel_other_title: 'Erklärung',
    cancel_other: 'Erzählen Sie uns, was passiert ist?',
    cancel_sickness_title: 'Ärztliches Attest',
    cancel_sickness: 'Bitte senden Sie uns ein ärztliches Attest über die Erkrankung.',
    copy_information: 'Daten kopieren',
    my_bookings: 'Buchungen',
    interpreter_now: 'Jetzt Dolmetscher',
    pre_book: 'Vorabgebuchte Dolmetschleistung',
    order: 'Bestellen',
    hero_order_interpretation: 'Dolmetschen',
    hero_order_translation: 'Übersetzung',
    book_interpretation: 'Dolmetschleistung buchen',
    time: 'Zeit',
    status: 'Status',
    search: 'Suchen',
    // Prebooking section titles and mode of interpretation
    details: 'Details',
    preferences: 'Präferenzen',
    invoicing_and_assignment_details: 'Rechnungs- und Auftragsdetails',
    invoicing: 'Abrechnung',
    cost_allocation: 'Kostenstelle',
    contract_label: 'Vertrag',
    prebooking_vat_question: 'MwSt.',
    prebooking_vat_applied: 'MwSt. enthalten',
    prebooking_vat_exempt: 'MwSt.-befreit',
    additional_invoicing_information: 'Zusätzliche Rechnungsinformationen',
    field_not_visible_to_interpreter: 'Die Feldinformationen sind für den Dolmetscher nicht sichtbar',
    customer_name_for_invoice: 'Kundenname (für Rechnung)',
    date_of_birth_for_invoice: 'Geburtsdatum (für Rechnung)',
    recipients_of_confirmation_and_change_notifications: 'Empfänger von Bestätigungs- und Änderungsbenachrichtigungen',
    additional_information_for_order_handler: 'Zusätzliche Informationen für den Auftragsbearbeiter',
    note_filling_this_field_will_prolong_processing_time: 'Beachten Sie, dass das Ausfüllen dieses Feldes die Bearbeitungszeit des Auftrags verlängert.',
    at_least_one_email_required: 'Mindestens eine E-Mail-Adresse ist erforderlich',
    summary: 'Zusammenfassung',
    back_to_edit: 'Zurück zur Bearbeitung',
    confirm_order: 'Bestellung bestätigen',
    submitting: 'Wird gesendet ...',
    mode_of_interpretation: 'Dolmetschmodus',
    phone_call: 'Telefonanruf',
    phone_call_tip: 'Nur Sprachverbindung per Telefonanruf',
    video_call: 'Videoanruf',
    video_call_tip: 'Stimme und Bild über mobile Daten',
    conference_call: 'Konferenzanruf',
    conference_call_tip: 'z. B. Microsoft Teams, Skype, Google Meet, Zoom',
    video_call_made_via_tulka_app: 'Videoanruf über die Tulká-App',
    Remote: 'Remote',
    presence_onsite: 'Vor Ort',
    announcement: 'Ankündigung',
    start_time: 'Startzeit',
    end_time: 'Endzeit',
    add_another: 'Mehr hinzufügen',
    does_not_matter: 'Egal',
    no_choice: 'Keine Auswahl',
    highest: 'Höchste',
    // New prebooking form keys
    select: 'Auswählen',
    select_notice: 'Was der Dolmetscher dem Benutzer mitteilen soll',
    required: 'Erforderlich',
    language_required: 'Sprache ist erforderlich',
    interpreted_and_target_language_must_differ: 'Interpretiersprache und Zielsprache dürfen nicht identisch sein',
    call_type_required: 'Anruftyp ist erforderlich',
    street_address_required: 'Straße und Hausnummer sind erforderlich',
    city_required: 'Stadt ist erforderlich',
    post_code_required: 'Postleitzahl ist erforderlich',
    message_content_required: 'Nachrichteninhalt ist erforderlich',
    customer_name_required: 'Kundenname ist erforderlich',
    date_of_birth_required: 'Geburtsdatum ist erforderlich',
    phone_number_required: 'Telefonnummer ist erforderlich',
    delivery_time: 'Lieferzeit',
    date_required: 'Datum ist erforderlich',
    date_too_far_in_future: 'Das Datum muss weniger als 5 Jahre in der Zukunft liegen',
    time_required: 'Zeit ist erforderlich',
    duration_required: 'Dauer ist erforderlich',
    at_least_one_time_slot_required: 'Mindestens ein Zeitfenster ist erforderlich',
    street_address: 'Straße und Hausnummer',
    post_code: 'Postleitzahl',
    city: 'Stadt',
    arrival_instruction_at_location: 'Ankunftsanweisungen am Standort',
    message_content: 'Nachrichteninhalt',
    message_max_length_info: 'Die maximale Länge der Nachricht beträgt 1.000 Zeichen.',
    last_delivery_date: 'Letztes Zustelldatum für die Nachricht',
    delivery_date_info: 'Der Dolmetscher wird bis zum Ende des ausgewählten Tages die angegebene Nummer anrufen.',
    interpreter_gender: 'Geschlecht des Dolmetschers',
    competence_level_special_need: 'Kompetenzniveau / besondere Anforderungen an den Dolmetscher',
    competence_level_helper_text: 'Standardmäßig sind alle Niveaustufen ausgewählt. Klicken Sie auf die Niveaustufen, die Sie nicht verwenden möchten, um die Auswahl aufzuheben. Bitte beachten Sie, dass sich die Auswahl an verfügbaren Dolmetschern verringert, wenn Sie bestimmte Niveaustufen abwählen.',
    authorized_interpreter: 'Autorisierter Dolmetscher',
    court_legal_interpreter: 'Gerichtsdolmetscher',
    healthcare_interpreter: 'Dolmetscher im Gesundheitswesen',
    registered_trained_interpreter: 'Zugelassener, ausgebildeter Dolmetscher',
    other_interpreters: 'Andere Dolmetscher',
    other_interpreter_level: 'Nicht qualifizierter Dolmetscher',
    let_system_choose_highest_qualified: 'Das System soll den am besten qualifizierten Dolmetscher auswählen',
    experiences: 'Anforderungen',
    security_cleared_interpreter: 'Sicherheitsüberprüfter Dolmetscher',
    additional_preferences: 'Zusätzliche Präferenzen',
    open: 'Öffnen',
    hide: 'Verbergen',
    request_preferred_interpreter: 'Bevorzugten Dolmetscher anfordern',
    exclude_specific_interpreters: 'Bestimmte(n) Dolmetscher ausschließen',
    interpreters_found_for_your_selections: 'Dolmetscher für Ihre Auswahl gefunden',
    how_to_handle_no_onsite_interpreter: 'Wie möchten Sie verfahren, wenn kein Dolmetscher vor Ort gefunden wird?',
    assign_remote_interpreter: 'Remote-Dolmetscher zuweisen',
    cancel_booking: 'Buchung stornieren',
    // Preferences section keys
    preferences_title: 'Präferenzen',
    preferences_interpreter_gender: 'Geschlecht des Dolmetschers',
    preferences_onsite_fallback: 'Wie sollen wir vorgehen, wenn vor Ort kein Dolmetscher gefunden wird?',
    preferences_accept_beyond_km: 'Akzeptieren Sie einen Dolmetscher, der die vertragliche Entfernung von {} km pro Strecke überschreitet?',
    preferences_km_beyond_limit: 'Um wie viele Kilometer wären Sie bereit, die Grenze von {} km pro Strecke zu überschreiten?',
    preferences_total_max_distance_label_one_way: 'Maximale Gesamtentfernung: {} km pro Strecke',
    preferences_total_max_distance_unlimited: 'Maximale Gesamtentfernung: unbegrenzt',
    unlimited: 'Unbegrenzt',
    km_unit: 'km',
    accepts_interpreters_within_km: 'AKZEPTIERT DOLMETSCHER INNERHALB VON ${distance} KM',
    preferences_fallback_assign_remote: 'Remote-Dolmetscher zuweisen',
    preferences_fallback_cancel: 'Buchung stornieren',
    preferences_additional_preferences: 'Zusätzliche Präferenzen',
    preferences_preferred_interpreter: 'Bevorzugten Dolmetscher anfordern',
    preferences_excluded_interpreter: 'Bestimmte(n) Dolmetscher ausschließen',
    preferences_search_placeholder: 'Dolmetscher nach Namen suchen ...',
    preferences_ukrainian_russian_fallback: 'Wenn kein ukrainischsprachiger Dolmetscher verfügbar ist, können wir einen russischsprachigen Dolmetscher zuweisen?',
    preferences_accept_lower_level: 'Wenn ein Dolmetscher auf dem gewünschten Niveau nicht verfügbar ist, akzeptieren Sie ein niedrigeres Niveau?',
    preferences_remote_backup_connection_type: 'Bevorzugter Verbindungstyp für Remote-Backup',
    preferences_remote_backup_phone: 'Telefonanruf',
    preferences_remote_backup_video: 'Videoanruf',
    preferences_remote_backup_conference: 'Konferenzanruf',
    interpreted_language: 'Sprache der Dolmetschleistung',
    favorite_title: 'Bevorzugte Dolmetscher',
    no_prebookings: 'Sie haben keine Vorabbuchungen.',
    prebooking_not_active: 'Ihr Vertrag beinhaltet keine Vorabbuchung.',
    reservation_number: 'Reservierungsnummer',
    external_order_id: 'Bestellkennung',
    email: 'E-Mail-Adresse',
    not_yet_support_interpreter_login:
      'Die neue Web-App unterstützt die Anmeldung für Dolmetscher noch nicht. Bitte nutzen Sie die mobile App.',
    please_try_again_later: 'Bitte versuchen Sie es später erneut.',
    no_languages: 'Keine Sprachen',
    interpreter_phone_number: 'Telefonnummer des Dolmetschers',
    remove: 'Löschen',
    presence_conference: 'Konferenz-/virtueller Raum',
    presence_conference_tip: 'z. B. Microsoft Teams, Skype, Google Meet, Zoom',
    interpreter_email: 'E-Mail-Adresse des Dolmetschers',
    all: 'Alle',
    invoice_user_group: 'Kostenstelle',
    cc_emails: 'Empfänger für Bestätigungs- und Änderungsbenachrichtigungen',
    cc_email: 'E-Mail-Adresse',
    cc_emails_copy: 'Empfänger für Bestätigungs- und Änderungsbenachrichtigungen',
    information_for_interpreter: 'Informationen für Dolmetscher',
    patient_name: 'Name des Kunden, der die Dolmetschleistung benötigt',
    upload_reference_document_optional: 'Referenzdokument hochladen (optional)',
    browse_files: 'Dateien durchsuchen',
    only_pdf_format_file_visible_to_interpreter: 'Nur PDF-Format. Die Datei ist nur für den zugewiesenen Dolmetscher sichtbar.',
    field_information_not_visible_on_bill: 'Die Feldinformationen sind auf der Rechnung nicht sichtbar',
    patient_name_description: 'Diese Angaben erscheinen nicht auf der Rechnung, sondern werden dem Dolmetscher zu Informationszwecken übermittelt, z. B. im Falle einer Inhaftierung.',
    customer: 'Kunde',
    customer_unit: 'Einheit',
    personal: 'Persönlich',
    search_for: 'Suchen nach Einheit, Sprache, Kostenstelle oder Kunde',
    failed_to_create_prebooking:
      'Neue Vorabbuchung konnte nicht erstellt werden. Bitte versuchen Sie es später erneut.',
    failed_to_create_all_prebookings: 'Alle Vorabbuchungen konnten nicht erstellt werden',
    slot: 'Zeitfenster',
    succeeded: 'erfolgreich',
    failed: 'fehlgeschlagen',
    to_start_interpretation:
      'Um die Dolmetschleistung zu starten, rufen Sie bitte diese Nummer an:',
    start_interpretation: 'Dolmetschleistung starten',
    hey_username: 'Hallo {username},',
    confirm_your_account_information: 'Bestätigen Sie Ihre Kontoinformationen',
    confirm_your_account_information_description:
      'Um den bestmöglichen Service zu bieten, bitten wir Sie, die folgenden Informationen zu Ihrem Profil zu bestätigen oder zu korrigieren',
    other: 'Sonstiges',
    no_options: 'Keine Suchergebnisse',
    search_message: 'Wird gesucht …',
    i_confirm_the_information: 'ICH BESTÄTIGE DIE ANGABEN',
    billing: 'Abrechnung',
    translations: 'Übersetzungen',
    order_translation: 'Übersetzung bestellen',
    translation_order_number: 'Bestellnr.',
    translation_order_date: 'Bestelldatum',
    translation_from: 'Von',
    translation_to: 'An',
    translation_username: 'Übersetzer',
    translation_delivery: 'Lieferung',
    translation_user_group: 'Benutzergruppe',
    translation_customer: 'Kunde',
    translation_status: 'Status',
    translation_status_new_order: 'Neue Bestellung',
    translation_status_in_progress: 'In Bearbeitung',
    translation_status_assigned: 'Zugewiesen',
    translation_status_completed: 'Abgeschlossen',
    translation_status_cancelled: 'Storniert',
    translation_status_delivered: 'Geliefert',
    translation_customer_id: 'Kunden-ID',
    translation_file_name: 'Dateiname',
    translation_estimated_count: 'Gesch\u00e4tzte Menge',
    translation_due_date: 'F\u00e4lligkeitsdatum',
    translation_assigned_jobs: 'Liste der zugewiesenen Auftr\u00e4ge',
    translation_order: '\u00dcbersetzungsauftrag',
    translation_details: 'Details',
    translation_customer_information: 'Kundeninformationen',
    translation_invoicing: 'Rechnungsstellung',
    translation_from_language: 'Von',
    translation_to_language: 'An',
    translation_desired_delivery_date: 'Gew\u00fcnschtes Lieferdatum',
    translation_instructions: 'Anweisungen/Hinweise f\u00fcr den \u00dcbersetzer',
    translation_estimated_total: 'Gesch\u00e4tzte Gesamtzahl (W\u00f6rter)',
    translation_estimated_scope: 'Gesch\u00e4tzter Umfang',
    translation_materials: 'Materialien zur \u00dcbersetzung',
    translation_customer_number: 'Kundennummer',
    translation_order_made_by: 'Bestellt von',
    translation_ordering_unit: 'Bestelleinheit',
    checking_your_billing_information: 'Überprüfen Ihrer Rechnungsdaten',
    billing_page_main_sub_header:
      'Überprüfen Sie, ob die Dolmetschleistung für die richtige Kostenstelle/Einheit erfolgt und ob die Abrechnungsreferenzdaten den Anweisungen entsprechen',
    interpreter_reported_duration: 'Vom Dolmetscher gemeldete Dauer',
    update: 'Aktualisieren',
    update_prebook: 'Vorabbuchung aktualisieren',
    your_changes_will_be_lost:
      'Sind Sie sicher, dass Sie abbrechen möchten? Ihre Änderungen gehen verloren.',
    settings: 'Einstellungen',
    user_home_group_header: 'Gruppe für Heimanwender',
    app_country: 'Land',
    address: 'Adresse',
    country_placeholder: 'Land auswählen',
    update_settings: 'Einstellungen speichern',
    has_car: 'Ich habe ein Auto',
    profile_options: 'Profiloptionen',
    no_invoice_reference: 'Keine Rechnungsreferenz',
    no_user_group_selected: 'Keine Benutzergruppe ausgewählt',
    prebook_successfully_updated: 'Rechnungsinformationen bestätigt',
    type_search_term_here: 'Suchbegriff hier eingeben',
    verify: 'Bestätigen',
    prebookings_successfully_updated: 'Rechnungsinformationen bestätigt',
    alternative_cost_center: 'Alternative Kostenstelle oder Auftragsnummer',
    alternative_cost_center_edit:
      'Alternative Kostenstelle oder Auftragsnummer bearbeiten',
    choose_default_cost_center: 'Standardkostenstelle auswählen',
    enter_or_confirm_username: 'E-Mail-Adresse für die Anmeldung eingeben oder bestätigen',
    enter_or_confirm_email: 'E-Mail-Adresse eingeben oder bestätigen, an die Buchungsbestätigungen und Änderungsbenachrichtigungen für gebuchte Dolmetschleistungen automatisch gesendet werden',
    you_can_change_this_information_at_any_time:
      'Sie können diese Informationen jederzeit über das Menü „Einstellungen“ ändern',
    edit: 'Bearbeiten',
    change_reservation: 'Ändern',
    copy_reservation: 'Kopieren',
    change_reservation_description: 'Reservierung ändern',
    copy_reservation_description: 'Reservierung kopieren',
    cancel_prebook_description: 'Reservierung stornieren',
    additional_cost_will_be_charged:
      'Es fallen zusätzliche Kosten an. Da der ursprünglich vereinbarte Termin innerhalb von 24 Stunden liegt, wird für diese Änderung eine zusätzliche Gebühr gemäß den Bestimmungen für kurzfristige Stornierungen in der Preisliste erhoben.',
    we_will_cancel_this_booking_and_make_a_new_one:
      'Wir stornieren diese Buchung und erstellen eine neue, falls Sie Änderungen hinsichtlich Uhrzeit, Datum, Art, Sprache oder Dauer vornehmen.',
    preview: 'Vorschau',
    edit_prebooking_details: 'Vorabbuchungsdetails bearbeiten',
    no_invoices: 'Sie haben keine Buchungen, die für die Rechnungsstellung bearbeitet werden müssen.',
    add: 'Hinzufügen',
    add_email: 'E-Mail hinzufügen',
    invite_to_the_group: 'Zur Gruppe einladen',
    invite_to_the_group_explanation:
      'Kennen Sie einen Kollegen, der in seinem Beruf Dolmetscherdienste nutzt? Laden Sie ihn zu Túlka ein',
    invite: 'Einladen',
    invite_success: 'Einladung erfolgreich gesendet.',
    invite_to_group: 'Neue Personen einladen',
    collaborators_header: 'Ihre Mitarbeitenden',
    add_collaborators: 'Mitarbeitenden hinzufügen',
    please_enter_email: 'Bitte E-Mail-Adresse eingeben',
    name: 'Name',
    collaborators_header_description:
      'Laden Sie einen Mitarbeitenden ein, um Ihre Buchungen gemeinsam zu verwalten. \nHinweis: Sie können nur einen bestehenden Benutzer einladen.',
    user_does_not_exist:
      'Benutzer existiert nicht, Sie können nur bestehende Benutzer einladen',
    invite_to_collaborate_success: 'Der Benutzer wurde erfolgreich zur Zusammenarbeit eingeladen.',
    collaborator_successfully_removed: 'Der Mitarbeitende wurde erfolgreich entfernt.',
    invalid_email_address: 'Ungültige E-Mail-Adresse',
    invalid_phone_number: 'Ungültige Telefonnummer',
    invalid_phone_number_error: 'Ungültige Telefonnummer',
    already_registered_phone: 'Diese Telefonnummer ist bereits bei einem anderen Benutzer registriert. Bitte wenden Sie sich an den Kundendienst ',
    phone_number_cannot_start_with_0: 'Die Telefonnummer darf im internationalen Format nicht mit einer 0 beginnen',
    email_address_from_different_organisation_domain:
      'E-Mail-Adresse von einer anderen Domain',
    this_user_already_added_to_collaborators:
      'Dieser Benutzer wurde bereits zu den Mitarbeitenden hinzugefügt',
    prebooked: 'Im Voraus gebucht',
    ondemand: 'Auf Abruf',
    reset_user_password: 'Passwort ändern',
    reset_user_email: 'E-Mail-Adresse für Buchungsbestätigungen ändern',
    reset_user_email_note_for_interpreter: 'Hinweis: Dies ändert nicht den Benutzernamen für die Anmeldung, sondern nur die E-Mail-Adresse, an die Buchungsbestätigungen und Änderungsbenachrichtigungen gesendet werden.',
    reset_user_email_for_login: 'E-Mail-Adresse für Anmeldung ändern',
    please_enter_password: 'Passwort',
    please_enter_new_password: 'Neues Passwort',
    please_enter_current_password: 'Aktuelles Passwort',
    please_repeat_password: 'Passwort wiederholen',
    please_repeat_new_password: 'Neues Passwort wiederholen',
    passwords_do_not_match: 'Passwörter stimmen nicht überein',
    old_password_is_required: 'Altes Passwort ist erforderlich',
    enter_new_password: 'Neues Passwort eingeben',
    repeat_new_password: 'Neues Passwort wiederholen',
    password_requirement:
      'Passwort muss mindestens 8 Zeichen lang sein und einen Groß- und Kleinbuchstaben sowie eine Zahl enthalten',
    all_day: 'Ganztägig',
    previous: 'Vorherige',
    next: 'Nächste',
    // today: 'Today',
    month: 'Monat',
    week: 'Woche',
    day: 'Tag',
    agenda: 'Agenda',
    date: 'Datum',
    // time: 'Time',
    event: 'Ereignis',
    no_events_in_range: 'Keine Ereignisse im Bereich',
    show_more: 'Mehr anzeigen',
    reports: 'Berichte',
    number_of_interpretations: 'Anzahl der Dolmetschungen',
    interpretation_breakdown_previous_month:
      'Dolmetschungsaufschlüsselung - vorheriger Monat',
    your_browser_is_not_supported: 'Ihr Browser wird nicht unterstützt.',
    edge_browser_is_not_supported: 'Der EDGE-Browser wird nicht unterstützt. Bitte verwenden Sie Google Chrome.',
    we_recommend_using_the_latest_version_of_chrome_or_firefox_in_order_to_continue_using_this_service:
      'Wir empfehlen die Verwendung der neuesten Version von Chrome oder Firefox, um diesen Service weiterhin zu nutzen.',
    use_of_interpretation_report: 'Nutzungsbericht der Dolmetschung',
    billing_report: 'Abrechnungsbericht',
    customer_reporting_report: 'Kundenbericht',
    data_export_report: 'Datenexportbericht',
    monetra_billing_report: 'Monetra Abrechnungsbericht',
    monetra_payroll_report: 'Monetra Gehaltsabrechnungsbericht',
    copy_data_to_new_booking: 'Daten zu neuer Buchung kopieren',
    replace_with_new_one: 'Mit neuer ersetzen',
    update_at_least_date_or_time_fields_to_create_a_booking:
      'Aktualisieren Sie mindestens die Datums- oder Zeitfelder, um eine Buchung zu erstellen',
    cancel_prebook: 'Stornieren',
    newButton: 'Neu',
    announcement_interpretation: 'Dolmetschleistung eine Ankündigung',
    customer_name_and_date_of_birth:
      'Kundenname und Geburtsdatum (für Rechnung)',
    customer_name: 'Kundenname (für Rechnung)',
    date_of_birth: 'Geburtsdatum (für Rechnung)',
    to_whom_the_message_is_forwarded_if_not_to_the_customer:
      'An wen die Nachricht weitergeleitet wird, wenn nicht an den Kunden',
    telephone_number_to_which_the_interpreter_will_call:
      'Telefonnummer(n), unter der/denen der Dolmetscher anrufen wird',
    main_telephone_number_to_which_the_interpreter_will_call:
      'Die primäre Telefonnummer, unter der der Dolmetscher anrufen wird',
    additional_telephone_number_to_which_the_interpreter_will_call:
      'Zusätzliche Telefonnummer(n), unter der/denen der Dolmetscher anrufen wird',
    message_to_customer_service_or_interpreter:
      'Nachricht an Kundendienst oder Dolmetscher',
    mandatory_information: 'Erforderliche Angaben',
    optional_information: 'Optionale Angaben',
    customer_data: 'Kundendaten',
    write_the_content: 'Nachrichteninhalt',
    write_the_content_of_the_matter_to_be_reported_below:
      'Geben Sie unten den Inhalt der zu meldenden Angelegenheit ein',
    content_data_tooltip:
      'Die Dolmetschleistung von Nachrichten ist eine einseitige, mündliche Übertragung einer Nachricht. Die maximale Länge der Nachricht beträgt 1.000 Zeichen.',
    content_data_second_tooltip:
      'Der Dolmetscher wird die angegebene Telefonnummer mindestens 5 Mal anrufen. Die Dolmetschleistung der Nachricht gilt als abgeschlossen, auch wenn die Nachricht den Kunden nicht erreicht.',
    calendar_tooltip_notice_interpretation:
      'Der Dolmetscher wird die bereitgestellte Nummer bis zum Ende des ausgewählten Tages anrufen.',
    calendars: 'Kalender',
    please_select_language: 'Sprache auswählen',
    please_select_interpreter: 'Bitte Dolmetscher auswählen',
    please_select_language_and_interpreter_to_see_the_calendar:
      'Bitte Sprache und Dolmetscher auswählen, um den Kalender zu sehen',
    please_select_time: 'Bitte Zeit auswählen',
    block_time: 'Gesperrte Zeit',
    block_time_description: 'Gesperrte Zeit – Während dieser Zeit erhält der Dolmetscher keine Anrufe oder Vorabbuchungen.',
    reservations_od: 'Reservierung für OD',
    reservations_od_description: 'Reservierung für OD – Während dieser Zeit erhält der Dolmetscher keine Vorabbuchungen, es wird ausschließlich OD berücksichtigt',
    unavailable_time: 'Nicht verfügbare Zeit',
    unavailability_type: 'Art der Nichtverfügbarkeit',
    pick_start_time: 'Startzeit auswählen',
    pick_end_time: 'Endzeit auswählen',
    time_successfuly_blocked: 'Zeit erfolgreich gesperrt',
    time_successfuly_unblocked: 'Gesperrte Zeit erfolgreich aufgehoben',
    time_successfuly_updated: 'Gesperrte Zeit erfolgreich aktualisiert',
    overlaping_information_dialog_mesage:
      'Die Termine überschneiden sich mit einer bestehenden Vorabbuchung oder einer anderen Nichtverfügbarkeit. Bitte entfernen Sie die sich überschneidenden Nichtverfügbarkeiten, stornieren Sie die sich überschneidenden Vorabbuchungen oder verwenden Sie andere Termine.',
    ok: 'ok',
    cancel_blocked_time_confirmation_message:
      'Sind Sie sicher, dass Sie die gesperrte Zeit stornieren möchten?',
    cancel_interpreter_blocked_time: 'Entsperren',
    relay_the_message_to_person: 'Nachricht an Person weiterleiten:',
    birthday: 'Geburtsdatum:',
    numbers_to_be_called: 'Anzurufende Nummern:',
    message: 'Nachricht:',
    to_whom_message_forwarded_if_not_customer: 'An wen wird die Nachricht weitergeleitet, wenn nicht an den Kunden?',
    write_here: 'Hier schreiben ...',
    main_telephone_number_interpreter_will_call: 'Primäre Telefonnummer, die der Dolmetscher anruft',
    additional_telephone_numbers_interpreter_will_call: 'Zusätzliche Telefonnummer(n), die der Dolmetscher anruft',
    phone_required: 'Telefonnummer ist erforderlich',
    phone_already_added: 'Telefonnummer bereits hinzugefügt',
    enter_phone_number: 'Telefonnummer eingeben',
    has_to_be_a_phone_number: 'Muss eine Telefonnummer sein',
    other_information_relevant_to_the_invoicing_such_as_information_about_the_customer:
      'Andere für die Abrechnung relevante Informationen, wie Informationen über den Kunden',
    this_invoice_needs_additional_information:
      'Diese Rechnung benötigt zusätzliche Informationen. Bitte füllen Sie die erforderlichen Felder aus, um Ihre Bestellung zu bestätigen',
    cancelled_by: 'Storniert von',
    cancel_reason: 'Stornierungsgrund',
    join_to_meeting: 'Am Meeting teilnehmen',
    ready_to_join: 'Möchten Sie teilnehmen?',
    what_is_your_name: 'Wie ist Ihr Name?',
    your_name: 'Ihr Name',
    waiting_for_luona_worker_and_interpreter:
      'Warten auf Luona-Mitarbeitender und Dolmetscher ...',
    waiting_label: 'Warten ...',
    type_message: 'Nachricht eingeben',
    looking_for: 'Wir bemühen uns, den besten Service zu bieten, aber manchmal dauert es. Bitte haben Sie Geduld, wir suchen nach',
    luona_worker_persone: 'Luona-Mitarbeitender',
    interpreter_persone: 'Dolmetscher',
    interpreter_status: 'On-Demand-Dolmetschleistungen',
    availability_yes: 'Jetzt verfügbar',
    availability_no: 'Sie sind nicht verfügbar.',
    // prebooking luona
    prebooking_page_title: 'Vorabbuchung',
    defaultPrebookingPageMessage: 'Sie haben keine Vorabbuchungen',
    go_to_prebookings_list: 'Zur Vorabbuchungsliste',
    luona_feedback_title: 'Umfrage zur Qualität',
    luona_feedback_description: 'Sie haben Luonas neue technologische Remote-Service-Plattform genutzt. Wir sammeln Feedback über den Service und wären dankbar, wenn Sie an unserer kurzen Umfrage teilnehmen würden.',
    luona_feedback_score: 'Wie wahrscheinlich ist es, dass Sie diese Remote-Service-Plattform einem Freund empfehlen würden?',
    luona_feedback: 'Feedback',
    feedback_sent: 'Vielen Dank für Ihr Feedback!',
    luona_prefer: 'Bevorzugt',
    Luona_lead: 'Führungsteam',
    luona_social: 'Sozial',
    luona_nurses: 'Medizinisch',
    go_to_services: 'Zu den Services',
    start_prebook: 'Starten',
    prebooking_is_gone: 'Die Vorabbuchung ist nicht mehr verfügbar',
    prebooking_not_answered: 'Leider können wir die Vorabbuchung nicht ausführen. Bitte vereinbaren Sie erneut einen Termin mit einem Experten.',
    prebooking_is_not_found: 'Leider können wir keine passende aktive Vorabbuchung finden. Bitte versuchen Sie, einen Dringlichkeitsanruf zu tätigen oder erneut eine Beratung mit einem Experten zu buchen.',
    prebooking_is_cancelled: 'Leider können wir keine passende aktive Vorabbuchung finden. Möglicherweise wurde sie storniert. Bitte versuchen Sie, einen Dringlichkeitsanruf zu tätigen oder erneut eine Beratung mit einem Experten zu buchen.',
    prebooking_is_too_late: 'Leider ist die Vorabbuchung bereits abgelaufen. Nach einer Wartezeit wurden die Dolmetscher an die Bearbeitung dringender Anrufe weitergeleitet. Bitte versuchen Sie, einen Dringlichkeitsanruf zu tätigen oder erneut einen Termin mit einem Experten zu vereinbaren.',
    prebooking_will_start_in: 'Ihr Termin beginnt in:',
    early_preview_intro: 'Sehr geehrte Luona-Kundin, sehr geehrter Luona-Kunde!',
    you_can_close_tab_for_now: 'Sie können diesen Tab vorerst schließen.',
    my_prebooking_list: 'Meine Reservierungen',
    connecting_to_meeting: 'Am Meeting teilnehmen',
    connecting_to_meeting_for_interpreter: 'Bitte bleiben Sie in der Leitung, wir verbinden alle Parteien',
    no_access_to_your_camera_or_microphone: 'Kein Zugang zu Ihrer Kamera oder Ihrem Mikrofon',
    remote_backup_to_onsite: 'Was tun, wenn vor Ort kein Dolmetscher gefunden wird?',
    use_remote_interpretation_option: 'Remote-Dolmetschleistung verwenden',
    cancel_prebooking_option: 'Vorabbuchung stornieren',
    which_remote_interpretation_type_do_you_choose: 'Für welche Art der Remote-Dolmetschleistung entscheiden Sie sich?',
    phone_interpretation: 'Dolmetschleistung per Telefon',
    conference_virtual_room: 'Konferenz-/Virtueller Raum (z. B. Google Meet, Teams, Zoom)',
    confirm_you_are_online: 'Haben Sie das Gespräch beendet? Wenn Sie weiterhin Anrufe entgegennehmen möchten, klicken Sie bitte auf die Schaltfläche „Wieder teilnehmen“.',
    join_back: 'Wieder teilnehmen',
    requestErrorMessageReasonPoorInternet: 'Hoppla! Etwas ist schiefgelaufen. Ein möglicher Grund dafür könnte eine schlechte Internetverbindung sein. Bitte überprüfen Sie Ihre Interneteinstellungen!',
    networkDisconnectedMessage: 'Ihre Internetverbindung ist nicht schnell genug für Videoanrufe. Bitte überprüfen Sie Ihre Interneteinstellungen!',
    interpreter_name: 'Dolmetscher',
    meeting_disconnected: 'Sie wurden getrennt',
    meeting_reconnecting: 'Sie werden wieder verbunden',
    meeting_reconnected: 'Sie wurden wieder verbunden',
    browser_does_not_support_video_effects: 'Der Browser unterstützt keine Videoeffekte',
    // Self-selfRegistration
    user_group_not_found: 'Wir können Ihre Registrierung zu diesem Zeitpunkt nicht abschließen, da Ihrer Organisation eine erforderliche Konfiguration fehlt. Bitte wenden Sie sich an unser Kundenservice-Team, um Hilfe bei der Lösung dieses Problems zu erhalten.',
    log_in: 'anmelden',
    sign_up: 'registrieren',
    create_an_account: 'Konto erstellen',
    contact_information: 'Kontaktinformationen',
    first_name: 'Vorname',
    last_name: 'Nachname',
    is_personal_email: 'Diese E-Mail-Adresse wird zur Überprüfung Ihrer Identität verwendet. Bitte geben Sie an, ob diese E-Mail-Adresse ausschließlich für die persönliche Kommunikation oder gemeinsam mit Kollegen verwendet wird:',
    email_for_personal: 'Die E-Mail-Adresse ist ausschließlich für die persönliche Kommunikation bestimmt',
    email_shared_with_colleagues: 'Die E-Mail-Adresse wird mit den Kollegen geteilt',
    check_email_again: 'Bitte geben Sie die E-Mail-Adresse erneut ein, um eine Bestätigungs-E-Mail zu senden.',
    is_personal_phone: 'Diese Telefonnummer wird zur Überprüfung Ihrer Identität verwendet. Bitte geben Sie an, ob diese Telefonnummer ausschließlich für die persönliche Kommunikation oder gemeinsam mit Kollegen verwendet wird:',
    phone_for_personal: 'Die Telefonnummer ist ausschließlich für die persönliche Kommunikation bestimmt',
    phone_shared_with_colleagues: 'Die Telefonnummer wird mit den Kollegen geteilt',
    check_phone_again_by_sms: 'Bitte geben Sie die Telefonnummer erneut ein, um die Bestätigungs-SMS zu senden.',
    check_phone_again_by_call: 'Bitte geben Sie die Festnetznummer erneut ein, um einen automatischen Anruf zu erhalten.',
    already_have_an_account_part1: 'Haben Sie bereits ein Konto? ',
    already_have_an_account_part2: 'Anmelden ',
    contact_info_email: 'E-Mail-Adresse',
    contact_info_phone: 'Telefonnummer',
    continue: 'Fortfahren',
    confirm_your_email: 'Bestätigen Sie Ihre E-Mail-Adresse',
    confirm_your_email_message: 'Um die Registrierung abzuschließen, haben wir eine Bestätigungs-E-Mail an die registrierte E-Mail-Adresse gesendet. Bitte bestätigen Sie die E-Mail, indem Sie den Anweisungen in der E-Mail folgen.',
    confirm_your_phone: 'Bestätigen Sie Ihr Telefon',
    confirm_your_mobile_phone_message: 'Um die Registrierung abzuschließen, haben wir eine Bestätigungs-SMS an die registrierte Telefonnummer gesendet. Bitte bestätigen Sie die Telefonnummer, indem Sie den Anweisungen in der SMS folgen.',
    confirm_your_phone_message: 'Sie erhalten einen automatisierten Anruf zur Bestätigung, dass Sie der Inhaber einer Festnetznummer sind. Während des Anrufs hören Sie einen Code, den Sie hier eingeben müssen.',
    confirmation_code: 'Bestätigungscode',
    didnt_receive_an_email: 'Keine E-Mail erhalten?',
    didnt_receive_a_call: 'Keinen Anruf erhalten?',
    didnt_receive_sms: 'Keine SMS erhalten?',
    send_email_again: 'E-Mail erneut senden',
    send_phone_again_for_sms: 'SMS erneut senden',
    send_phone_again_for_call: 'Weiteren Rückruf anfordern',
    verification_page: 'Bestätigungsseite',
    verification_link_expired: 'Etwas ist schiefgelaufen. Der Bestätigungslink ist möglicherweise abgelaufen. Bitte versuchen Sie es erneut.',
    waiting_for_verification: 'Warten auf Bestätigung',
    select_the_correct_cost_center_regarding_invoicing: 'Wählen Sie die korrekte Kostenstelle für die Abrechnung. Wenn Sie die korrekte Kostenstelle nicht finden können, wählen Sie die Option „Ich konnte die korrekte Kostenstelle nicht finden“.',
    how_often_do_you_predict_to_utilize_interpretation_services: 'Wie oft prognostizieren Sie die Nutzung von Dolmetschdiensten?',
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    more_than_weekly: 'Seltener als wöchentlich',
    periodically: 'Regelmäßig',
    cost_center: 'Kostenstelle',
    i_could_not_find_the_correct_cost_center: 'Ich konnte die korrekte Kostenstelle nicht finden',
    information_regarding_cost_center: 'Informationen zur Kostenstelle (Branche/Abteilung, in der Sie arbeiten)',
    please_tell_us_where_you_work_in_which_unit_etc: 'Bitte teilen Sie uns mit, wo Sie arbeiten, in welcher Einheit usw.',
    update_user_home_group_failed: 'Die Aktualisierung der Benutzer-Heimgruppe ist fehlgeschlagen',
    set_up_your_password: 'Ihr Passwort einrichten',
    repeat_password: 'Passwort wiederholen',
    set_password_failed: 'Das Festlegen des Passworts ist fehlgeschlagen',
    submit: 'senden',
    account_created: 'Konto erstellt!',
    you_can_now_login_to_the_tulka_application_using_your_credentials: 'Sie können sich jetzt bei Túlka anmelden. Die Schaltfläche am Ende der Seite führt Sie direkt zur Browser-Version von Túlka.',
    we_have_also_sent_you_instructions_for_use_by_email: 'Wir haben Ihnen auch die Anweisungen per E-Mail gesendet.',
    open_mobile_app: 'Mobile App öffnen',
    login_to_web: 'Bei WEB anmelden',
    account_found: 'Konto gefunden',
    please_log_in_or_request_a_new_password: 'Bitte melden Sie sich an oder fordern Sie ein neues Passwort an.',
    forgot_password: 'Passwort vergessen',
    no_contract_found: 'Kein Vertrag gefunden',
    it_seems_like_you_dont_have_an_contract_with_tulka_based_on_your_email_address: 'Ihrer E-Mail-Adresse zufolge scheinen Sie keinen Vertrag mit Túlka zu haben.',
    please_contact_our_sales_to_begin_using_tulka: 'Wenn Sie Túlka verwenden möchten, wenden Sie sich an unseren Kundendienst über den Chat unten rechts auf der Seite, telefonisch unter {customerServicePhoneNumber} oder per E-Mail an {infoEmail}',
    email_already_registered: 'Die E-Mail-Adresse ist bereits mit einem anderen Konto registriert.',
    contact_service_with_chat: 'Bitte wenden Sie sich an den Kundendienst über den Chat oder telefonisch unter der Nummer ',
    contact_service_without_chat: 'Bitte wenden Sie sich an den Kundendienst telefonisch unter der Nummer ',
    contact_sales: 'telefonisch unter 030 660 6400 oder per E-Mail an info@tulka.com',
    invalid_code: 'Ungültiger Code',
    invalid_field_value: 'Dieses Feld ist erforderlich und darf nicht leer sein.',
    fistName_requirement: 'Vorname erforderlich',
    lastName_requirement: 'Nachname erforderlich',
    contact_service_contacts: 'Tel. 030 660 6400 | info@tulka.com',
    backup_option: 'Backup-Option',
    no_backup_option_selected: 'Keine Backup-Option ausgewählt',
    od_details_title: 'Geben Sie die Dauer und das Thema an (optional)',
    od_details_subject_subtitle: 'Thema der Dolmetschleistung',
    subject_placeholder: 'Wird mit Dolmetschern geteilt',
    estimated_duration: 'Geschätzte Dauer',
    interpreter_level_label: 'Niveau',

    // Translation Order Wizard
    translation_order_title: 'Übersetzungsauftrag',
    translation_order_step_details: 'Auftragsdetails',
    translation_order_step_invoicing: 'Rechnungs- und Auftragsdetails',
    translation_order_details: 'Details',
    translation_order_language_from: 'Ausgangssprache',
    translation_order_language_to: 'Zielsprache',
    translation_order_upload_reference: 'Referenzdokument hochladen',
    translation_order_browse_files: 'Dateien durchsuchen',
    translation_order_accepted_types: 'Akzeptierte Dateitypen',
    translation_order_estimated_scope: 'Geschätzter Umfang',
    translation_order_select_type: 'Typ auswählen',
    translation_order_scope_words: 'Wörter',
    translation_order_scope_pages: 'Seiten',
    translation_order_scope_minutes: 'Minuten',
    translation_order_scope_help_text: 'Der geschätzte Umfang der Übersetzung dient lediglich der Suche nach einem geeigneten Übersetzer und hat keinen direkten Einfluss auf den Rechnungsbetrag.',
    translation_order_instructions: 'Anweisungen für den Übersetzer',
    translation_order_instructions_placeholder: 'z. B. „Bitte achten Sie auf die medizinischen Fachbegriffe“, „Die Zielgruppe sind Kinder“',
    translation_order_message_to_translator: 'Nachricht an den Übersetzer',
    translation_order_customer_service_instructions: 'Kundendienstanweisungen',
    translation_order_delivery_date: 'Gewünschtes Lieferdatum',
    translation_order_delivery_date_help: 'Der angegebene Liefertermin ist unverbindlich und für den Übersetzer nicht verpflichtend.',
    translation_order_specifying_invoicing_details: 'Angabe der Rechnungsdetails',
    translation_order_invoice_references: 'Rechnungsreferenzen',
    translation_order_additional_invoicing_placeholder: 'Die Feldinformationen sind für den Dolmetscher nicht sichtbar',
    translation_order_notifications: 'Benachrichtigungen',
    translation_order_notification_emails: 'Benachrichtigungs-E-Mails',
    translation_order_materials: 'Materialien zur Übersetzung',
    translation_order_show_all: 'Alle anzeigen',
    translation_order_preview_not_available: 'Die Vorschau ist für diesen Dateityp nicht verfügbar',
    translation_order_customer_info: 'Kundeninformationen',
    translation_order_customer_number: 'Kundennummer',
    translation_order_order_number: 'Bestellnummer',
    translation_order_ordered_by: 'Bestellt von',
    translation_order_ordering_unit: 'Bestelleinheit',
    translation_order_estimated_total: 'Geschätzter Gesamtbetrag',
    translation_order_confirmation: 'Auftragsbestätigung',
    translation_order_cancel_order: 'Auftrag stornieren',
    translation_order_cancel_not_possible: 'Die Übersetzung hat begonnen und kann hier nicht mehr storniert werden. Bitte wenden Sie sich an den Kundenservice.',
    translation_download_material: 'Material herunterladen',
    translation_upload_material: 'Materialien hochladen',
    uploading: 'Wird hochgeladen…',
    uploaded: 'Hochgeladen',
    downloading: 'Wird heruntergeladen…',
    transfer_failed: 'Übertragung fehlgeschlagen',
    translation_translated_materials: 'Übersetzte Materialien',
    translation_materials_for_translation: 'Materialien zur Übersetzung',
    translation_order_created_successfully: 'Übersetzungsauftrag erfolgreich erstellt',
    translation_order_uploading_attachments_notice: 'Warten auf den Upload der Anhänge. Bitte lassen Sie diese Seite geöffnet, bis der Upload abgeschlossen ist.',
    translation_order_wait_for_upload: 'Bitte warten Sie, bis die Anhänge hochgeladen wurden.',
    translation_order_cancelled_successfully: 'Übersetzungsauftrag erfolgreich storniert',
    translation_order_attachment_upload_failed: 'Anhang konnte nicht hochgeladen werden',
    translation_order_submit_failed: 'Übersetzungsauftrag konnte nicht erstellt werden',
    translation_order_cancel_failed: 'Übersetzungsauftrag konnte nicht storniert werden',
    translation_mark_completed: 'Als abgeschlossen markieren',
    translation_mark_completed_success: 'Übersetzung als abgeschlossen markiert',
    translation_mark_completed_failed: 'Übersetzung konnte nicht als abgeschlossen markiert werden',
    translation_change_status: 'Ändern',
    translation_task_completed: 'Aufgabe abgeschlossen',
    translation_revert_completed_failed: 'Der Abschlussstatus konnte nicht zurückgesetzt werden',
    translation_order_from_language_required: 'Ausgangssprache ist erforderlich',
    translation_order_to_language_required: 'Zielsprache ist erforderlich',
    translation_order_languages_must_differ: 'Ausgangs- und Zielsprache müssen unterschiedlich sein',
    translation_order_files_required: 'Bitte laden Sie mindestens eine Datei hoch',
    translation_order_scope_required: 'Geschätzter Umfang ist erforderlich',
    translation_order_scope_type_required: 'Umfangstyp ist erforderlich',
    translation_order_delivery_date_required: 'Gewünschtes Lieferdatum ist erforderlich',
    translation_order_delivery_date_too_far: 'Das gewünschte Lieferdatum muss weniger als 5 Jahre in der Zukunft liegen',
    translation_order_translator_type: 'Welche Art von Übersetzer benötigen Sie?',
    translation_order_translator_type_required: 'Bitte wählen Sie mindestens einen Übersetzertyp aus',
  },

  fr: {
    ai_interpreter: 'Interprète IA',
    ai_cost_center: 'Centre de coûts',
    ai_target_language: 'Langue cible',
    ai_alt_cost_order: 'Coût alt. / commande',
    invoice_ref: 'Réf. facture',
    ai_download_transcript: 'Télécharger la transcription',
    ai_download_summary: 'Télécharger le résumé',
    ai_transcription: 'Transcription',
    ai_summary: 'Résumé',
    ai_send_email: 'Envoyer par e-mail',
    ai_send_email_title: 'Envoyer la transcription par e-mail',
    ai_send_email_explanation: 'Saisissez l\'adresse e-mail à laquelle la transcription sera envoyée.',
    ai_include_summary: 'Inclure le résumé',
    ai_email_subject_placeholder: 'Votre référence pour l\'objet de l\'e-mail (facultatif)',
    ai_search_placeholder: 'Rechercher une mission d\'interprétation IA',
    ai_no_sessions: 'Aucune session d\'interprétation IA pour le moment',
    ai_download_retention: 'Les transcriptions et les résumés peuvent être téléchargés pendant 24 heures après la fin de l’interprétation.',
    ai_download_unavailable: 'Ce fichier n\'est plus disponible.',
    ai_download_forbidden: 'Vous n\'avez pas la permission d\'accéder à ce fichier.',
    ai_download_timeout: 'Le fichier est en cours de génération, veuillez réessayer sous peu.',
    ai_email_sent: 'E-mail envoyé.',
    ai_email_failed: 'Échec de l\'envoi de l\'e-mail.',
    ai_email_invalid: 'Adresse e-mail invalide.',
    ai_email_domain_not_allowed: 'Ce domaine e-mail n\'est pas autorisé.',
    ai_allowed_email_domains: 'Domaines e-mail autorisés :',
    ai_own_email_only: 'La transcription ne peut être envoyée qu\'à votre propre adresse e-mail.',
    please_wait: 'Veuillez patienter...',
    done: 'Done',
    fin: 'Finnois',
    eng: 'Anglais',
    nor: 'Norvégien',
    swe: 'Suédois',
    dan: 'Danois',
    fra: 'Français',
    cze: 'Tchèque',
    hrv: 'Croate',
    sqi: 'Albanais',
    ben: 'Bengali',
    amh: 'Amharique',
    bul: 'Bulgare',
    nld: 'Néerlandais',
    ara: 'Arabe',
    deu: 'Allemand',
    urd: 'Ourdou',
    mya: 'Birman',
    mieli: 'Humeur',
    mainio: 'Excellent',
    ccb2b: '📞 Contacter le service client',
    testb2b: '📞 Tester / Contacter le service client',
    vls: 'Flamand',
    ckb: 'Sorani',
    nep: 'Népalais',
    prs: 'Dari',
    hurja: 'Sauvage',
    lao: 'Lao',
    no_language_selected: 'Aucune langue sélectionnée',
    ui_language: 'Langue de l\'interface utilisateur',
    close: 'Fermer',
    // feedback
    failed_to_find_prebooking_data: 'Impossible de trouver cette pré-réservation',
    prebooking_was_cancelled: 'Cette pré-réservation a été annulée',
    feedback_not_open_yet: 'L\'interprétation n\'ayant pas encore eu lieu, vous ne pouvez pas nous laisser de commentaire pour le moment.',
    how_did_we_do: 'Comment était votre expérience ?',
    stars_rating_subtitle: 'Vos commentaires nous aident à améliorer notre service.',
    where_can_we_improve_upon: 'Comment pourrions-nous nous améliorer ?',
    leave_open_feedback: 'Donner un commentaire en texte libre',
    describe_your_experience_here: 'Racontez ce qui s\'est passé dans vos propres mots',
    i_wish_to_be_contacted: 'Veuillez me contacter',
    choose_one_or_more_options: 'Choisissez une ou plusieurs options',
    thank_you_for_your_feedback: 'Merci pour vos commentaires !',
    // customer guide for od-call (modal)
    if_neither_number_works: ' Si aucun numéro ne fonctionne, entrez le numéro de service dans le format suivant :',
    order_an_interpreter_by_calling_the_number: 'Commandez un interprète en appelant le numéro',
    main_calling_number: '041 400 1234',
    main_calling_number_with_code: '*31# 041 400 1234',
    main_calling_number_with_zero: '0041 400 1234',
    phone_must_be_registered: 'Le téléphone que vous utilisez pour appeler notre numéro d\'urgence doit être enregistré dans notre système.',
    note: 'Note !',
    number_is_encrypted: ' Si votre numéro est crypté, entrez le numéro de service dans le format suivant :',
    attention_for_hus: 'Attention aux opérateurs du réseau filaire HUS !',
    contact_to_customer_service: 'En cas de problème, contactez notre service client.',
    select_interpreter_language: 'Une fois l\'appel connecté, sélectionnez la langue à interpréter parmi les suivantes en saisissant le numéro à l\'aide des touches numériques du téléphone',
    accept_incoming_prebookings: 'Accepter ou refuser les pré-réservations entrantes',
    accept: 'Accepter',
    decline: 'Refuser',
    accept_all: 'Accepter tout',
    date_and_time: 'Date et heure',
    duration: 'Durée',
    language: 'Langue',
    presence: 'Présence',
    prebookings_already_checked: 'Pré-réservations déjà vérifiées',
    username_not_unique: 'L\'email de connexion n\'est pas unique.',
    new_username_set: 'Nouveau nom d\'utilisateur défini : ',
    // LUONA
    luonaSignupForm: 'Formulaire d\'inscription',

    label_name: 'Prénom et nom de famille',
    placeholder_name: 'Lettres latines uniquement',
    validate_name: 'Plus de 3 caractères',

    label_phone: 'Téléphone',
    placeholder_phone: '+3XXXXXXXXXXX',
    validate_phone: 'numéro de téléphone mobile au format : +XXXXXXXXXXXX',

    label_email: 'Email',
    placeholder_email: 'utilisateur@mail.com',
    validate_email: 'email au format : utilisateur@mail.com',

    label_city: 'Ville',
    placeholder_city: 'Nom de la ville',
    validate_city: 'Lettres latines uniquement',
    selectOption: 'Sélectionner la ville',

    agreePrivacyPolicy: 'J\'accepte la ',
    privacyPolicy: 'politique de confidentialité',
    luonaSignupButton: 'Envoyer',
    requestErrorMessage: 'Quelque chose s\'est mal passé, veuillez réessayer !',
    minimalPrebookingTimeBumperError: 'L\'heure de pré-réservation est trop proche. Veuillez sélectionner une autre heure.',
    minimalPrebookingOnSiteTimeBumperError: 'L\'heure de début de l\'interprétation sur place est trop proche. Veuillez sélectionner une autre date et heure.',
    new_password_success: 'Nouveau mot de passe ajouté avec succès',
    new_password_wrong: 'Ancien mot de passe introuvable',
    requestErrorMessageUserNotFound: 'Saisissez le numéro de téléphone et l\'adresse e-mail enregistrés.',
    requestErrorMessageUserExist:
      'L\'adresse e-mail ou le numéro de téléphone fourni est déjà utilisé, veuillez en essayer un autre.',
    slot_not_free_anymore: 'Désolé, le créneau horaire sélectionné n\'est plus disponible',
    no_interpreter_in_prebooking: 'Aucun interprète dans la pré-réservation',
    back_to_telegram: 'Retour à Telegram',
    what_is_your_language: 'Bonjour, quelle est votre langue',
    what_you_need_help_with: 'Pour quoi avez-vous besoin d\'aide ?',
    selectable_langs: 'Langue',
    selectable_servises: 'Services',
    selectable_time: 'Heure',
    selectable_interpreter: 'La langue de consultation est l\'anglais ou le finnois. Avez-vous besoin d\'un interprète ?',
    authtorize: 'Autorisation',
    choose_time: 'Veuillez choisir l\'heure pour votre pré-réservation',
    prebook_not_available_message: 'Malheureusement, ce service n\'est pas disponible en ce moment. Horaires de travail : du lundi au vendredi {SCHEDULE}',
    health: 'Santé',
    work_or_study: 'Travail ou études',
    money_or_livelihood: 'Argent ou subsistance',
    reception_allowance: 'Allocation d\'accueil / carte PFS',
    my_money_is_not_enough: 'À court d\'argent',
    copy_email: 'Copier l\'email',
    successfully_copied: 'E-mail copié avec succès',
    copied_to_clipboard: 'Copié dans le presse-papiers',
    other_practical_matters: 'Autre sujet pratique',
    thanks_for_booking: 'Merci pour votre réservation.',
    prebook_created_at: 'Votre réunion vidéo a été confirmée comme suit :',
    prebooking_skill: 'Problème :',
    you_need_high_network: 'Pour assurer la qualité de la réunion, veuillez vous assurer d\'avoir une connexion réseau stable et rapide, suffisante pour la vidéoconférence.',
    you_will_got_accept: 'Vous recevrez une confirmation de réservation et deux rappels par SMS et e-mail.',
    message_with_link_to_meeting: 'Les messages contiennent un lien à partir duquel vous pouvez accéder à la réunion à l\'heure convenue.',
    dont_forget_decline_prebooking: 'N\'oubliez pas d\'annuler la réunion si vous n\'êtes pas en mesure d\'y participer.',
    for_decline_need: 'Vous pouvez le faire dans :',
    click_for_decline_prebooking: 'puis cliquer sur le bouton SUPPRIMER de votre pré-réservation.',
    best_regards: 'Meilleures salutations,',
    luona_DigiVOK: 'Luona DigiVOK',
    emigration_or_holiday_outside_Finland:
      'Émigration ou vacances en dehors de la Finlande',
    free_time: 'Temps libre',
    housing: 'Logement',
    child_care: 'Enfant',
    child_health: 'Santé',
    upbringing_parenting: 'Éducation/Parentalité',
    kindergarten_or_school: 'Garderie ou école',
    reception_centre_info_service: 'Service d\'information du centre d\'accueil',
    physical_or_mental_symptoms: 'Santé',
    related_to_money_or_livelihood: 'Sécurité financière',
    related_to_your_own_or_family_life_situation:
      'Circonstances liées à moi-même ou à ma famille',
    legal_matter: 'Affaire juridique',
    everyday_practical_things: 'Choses pratiques quotidiennes',
    service_housing: 'Logement',
    how_do_you_judge_the_criticality_of_your_case:
      'Comment évaluez-vous la criticité de votre cas ?',
    help_need_today: 'Urgent, devrait être traité dans la journée',
    help_need_in_couple_of_days: 'Urgent, mais peut attendre quelques jours',
    help_is_not_urgent: 'Pas urgent',
    call_now: 'Appeler maintenant',
    book_an_appointment: 'Prendre rendez-vous',

    help_need_in_week: 'Besoin d\'aide dans la semaine',
    authtorize_yourself: 'Autorisez-vous',
    user_successfully_registered: 'L\'autorisation a réussi',
    book_time: 'Réserver un créneau',
    what_time_works_for_you: 'Quelle heure vous convient ?',
    wizard_default_message:
      'Si la situation met la vie en danger, appelez le 112. Si votre problème de santé ne peut pas attendre le prochain jour ouvrable, appelez le 116117 pour obtenir des conseils. Si vous avez une autre crise aiguë, appelez le service de crise sociale de votre municipalité.',
    wizard_welcome_message:
      'Bienvenue au service Luona ! Nous allons faire tout ce que nous pouvons pour vous aider. Comment pouvons-nous vous aider ?',
    wizard_PrebookingStep_header:
      'Nous nous efforçons de traiter les situations immédiatement. Si tous nos employés sont occupés, vous aurez la possibilité de prendre rendez-vous via ceci. Souhaitez-vous prendre rendez-vous ou appeler maintenant ?',
    wizard_TimeStep_header:
      'Malheureusement, personne n\'a pu répondre maintenant. Vous pouvez réserver un créneau à partir d\'ici.',
    // LUONA

    loginTitle: 'Se connecter',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    loginButton: 'Se connecter',
    loginFailed: 'Échec de la connexion',
    sessionExpired: 'La session a expiré. Veuillez vous reconnecter.',
    meeting_closed: 'La réunion a été fermée.',
    signin_code_block_message: 'Cet e-mail est déjà utilisé auparavant. Nous avons envoyé le code de vérification à votre adresse e-mail : [email]. Veuillez saisir le code de vérification dans le champ ci-dessous. ',
    placeholder_signin_code: 'code',
    close_meeting_confirmation_message: 'Êtes-vous sûr de vouloir quitter l\'appel ? Pour tous les participants, cet appel sera également fermé',
    internet_connection_lost: 'Connexion Internet perdue',
    internet_connection_exist: 'Connexion Internet rétablie',
    errorTitle: 'Oups !',
    warnTitle: 'Hmmm...',
    successTitle: 'Parfait !',

    selectLanguage: 'Choisir la langue',
    interpreter: 'Interprète',
    startInterpreting: 'Interpréter',
    requestInterpreting: 'Demander une interprétation',

    interpretationNeeded: 'Interprétation nécessaire',
    requestForInterpretation: 'Une interprétation est nécessaire !',
    requestForCall: 'Le client prend contact',
    nothingToInterpret: 'Toutes les demandes ont été répondues.',
    noInterpretationNeeded: 'Toutes les demandes ont été répondues.',

    doYouWantToHangUp: 'Voulez-vous vraiment raccrocher ?',
    oppositeSideHangsUp: 'L\'autre personne a quitté la conversation.',
    networkTerminated: 'La conversation a été déconnectée.',
    review: 'Évaluation',
    customerFeedbackEnjoyingTulka: 'Satisfait du service ?',
    customerRatingInterpreter: 'Mon avis sur l\'interprète',
    customerInvoiceNotes: 'Référence de facturation',
    deviation: 'Écart',
    deviation_resolution: 'Résolution de l\'écart',
    deviation_must_be_resolved_before_confirming: 'L\'écart doit être résolu avant que cela puisse être confirmé.',
    interpreterRatingInterpreter: 'Comment ça s\'est passé ?',
    interpreterRatingCustomer: 'Comment ai-je fait ?',
    ratingQuality: 'Qualité technique',
    feedback: 'Commentaires',
    feedbackDesc: 'Écrivez vos commentaires ici',
    feedbackContactMe: 'Veuillez me contacter',
    proceed: 'Envoyer',
    skip: 'Ignorer',

    endCall: 'Terminer l\'appel',
    refresh: 'Actualiser',
    logout: 'Se déconnecter',
    toggleCamera: 'Basculer la caméra',
    toggleAudio: 'Basculer l\'audio',

    onlyChromeSupported: 'Navigateur non pris en charge',
    pleaseUseChrome: 'Veuillez installer Google Chrome pour utiliser l\'application Web Túlka',
    downloadChrome: 'Cliquez ici pour installer',
    continueInterpretation: 'Continuer l\'interprétation',
    roomInfoCallEndedClosed: 'Le serveur a fermé la conversation.',
    feedbackTooLate: 'L\'option de continuer n\'est plus disponible !',

    noTimeLeft: 'L\'utilisation de la démo est terminée. Nous vous contacterons bientôt !',
    minutesConsumed: 'L\'utilisation de la démo est maintenant terminée. Nous vous contacterons bientôt !',
    timeLeft: 'Temps d\'interprétation restant : {}',
    zeroTimeLeft: 'L\'utilisation de la démo est terminée.\nNous vous contacterons bientôt !',
    freeUseLeft: 'Temps restant',

    failedToSendFeedback: 'Échec de l\'envoi des commentaires !',
    failedLogOut: 'Échec de la déconnexion.',
    failedToCreateChatroom: 'Échec du démarrage d\'une interprétation !',
    failedToConnect: 'Échec de la connexion au serveur.',
    waitingForInterpreter:
      'Votre demande a été envoyée aux interprètes. Le temps d\'attente est généralement de 1 à 3 minutes.',
    waitingForCustomer: 'En attente du client...',
    waiting_time: 'Le temps d\'attente est',
    pleaseWait: 'Veuillez patienter...',
    youHaveWaitedFor: 'Vous avez attendu {}',
    error500: 'Quelque chose s\'est mal passé. Veuillez réessayer.',
    roomInfoHasAudioPacketLoss: 'Mauvaise connexion !',

    yes: 'Oui',
    no: 'Non',
    cancel: 'Annuler',

    // Attachment feature
    attachment_status_pending: 'Traitement en cours...',
    attachment_status_converting: 'Conversion en PDF...',
    attachment_status_conversion_failed: 'Échec de la conversion',
    attachment_fetch_error: 'Échec du chargement des informations de la pièce jointe',
    attachment_conversion_in_progress: 'Le fichier est en cours de conversion. Veuillez patienter...',
    attachment_conversion_failed_download: 'Téléchargement impossible - échec de la conversion. Veuillez téléverser un autre fichier.',
    attachment_deleted: 'La pièce jointe a été supprimée.',
    attachment_download_error: 'Échec du téléchargement de la pièce jointe',
    attachment_delete_forbidden: 'Vous n\'avez pas la permission de supprimer cette pièce jointe.',
    attachment_delete_error: 'Échec de la suppression de la pièce jointe',
    attachment_upload_failed: 'Réservation créée, mais le téléversement de la pièce jointe a échoué. Vous pouvez réessayer plus tard.',
    attachment_upload_partial_failed: 'Certaines pièces jointes n\'ont pas été téléversées. Veuillez réessayer.',
    attachment_empty_file: 'Le fichier est vide',
    attachment_invalid_type: 'Type de fichier non autorisé',
    attachment_file_too_large: 'Fichier trop volumineux',
    customer_documents: 'Documents client',
    attachment_select_file: 'Sélectionner un document',
    attachment_help_text: 'Formats pris en charge : PDF, DOCX, PPTX, TXT, PNG, JPG (max 5Mo). Le document sera visible par l’interprète assigné.',
    no_attachment: 'Aucun document joint',
    attachment_not_ready: 'Le fichier n\'est pas encore prêt à être téléchargé',
    attachment_preview_error: 'Échec du chargement de l\'aperçu de la pièce jointe',
    download: 'Télécharger',
    delete_attachment: 'Supprimer la pièce jointe',
    delete_attachment_title: 'Supprimer la pièce jointe ?',
    delete_attachment_confirm: 'Êtes-vous sûr de vouloir supprimer ce fichier ? Cette action est irréversible.',
    delete: 'Supprimer',

    default: 'Par défaut',
    termsOfUse: 'Conditions d\'utilisation et politique de confidentialité',
    options: 'Afficher les options',
    hideOptions: 'Masquer les options',

    enable_notifications: 'Activer les notifications',
    disable_notifications: 'Désactiver les notifications',
    disable_duration: 'Désactiver les notifications pendant',
    for_hour: '1 heure',
    for_day: '1 jour',
    for_week: '1 semaine',
    for_month: '1 mois',
    for_a_day: '1 jour',
    for_days: '{} jours',
    for_a_day_an_hour: '1 jour, 1 heure',
    for_a_day_hours: '1 jour, {} heures',
    for_days_an_hour: '{} jours, 1 heure',
    for_days_hours: '{d} jours, {h} heures',
    notifications_disabled_for: 'Notifications désactivées pour\n{}',
    failed_to_disable_notifications:
      'Échec de la désactivation des notifications. Veuillez réessayer plus tard.',
    failed_to_enable_notifications:
      'Échec de l\'activation des notifications. Veuillez réessayer plus tard.',
    forgot_password_link: 'Mot de passe oublié ?',
    forgot_password_info:
      'Si vous avez un compte, nous pouvons vous envoyer un nouveau mot de passe par SMS ou e-mail. Dans d\'autres cas, contactez {infoEmail}.',
    placeholder_phone_number: '+35840...',
    phone_number_title: 'Numéro de téléphone',
    forgot_password_error:
      'Le SMS ou l\'e-mail n\'a pas pu être envoyé. Veuillez contacter {infoEmail}',
    forgot_password_duplicate_email_error:
      'Votre mot de passe ne peut pas être réinitialisé. Veuillez contacter le service client.',
    forgot_password_success:
      'Merci. Vous devriez recevoir votre mot de passe par SMS ou e-mail sous peu.',
    skillModalQuestion:
      'Avez-vous besoin de cette expérience ? Le temps d\'attente peut être plus long.',
    od_type_title: 'Quel type d\'interprète ?',
    od_type_ai: 'IA',
    od_type_ai_subtitle: 'Interprète IA',
    od_type_human: 'Humain',
    od_type_human_subtitle: 'Interprète humain',
    select_customer_gender: 'Spécifiez le sexe pour vous-même et votre client',
    your_gender: 'Votre sexe',
    customer_gender: 'Sexe du client',
    male: 'Masculin',
    female: 'Féminin',
    invoice_cause_title: 'Répartition de la facture',
    invoice_cause_subtitle: 'Veuillez sélectionner la valeur de répartition de la facture.',
    customer_reference_title: 'Informations de facturation supplémentaires',
    targetLanguage: 'Langue que vous comprenez',
    openingTimes: '',
    systemAlert: 'Problèmes techniques avec le service. Nos excuses.',

    chatFailed: 'Échec de la connexion au chat textuel.',
    chatTipInterpreter:
      'Ici, vous pouvez chatter avec le client. Tous les messages sont détruits immédiatement lorsque l\'interprétation se termine.',
    chatTipCustomer:
      'Ici, vous pouvez chatter avec l\'interprète. Tous les messages sont détruits immédiatement lorsque l\'interprétation se termine.',
    chatSendFailed: 'Échec de l\'envoi du message.',
    chatTypeMessage: 'Tapez un message...',
    invoiceRefMandatory: 'La référence de facturation est un champ obligatoire.',
    invoiceRefUserGroupMandatory: 'Veuillez sélectionner un destinataire pour la facture.',
    selectInvoiceRefUserGroup: '-- Sélectionner --',

    show_feedbacks: 'Évaluations',
    show_feedbacks_title: 'Comment j\'ai été évalué',
    failedToFetchFeedbacks: 'Échec de la récupération des évaluations.',
    statistics: 'Mes interprétations',
    no_statistics: 'Aucune statistique disponible.',
    stats_disclaimer:
      'Les chiffres ne sont que des estimations et peuvent ne pas correspondre exactement à la fiche de paie finale.',
    stats_today: 'Aujourd\'hui',
    stats_yesterday: 'Hier',
    stats_this_week: 'Cette semaine',
    stats_last_week: 'La semaine dernière',
    stats_this_month: 'Ce mois-ci',
    stats_last_month: 'Le mois dernier',
    stats_this_year: 'Cette année',
    stats_last_year: 'L\'année dernière',

    feedbackButton: 'Appuyez pour écrire des commentaires',
    feedback_already_exist: 'Les commentaires sont fermés',
    feedback_need_to_leave: 'Les commentaires sont ouverts',
    feedback_do_next: 'Vous pouvez maintenant fermer cet onglet.',
    chatroom_not_exist: 'Commentaires pas encore ouverts',

    // Prebooking
    prebook: 'Interprétation pré-réservée',
    prebooking_date_header: 'Quand avez-vous besoin d\'un interprète ?',
    prebooking_date_header_notice: 'Dernière date pour que le message soit livré',
    step: '{step} sur {steps}',
    choose_button: 'Sélectionner',
    prebooking_duration_header:
      'Combien de temps pensez-vous avoir besoin d\'un interprète ?',
    hours_minutes: '{h}:{m}',
    hour_minutes: '{h}:{m}',
    minutes: '{} min',
    hour: '60 min',
    hours: '{}:00',
    customer_reference: 'Informations de facturation supplémentaires',
    customer_reference_placeholder: 'Les informations du champ ne sont pas visibles par l\'interprète',
    please_provide_customer_reference: 'Veuillez fournir des informations supplémentaires.',
    prebooking_time_header: 'À quelle heure avez-vous besoin d\'un interprète ?',
    select_language_title: 'Quelle devrait être la langue d\'interprétation ?',
    fetching_languages: 'Récupération des langues...',
    invoice_cause: 'Répartition des coûts',
    invoice_cause_description: 'Veuillez sélectionner le centre de coûts approprié',
    invoice_ref_placeholder: 'NOTE ! Le service client ne lit pas ceci.',
    call_type_video: 'Vidéo',
    call_type_call: 'Appel',
    call_type_question: 'Veuillez choisir le type de connexion',
    additional_order_info: 'Informations de commande supplémentaires',
    confirm_prebooking: 'Veuillez vérifier les détails de la réservation.',
    comment: 'Informations supplémentaires nécessaires pour le gestionnaire de commande',
    prebooking_date: 'Date',
    prebooking_time: 'Heure',
    prebooking_duration: 'Durée',
    language_title: 'Langue',
    presence_title: 'Présence',
    call_type_title: 'Type d\'appel',
    select_target_language_title: 'Quelle est votre langue ?',
    location_question: 'Quel est l\'emplacement ?',
    location_placeholder_city: 'Ville',
    location_placeholder_address: 'Adresse de rue',
    location_placeholder_postcode: 'Code postal',
    add_message_to_interpreter: 'Ajouter un message à l\'interprète',
    subject: 'Sujet',
    url_for_video_meeting: 'URL/lien vers la réunion vidéo',
    url_for_video_meeting_label: 'URL/lien',
    interpretation_location_details: 'Instructions d\'arrivée à l\'emplacement (par ex. informations sur l\'accessibilité, bureau, escaliers, étage, salle, etc.)',
    address_info: 'Informations d\'adresse',
    arrival_instructions: 'Instructions d\'arrivée',
    addressAndArrivalInstrustions: 'Adresse et instructions d\'arrivée',
    preferred_interpreters_question: 'Souhaitez-vous sélectionner un interprète préféré ?',
    search_preferred_interpreter: 'Trouver un interprète par nom',
    not_guarantee: 'Nous faisons de notre mieux pour obtenir l\'interprète souhaité, mais ne pouvons pas garantir qu\'il/elle soit disponible.',
    history_is_limited: 'Le résultat de recherche est limité car vous n\'avez pas encore utilisé beaucoup d\'interprètes.',
    presence_question: 'Quel type d\'interprétation ?',
    presence_remote: 'À distance',
    presence_remote_tip: 'Via vidéo ou appel en utilisant l\'application',
    presence_on_site: 'Sur site',
    presence_on_site_tip: 'Interprète physiquement présent',
    presence_notice: 'Interprétation d\'annonce',
    presence_notice_tip: 'Message écrit livré comme interprétation parlée',
    select_favorite: 'Voulez-vous sélectionner des interprètes préférés ?',
    any_favorite: 'Aucune préférence',
    call_type_call_tip: 'Voix uniquement en utilisant un appel téléphonique',
    call_type_video_tip: 'Voix et image en utilisant des données mobiles',
    target_language_title: 'Votre langue de travail',
    invoice_ref_title: 'Étiquette de facture',
    save_prebooking: 'Réserver',
    edit_prebooking: 'Sauvegarder',
    any_gender: 'Peu importe',
    any_dialect: 'Aucun besoin spécifique',
    gender_title: 'Sexe',
    dialect_title: 'Dialecte',
    select_skill: 'Y a-t-il des besoins spéciaux pour l\'interprète ?',
    select_dialect: 'Avez-vous besoin d\'un dialecte spécifique ?',
    select_qualification: 'Avez-vous besoin de qualifications spéciales ?',
    select_gender: 'Le sexe de l\'interprète est-il important ?',
    any_skill: 'Aucun besoin spécial',
    any_qualification: 'Aucune qualification spéciale',
    skill_title: 'Besoins spéciaux',
    unconfirmed_prebooking: 'En attente de confirmation',
    confirmed: 'Confirmé',
    delivered: 'Livré',
    not_able_to_reach: 'Impossible d\'atteindre',
    cancelled: 'Annulé',
    ongoing_prebooking: 'En cours',
    report_deviation: 'Signaler une anomalie',
    active: 'Actif',
    location_title_city: 'Ville',
    location_title_address: 'Adresse de rue',
    // Help tooltips
    help_prebooking_summary_title: 'Écrivez ici seulement les informations supplémentaires nécessaires pour le gestionnaire de commande',
    help_prebooking_summary:
      'Notez que remplir ce champ prolongera le temps de traitement de la commande.',
    help_call_type_title: 'Connexion d\'interprétation',
    help_call_type:
      'Avec une interprétation téléphonique, vous pouvez joindre des personnes qui sont dans des endroits différents (conférence téléphonique).\n\nDans une interprétation vidéo, les gens peuvent se voir, et vous pouvez aussi montrer du texte à l\'interprète pour traduire. La vidéo peut être activée ou désactivée à tout moment pendant l\'interprétation.\n\nVous pouvez changer la connexion d\'interprétation en terminant l\'interprétation et en sélectionnant \'Continuer l\'interprétation\'.',
    help_gender_title: 'Sexe de l\'interprète',
    help_gender:
      'Vous pouvez demander un interprète d\'un sexe spécifique. Veuillez noter que la sélection peut résulter en un nombre plus petit d\'interprètes disponibles et rendre moins probable d\'en obtenir un.',
    help_dialect_title: 'Dialecte de l\'interprète',
    help_dialect:
      'Vous pouvez demander un interprète qui connaît un dialecte spécifique de la langue sélectionnée. Veuillez noter que la sélection peut résulter en un nombre plus petit d\'interprètes disponibles et rendre moins probable d\'en obtenir un.',
    help_confirmation_title: 'Confirmez votre centre de coûts par défaut',
    help_confirmation:
      'Vos commandes seront allouées par défaut à votre centre de coûts par défaut, sauf si vous spécifiez un centre de coûts alternatif lors de la passation de la commande.',
    tomorrow: 'Demain',
    today: 'Aujourd\'hui',
    now: 'Maintenant',
    help_location_title: 'Emplacement',
    help_location:
      'Tapez l\'emplacement de l\'interprétation. Cela peut être une adresse ou un autre identifiant.',
    help_favorites_title: 'Interprètes préférés',
    help_favorites:
      'Vous pouvez sélectionner un ou plusieurs de vos interprètes favoris comme interprètes préférés. Si l\'un des favoris est disponible, il/elle sera assigné(e) à l\'interprétation.',
    on_site_not_available_in_app:
      'L\'interprétation sur site ne peut pas être démarrée depuis l\'application.',
    searching_interpreter: 'Recherche d\'interprète',
    please_call_to_this_number: 'Veuillez appeler ce numéro',
    back: 'Retour',
    rejoin_meeting: 'Rejoindre la réunion',
    change_language: 'Changer de langue',
    prebook_successfully_created: 'Pré-réservation créée avec succès',
    prebook_successfully_edit: 'Pré-réservation mise à jour avec succès',
    prebook_successfully_cancelled: 'Pré-réservation annulée avec succès',
    prebook_successfully_accepted: 'Pré-réservation acceptée avec succès',
    prebooking_details: 'Détails de la pré-réservation',
    select_contract_title: 'Sélectionner un contrat',
    select_contract_subtitle: 'Choisissez le contrat à utiliser pour cette commande.',
    prebook_confirmation_message:
      'Êtes-vous sûr de vouloir abandonner la pré-réservation ?',
    cancel_prebook_confirmation_message:
      'Êtes-vous sûr de vouloir annuler la pré-réservation ?',
    really_cancel_prebooking_too_late:
      'Êtes-vous sûr de vouloir annuler la pré-réservation ? À ce stade, l\'annulation n\'est pas gratuite.',
    cancel_reason_selection: 'Quelle est la raison de l\'annulation ?',
    cancel_reason_sickness: 'Maladie personnelle',
    cancel_sickness_tip: 'Certificat médical requis',
    cancel_reason_mistake: 'Erreur',
    cancel_reason_other: 'Autre',
    cancel_reason_other_tip: 'Une explication en texte libre est requise.',
    cancel_other_title: 'Explication',
    cancel_other: 'Dites-nous ce qui s\'est passé ?',
    cancel_sickness_title: 'Certificat médical',
    cancel_sickness: 'Veuillez envoyer un certificat médical de la maladie.',
    copy_information: 'Copier les informations',
    my_bookings: 'Réservations',
    interpreter_now: 'Interprète maintenant',
    pre_book: 'Interprétation pré-réservée',
    order: 'Commander',
    hero_order_interpretation: 'Interprétation',
    hero_order_translation: 'Traduction',
    book_interpretation: 'Réserver une interprétation',
    time: 'Heure',
    status: 'Statut',
    search: 'Rechercher',
    // Prebooking section titles and mode of interpretation
    details: 'Détails',
    preferences: 'Préférences',
    invoicing_and_assignment_details: 'Facturation et détails de mission',
    invoicing: 'Facturation',
    cost_allocation: 'Centre de coûts',
    contract_label: 'Contrat',
    prebooking_vat_question: 'TVA',
    prebooking_vat_applied: 'TVA incluse',
    prebooking_vat_exempt: 'Exonéré de TVA',
    additional_invoicing_information: 'Informations de facturation supplémentaires',
    field_not_visible_to_interpreter: 'Les informations du champ ne sont pas visibles pour l\'interprète',
    customer_name_for_invoice: 'Nom du client (pour facture)',
    date_of_birth_for_invoice: 'Date de naissance (pour facture)',
    recipients_of_confirmation_and_change_notifications: 'Destinataires des notifications de confirmation et de modification',
    additional_information_for_order_handler: 'Informations supplémentaires pour le gestionnaire de commande',
    note_filling_this_field_will_prolong_processing_time: 'Notez que le remplissage de ce champ prolongera le temps de traitement de la commande.',
    at_least_one_email_required: 'Au moins une adresse e-mail est requise',
    summary: 'Résumé',
    back_to_edit: 'Retour à la modification',
    confirm_order: 'Confirmer la commande',
    submitting: 'Envoi en cours...',
    mode_of_interpretation: 'Mode d\'interprétation',
    phone_call: 'Appel téléphonique',
    phone_call_tip: 'Voix uniquement via un appel téléphonique',
    video_call: 'Appel vidéo',
    video_call_tip: 'Voix et image via données mobiles',
    conference_call: 'Conférence téléphonique',
    conference_call_tip: 'par ex. Microsoft Teams, Skype, Google Meet, Zoom',
    video_call_made_via_tulka_app: 'Appel vidéo via l\'application Tulká',
    Remote: 'À distance',
    presence_onsite: 'Sur place',
    announcement: 'Annonce',
    start_time: 'Heure de début',
    end_time: 'Heure de fin',
    add_another: 'Ajouter un autre',
    does_not_matter: 'Peu importe',
    no_choice: 'Pas de choix',
    highest: 'Le plus élevé',
    // New prebooking form keys
    select: 'Sélectionner',
    select_notice: 'Ce que l\'interprète doit transmettre à l\'utilisateur',
    required: 'Obligatoire',
    language_required: 'La langue est obligatoire',
    interpreted_and_target_language_must_differ: 'La langue interprétée et la langue cible doivent être différentes',
    delivery_time: 'Heure de livraison',
    date_required: 'La date est obligatoire',
    date_too_far_in_future: 'La date doit être à moins de 5 ans dans le futur',
    time_required: 'L\'heure est obligatoire',
    duration_required: 'La durée est obligatoire',
    at_least_one_time_slot_required: 'Au moins un créneau horaire est requis',
    street_address: 'Adresse',
    post_code: 'Code postal',
    city: 'Ville',
    arrival_instruction_at_location: 'Instructions d\'arrivée sur place',
    message_content: 'Contenu du message',
    message_max_length_info: 'La longueur maximale du message est de 1000 caractères.',
    last_delivery_date: 'Dernière date de livraison du message',
    delivery_date_info: 'L\'interprète appellera le numéro fourni avant la fin de la journée sélectionnée.',
    interpreter_gender: 'Genre de l\'interprète',
    competence_level_special_need: 'Niveau de compétence / besoin spécial pour l\'interprète',
    competence_level_helper_text: 'Tous les niveaux sont inclus par défaut. Cliquez pour désélectionner les niveaux que vous ne souhaitez pas utiliser. Veuillez noter que la sélection d\'interprètes disponibles sera réduite si vous désélectionnez des niveaux de compétence.',
    authorized_interpreter: 'Interprète autorisé',
    court_legal_interpreter: 'Interprète judiciaire/juridique',
    healthcare_interpreter: 'Interprète médical',
    registered_trained_interpreter: 'Interprète formé enregistré',
    other_interpreters: 'Autres interprètes',
    other_interpreter_level: 'Autre interprète',
    let_system_choose_highest_qualified: 'Laisser le système choisir l\'interprète le plus qualifié',
    experiences: 'Exigences',
    security_cleared_interpreter: 'Interprète habilité sécurité',
    additional_preferences: 'Préférences supplémentaires',
    open: 'Ouvrir',
    hide: 'Masquer',
    request_preferred_interpreter: 'Demander un interprète préféré',
    exclude_specific_interpreters: 'Exclure des interprètes spécifiques',
    interpreters_found_for_your_selections: 'interprètes trouvés pour vos sélections',
    how_to_handle_no_onsite_interpreter: 'Comment souhaitez-vous procéder si aucun interprète sur place n\'est trouvé?',
    assign_remote_interpreter: 'Attribuer un interprète à distance',
    cancel_booking: 'Annuler la réservation',
    // Preferences section keys
    preferences_title: 'Préférences',
    preferences_interpreter_gender: 'Genre de l\'interprète',
    preferences_onsite_fallback: 'Comment souhaitez-vous que nous gérions le cas où aucun interprète n\'est trouvé sur place?',
    preferences_accept_beyond_km: 'Acceptez-vous un interprète au-delà de la limite contractuelle de {} km aller simple?',
    preferences_km_beyond_limit: 'De combien de km accepteriez-vous de dépasser la limite de {} km aller simple?',
    preferences_total_max_distance_label_one_way: 'Distance maximale totale: {} km aller simple',
    preferences_total_max_distance_unlimited: 'Distance maximale totale: illimitée',
    unlimited: 'Illimité',
    km_unit: 'km',
    accepts_interpreters_within_km: 'ACCEPTE LES INTERPRÈTES DANS UN RAYON DE ${distance} KM',
    preferences_fallback_assign_remote: 'Assigner un interprète à distance',
    preferences_fallback_cancel: 'Annuler la réservation',
    preferences_additional_preferences: 'Préférences supplémentaires',
    preferences_preferred_interpreter: 'Demander un interprète préféré',
    preferences_excluded_interpreter: 'Exclure un(des) interprète(s) spécifique(s)',
    preferences_search_placeholder: 'Rechercher un interprète par nom...',
    preferences_ukrainian_russian_fallback: 'Si un interprète parlant ukrainien n\'est pas disponible, pouvons-nous assigner un interprète parlant russe?',
    preferences_accept_lower_level: 'Si un interprète au niveau demandé n\'est pas disponible, acceptez-vous un niveau inférieur?',
    preferences_remote_backup_connection_type: 'Type de connexion préféré pour la sauvegarde à distance',
    preferences_remote_backup_phone: 'Appel téléphonique',
    preferences_remote_backup_video: 'Appel vidéo',
    preferences_remote_backup_conference: 'Conférence téléphonique',
    interpreted_language: 'Langue interprétée',
    favorite_title: 'Interprètes préférés',
    no_prebookings: 'Vous n\'avez aucune pré-réservation.',
    prebooking_not_active: 'Votre contrat n\'inclut pas la pré-réservation.',
    reservation_number: 'Numéro de réservation',
    external_order_id: 'Identifiant de commande',
    email: 'E-mail',
    not_yet_support_interpreter_login:
      'La nouvelle application web ne prend pas encore en charge la connexion d\'interprète. Veuillez utiliser l\'application mobile.',
    please_try_again_later: 'Veuillez réessayer plus tard.',
    no_languages: 'Aucune langue',
    interpreter_phone_number: 'Numéro de téléphone de l\'interprète',
    remove: 'Supprimer',
    presence_conference: 'Conférence / salle virtuelle',
    presence_conference_tip: 'par ex. Microsoft Teams, Skype, Google Meet, Zoom',
    interpreter_email: 'Email de l\'interprète',
    all: 'Tout',
    invoice_user_group: 'Centre de coûts',
    cc_emails: 'Destinataires des confirmations et notifications de changement',
    cc_email: 'Adresse e-mail',
    cc_emails_copy: 'Destinataires des confirmations et notifications de changement',
    information_for_interpreter: 'Informations pour l\'interprète',
    patient_name: 'Le nom de votre client qui a besoin de l\'interprète',
    upload_reference_document_optional: 'Télécharger le document de référence (optionnel)',
    browse_files: 'Parcourir les fichiers',
    only_pdf_format_file_visible_to_interpreter: 'Format PDF uniquement. Le fichier n\'est visible que par l\'interprète assigné.',
    field_information_not_visible_on_bill: 'Les informations du champ ne sont pas visibles sur la facture',
    patient_name_description: 'Cette information n\'apparaît pas sur la facture, mais va à l\'interprète pour information, par ex. en cas de détention.',
    customer: 'Client',
    customer_unit: 'Unité',
    personal: 'Personnel',
    search_for: 'Rechercher une unité, langue, centre de coûts ou client',
    failed_to_create_prebooking:
      'Échec de la création d\'une nouvelle pré-réservation. Veuillez réessayer plus tard.',
    failed_to_create_all_prebookings: 'Échec de la création de toutes les pré-réservations',
    slot: 'Créneau',
    succeeded: 'réussi',
    failed: 'échoué',
    to_start_interpretation:
      'Pour commencer l\'interprétation, veuillez appeler ce numéro :',
    start_interpretation: 'Commencer l\'interprétation',
    hey_username: 'Salut {username},',
    confirm_your_account_information: 'Confirmez les informations de votre compte',
    confirm_your_account_information_description:
      'Afin de fournir le service le plus fluide possible, nous vous demandons de confirmer ou corriger les informations ci-dessous concernant votre profil',
    other: 'Autre',
    no_options: 'Aucun résultat de recherche',
    search_message: 'Rechercher...',
    i_confirm_the_information: 'JE CONFIRME LES INFORMATIONS',
    billing: 'Facturation',
    translations: 'Traductions',
    order_translation: 'Commander une traduction',
    translation_order_number: 'N° de commande',
    translation_order_date: 'Date de commande',
    translation_from: 'De',
    translation_to: 'Vers',
    translation_username: 'Utilisateur',
    translation_delivery: 'Livraison',
    translation_user_group: 'Groupe d\'utilisateurs',
    translation_customer: 'Client',
    translation_status: 'Statut',
    translation_status_new_order: 'Nouvelle commande',
    translation_status_in_progress: 'En cours',
    translation_status_assigned: 'Attribué',
    translation_status_completed: 'Terminé',
    translation_status_cancelled: 'Annulé',
    translation_status_delivered: 'Livré',
    translation_customer_id: 'ID Client',
    translation_file_name: 'Nom du fichier',
    translation_estimated_count: 'Quantit\u00e9 estim\u00e9e',
    translation_due_date: 'Date d\'échéance',
    translation_assigned_jobs: 'Liste des travaux assign\u00e9s',
    translation_order: 'Commande de traduction',
    translation_details: 'D\u00e9tails',
    translation_customer_information: 'Informations client',
    translation_invoicing: 'Facturation',
    translation_from_language: 'De',
    translation_to_language: 'Vers',
    translation_desired_delivery_date: 'Date de livraison souhait\u00e9e',
    translation_instructions: 'Instructions/notes pour le traducteur',
    translation_estimated_total: 'Total estim\u00e9 (mots)',
    translation_estimated_scope: 'Port\u00e9e estim\u00e9e',
    translation_materials: 'Mat\u00e9riaux \u00e0 traduire',
    translation_customer_number: 'Num\u00e9ro client',
    translation_order_made_by: 'Command\u00e9 par',
    translation_ordering_unit: 'Unit\u00e9 commandante',
    checking_your_billing_information: 'Vérification de vos informations de facturation',
    billing_page_main_sub_header:
      'Vérifiez que l\'interprétation est pour le bon centre de coûts / unité et que les informations de référence de facturation sont conformes aux instructions',
    interpreter_reported_duration: 'Durée signalée par l\'interprète',
    update: 'Mettre à jour',
    update_prebook: 'Mettre à jour la pré-réservation',
    your_changes_will_be_lost:
      'Êtes-vous sûr de vouloir annuler ? Vos modifications seront supprimées.',
    settings: 'Paramètres',
    user_home_group_header: 'Groupe d\'utilisateurs domicile',
    app_country: 'Pays',
    address: 'Adresse',
    country_placeholder: 'Sélectionner le pays',
    update_settings: 'Sauvegarder les paramètres',
    has_car: 'J\'ai une voiture',
    profile_options: 'Options de profil',
    no_invoice_reference: 'Aucune référence de facture',
    no_user_group_selected: 'Aucun groupe d\'utilisateurs sélectionné',
    prebook_successfully_updated: 'Informations de facturation confirmées',
    type_search_term_here: 'Tapez le terme de recherche ici',
    verify: 'Confirmer',
    prebookings_successfully_updated: 'Informations de facturation confirmées',
    alternative_cost_center: 'Centre de coûts alternatif ou numéro de commande',
    alternative_cost_center_edit:
      'Modifier le centre de coûts alternatif ou le numéro de commande',
    choose_default_cost_center: 'Choisir le centre de coûts par défaut',
    enter_or_confirm_username: 'Saisissez ou confirmez l\'email utilisé pour la connexion',
    enter_or_confirm_email: 'Saisissez ou confirmez une adresse e-mail à laquelle les confirmations de réservation et les notifications de changement pour les interprétations réservées sont automatiquement envoyées',
    you_can_change_this_information_at_any_time:
      'Vous pouvez modifier ces informations à tout moment depuis le menu "Paramètres"',
    edit: 'Modifier',
    change_reservation: 'Changer',
    copy_reservation: 'Copier',
    change_reservation_description: 'Changer la réservation',
    copy_reservation_description: 'Copier la réservation',
    cancel_prebook_description: 'Annuler la réservation',
    additional_cost_will_be_charged:
      'Des frais supplémentaires seront facturés. L\'heure prévue originale a lieu dans les 24 heures, donc ce changement entraînera des frais supplémentaires selon l\'annulation de dernière minute dans la liste de prix',
    we_will_cancel_this_booking_and_make_a_new_one:
      'Nous annulerons cette réservation et en ferons une nouvelle si vous changez - heure, date, type, langue, durée',
    preview: 'Aperçu',
    edit_prebooking_details: 'Modifier les détails de la pré-réservation',
    no_invoices: 'Vous n\'avez aucune réservation à traiter pour la facturation.',
    add: 'Ajouter',
    add_email: 'Ajouter un e-mail',
    invite_to_the_group: 'Inviter au groupe',
    invite_to_the_group_explanation:
      'Connaissez-vous un collègue qui utilise des services d\'interprétation dans sa profession ? Invitez-la à Túlka',
    invite: 'Inviter',
    invite_success: 'Invitation envoyée avec succès.',
    invite_to_group: 'Inviter de nouvelles personnes',
    collaborators_header: 'Vos collaborateurs',
    add_collaborators: 'Ajouter des collaborateurs',
    please_enter_email: 'Veuillez saisir l\'email',
    name: 'Nom',
    collaborators_header_description:
      'Invitez un collaborateur à co-gérer vos réservations. \nRemarque : Vous ne pouvez inviter qu\'un utilisateur existant.',
    user_does_not_exist:
      'L\'utilisateur n\'existe pas, vous ne pouvez inviter qu\'un utilisateur existant',
    invite_to_collaborate_success: 'Utilisateur invité avec succès à collaborer.',
    collaborator_successfully_removed: 'Collaborateur supprimé avec succès.',
    invalid_email_address: 'Adresse e-mail invalide',
    invalid_phone_number: 'Numéro de téléphone invalide',
    invalid_phone_number_error: 'Numéro de téléphone invalide',
    already_registered_phone: 'Ce numéro de téléphone est déjà enregistré pour un autre utilisateur. Veuillez contacter le service client ',
    phone_number_cannot_start_with_0: 'Le numéro de téléphone ne peut pas commencer par 0 en format international',
    email_address_from_different_organisation_domain:
      'Adresse e-mail d\'un domaine d\'organisation différent',
    this_user_already_added_to_collaborators:
      'Cet utilisateur a déjà été ajouté aux collaborateurs',
    prebooked: 'Pré-réservé',
    ondemand: 'À la demande',
    reset_user_password: 'Changer le mot de passe',
    reset_user_email: 'Changer l\'email pour les confirmations de réservation',
    reset_user_email_note_for_interpreter: 'Remarque : Cela ne modifie pas le nom d\'utilisateur de connexion, seulement l\'adresse e-mail à laquelle les confirmations de réservation et les notifications de modification sont envoyées.',
    reset_user_email_for_login: 'Changer l\'email pour la connexion',
    please_enter_password: 'Mot de passe',
    please_enter_new_password: 'Nouveau mot de passe',
    please_enter_current_password: 'Mot de passe actuel',
    please_repeat_password: 'Répéter le mot de passe',
    please_repeat_new_password: 'Nouveau mot de passe à nouveau',
    passwords_do_not_match: 'Les mots de passe ne correspondent pas',
    old_password_is_required: 'L\'ancien mot de passe est requis',
    enter_new_password: 'Saisir le nouveau mot de passe',
    repeat_new_password: 'Répéter le nouveau mot de passe',
    password_requirement:
      'Le mot de passe doit comporter au moins 8 caractères, incluant une lettre majuscule et minuscule, un chiffre',
    all_day: 'Toute la journée',
    previous: 'Précédent',
    next: 'Suivant',
    // today: 'Aujourd\'hui',
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour',
    agenda: 'Agenda',
    date: 'Date',
    // time: 'Heure',
    event: 'Événement',
    no_events_in_range: 'Aucun événement dans la plage',
    show_more: 'Afficher plus',
    reports: 'Rapports',
    number_of_interpretations: 'Nombre d\'interprétations',
    interpretation_breakdown_previous_month:
      'Répartition des interprétations - mois précédent',
    your_browser_is_not_supported: 'Votre navigateur n\'est pas pris en charge.',
    edge_browser_is_not_supported: 'Le navigateur EDGE n\'est pas pris en charge. Veuillez utiliser Google Chrome.',
    we_recommend_using_the_latest_version_of_chrome_or_firefox_in_order_to_continue_using_this_service:
      'Nous recommandons d\'utiliser la dernière version de Chrome ou Firefox pour continuer à utiliser ce service.',
    use_of_interpretation_report: 'Rapport d\'utilisation de l\'interprétation',
    billing_report: 'Rapport de facturation',
    customer_reporting_report: 'Rapport client',
    data_export_report: 'Exportation de données',
    monetra_billing_report: 'Rapport de facturation Monetra',
    monetra_payroll_report: 'Rapport de paie Monetra',
    copy_data_to_new_booking: 'Copier les données vers une nouvelle réservation',
    replace_with_new_one: 'Remplacer par un nouveau',
    update_at_least_date_or_time_fields_to_create_a_booking:
      'Mettez à jour au moins les champs Date ou Heure pour créer une réservation',
    cancel_prebook: 'Annuler',
    newButton: 'Nouveau',
    announcement_interpretation: 'Interprétation d\'annonce',
    customer_name_and_date_of_birth:
      'Nom du client et date de naissance (pour la facture)',
    customer_name: 'Nom du client (pour la facture)',
    date_of_birth: 'Date de naissance (pour la facture)',
    to_whom_the_message_is_forwarded_if_not_to_the_customer:
      'À qui le message est transmis, si ce n\'est pas au client',
    telephone_number_to_which_the_interpreter_will_call:
      'Numéro(s) de téléphone que l\'interprète appellera',
    main_telephone_number_to_which_the_interpreter_will_call:
      'Numéro de téléphone principal que l\'interprète appellera',
    additional_telephone_number_to_which_the_interpreter_will_call:
      'Numéro(s) de téléphone supplémentaire(s) que l\'interprète appellera',
    message_to_customer_service_or_interpreter:
      'Message au service client ou à l\'interprète',
    mandatory_information: 'Informations obligatoires',
    optional_information: 'Informations optionnelles',
    customer_data: 'Données client',
    write_the_content: 'Contenu du message',
    write_the_content_of_the_matter_to_be_reported_below:
      'Écrivez le contenu de l\'affaire à signaler ci-dessous',
    content_data_tooltip:
      'L\'interprétation de message est une interprétation parlée unidirectionnelle d\'un message. La longueur maximale du message est de 1000 caractères.',
    content_data_second_tooltip:
      'L\'interprète appellera le numéro de téléphone donné au moins 5 fois. L\'interprétation du message sera considérée comme terminée même lorsque le message n\'atteint pas le client.',
    calendar_tooltip_notice_interpretation:
      'L\'interprète appellera le numéro fourni avant la fin du jour sélectionné.',
    calendars: 'Calendriers',
    please_select_language: 'Choisir la langue',
    please_select_interpreter: 'Veuillez sélectionner l\'interprète',
    please_select_language_and_interpreter_to_see_the_calendar:
      'Veuillez sélectionner la langue et l\'interprète pour voir le calendrier',
    please_select_time: 'Veuillez sélectionner l\'heure',
    block_time: 'Temps bloqué',
    block_time_description: 'Temps bloqué - Pendant ce temps, l\'interprète ne recevra aucun appel ou pré-réservation.',
    reservations_od: 'Réservation pour OD',
    reservations_od_description: 'Réservation pour OD - Pendant ce temps, l\'interprète ne recevra pas de pré-réservations, mais sera ciblé uniquement pour OD',
    unavailable_time: 'Temps indisponible',
    unavailability_type: 'Type d\'indisponibilité',
    pick_start_time: 'Choisir une heure de début',
    pick_end_time: 'Choisir une heure de fin',
    time_successfuly_blocked: 'Temps bloqué avec succès',
    time_successfuly_unblocked: 'Temps bloqué annulé avec succès',
    time_successfuly_updated: 'Temps bloqué mis à jour avec succès',
    overlaping_information_dialog_mesage:
      'Les dates se chevauchent avec une pré-réservation existante ou une autre indisponibilité. Veuillez supprimer les indisponibilités qui se chevauchent, annuler les pré-réservations qui se chevauchent ou utiliser des dates différentes.',
    ok: 'ok',
    cancel_blocked_time_confirmation_message:
      'Êtes-vous sûr de vouloir annuler le temps bloqué ?',
    cancel_interpreter_blocked_time: 'Débloquer',
    relay_the_message_to_person: 'Relayer le message à la personne :',
    birthday: 'Date de naissance :',
    numbers_to_be_called: 'Numéros à appeler :',
    message: 'Message :',
    to_whom_message_forwarded_if_not_customer: 'À qui le message est transmis, si ce n\'est pas le client',
    write_here: 'Écrire ici...',
    main_telephone_number_interpreter_will_call: 'Numéro de téléphone principal que l\'interprète appellera',
    additional_telephone_numbers_interpreter_will_call: 'Numéro(s) de téléphone supplémentaire(s) que l\'interprète appellera',
    phone_required: 'Numéro de téléphone requis',
    phone_already_added: 'Numéro de téléphone déjà ajouté',
    enter_phone_number: 'Entrer le numéro de téléphone',
    has_to_be_a_phone_number: 'Doit être un numéro de téléphone',
    other_information_relevant_to_the_invoicing_such_as_information_about_the_customer:
      'Autres informations pertinentes pour la facturation, telles que les informations sur le client',
    this_invoice_needs_additional_information:
      'Cette facture nécessite des informations supplémentaires. Veuillez remplir les champs requis pour confirmer votre commande',
    cancelled_by: 'Annulé par',
    cancel_reason: 'Raison d\'annulation',
    join_to_meeting: 'Rejoindre la réunion',
    ready_to_join: 'Prêt à rejoindre ?',
    what_is_your_name: 'Quel est votre nom ?',
    your_name: 'Votre nom',
    waiting_for_luona_worker_and_interpreter:
      'En attente du travailleur Luona et de l\'interprète...',
    waiting_label: 'En attente...',
    type_message: 'Tapez un message',
    looking_for: 'Nous essayons de fournir le meilleur service mais parfois cela prend du temps. Veuillez patienter, nous cherchons',
    luona_worker_persone: 'Travailleur Luona',
    interpreter_persone: 'Interprète',
    interpreter_status: 'Interprétations à la demande',
    availability_yes: 'Disponible maintenant',
    availability_no: 'Vous n\'êtes pas disponible.',
    // prebooking luona
    prebooking_page_title: 'Pré-réservation',
    defaultPrebookingPageMessage: 'Vous n\'avez aucune pré-réservation',
    go_to_prebookings_list: 'Aller à la liste des pré-réservations',
    luona_feedback_title: 'Enquête de qualité',
    luona_feedback_description: 'Vous avez profité de la nouvelle plateforme de service à distance technologique de Luona. Nous recueillons des commentaires sur le service, et nous serions reconnaissants si vous répondiez à notre courte enquête.',
    luona_feedback_score: 'Quelle est la probabilité que vous recommandiez cette plateforme de service à distance à un ami ?',
    luona_feedback: 'Commentaires',
    feedback_sent: 'Merci pour vos commentaires !',
    luona_prefer: 'Préférentiel',
    Luona_lead: 'Équipe de direction',
    luona_social: 'Social',
    luona_nurses: 'Médical',
    go_to_services: 'Aller aux services',
    start_prebook: 'Commencer',
    prebooking_is_gone: 'La pré-réservation a disparu',
    prebooking_not_answered: 'Malheureusement, nous ne pouvons pas livrer la pré-réservation. Réservez à nouveau une consultation avec un spécialiste',
    prebooking_is_not_found: 'Malheureusement, nous ne trouvons pas de pré-réservation active correspondante. Veuillez essayer de faire un appel d\'urgence ou réserver à nouveau une consultation avec un spécialiste.',
    prebooking_is_cancelled: 'Malheureusement, nous ne trouvons pas de pré-réservation active correspondante. Elle a peut-être été annulée. Veuillez essayer de faire un appel d\'urgence ou réserver à nouveau une consultation avec un spécialiste.',
    prebooking_is_too_late: 'Malheureusement, l\'heure de début de la pré-réservation est passée. Après l\'attente, les interprètes ont été redirigés pour traiter les appels urgents. Veuillez essayer de faire un appel d\'urgence ou réserver à nouveau une consultation avec un spécialiste.',
    prebooking_will_start_in: 'Le début de votre rendez-vous est dans :',
    early_preview_intro: 'Cher client Luona !',
    you_can_close_tab_for_now: 'Vous pouvez fermer cet onglet pour l\'instant.',
    my_prebooking_list: 'Mes réservations',
    connecting_to_meeting: 'Connexion à la réunion',
    connecting_to_meeting_for_interpreter: 'Veuillez rester en ligne, nous connectons toutes les parties',
    no_access_to_your_camera_or_microphone: 'Aucun accès à votre caméra ou microphone',
    remote_backup_to_onsite: 'Que faire si aucun interprète n\'est trouvé sur site ?',
    use_remote_interpretation_option: 'Utiliser l\'interprétation à distance',
    cancel_prebooking_option: 'Annuler la pré-réservation',
    which_remote_interpretation_type_do_you_choose: 'Quel type d\'interprétation à distance choisissez-vous ?',
    phone_interpretation: 'Interprétation téléphonique',
    conference_virtual_room: 'Conférence / Salle virtuelle (par ex. Google meet, Teams, Zoom)',
    confirm_you_are_online: 'Êtes-vous parti ? Si vous voulez continuer à accepter les appels, veuillez cliquer sur le bouton "Revenir".',
    join_back: 'Revenir',
    requestErrorMessageReasonPoorInternet: 'Oups ! Quelque chose s\'est mal passé. Une des raisons pourrait être une mauvaise connexion internet. Veuillez vérifier vos paramètres internet !',
    networkDisconnectedMessage: 'Votre connexion internet n\'est pas assez rapide pour les appels vidéo. Veuillez vérifier vos paramètres internet !',
    interpreter_name: 'Interprète',
    meeting_disconnected: 'Vous avez été déconnecté',
    meeting_reconnecting: 'Vous êtes en cours de reconnexion',
    meeting_reconnected: 'Vous avez été reconnecté',
    browser_does_not_support_video_effects: 'Le navigateur ne prend pas en charge les effets vidéo',
    // Self-selfRegistration
    user_group_not_found: 'Nous ne parvenons pas à terminer votre inscription pour le moment car votre organisation manque d\'une configuration requise. Veuillez contacter notre équipe de service client pour obtenir de l\'aide à résoudre ce problème.',
    log_in: 'se connecter',
    sign_up: 's\'inscrire',
    create_an_account: 'Créer un compte',
    contact_information: 'Informations de contact',
    first_name: 'Prénom',
    last_name: 'Nom de famille',
    is_personal_email: 'Cette adresse e-mail est utilisée pour vérifier votre identité. Veuillez spécifier si cette adresse e-mail est uniquement pour la communication personnelle ou partagée avec des collègues :',
    email_for_personal: 'L\'email est uniquement pour la communication personnelle',
    email_shared_with_colleagues: 'L\'email est partagé avec des collègues',
    check_email_again: 'Veuillez saisir à nouveau l\'adresse e-mail pour l\'envoi de l\'e-mail de vérification.',
    is_personal_phone: 'Ce numéro de téléphone est utilisé pour vérifier votre identité. Veuillez spécifier si ce numéro de téléphone est uniquement pour la communication personnelle ou partagé avec des collègues :',
    phone_for_personal: 'Le numéro de téléphone est uniquement pour la communication personnelle',
    phone_shared_with_colleagues: 'Le numéro de téléphone est partagé avec des collègues',
    check_phone_again_by_sms: 'Veuillez saisir à nouveau le numéro de téléphone pour l\'envoi du SMS de vérification.',
    check_phone_again_by_call: 'Veuillez saisir à nouveau le numéro de ligne fixe pour recevoir un appel automatisé.',
    already_have_an_account_part1: 'Vous avez déjà un compte ? ',
    already_have_an_account_part2: 'Se connecter ',
    contact_info_email: 'Email',
    contact_info_phone: 'Numéro de téléphone',
    continue: 'Continuer',
    confirm_your_email: 'Confirmez votre email',
    confirm_your_email_message: 'Pour terminer l\'inscription, nous avons envoyé un e-mail de vérification à l\'adresse e-mail enregistrée. Veuillez vérifier l\'e-mail en suivant les instructions dans l\'e-mail.',
    confirm_your_phone: 'Confirmez votre téléphone',
    confirm_your_mobile_phone_message: 'Pour terminer l\'inscription, nous avons envoyé un SMS de vérification au numéro de téléphone enregistré. Veuillez vérifier le numéro de téléphone en suivant les instructions dans le SMS.',
    confirm_your_phone_message: 'Vous recevrez un appel automatisé pour vérifier la propriété d\'un numéro de ligne fixe. Pendant l\'appel, vous entendrez un code, que vous devez taper ici.',
    confirmation_code: 'Code de confirmation',
    didnt_receive_an_email: 'Vous n\'avez pas reçu d\'e-mail ?',
    didnt_receive_a_call: 'Vous n\'avez pas reçu d\'appel ?',
    didnt_receive_sms: 'Vous n\'avez pas reçu de SMS ?',
    send_email_again: 'Renvoyer l\'e-mail',
    send_phone_again_for_sms: 'Renvoyer le SMS',
    send_phone_again_for_call: 'Demander un autre rappel',
    verification_page: 'Page de vérification',
    verification_link_expired: 'Quelque chose s\'est mal passé. Le lien de vérification a peut-être expiré. Veuillez réessayer.',
    waiting_for_verification: 'En attente de vérification',
    select_the_correct_cost_center_regarding_invoicing: 'Sélectionnez le bon centre de coûts concernant la facturation. Si vous ne trouvez pas le bon centre de coûts, sélectionnez l\'option "Je n\'ai pas pu trouver le bon centre de coûts".',
    how_often_do_you_predict_to_utilize_interpretation_services: 'À quelle fréquence prévoyez-vous d\'utiliser les services d\'interprétation ?',
    daily: 'Quotidiennement',
    weekly: 'Hebdomadairement',
    more_than_weekly: 'Plus rarement qu\'hebdomadairement',
    periodically: 'Périodiquement',
    cost_center: 'Centre de coûts',
    i_could_not_find_the_correct_cost_center: 'Je n\'ai pas pu trouver le bon centre de coûts',
    information_regarding_cost_center: 'Informations concernant le centre de coûts (Industrie / département où vous travaillez)',
    please_tell_us_where_you_work_in_which_unit_etc: 'Veuillez nous dire où vous travaillez, dans quelle unité, etc.',
    update_user_home_group_failed: 'Échec de la mise à jour du groupe domicile de l\'utilisateur',
    set_up_your_password: 'Configurez votre mot de passe',
    repeat_password: 'Répéter le mot de passe',
    set_password_failed: 'Échec de la définition du mot de passe',
    submit: 'soumettre',
    account_created: 'Compte créé !',
    you_can_now_login_to_the_tulka_application_using_your_credentials: 'Vous pouvez maintenant vous connecter à Túlka. Le bouton en bas de la page vous mène directement à la version navigateur de Túlka.',
    we_have_also_sent_you_instructions_for_use_by_email: 'Nous vous avons également envoyé les instructions par e-mail.',
    open_mobile_app: 'Ouvrir l\'application mobile',
    login_to_web: 'Se connecter au WEB',
    account_found: 'Compte trouvé',
    please_log_in_or_request_a_new_password: 'Veuillez vous connecter ou demander un nouveau mot de passe.',
    forgot_password: 'Mot de passe oublié',
    no_contract_found: 'Aucun contrat trouvé',
    it_seems_like_you_dont_have_an_contract_with_tulka_based_on_your_email_address: 'Il semble que vous n\'ayez pas de contrat avec Túlka basé sur votre adresse e-mail.',
    please_contact_our_sales_to_begin_using_tulka: 'Si vous voulez utiliser Túlka, contactez notre service client via le chat en bas à droite de la page, par téléphone au {customerServicePhoneNumber} ou par e-mail à {infoEmail}',
    email_already_registered: 'L\'e-mail est déjà enregistré avec un autre compte.',
    contact_service_with_chat: 'Veuillez contacter le service client par chat ou en appelant le numéro ',
    contact_service_without_chat: 'Veuillez contacter le service client en appelant le numéro ',
    contact_sales: 'par téléphone au 030 660 6400 ou par e-mail à info@tulka.com',
    invalid_code: 'Code invalide',
    invalid_field_value: 'Ce champ est requis et ne peut pas être vide.',
    fistName_requirement: 'Prénom requis',
    lastName_requirement: 'Nom de famille requis',
    contact_service_contacts: 'tél. 030 660 6400 | info@tulka.com',
    backup_option: 'Option de sauvegarde',
    no_backup_option_selected: 'Aucune option de sauvegarde sélectionnée',
    od_details_title: 'Précisez le sujet et la durée de l\'interprétation (facultatif)',
    od_details_subject_subtitle: 'Sujet de l\'interprétation',
    subject_placeholder: 'Partagé avec les interprètes',
    estimated_duration: 'Durée estimée',
    interpreter_level_label: 'Niveau',

    // Translation Order Wizard
    translation_order_title: 'Commande de traduction',
    translation_order_step_details: 'Détails de la commande',
    translation_order_step_invoicing: 'Facturation et détails de la mission',
    translation_order_details: 'Détails',
    translation_order_language_from: 'Langue source',
    translation_order_language_to: 'Langue cible',
    translation_order_upload_reference: 'Télécharger le document de référence',
    translation_order_browse_files: 'Parcourir les fichiers',
    translation_order_accepted_types: 'Types de fichiers acceptés',
    translation_order_estimated_scope: 'Volume estimé',
    translation_order_select_type: 'Sélectionner le type',
    translation_order_scope_words: 'Mots',
    translation_order_scope_pages: 'Pages',
    translation_order_scope_minutes: 'Minutes',
    translation_order_scope_help_text: 'Le volume estimé de la traduction est utilisé uniquement pour trouver un traducteur approprié et n\'a aucun impact direct sur le montant facturé.',
    translation_order_instructions: 'Instructions pour le traducteur',
    translation_order_instructions_placeholder: 'Ajouter des instructions pour le traducteur...',
    translation_order_message_to_translator: 'Message au traducteur',
    translation_order_customer_service_instructions: 'Instructions du service client',
    translation_order_delivery_date: 'Date de livraison souhaitée',
    translation_order_delivery_date_help: 'La date de livraison souhaitée est indicative et n\'engage pas le traducteur.',
    translation_order_specifying_invoicing_details: 'Spécification des détails de facturation',
    translation_order_invoice_references: 'Références de facturation',
    translation_order_additional_invoicing_placeholder: 'Les informations du champ ne sont pas visibles pour l\'interprète',
    translation_order_notifications: 'Notifications',
    translation_order_notification_emails: 'E-mails de notification',
    translation_order_materials: 'Matériaux',
    translation_order_show_all: 'Tout afficher',
    translation_order_preview_not_available: 'L\'aperçu n\'est pas disponible pour ce type de fichier',
    translation_order_customer_info: 'Informations client',
    translation_order_customer_number: 'Numéro client',
    translation_order_order_number: 'Numéro de commande',
    translation_order_ordered_by: 'Commandé par',
    translation_order_ordering_unit: 'Unité commanditaire',
    translation_order_estimated_total: 'Volume total estimé',
    translation_order_confirmation: 'Confirmation de commande',
    translation_order_cancel_order: 'Annuler la commande',
    translation_order_cancel_not_possible: 'La traduction a commencé et ne peut plus être annulée ici. Veuillez contacter le service client.',
    translation_download_material: 'Télécharger le matériel',
    translation_upload_material: 'Télécharger la traduction',
    uploading: 'Téléversement…',
    uploaded: 'Téléversé',
    downloading: 'Téléchargement…',
    transfer_failed: 'Échec du transfert',
    translation_translated_materials: 'Matériaux traduits',
    translation_materials_for_translation: 'Matériaux à traduire',
    translation_order_created_successfully: 'Commande de traduction créée avec succès',
    translation_order_uploading_attachments_notice: 'En attente du téléversement des pièces jointes. Veuillez garder cette page ouverte jusqu\'à la fin du téléversement.',
    translation_order_wait_for_upload: 'Veuillez patienter jusqu\'à ce que les pièces jointes aient été téléversées.',
    translation_order_cancelled_successfully: 'Commande de traduction annulée avec succès',
    translation_order_attachment_upload_failed: 'Échec du téléchargement de la pièce jointe',
    translation_order_submit_failed: 'Échec de la création de la commande de traduction',
    translation_order_cancel_failed: 'Échec de l\'annulation de la commande de traduction',
    translation_mark_completed: 'Marquer comme terminé',
    translation_mark_completed_success: 'Traduction marquée comme terminée',
    translation_mark_completed_failed: 'Échec du marquage de la traduction comme terminée',
    translation_change_status: 'Modifier',
    translation_task_completed: 'Tâche terminée',
    translation_revert_completed_failed: 'Échec de l\'annulation du statut terminé',
    translation_order_from_language_required: 'La langue source est requise',
    translation_order_to_language_required: 'La langue cible est requise',
    translation_order_languages_must_differ: 'Les langues source et cible doivent être différentes',
    translation_order_files_required: 'Veuillez télécharger au moins un fichier',
    translation_order_scope_required: 'Le volume estimé est requis',
    translation_order_scope_type_required: 'Le type de volume est requis',
    translation_order_delivery_date_required: 'La date de livraison souhaitée est requise',
    translation_order_delivery_date_too_far: 'La date de livraison souhaitée doit être à moins de 5 ans dans le futur',
    translation_order_translator_type: 'De quel type de traducteur avez-vous besoin ?',
    translation_order_translator_type_required: 'Veuillez sélectionner au moins un type de traducteur',
  },

  sv: {
    no_orderable_contract: 'Inget avtal är tillgängligt för dina språk. Kontakta kundtjänst.',
    no_translation_contract: 'Inget av dina avtal tillåter översättningsbeställningar. Kontakta kundtjänst.',
    ai_interpreter: 'AI-tolk',
    ai_cost_center: 'Kostnadsställe',
    ai_target_language: 'Målspråk',
    ai_alt_cost_order: 'Alt. kostnad / order',
    invoice_ref: 'Fakturaref.',
    ai_download_transcript: 'Ladda ner transkription',
    ai_download_summary: 'Ladda ner sammanfattning',
    ai_transcription: 'Transkription',
    ai_summary: 'Sammanfattning',
    ai_send_email: 'Skicka e-post',
    ai_send_email_title: 'Skicka transkription via e-post',
    ai_send_email_explanation: 'Ange e-postadressen som transkriptionen ska skickas till.',
    ai_include_summary: 'Inkludera sammanfattning',
    ai_email_subject_placeholder: 'Din referens för e-postämnet (valfritt)',
    ai_search_placeholder: 'Sök AI-tolkuppdrag',
    ai_no_sessions: 'Inga AI-tolksessioner ännu',
    ai_download_retention: 'Transkriptioner och sammanfattningar kan laddas ner i 24 timmar efter att tolkningen har avslutats.',
    ai_download_unavailable: 'Den här filen är inte längre tillgänglig.',
    ai_download_forbidden: 'Du har inte behörighet att komma åt den här filen.',
    ai_download_timeout: 'Filen genereras fortfarande, försök igen om en liten stund.',
    ai_email_sent: 'E-post skickad.',
    ai_email_failed: 'Det gick inte att skicka e-posten.',
    ai_email_invalid: 'Ogiltig e-postadress.',
    ai_email_domain_not_allowed: 'Den här e-postdomänen är inte tillåten.',
    ai_allowed_email_domains: 'Tillåtna e-postdomäner:',
    ai_own_email_only: 'Transkriptionen kan endast skickas till din egen e-postadress.',
    please_wait: 'Vänligen vänta...',
    done: 'Done',
    fin: 'Finska',
    eng: 'Engelska',
    nor: 'Norska',
    swe: 'Svenska',
    dan: 'Danska',
    fra: 'Franska',
    cze: 'Tjeckiska',
    hrv: 'Kroatiska',
    sqi: 'Albanska',
    ben: 'Bengali',
    amh: 'Amhariska',
    bul: 'Bulgariska',
    nld: 'Nederländska',
    ara: 'Arabiska',
    deu: 'Tyska',
    urd: 'Urdu',
    mya: 'Burmesiska',
    mieli: 'Sinne',
    mainio: 'Perfekt',
    ccb2b: '📞 Kontakta kundservice',
    testb2b: '📞 Test / Kontakta kundservice',
    vls: 'Flamländska',
    ckb: 'Sorani',
    nep: 'Nepalesiska',
    prs: 'Dari',
    hurja: 'Vild',
    lao: 'Laotiska',
    no_language_selected: 'Välj språk',
    ui_language: 'Välj språk',
    close: 'Stäng',
    // feedback
    failed_to_find_prebooking_data: 'Finner inte denna beställning',
    prebooking_was_cancelled: 'Denna beställning är avbokad',
    feedback_not_open_yet: 'Uppdraget har inte startat. Du kan ge oss återkopling när uppdraget är utfört.',
    how_did_we_do: 'Hur var din upplevelse av uppdraget?',
    stars_rating_subtitle: 'Din återkoppling hjälper oss att förbättra våra tjänster.',
    where_can_we_improve_upon: 'Vad kan bli bättre?',
    leave_open_feedback: 'Ge oss din återkoppling',
    describe_your_experience_here: 'Ge en kort återkoppling',
    i_wish_to_be_contacted: 'Vänligen kontakta mig',
    choose_one_or_more_options: 'Välj alternativ',
    thank_you_for_your_feedback: 'Tack för återkopplingen!',
    // customer guide for od-call (modal)
    if_neither_number_works: 'Om telefonnumret inte fungerar, skriv in telefonnumret så här:',
    order_an_interpreter_by_calling_the_number: 'Beställ en tolk genom att ringa numret',
    main_calling_number: '02541',
    main_calling_number_with_code: '*47# 02541',
    main_calling_number_with_zero: '0047 02541',
    phone_must_be_registered: 'Telefonnumret du använder måste vara registrerat som beställare i vårt beställningssystem.',
    note: 'Obs!',
    number_is_encrypted: ' Om ditt nummer är krypterat eller dolt, skriv in telefonnumret så här:',
    attention_for_hus: 'OBS för HUS trådbundna nätoperatörer!',
    contact_to_customer_service: 'Om du får problem, kontakta vår kundservice direkt.',
    select_interpreter_language: 'Välj från språk',
    accept_incoming_prebookings: 'Godkänn eller avslå uppdrag',
    accept: 'Godkänn',
    decline: 'Avslå',
    accept_all: 'Godkänn alla',
    date_and_time: 'Datum och tid',
    duration: 'Varaktighet',
    language: 'Språk',
    presence: 'Uppdragstyp',
    prebookings_already_checked: 'Beställning är redan kontrollerad',
    username_not_unique: 'Din e-postadress används redan.',
    new_username_set: 'Nytt användarnamn: ',
    luonaSignupForm: 'Registrering',
    label_name: 'Förnamn och efternamn',
    placeholder_name: 'Skriv in namnet',
    validate_name: 'Mer än 3 tecken',
    label_phone: 'Telefon',
    placeholder_phone: '+46XXXXXXXX',
    validate_phone: 'telefonnummer i format: +46XXXXXXXX',
    label_email: 'E-post',
    placeholder_email: 'anvandare@mail.se',
    validate_email: 'e-post i format: anvandare@mail.se',
    label_city: 'Stad',
    placeholder_city: 'Namn på stad',
    validate_city: 'Skriv in namnet på staden/platsen',
    selectOption: 'Välj stad',
    agreePrivacyPolicy: 'Jag godkänner ',
    privacyPolicy: 'integritetspolicy',
    luonaSignupButton: 'Skicka',
    requestErrorMessage: 'Något gick fel, vänligen försök igen!',
    minimalPrebookingTimeBumperError: 'Starttidpunkten för ditt uppdrag är för tidig. Vänligen välj en annan tidpunkt.',
    minimalPrebookingOnSiteTimeBumperError: 'Starttiden för tolkning på plats är för tidig. Vänligen välj ett annat datum och en annan tid.',
    new_password_success: 'Nytt lösenord är ändrat',
    new_password_wrong: 'Gammalt lösenord hittades inte',
    requestErrorMessageUserNotFound: 'Skriv in ditt telefonnummer och e-postadress.',
    requestErrorMessageUserExist: 'Angiven e-post eller telefonnummer används redan, vänligen försök med ett annat.',
    slot_not_free_anymore: 'Beklagar, vald tidsperiod är inte längre tillgänglig',
    no_interpreter_in_prebooking: 'Ingen tolk i beställning',
    back_to_telegram: 'Tillbaka till Appen',
    what_is_your_language: 'Hej, vad är ditt språk',
    what_you_need_help_with: 'Vad behöver du hjälp med?',
    selectable_langs: 'Språk',
    selectable_servises: 'Tjänster',
    selectable_time: 'Tid',
    selectable_interpreter: 'Språket är svenska. Behöver du en tolk?',
    authtorize: 'Godkännande',
    choose_time: 'Välj tidpunkt',
    prebook_not_available_message: 'Tyvärr är tjänsten inte tillgänglig just nu. Öppettider: Måndag till fredag {SCHEDULE}',
    health: 'Hälsa',
    work_or_study: 'Arbete eller studier',
    money_or_livelihood: 'Pengar eller försörjning',
    reception_allowance: 'Bidrag / PFS-kort',
    my_money_is_not_enough: 'Tar slut på pengar',
    copy_email: 'Kopiera e-post',
    successfully_copied: 'E-post kopierad',
    copied_to_clipboard: 'Kopierat till urklipp',
    other_practical_matters: 'Andra praktiska ärenden',
    thanks_for_booking: 'Tack för din beställning.',
    prebook_created_at: 'Ditt skärmuppdrag har bekräftats:',
    prebooking_skill: 'Ärende:',
    you_need_high_network: 'Vänligen se till att du har en stabil och snabb nätverksanslutning.',
    you_will_got_accept: 'Du kommer att få en beställningsbekräftelse och påminnelser via SMS och e-post.',
    message_with_link_to_meeting: 'Du kommer att få länk till skärmuppdraget. Tryck på denna för att komma in i mötet vid avtalad tidpunkt.',
    dont_forget_decline_prebooking: 'Kom ihåg att avboka uppdraget om du inte kan utföra detta.',
    for_decline_need: 'Du kan göra det i:',
    click_for_decline_prebooking: 'och klicka sedan på AVBOKA-knappen på ditt uppdrag.',
    best_regards: 'Vänliga hälsningar,',
    luona_DigiVOK: 'Luona DigiVOK',
    emigration_or_holiday_outside_Finland: 'Emigration eller semester utanför Finland',
    free_time: 'Fritid',
    housing: 'Boende',
    child_care: 'Barn',
    child_health: 'Hälsa',
    upbringing_parenting: 'Uppfostran/Föräldrar',
    kindergarten_or_school: 'Förskola eller skola',
    reception_centre_info_service: 'Mottagningscentrum informationstjänst',
    physical_or_mental_symptoms: 'Hälsa',
    related_to_money_or_livelihood: 'Ekonomisk trygghet',
    related_to_your_own_or_family_life_situation: 'Livssituation för min egen eller min familj',
    legal_matter: 'Juridisk process',
    everyday_practical_things: 'Dagliga sysslor',
    service_housing: 'Boende',
    how_do_you_judge_the_criticality_of_your_case: 'Hur bedömer du ditt ärende?',
    help_need_today: 'Brådskande, bör hanteras idag',
    help_need_in_couple_of_days: 'Brådskande, men kan vänta några dagar',
    help_is_not_urgent: 'Inte brådskande',
    call_now: 'Ring nu',
    book_an_appointment: 'Beställ ett uppdrag',
    help_need_in_week: 'Önskar hjälp under veckan',
    authtorize_yourself: 'Bekräfta din identitet',
    user_successfully_registered: 'Auktoriseringen lyckades',
    book_time: 'Beställ tid',
    what_time_works_for_you: 'Vilken tid passar för dig?',
    wizard_default_message: 'Om situationen är livshotande, ring 112. Om du har hälsoproblem som inte kan vänta till nästa dag, ring 112 för råd. Om det gäller annan akut kris, kontakta hjälptjänsten i din kommun.',
    wizard_welcome_message: 'Välkommen till Hero Tolk! Vi ska göra vad vi kan för att hjälpa dig. Hur kan vi hjälpa dig?',
    wizard_PrebookingStep_header: 'Vi arbetar med att hantera situationen. Om alla våra medarbetare är upptagna får du möjlighet att beställa en tid. Vill du beställa en tid eller komma i kontakt med oss nu?',
    wizard_TimeStep_header: 'Tyvärr är ingen av våra konsulter lediga. Du kan beställa tid härifrån.',
    loginTitle: 'Logga in',
    username: 'Användarnamn',
    password: 'Lösenord',
    loginButton: 'Logga in',
    loginFailed: 'Inloggningen misslyckades',
    sessionExpired: 'Sessionen har löpt ut. Vänligen logga in igen.',
    meeting_closed: 'Mötet är avslutat.',
    signin_code_block_message: 'Denna e-post har använts tidigare. Vi skickade verifieringskoden till din e-postadress: [email]. Vänligen skriv in verifieringskoden i fältet nedan. ',
    placeholder_signin_code: 'kod',
    close_meeting_confirmation_message: 'Är du säker på att du vill avsluta samtalet? Detta samtal kommer att avslutas för alla deltagare',
    internet_connection_lost: 'Förlorad internetanslutning',
    internet_connection_exist: 'Återupprättad internetanslutning',
    errorTitle: 'Hoppsan!',
    warnTitle: 'Hmm...',
    successTitle: 'Perfekt!',
    selectLanguage: 'Välj språk',
    interpreter: 'Tolk',
    startInterpreting: 'Tolk',
    requestInterpreting: 'Beställ tolkuppdrag',
    interpretationNeeded: 'Måste ha tolk',
    requestForInterpretation: 'Måste ha tolk!',
    requestForCall: 'Kund tar kontakt',
    nothingToInterpret: 'Alla förfrågningar har besvarats.',
    noInterpretationNeeded: 'Alla förfrågningar har besvarats.',
    doYouWantToHangUp: 'Vill du verkligen lägga på?',
    oppositeSideHangsUp: 'Den andra personen har lämnat samtalet.',
    networkTerminated: 'Samtalet kopplades från.',
    review: 'Bedömning',
    customerFeedbackEnjoyingTulka: 'Nöjd med tjänsten?',
    customerRatingInterpreter: 'Min återkoppling om tolken',
    customerInvoiceNotes: 'Fakturareferens',
    deviation: 'Avvikelse',
    deviation_resolution: 'Avvikelselösning',
    deviation_must_be_resolved_before_confirming: 'Avvikelsen måste lösas innan detta kan bekräftas.',
    interpreterRatingInterpreter: 'Hur gick det?',
    interpreterRatingCustomer: 'Hur bra gjorde jag det?',
    ratingQuality: 'Teknisk kvalitet',
    feedback: 'Feedback',
    feedbackDesc: 'Skriv dina kommentarer här',
    feedbackContactMe: 'Vänligen kontakta mig',
    proceed: 'Skicka',
    skip: 'Hoppa över',
    endCall: 'Avsluta samtal',
    refresh: 'Uppdatera',
    logout: 'Logga ut',
    toggleCamera: 'Slå av/på kamera',
    toggleAudio: 'Slå av/på ljud',
    onlyChromeSupported: 'Webbläsaren stöds inte',
    pleaseUseChrome: 'Vänligen installera Google Chrome för att använda Túlka Web App',
    downloadChrome: 'Klicka här för att installera',
    continueInterpretation: 'Fortsätt tolkning',
    roomInfoCallEndedClosed: 'Servern stängde samtalet.',
    feedbackTooLate: 'Fortsätt-alternativet är inte längre tillgängligt!',
    noTimeLeft: 'Demon är avslutad. Vi kontaktar dig snart!',
    minutesConsumed: 'Demon är nu avslutad. Vi kontaktar dig snart!',
    timeLeft: 'Tolkningstid kvar: {}',
    zeroTimeLeft: 'Demon är avslutad.\nVi kontaktar dig snart!',
    freeUseLeft: 'Tid kvar',
    failedToSendFeedback: 'Kunde inte skicka feedback!',
    failedLogOut: 'Kunde inte logga ut.',
    failedToCreateChatroom: 'Kunde inte starta en tolkning!',
    failedToConnect: 'Kunde inte ansluta till server.',
    waitingForInterpreter: 'Din förfrågan skickades till tolkarna. Väntetiden är vanligtvis 1 till 3 minuter.',
    waitingForCustomer: 'Väntar på kund...',
    waiting_time: 'Väntetiden är',
    pleaseWait: 'Vänligen vänta...',
    youHaveWaitedFor: 'Du har väntat {}',
    error500: 'Något gick fel. Vänligen försök igen.',
    roomInfoHasAudioPacketLoss: 'Dålig anslutning!',
    yes: 'Ja',
    no: 'Nej',
    cancel: 'Avboka',

    // Attachment feature
    attachment_status_pending: 'Bearbetar...',
    attachment_status_converting: 'Konverterar till PDF...',
    attachment_status_conversion_failed: 'Konvertering misslyckades',
    attachment_fetch_error: 'Kunde inte ladda bilageinformation',
    attachment_conversion_in_progress: 'Filen konverteras. Vänta...',
    attachment_conversion_failed_download: 'Kan inte ladda ner - konvertering misslyckades. Ladda upp en annan fil.',
    attachment_deleted: 'Bilagan har raderats.',
    attachment_download_error: 'Kunde inte ladda ner bilaga',
    attachment_delete_forbidden: 'Du har inte behörighet att radera denna bilaga.',
    attachment_delete_error: 'Kunde inte radera bilaga',
    attachment_upload_failed: 'Bokning skapad, men uppladdning av bilaga misslyckades. Du kan försöka ladda upp igen senare.',
    attachment_upload_partial_failed: 'Vissa bilagor kunde inte laddas upp. Försök igen.',
    attachment_empty_file: 'Filen är tom',
    attachment_invalid_type: 'Filtypen är inte tillåten',
    attachment_file_too_large: 'Filen är för stor',
    customer_documents: 'Kunddokument',
    attachment_select_file: 'Välj dokument',
    attachment_help_text: 'Format som stöds: PDF, DOCX, PPTX, TXT, PNG, JPG (max 5MB). Dokumentet blir synligt för tilldelad tolk.',
    no_attachment: 'Inget dokument bifogat',
    attachment_not_ready: 'Filen är inte redo för nedladdning',
    attachment_preview_error: 'Det gick inte att läsa in förhandsgranskning av bilaga',
    download: 'Ladda ner',
    delete_attachment: 'Radera bilaga',
    delete_attachment_title: 'Radera bilaga?',
    delete_attachment_confirm: 'Är du säker på att du vill radera den här filen? Åtgärden kan inte ångras.',
    delete: 'Radera',

    default: 'Standard',
    termsOfUse: 'Användarvillkor och integritetspolicy',
    options: 'Visa alternativ',
    hideOptions: 'Dölj alternativ',
    enable_notifications: 'Aktivera aviseringar',
    disable_notifications: 'Inaktivera aviseringar',
    disable_duration: 'Inaktivera aviseringar i',
    for_hour: '1 timme',
    for_day: '1 dag',
    for_week: '1 vecka',
    for_month: '1 månad',
    for_a_day: '1 dag',
    for_days: '{} dagar',
    for_a_day_an_hour: '1 dag, 1 timme',
    for_a_day_hours: '1 dag, {} timmar',
    for_days_an_hour: '{} dagar, 1 timme',
    for_days_hours: '{d} dagar, {h} timmar',
    notifications_disabled_for: 'Aviseringar inaktiverade i\n{}',
    failed_to_disable_notifications: 'Kunde inte inaktivera aviseringar. Vänligen försök igen senare.',
    failed_to_enable_notifications: 'Kunde inte aktivera aviseringar. Vänligen försök igen senare.',
    forgot_password_link: 'Glömt ditt lösenord?',
    forgot_password_info: 'Om du har ett konto kan vi skicka dig ett nytt lösenord via SMS eller e-post. I andra fall kontakta {infoEmail}.',
    placeholder_phone_number: '+4670...',
    phone_number_title: 'Telefonnummer',
    forgot_password_error: 'SMS:et eller e-posten kunde inte skickas. Vänligen kontakta {infoEmail}',
    forgot_password_duplicate_email_error: 'Ditt lösenord kan inte återställas. Vänligen kontakta kundservice.',
    forgot_password_success: 'Tack. Du ska få ditt lösenord via SMS eller e-post snart.',
    skillModalQuestion: 'Behöver du denna erfarenhet? Väntetiden kan bli längre.',
    od_type_title: 'Vilken typ av tolk?',
    od_type_ai: 'AI',
    od_type_ai_subtitle: 'AI-tolk',
    od_type_human: 'Människa',
    od_type_human_subtitle: 'Mänsklig tolk',
    select_customer_gender: 'Specificera kön för dig själv och din kund',
    your_gender: 'Ditt kön',
    customer_gender: 'Kundens kön',
    male: 'Man',
    female: 'Kvinna',
    invoice_cause_title: 'Fakturafördelning',
    invoice_cause_subtitle: 'Vänligen välj fakturafördelningsvärdet.',
    customer_reference_title: 'Ytterligare faktureringsinformation',
    targetLanguage: 'Språk du förstår',
    openingTimes: '',
    systemAlert: 'Tekniska problem med tjänsten. Beklagar.',
    chatFailed: 'Kunde inte ansluta till textchatt.',
    chatTipInterpreter: 'Här kan du chatta med kunden. Alla meddelanden förstörs omedelbart när tolkningen avslutas.',
    chatTipCustomer: 'Här kan du chatta med tolken. Alla meddelanden förstörs omedelbart när tolkningen avslutas.',
    chatSendFailed: 'Kunde inte skicka meddelandet.',
    chatTypeMessage: 'Skriv ett meddelande...',
    invoiceRefMandatory: 'Fakturareferens är ett obligatoriskt fält.',
    invoiceRefUserGroupMandatory: 'Vänligen välj en mottagare för fakturan.',
    selectInvoiceRefUserGroup: '-- Välj --',
    show_feedbacks: 'Omdömen',
    show_feedbacks_title: 'Hur jag blev bedömd',
    failedToFetchFeedbacks: 'Kunde inte hämta omdömena.',
    statistics: 'Mina tolkningar',
    no_statistics: 'Ingen statistik tillgänglig.',
    stats_disclaimer: 'Siffrorna är endast uppskattningar och stämmer inte nödvändigtvis med den slutliga lönebeskedet.',
    stats_today: 'Idag',
    stats_yesterday: 'Igår',
    stats_this_week: 'Denna vecka',
    stats_last_week: 'Förra veckan',
    stats_this_month: 'Denna månad',
    stats_last_month: 'Förra månaden',
    stats_this_year: 'I år',
    stats_last_year: 'Förra året',
    feedbackButton: 'Tryck för att skriva kommentarer',
    feedback_already_exist: 'Feedback är stängd',
    feedback_need_to_leave: 'Feedback är öppen',
    feedback_do_next: 'Du kan nu stänga denna flik.',
    chatroom_not_exist: 'Feedback inte öppnad ännu',

    // Prebooking
    prebook: 'Förboklad tolkning',
    prebooking_date_header: 'När behöver du en tolk?',
    prebooking_date_header_notice: 'Senaste datum för leverans av meddelandet',
    step: '{step} av {steps}',
    choose_button: 'Välj',
    prebooking_duration_header: 'Hur länge tror du att du behöver en tolk?',
    hours_minutes: '{h}:{m}',
    hour_minutes: '{h}:{m}',
    minutes: '{} min',
    hour: '60 min',
    hours: '{}:00',
    customer_reference: 'Ytterligare faktureringsinformation',
    customer_reference_placeholder: 'Denna information är inte synlig för tolken',
    please_provide_customer_reference: 'Vänligen ange ytterligare information.',
    prebooking_time_header: 'När behöver du en tolk?',
    select_language_title: 'Vilket språk ska tolken använda?',
    fetching_languages: 'Hämtar språk...',
    invoice_cause: 'Kostnadsfördelning',
    invoice_cause_description: 'Vänligen välj lämpligt kostnadsställe',
    invoice_ref_placeholder: 'OBS! Kundservice läser inte detta.',
    call_type_video: 'Video',
    call_type_call: 'Samtal',
    call_type_question: 'Vänligen välj anslutningstyp',
    additional_order_info: 'Ytterligare beställningsinformation',
    confirm_prebooking: 'Vänligen kontrollera beställningsuppgifterna.',
    comment: 'Nödvändig tilläggsinformation till beställningshandläggare',
    prebooking_date: 'Datum',
    prebooking_time: 'Tid',
    prebooking_duration: 'Varaktighet',
    language_title: 'Språk',
    presence_title: 'Närvaro',
    call_type_title: 'Samtalstyp',
    select_target_language_title: 'Vad är ditt språk?',
    location_question: 'Var är platsen?',
    location_placeholder_city: 'Stad',
    location_placeholder_address: 'Gatuadress',
    location_placeholder_postcode: 'Postnummer',
    add_message_to_interpreter: 'Lägg till meddelande till tolk',
    subject: 'Ämne',
    url_for_video_meeting: 'URL/länk till videomöte',
    url_for_video_meeting_label: 'URL/länk',
    interpretation_location_details: 'Instruktioner vid ankomst (t.ex. information om tillgänglighet, kontor, trappor, våning, rum, osv.)',
    address_info: 'Adressinformation',
    arrival_instructions: 'Ankomstinstruktioner',
    addressAndArrivalInstrustions: 'Adress och ankomstinstruktioner',
    preferred_interpreters_question: 'Vill du välja en föredragen tolk?',
    search_preferred_interpreter: 'Hitta tolk efter namn',
    not_guarantee: 'Vi gör vårt bästa för att få önskad tolk, men kan inte garantera att hen är tillgänglig.',
    history_is_limited: 'Sökresultatet är begränsat eftersom du inte har använt många tolkar ännu.',
    presence_question: 'Vilken typ av tolkning?',
    presence_remote: 'Fjärr',
    presence_remote_tip: 'Via video eller samtal med appen',
    presence_on_site: 'Platstolk',
    presence_on_site_tip: 'Tolk fysiskt närvarande',
    presence_notice: 'Telefonmeddelande',
    presence_notice_tip: 'Skriftligt meddelande levererat som talad tolkning',
    select_favorite: 'Vill du välja föredragna tolkar?',
    any_favorite: 'Ingen preferens',
    call_type_call_tip: 'Bara röst med hjälp av telefonsamtal',
    call_type_video_tip: 'Röst och bild med hjälp av mobildata',
    target_language_title: 'Ditt arbetsspråk',
    invoice_ref_title: 'Fakturamärke',
    save_prebooking: 'Beställ',
    edit_prebooking: 'Spara',
    any_gender: 'Spelar ingen roll',
    any_dialect: 'Inga specifika behov',
    gender_title: 'Kön',
    dialect_title: 'Dialekt',
    select_skill: 'Har tolken några särskilda behov?',
    select_dialect: 'Behöver du en specifik dialekt?',
    select_qualification: 'Behöver du särskilda kvalifikationer?',
    select_gender: 'Spelar tolkens kön någon roll?',
    any_skill: 'Inga särskilda behov',
    any_qualification: 'Inga specifika kvalifikationer',
    skill_title: 'Särskilda behov',
    unconfirmed_prebooking: 'Väntar på bekräftelse',
    confirmed: 'Bekräftad',
    delivered: 'Levererad',
    not_able_to_reach: 'Inte möjligt att nå',
    cancelled: 'Avbokad',
    ongoing_prebooking: 'Pågående',
    report_deviation: 'Rapportera avvikelse',
    active: 'Aktiv',
    location_title_city: 'Stad',
    location_title_address: 'Gatuadress',
    help_prebooking_summary_title: 'Skriv här endast nödvändig tilläggsinformation till beställningshandläggare',
    help_prebooking_summary: 'Observera att ifyllning av detta fält kommer att förlänga handläggningstiden för beställningen.',
    help_call_type_title: 'Tolkningsanslutning',
    help_call_type: 'Med telefontolkning kan du inkludera personer som är på olika platser (konferenssamtal).\n\nI videotolkning kan personer se varandra, och du kan också visa text till tolken för översättning. Video kan aktiveras eller inaktiveras när som helst under tolkningen.\n\nDu kan ändra tolkningsanslutningen genom att avsluta tolkningen och välja "Fortsätt tolkning".',
    help_gender_title: 'Tolkens kön',
    help_gender: 'Du kan be om en tolk av ett specifikt kön. Var medveten om att valet kan resultera i ett mindre antal tillgängliga tolkar och göra det mindre sannolikt att få en.',
    help_dialect_title: 'Tolkens dialekt',
    help_dialect: 'Du kan be om en tolk som känner till en specifik dialekt av det valda språket. Var medveten om att valet kan resultera i ett mindre antal tillgängliga tolkar och göra det mindre sannolikt att få en.',
    help_confirmation_title: 'Bekräfta ditt standardkostnadsställe',
    help_confirmation: 'Dina beställningar kommer som standard att tilldelas ditt standardkostnadsställe, såvida du inte specificerar ett alternativt kostnadsställe när du lägger in beställningen.',
    tomorrow: 'Imorgon',
    today: 'Idag',
    now: 'Nu',
    help_location_title: 'Plats',
    help_location: 'Skriv in platsen för tolkningen. Detta kan vara en adress eller annan identifierare.',
    help_favorites_title: 'Föredragna tolkar',
    help_favorites: 'Du kan välja en eller flera av dina favorittolkar som de föredragna tolkarna. Om en av favoriterna är tillgänglig kommer hen att tilldelas tolkningen.',
    on_site_not_available_in_app: 'Tolking på plats kan inte startas från appen.',
    searching_interpreter: 'Letar efter tolk',
    please_call_to_this_number: 'Vänligen ring till detta nummer',
    back: 'Tillbaka',
    rejoin_meeting: 'Gå med i mötet igen',
    change_language: 'Byt språk',
    prebook_successfully_created: 'Förbokning framgångsrikt skapad',
    prebook_successfully_edit: 'Förbokning framgångsrikt uppdaterad',
    prebook_successfully_cancelled: 'Förbokning framgångsrikt avbokad',
    prebook_successfully_accepted: 'Förbokning framgångsrikt godkänd',
    prebooking_details: 'Förbokningsdetaljer',
    select_contract_title: 'Välj avtal',
    select_contract_subtitle: 'Välj avtalet som ska användas för den här beställningen.',
    prebook_confirmation_message: 'Är du säker på att du vill avboka uppdraget?',
    cancel_prebook_confirmation_message: 'Är du säker på att du vill avboka uppdraget?',
    really_cancel_prebooking_too_late: 'Är du säker på att du vill avboka uppdraget? I detta skede är avbokning inte gratis.',
    cancel_reason_selection: 'Vad är orsaken till avbokningen?',
    cancel_reason_sickness: 'Egen sjukdom',
    cancel_sickness_tip: 'Läkarintyg krävs',
    cancel_reason_mistake: 'Fel',
    cancel_reason_other: 'Annat',
    cancel_reason_other_tip: 'En fritextförklaring krävs.',
    cancel_other_title: 'Förklaring',
    cancel_other: 'Berätta för oss vad som hände?',
    cancel_sickness_title: 'Läkarintyg',
    cancel_sickness: 'Vänligen skicka ett läkarintyg för sjukdomen.',
    copy_information: 'Kopiera information',
    my_bookings: 'Beställningar',
    interpreter_now: 'Tolk nu',
    pre_book: 'Förbokad tolkning',
    order: 'Beställ',
    hero_order_interpretation: 'Tolkning',
    hero_order_translation: 'Översättning',
    book_interpretation: 'Boka tolkning',
    time: 'Tid',
    status: 'Status',
    search: 'Sök',
    // Prebooking section titles and mode of interpretation
    details: 'Detaljer',
    preferences: 'Preferenser',
    invoicing_and_assignment_details: 'Fakturering och uppdragsdetaljer',
    invoicing: 'Fakturering',
    cost_allocation: 'Kostnadsställe',
    contract_label: 'Avtal',
    prebooking_vat_question: 'Moms',
    prebooking_vat_applied: 'Moms inkluderad',
    prebooking_vat_exempt: 'Momsfri',
    additional_invoicing_information: 'Ytterligare faktureringsinformation',
    field_not_visible_to_interpreter: 'Fältinformationen är inte synlig för tolken',
    customer_name_for_invoice: 'Kundnamn (för faktura)',
    date_of_birth_for_invoice: 'Födelsedatum (för faktura)',
    recipients_of_confirmation_and_change_notifications: 'Mottagare av bekräftelse- och ändringsmeddelanden',
    additional_information_for_order_handler: 'Ytterligare information för uppdragshandläggare',
    note_filling_this_field_will_prolong_processing_time: 'Observera att ifyllning av detta fält kommer att förlänga bearbetningstiden för beställningen.',
    at_least_one_email_required: 'Minst en e-postadress krävs',
    summary: 'Sammanfattning',
    back_to_edit: 'Tillbaka till redigering',
    confirm_order: 'Bekräfta beställning',
    submitting: 'Skickar...',
    mode_of_interpretation: 'Tolkningsläge',
    phone_call: 'Telefontolk',
    phone_call_tip: 'Endast röst via ett telefonsamtal',
    video_call: 'Videosamtal',
    video_call_tip: 'Röst och bild via mobildata',
    conference_call: 'Skärmtolk',
    conference_call_tip: 't.ex. Microsoft Teams, Skype, Google Meet, Zoom',
    video_call_made_via_tulka_app: 'Videosamtal via Tulká-appen',
    Remote: 'Fjärr',
    presence_onsite: 'På plats',
    announcement: 'Telefonmeddelande',
    start_time: 'Starttid',
    end_time: 'Sluttid',
    add_another: 'Lägg till en annan',
    does_not_matter: 'Spelar ingen roll',
    no_choice: 'Inget val',
    highest: 'Högsta',
    // New prebooking form keys
    select: 'Välj',
    select_notice: 'Vad tolken ska förmedla till användaren',
    required: 'Obligatorisk',
    language_required: 'Språk är obligatoriskt',
    interpreted_and_target_language_must_differ: 'Tolkad språk och målspråk kan inte vara samma',
    call_type_required: 'Samtalstyp är obligatorisk',
    street_address_required: 'Gatuadress är obligatorisk',
    city_required: 'Stad är obligatorisk',
    post_code_required: 'Postnummer är obligatoriskt',
    message_content_required: 'Meddelandeinnehåll är obligatoriskt',
    customer_name_required: 'Kundnamn är obligatoriskt',
    date_of_birth_required: 'Födelsedatum är obligatoriskt',
    phone_number_required: 'Telefonnummer är obligatoriskt',
    delivery_time: 'Leveranstid',
    date_required: 'Datum är obligatoriskt',
    date_too_far_in_future: 'Datumet måste vara mindre än 5 år framåt i tiden',
    time_required: 'Tid är obligatorisk',
    duration_required: 'Varaktighet är obligatorisk',
    at_least_one_time_slot_required: 'Minst en tidslucka krävs',
    street_address: 'Gatuadress',
    post_code: 'Postnummer',
    city: 'Stad',
    arrival_instruction_at_location: 'Ankomstinstruktioner på plats',
    message_content: 'Meddelandeinnehåll',
    message_max_length_info: 'Maximal längd på meddelandet är 1000 tecken.',
    last_delivery_date: 'Sista datum för meddelandets leverans',
    delivery_date_info: 'Tolken kommer att ringa det angivna numret senast i slutet av den valda dagen.',
    interpreter_gender: 'Tolkens kön',
    competence_level_special_need: 'Kompetensnivå / speciellt behov för tolk',
    competence_level_helper_text: 'Alla nivåer är inkluderade som standard. Klicka för att avmarkera nivåer du inte vill använda. Observera att urvalet av tillgängliga tolkar minskar om du avmarkerar några kompetensnivåer.',
    authorized_interpreter: 'Auktoriserad tolk',
    court_legal_interpreter: 'Rätts-/juridisk tolk',
    healthcare_interpreter: 'Sjukvårdstolk',
    registered_trained_interpreter: 'Registrerad utbildad tolk',
    other_interpreters: 'Andra tolkar',
    other_interpreter_level: 'Övrig tolk',
    let_system_choose_highest_qualified: 'Låt systemet välja den högst kvalificerade tolken',
    experiences: 'Krav',
    security_cleared_interpreter: 'Säkerhetsgodkänd tolk',
    additional_preferences: 'Ytterligare preferenser',
    open: 'Öppna',
    hide: 'Dölj',
    request_preferred_interpreter: 'Begär föredragen tolk',
    exclude_specific_interpreters: 'Uteslut specifika tolkar',
    interpreters_found_for_your_selections: 'tolkar hittade för dina val',
    how_to_handle_no_onsite_interpreter: 'Hur vill du hantera om ingen tolk på plats hittas?',
    assign_remote_interpreter: 'Tilldela fjärrtolk',
    cancel_booking: 'Avboka bokning',
    // Preferences section keys
    preferences_title: 'Preferenser',
    preferences_interpreter_gender: 'Tolkens kön',
    preferences_onsite_fallback: 'Hur vill du att vi ska hantera fall där ingen tolk hittas på plats?',
    preferences_accept_beyond_km: 'Godkänner ni tolk utöver den avtalsenliga gränsen på {} km enkel resa?',
    preferences_km_beyond_limit: 'Med hur många km skulle du acceptera att gå utöver gränsen på {} km enkel resa?',
    preferences_total_max_distance_label_one_way: 'Totalt maximalt avstånd: {} km enkel resa',
    preferences_total_max_distance_unlimited: 'Totalt maximalt avstånd: obegränsat',
    unlimited: 'Obegränsad',
    km_unit: 'km',
    accepts_interpreters_within_km: 'ACCEPTERAR TOLKAR INOM ${distance} KM',
    preferences_fallback_assign_remote: 'Tilldela fjärrtolk',
    preferences_fallback_cancel: 'Avboka bokning',
    preferences_additional_preferences: 'Ytterligare preferenser',
    preferences_preferred_interpreter: 'Begär föredragen tolk',
    preferences_excluded_interpreter: 'Exkludera specifik tolk(er)',
    preferences_search_placeholder: 'Sök tolk efter namn...',
    preferences_ukrainian_russian_fallback: 'Om en ukrainsktalande tolk inte är tillgänglig, kan vi tilldela en rysktalande tolk?',
    preferences_accept_lower_level: 'Om en tolk på önskad nivå inte är tillgänglig, accepterar du en lägre nivå?',
    preferences_remote_backup_connection_type: 'Önskad anslutningstyp för fjärrbackup',
    preferences_remote_backup_phone: 'Telefonsamtal',
    preferences_remote_backup_video: 'Videosamtal',
    preferences_remote_backup_conference: 'Konferenssamtal',
    interpreted_language: 'Tolkat språk',
    favorite_title: 'Föredragna tolkar',
    no_prebookings: 'Du har inga förbokningar.',
    prebooking_not_active: 'Ditt kontrakt inkluderar inte förbokning.',
    reservation_number: 'Reservationsnummer',
    external_order_id: 'Beställnings-id',
    email: 'E-post',
    not_yet_support_interpreter_login: 'Den nya webbappen stöder inte tolkinloggning ännu. Vänligen använd mobilappen.',
    please_try_again_later: 'Vänligen försök igen senare.',
    no_languages: 'Inga språk',
    interpreter_phone_number: 'Tolk telefonnummer',
    remove: 'Ta bort',
    presence_conference: 'Skärmtolk',
    presence_conference_tip: 't.ex. Microsoft Teams, Skype, Google Meet, Zoom',
    interpreter_email: 'Tolk e-post',
    all: 'Alla',
    invoice_user_group: 'Kostnadsställe',
    cc_emails: 'Mottagare av bekräftelse och ändringsaviseringar',
    cc_email: 'E-postadress',
    cc_emails_copy: 'Mottagare av bekräftelse och ändringsaviseringar',
    information_for_interpreter: 'Information till tolk',
    patient_name: 'Din klients namn som behöver tolken',
    upload_reference_document_optional: 'Ladda upp referensdokument (valfritt)',
    browse_files: 'Bläddra bland filer',
    only_pdf_format_file_visible_to_interpreter: 'Endast PDF-format. Filen är endast synlig för den tilldelade tolken.',
    field_information_not_visible_on_bill: 'Fältinformationen är inte synlig på fakturan',
    patient_name_description: 'Denna information visas inte på räkningen, utan går till tolken för information, t.ex. vid anhållande.',
    customer: 'Kund',
    customer_unit: 'Enhet',
    personal: 'Personlig',
    search_for: 'Sök efter enhet, språk, kostnadsställe eller kund',
    failed_to_create_prebooking: 'Kunde inte skapa en ny förbokning. Vänligen försök igen senare.',
    failed_to_create_all_prebookings: 'Kunde inte skapa alla förbokningar',
    slot: 'Tidslucka',
    succeeded: 'lyckades',
    failed: 'misslyckades',
    to_start_interpretation: 'För att starta tolkning, vänligen ring till detta nummer:',
    start_interpretation: 'Starta tolkning',
    hey_username: 'Hej {username},',
    confirm_your_account_information: 'Bekräfta din kontoinformation',
    confirm_your_account_information_description: 'För att ge den smidigaste möjliga tjänsten ber vi dig bekräfta eller korrigera informationen nedan angående din profil',
    other: 'Annat',
    no_options: 'Inga sökresultat',
    search_message: 'Sök...',
    i_confirm_the_information: 'JAG BEKRÄFTAR INFORMATIONEN',
    billing: 'Fakturering',
    translations: 'Översättningar',
    order_translation: 'Beställ översättning',
    translation_order_number: 'Ordernr.',
    translation_order_date: 'Orderdatum',
    translation_from: 'Från',
    translation_to: 'Till',
    translation_username: 'Användarnamn',
    translation_delivery: 'Leverans',
    translation_user_group: 'Användargrupp',
    translation_customer: 'Kund',
    translation_status: 'Status',
    translation_status_new_order: 'Ny beställning',
    translation_status_in_progress: 'Pågående',
    translation_status_assigned: 'Tilldelad',
    translation_status_completed: 'Slutförd',
    translation_status_cancelled: 'Avbruten',
    translation_status_delivered: 'Levererad',
    translation_customer_id: 'Kund-ID',
    translation_file_name: 'Filnamn',
    translation_estimated_count: 'Uppskattat antal',
    translation_due_date: 'F\u00f6rfallodatum',
    translation_assigned_jobs: 'Lista \u00f6ver tilldelade uppdrag',
    translation_order: '\u00d6vers\u00e4ttningsorder',
    translation_details: 'Detaljer',
    translation_customer_information: 'Kundinformation',
    translation_invoicing: 'Fakturering',
    translation_from_language: 'Fr\u00e5n',
    translation_to_language: 'Till',
    translation_desired_delivery_date: '\u00d6nskat leveransdatum',
    translation_instructions: 'Instruktioner/anteckningar till \u00f6vers\u00e4ttaren',
    translation_estimated_total: 'Uppskattat totalt (ord)',
    translation_estimated_scope: 'Uppskattat omf\u00e5ng',
    translation_materials: 'Material f\u00f6r \u00f6vers\u00e4ttning',
    translation_customer_number: 'Kundnummer',
    translation_order_made_by: 'Best\u00e4lld av',
    translation_ordering_unit: 'Best\u00e4llande enhet',
    checking_your_billing_information: 'Kontrollerar din faktureringsinformation',
    billing_page_main_sub_header: 'Kontrollera att tolkningen är för rätt kostnadsställe / enhet och att fakturareferensinformationen är i enlighet med instruktionerna',
    interpreter_reported_duration: 'Tolkrapporterad varaktighet',
    update: 'Uppdatera',
    update_prebook: 'Uppdatera förbokning',
    your_changes_will_be_lost: 'Är du säker på att du vill avboka? Dina ändringar kommer att raderas.',
    settings: 'Inställningar',
    user_home_group_header: 'Hemma användargrupp',
    app_country: 'Land',
    address: 'Adress',
    country_placeholder: 'Välj land',
    update_settings: 'Spara inställningar',
    has_car: 'Jag har en bil',
    profile_options: 'Profilalternativ',
    no_invoice_reference: 'Ingen fakturareferens',
    no_user_group_selected: 'Ingen användargrupp vald',
    prebook_successfully_updated: 'Faktureringsinformation bekräftad',
    type_search_term_here: 'Skriv sökord här',
    verify: 'Bekräfta',
    prebookings_successfully_updated: 'Faktureringsinformation bekräftad',
    alternative_cost_center: 'Alternativt kostnadsställe eller ordernummer',
    alternative_cost_center_edit: 'Redigera alternativt kostnadsställe eller ordernummer',
    choose_default_cost_center: 'Välj standardkostnadsställe',
    enter_or_confirm_username: 'Skriv in eller bekräfta e-posten som används för inloggning',
    enter_or_confirm_email: 'Skriv in eller bekräfta en e-postadress som beställningsbekräftelser och ändringsaviseringar för beställda tolkningar automatiskt skickas till',
    you_can_change_this_information_at_any_time: 'Du kan ändra denna information när som helst från "Inställningar"-menyn',
    edit: 'Redigera',
    change_reservation: 'Ändra',
    copy_reservation: 'Kopiera',
    change_reservation_description: 'Ändra reservation',
    copy_reservation_description: 'Kopiera reservation',
    cancel_prebook_description: 'Avboka reservation',
    additional_cost_will_be_charged: 'Tilläggskostnad kommer att debiteras. Ursprungligt planerad tid äger rum inom 24 timmar, så denna ändring kommer att medföra en tilläggsavgift som vid sista minuten-avbokning enligt prislistan',
    we_will_cancel_this_booking_and_make_a_new_one: 'Vi kommer att avboka denna beställning och göra en ny om du ändrar - tid, datum, typ, språk, varaktighet',
    preview: 'Förhandsgranskning',
    edit_prebooking_details: 'Redigera förbokningsdetaljer',
    no_invoices: 'Du har inga beställningar att behandla för fakturering.',
    add: 'Lägg till',
    add_email: 'Lägg till e-post',
    invite_to_the_group: 'Bjud in till gruppen',
    invite_to_the_group_explanation: 'Känner du en kollega som använder tolktjänster i sitt yrke? Bjud in henne till Túlka',
    invite: 'Bjud in',
    invite_success: 'Inbjudan framgångsrikt skickad.',
    invite_to_group: 'Bjud in nya personer',
    collaborators_header: 'Dina samarbetspartners',
    add_collaborators: 'Lägg till samarbetspartners',
    please_enter_email: 'Vänligen skriv in e-post',
    name: 'Namn',
    collaborators_header_description: 'Bjud in en samarbetspartner att administrera dina beställningar tillsammans med dig. \nOBS: Du kan bara bjuda in en befintlig användare.',
    user_does_not_exist: 'Användaren finns inte, du kan bara bjuda in befintlig användare',
    invite_to_collaborate_success: 'Användaren är framgångsrikt inbjuden att samarbeta.',
    collaborator_successfully_removed: 'Samarbetspartner framgångsrikt borttagen.',
    invalid_email_address: 'Ogiltig e-postadress',
    invalid_phone_number: 'Ogiltigt telefonnummer',
    invalid_phone_number_error: 'Ogiltigt telefonnummer',
    already_registered_phone: 'Detta telefonnummer är redan registrerat till en annan användare. Vänligen kontakta kundservice ',
    phone_number_cannot_start_with_0: 'Telefonnumret kan inte börja med 0 i internationellt format',
    email_address_from_different_organisation_domain: 'E-postadress från annan domän',
    this_user_already_added_to_collaborators: 'Denna användare är redan tillagd till samarbetspartners',
    prebooked: 'Förbokad',
    ondemand: 'På förfrågan',
    reset_user_password: 'Ändra lösenord',
    reset_user_email: 'Ändra e-post för beställningsbekräftelser',
    reset_user_email_note_for_interpreter: 'Obs: Detta ändrar inte användarnamnet för inloggning, utan endast e-postadressen som bokningsbekräftelser och ändringsmeddelanden skickas till.',
    reset_user_email_for_login: 'Ändra e-post för inloggning',
    please_enter_password: 'Lösenord',
    please_enter_new_password: 'Nytt lösenord',
    please_enter_current_password: 'Nuvarande lösenord',
    please_repeat_password: 'Upprepa lösenord',
    please_repeat_new_password: 'Nytt lösenord igen',
    passwords_do_not_match: 'Lösenorden stämmer inte överens',
    old_password_is_required: 'Gammalt lösenord krävs',
    enter_new_password: 'Skriv in nytt lösenord',
    repeat_new_password: 'Upprepa nytt lösenord',
    password_requirement: 'Lösenordet måste ha minst 8 tecken, inklusive en stor och en liten bokstav, och ett tal',
    all_day: 'Hela dagen',
    previous: 'Föregående',
    next: 'Nästa',
    month: 'Månad',
    week: 'Vecka',
    day: 'Dag',
    agenda: 'Agenda',
    date: 'Datum',
    event: 'Händelse',
    no_events_in_range: 'Inga händelser i området',
    show_more: 'Visa mer',
    reports: 'Rapporter',
    number_of_interpretations: 'Antal tolkningar',
    interpretation_breakdown_previous_month: 'Tolkningsöversikt - föregående månad',
    your_browser_is_not_supported: 'Din webbläsare stöds inte.',
    edge_browser_is_not_supported: 'Edge-webbläsaren stöds inte. Vänligen använd Google Chrome.',
    we_recommend_using_the_latest_version_of_chrome_or_firefox_in_order_to_continue_using_this_service: 'Vi rekommenderar att använda den senaste versionen av Chrome eller Firefox för att fortsätta använda denna tjänst.',
    use_of_interpretation_report: 'Tolkningsanvändning',
    billing_report: 'Fakturering',
    customer_reporting_report: 'Kundrapportering',
    data_export_report: 'Dataexport',
    monetra_billing_report: 'Monetra Fakturering',
    monetra_payroll_report: 'Monetra Lön',
    copy_data_to_new_booking: 'Kopiera data till ny beställning',
    replace_with_new_one: 'Ersätt med ny',
    update_at_least_date_or_time_fields_to_create_a_booking: 'Uppdatera minst datum- eller tidsfält för att skapa en beställning',
    cancel_prebook: 'Avboka',
    newButton: 'Ny',
    announcement_interpretation: 'Tillkännagivande tolkning',
    customer_name_and_date_of_birth: 'Kundens namn och födelsedatum (för faktura)',
    customer_name: 'Kundens namn (för faktura)',
    date_of_birth: 'Födelsedatum (för faktura)',
    to_whom_the_message_is_forwarded_if_not_to_the_customer: 'Till vem meddelandet vidarebefordras, om inte till kunden',
    telephone_number_to_which_the_interpreter_will_call: 'Telefonnummer som tolken kommer att ringa till',
    main_telephone_number_to_which_the_interpreter_will_call: 'Huvudtelefonnummer som tolken kommer att ringa till',
    additional_telephone_number_to_which_the_interpreter_will_call: 'Ytterligare telefonnummer som tolken kommer att ringa till',
    message_to_customer_service_or_interpreter: 'Meddelande till kundservice eller tolk',
    mandatory_information: 'Obligatorisk information',
    optional_information: 'Valfri information',
    customer_data: 'Kunddata',
    write_the_content: 'Meddelandeinnehåll',
    write_the_content_of_the_matter_to_be_reported_below: 'Skriv innehållet i ärendet som ska rapporteras nedan',
    content_data_tooltip: 'Meddelande tolkning är en envägstolkning av ett muntligt meddelande. Maximal längd på meddelandet är 1000 tecken.',
    content_data_second_tooltip: 'Tolken kommer att ringa det angivna telefonnumret inntil 5 gånger. Tolkningen av meddelandet kommer att anses som slutförd även när meddelandet inte når kunden.',
    calendar_tooltip_notice_interpretation: 'Tolken kommer att ringa numret som är angivet inom slutet av den valda dagen.',
    calendars: 'Kalendrar',
    please_select_language: 'Välj språk',
    please_select_interpreter: 'Vänligen välj tolk',
    please_select_language_and_interpreter_to_see_the_calendar: 'Vänligen välj språk och tolk för att se kalendern',
    please_select_time: 'Vänligen välj tid',
    block_time: 'Blockerad tid',
    block_time_description: 'Blockerad tid - Under denna tid kommer tolken inte att ta emot några samtal eller förbokningar.',
    reservations_od: 'Reservation för OD',
    reservations_od_description: 'Reservation för OD - Under denna tid kommer tolken inte att ta emot förbokningar, utan endast vara inriktad mot OD',
    unavailable_time: 'Otillgänglig tid',
    unavailability_type: 'Otillgänglighetstyp',
    pick_start_time: 'Välj starttid',
    pick_end_time: 'Välj sluttid',
    time_successfuly_blocked: 'Tid framgångsrikt blockerad',
    time_successfuly_unblocked: 'Blockerad tid framgångsrikt avbokad',
    time_successfuly_updated: 'Blockerad tid framgångsrikt uppdaterad',
    overlaping_information_dialog_mesage: 'Datumen överlappar med en befintlig förbokning eller annan otillgänglighet. Vänligen ta bort överlappande otillgängligheter, avboka överlappande förbokningar eller använd andra datum.',
    ok: 'ok',
    cancel_blocked_time_confirmation_message: 'Är du säker på att du vill avboka den blockerade tiden?',
    cancel_interpreter_blocked_time: 'Häv blockering',
    relay_the_message_to_person: 'Vidarebefordra meddelandet till person:',
    birthday: 'Födelsedatum:',
    numbers_to_be_called: 'Nummer som ska ringas:',
    message: 'Meddelande:',
    to_whom_message_forwarded_if_not_customer: 'Till vem meddelandet vidarebefordras, om inte kund',
    write_here: 'Skriv här...',
    main_telephone_number_interpreter_will_call: 'Huvudtelefonnummer som tolken ringer',
    additional_telephone_numbers_interpreter_will_call: 'Ytterligare telefonnummer som tolken ringer',
    phone_required: 'Telefonnummer krävs',
    phone_already_added: 'Telefonnummer redan tillagt',
    enter_phone_number: 'Ange telefonnummer',
    has_to_be_a_phone_number: 'Måste vara ett giltigt telefonnummer',
    other_information_relevant_to_the_invoicing_such_as_information_about_the_customer: 'Annan information relevant för faktureringen, såsom information om kunden',
    this_invoice_needs_additional_information: 'Denna faktura behöver ytterligare information. Vänligen fyll i de nödvändiga fälten för att bekräfta din beställning',
    cancelled_by: 'Avbokad av',
    cancel_reason: 'Avbokningsorsak',
    join_to_meeting: 'Gå med i mötet',
    ready_to_join: 'Redo att gå med?',
    what_is_your_name: 'Vad heter du?',
    your_name: 'Ditt namn',
    waiting_for_luona_worker_and_interpreter: 'Väntar på Luona-medarbetare och tolk...',
    waiting_label: 'Väntar...',
    type_message: 'Skriv ett meddelande',
    looking_for: 'Vi försöker ge den bästa tjänsten, men ibland tar det tid. Vänligen håll ut, vi letar efter',
    luona_worker_persone: 'Luona-medarbetare',
    interpreter_persone: 'Tolk',
    interpreter_status: 'Tolkningar på förfrågan',
    availability_yes: 'Tillgänglig nu',
    availability_no: 'Du är inte tillgänglig.',
    prebooking_page_title: 'Förbokning',
    defaultPrebookingPageMessage: 'Du har inga förbokningar',
    go_to_prebookings_list: 'Gå till förbokningslistan',
    luona_feedback_title: 'Kvalitetsundersökning',
    luona_feedback_description: 'Du har använt dig av Luonas nya teknologiska fjärrserviceplattform. Vi samlar feedback om tjänsten, och vi skulle vara tacksamma om du svarar på vår korta undersökning.',
    luona_feedback_score: 'Hur sannolikt är det att du skulle rekommendera denna fjärrserviceplattform till en vän?',
    luona_feedback: 'Feedback',
    feedback_sent: 'Tack för feedbacken!',
    luona_prefer: 'Föredragen',
    Luona_lead: 'Ledarteam',
    luona_social: 'Social',
    luona_nurses: 'Medicinsk',
    go_to_services: 'Gå till tjänster',
    start_prebook: 'Starta',
    prebooking_is_gone: 'Förbokning är borta',
    prebooking_not_answered: 'Tyvärr kan vi inte leverera förbokningen. Beställ en konsultation med en specialist igen',
    prebooking_is_not_found: 'Tyvärr kan vi inte hitta en matchande aktiv förbokning. Vänligen försök att göra ett nödsamtal eller beställ en konsultation med en specialist igen.',
    prebooking_is_cancelled: 'Tyvärr kan vi inte hitta en matchande aktiv förbokning. Kanske blev den avbokad. Vänligen försök att göra ett nödsamtal eller beställ en konsultation med en specialist igen.',
    prebooking_is_too_late: 'Tyvärr har starttiden för förbokningen passerat. Efter att ha väntat omdirigerades tolkarna till att hantera brådskande ärenden. Vänligen försök att göra ett nödsamtal eller beställ en konsultation med en specialist igen.',
    prebooking_will_start_in: 'Starten på din avtal är om:',
    early_preview_intro: 'Kära Luona-kund!',
    you_can_close_tab_for_now: 'Du kan stänga denna flik för nu.',
    my_prebooking_list: 'Mina reservationer',
    connecting_to_meeting: 'Ansluter till möte',
    connecting_to_meeting_for_interpreter: 'Vänligen håll linjen, vi ansluter alla parter',
    no_access_to_your_camera_or_microphone: 'Ingen åtkomst till din kamera eller mikrofon',
    remote_backup_to_onsite: 'Vad gör du om ingen tolk finns på plats?',
    use_remote_interpretation_option: 'Använd fjärrtolkning',
    cancel_prebooking_option: 'Avboka förbokning',
    which_remote_interpretation_type_do_you_choose: 'Vilken fjärrtolkningstyp väljer du?',
    phone_interpretation: 'Telefontolkning',
    conference_virtual_room: 'Konferens / virtuellt rum (t.ex. Google meet, Teams, Zoom)',
    confirm_you_are_online: 'Drog du? Om du vill fortsätta ta emot samtal, vänligen klicka på knappen "Gå med igen".',
    join_back: 'Gå med igen',
    requestErrorMessageReasonPoorInternet: 'Hoppsan! Något gick fel. En av orsakerna kan vara dålig internetanslutning. Vänligen kontrollera dina internetinställningar!',
    networkDisconnectedMessage: 'Din internetanslutning är inte snabb nog för videosamtal. Vänligen kontrollera dina internetinställningar!',
    interpreter_name: 'Tolk',
    meeting_disconnected: 'Du har kopplats från',
    meeting_reconnecting: 'Du återansluts',
    meeting_reconnected: 'Du har återanslutits',
    browser_does_not_support_video_effects: 'Webbläsaren stöder inte videoeffekter',
    user_group_not_found: 'Vi kan inte slutföra din registrering just nu eftersom din organisation saknar nödvändig konfiguration. Vänligen kontakta vår kundservice för hjälp att lösa detta problem.',
    log_in: 'logga in',
    sign_up: 'registrera dig',
    create_an_account: 'Skapa ett konto',
    contact_information: 'Kontaktinformation',
    first_name: 'Förnamn',
    last_name: 'Efternamn',
    is_personal_email: 'Denna e-postadress används för att verifiera din identitet. Vänligen specificera om denna e-postadress endast är för personlig kommunikation eller delas med kollegor:',
    email_for_personal: 'E-post är endast för personlig kommunikation',
    email_shared_with_colleagues: 'E-post delas med kollegor',
    check_email_again: 'Vänligen skriv in e-postadress igen för att skicka verifieringse-post.',
    is_personal_phone: 'Detta telefonnummer används för att verifiera din identitet. Vänligen specificera om detta telefonnummer endast är för personlig kommunikation eller delas med kollegor:',
    phone_for_personal: 'Telefonnumret är endast för personlig kommunikation',
    phone_shared_with_colleagues: 'Telefonnumret delas med kollegor',
    check_phone_again_by_sms: 'Vänligen skriv in telefonnummer igen för att skicka verifierings-SMS.',
    check_phone_again_by_call: 'Vänligen skriv in fasttelefonnummer igen för att ta emot ett automatiskt samtal.',
    already_have_an_account_part1: 'Har du redan ett konto? ',
    already_have_an_account_part2: 'Logga in ',
    contact_info_email: 'E-post',
    contact_info_phone: 'Telefonnummer',
    continue: 'Fortsätt',
    confirm_your_email: 'Bekräfta din e-post',
    confirm_your_email_message: 'För att slutföra registreringen har vi skickat ett verifieringse-post till den registrerade e-posten. Vänligen verifiera e-post genom att följa instruktionerna i e-posten.',
    confirm_your_phone: 'Bekräfta din telefon',
    confirm_your_mobile_phone_message: 'För att slutföra registreringen har vi skickat ett verifierings-SMS till det registrerade telefonnumret. Vänligen verifiera telefonnumret genom att följa instruktionerna i SMS:et.',
    confirm_your_phone_message: 'Du kommer att få ett automatiskt samtal för att verifiera ägarskap av ett fasttelefonnummer. Under samtalet kommer du att höra en kod som du måste skriva in här.',
    confirmation_code: 'Bekräftelsekod',
    didnt_receive_an_email: 'Fick du inte ett e-post?',
    didnt_receive_a_call: 'Fick du inte ett samtal?',
    didnt_receive_sms: 'Fick du inte SMS?',
    send_email_again: 'Skicka e-post igen',
    send_phone_again_for_sms: 'Skicka SMS igen',
    send_phone_again_for_call: 'Be om ett nytt återuppringning',
    verification_page: 'Verifieringssida',
    verification_link_expired: 'Något gick fel. Verifieringslänken kan ha löpt ut. Vänligen försök igen.',
    waiting_for_verification: 'Väntar på verifiering',
    select_the_correct_cost_center_regarding_invoicing: 'Välj rätt kostnadsställe angående fakturering. Om du inte kan hitta rätt kostnadsställe, välj "Jag kunde inte hitta rätt kostnadsställe"-alternativet.',
    how_often_do_you_predict_to_utilize_interpretation_services: 'Hur ofta förväntar du dig att använda tolktjänster?',
    daily: 'Dagligen',
    weekly: 'Veckovis',
    more_than_weekly: 'Mer sällan än veckovis',
    periodically: 'Periodiskt',
    cost_center: 'Kostnadsställe',
    i_could_not_find_the_correct_cost_center: 'Jag kunde inte hitta rätt kostnadsställe',
    information_regarding_cost_center: 'Information angående kostnadsställe (Bransch / avdelning där du arbetar)',
    please_tell_us_where_you_work_in_which_unit_etc: 'Vänligen berätta för oss var du arbetar, i vilken enhet osv.',
    update_user_home_group_failed: 'Uppdatering av användargrupp misslyckades',
    set_up_your_password: 'Ställ in ditt lösenord',
    repeat_password: 'Upprepa lösenord',
    set_password_failed: 'Inställning av lösenord misslyckades',
    submit: 'skicka in',
    account_created: 'Konto skapat!',
    you_can_now_login_to_the_tulka_application_using_your_credentials: 'Du kan nu logga in på Túlka. Knappen längst ner på sidan tar dig direkt till webbläsarversionen av Túlka.',
    we_have_also_sent_you_instructions_for_use_by_email: 'Vi har också skickat dig instruktionerna via e-post.',
    open_mobile_app: 'Öppna mobilapp',
    login_to_web: 'Logga in på WEB',
    account_found: 'Konto hittat',
    please_log_in_or_request_a_new_password: 'Vänligen logga in eller be om ett nytt lösenord.',
    forgot_password: 'Glömt lösenord',
    no_contract_found: 'Inget kontrakt hittat',
    it_seems_like_you_dont_have_an_contract_with_tulka_based_on_your_email_address: 'Det verkar som att du inte har ett kontrakt med Túlka baserat på din e-postadress.',
    please_contact_our_sales_to_begin_using_tulka: 'Om du vill använda Túlka, kontakta vår kundservice via chatten längst ner till höger på sidan, på telefon {customerServicePhoneNumber} eller via e-post på {infoEmail}',
    email_already_registered: 'E-post är redan registrerad med ett annat konto.',
    contact_service_with_chat: 'Vänligen kontakta kundservice med chatt eller genom att ringa numret ',
    contact_service_without_chat: 'Vänligen kontakta kundservice genom att ringa numret ',
    contact_sales: 'på telefon 030 660 6400 eller via e-post på info@tulka.com',
    invalid_code: 'Ogiltig kod',
    invalid_field_value: 'Detta fält är obligatoriskt och kan inte vara tomt.',
    fistName_requirement: 'Förnamn krävs',
    lastName_requirement: 'Efternamn krävs',
    contact_service_contacts: 'tel. 030 660 6400 | info@tulka.com',
    backup_option: 'Backup-alternativ',
    no_backup_option_selected: 'Inget backup-alternativ valt',
    od_details_title: 'Ange varaktighet och ämne (valfritt)',
    od_details_subject_subtitle: 'Tolkningens ämne',
    subject_placeholder: 'Delas med tolkarna',
    estimated_duration: 'Uppskattad varaktighet',
    interpreter_level_label: 'Nivå',

    // Translation Order Wizard
    translation_order_title: 'Översättningsbeställning',
    translation_order_step_details: 'Beställningsdetaljer',
    translation_order_step_invoicing: 'Fakturering och uppdragsdetaljer',
    translation_order_details: 'Detaljer',
    translation_order_language_from: 'Språk från',
    translation_order_language_to: 'Språk till',
    translation_order_upload_reference: 'Ladda upp referensdokument',
    translation_order_browse_files: 'Bläddra bland filer',
    translation_order_accepted_types: 'Godkända filtyper',
    translation_order_estimated_scope: 'Beräknat omfång',
    translation_order_select_type: 'Välj typ',
    translation_order_scope_words: 'Ord',
    translation_order_scope_pages: 'Sidor',
    translation_order_scope_minutes: 'Minuter',
    translation_order_scope_help_text: 'Det beräknade omfånget av översättningen används endast för att hitta en lämplig översättare och har ingen direkt inverkan på fakturabeloppet.',
    translation_order_instructions: 'Instruktioner till översättare',
    translation_order_instructions_placeholder: 'Lägg till instruktioner till översättaren...',
    translation_order_message_to_translator: 'Meddelande till översättare',
    translation_order_customer_service_instructions: 'Kundtjänstinstruktioner',
    translation_order_delivery_date: 'Önskat leveransdatum',
    translation_order_delivery_date_help: 'Önskat leveransdatum är vägledande och binder inte översättaren.',
    translation_order_specifying_invoicing_details: 'Specificering av faktureringsdetaljer',
    translation_order_invoice_references: 'Fakturareferenser',
    translation_order_additional_invoicing_placeholder: 'Fältinformationen är inte synlig för tolken',
    translation_order_notifications: 'Aviseringar',
    translation_order_notification_emails: 'Aviseringsmejl',
    translation_order_materials: 'Material',
    translation_order_show_all: 'Visa alla',
    translation_order_preview_not_available: 'Förhandsgranskning är inte tillgänglig för denna filtyp',
    translation_order_customer_info: 'Kundinformation',
    translation_order_customer_number: 'Kundnummer',
    translation_order_order_number: 'Beställningsnummer',
    translation_order_ordered_by: 'Beställd av',
    translation_order_ordering_unit: 'Beställande enhet',
    translation_order_estimated_total: 'Beräknat totalt omfång',
    translation_order_confirmation: 'Orderbekräftelse',
    translation_order_cancel_order: 'Avbeställ order',
    translation_order_cancel_not_possible: 'Översättningen har påbörjats och kan inte avbrytas här, kontakta kundtjänst.',
    translation_download_material: 'Ladda ner material',
    translation_upload_material: 'Ladda upp översättning',
    uploading: 'Laddar upp…',
    uploaded: 'Uppladdad',
    downloading: 'Laddar ner…',
    transfer_failed: 'Överföringen misslyckades',
    translation_translated_materials: 'Översatta material',
    translation_materials_for_translation: 'Material för översättning',
    translation_order_created_successfully: 'Översättningsbeställning skapad',
    translation_order_uploading_attachments_notice: 'Väntar på att bilagorna ska laddas upp. Håll denna sida öppen tills uppladdningen är klar.',
    translation_order_wait_for_upload: 'Vänligen vänta tills bilagorna har laddats upp.',
    translation_order_cancelled_successfully: 'Översättningsbeställning avbeställd',
    translation_order_attachment_upload_failed: 'Det gick inte att ladda upp bilagan',
    translation_order_submit_failed: 'Det gick inte att skapa översättningsbeställningen',
    translation_order_cancel_failed: 'Det gick inte att avbeställa översättningsbeställningen',
    translation_mark_completed: 'Markera som slutförd',
    translation_mark_completed_success: 'Översättning markerad som slutförd',
    translation_mark_completed_failed: 'Det gick inte att markera översättningen som slutförd',
    translation_change_status: 'Ändra',
    translation_task_completed: 'Uppgift slutförd',
    translation_revert_completed_failed: 'Det gick inte att återställa slutförandestatusen',
    translation_order_from_language_required: 'Källspråk krävs',
    translation_order_to_language_required: 'Målspråk krävs',
    translation_order_languages_must_differ: 'Käll- och målspråk måste vara olika',
    translation_order_files_required: 'Ladda upp minst en fil',
    translation_order_scope_required: 'Beräknat omfång krävs',
    translation_order_scope_type_required: 'Omfångstyp krävs',
    translation_order_delivery_date_required: 'Önskat leveransdatum krävs',
    translation_order_delivery_date_too_far: 'Önskat leveransdatum måste vara mindre än 5 år framåt i tiden',
    translation_order_translator_type: 'Vilken typ av översättare behöver du?',
    translation_order_translator_type_required: 'Välj minst en översättartyp',
  },

  'herotolk-norway': {
    no: {
      my_bookings: 'Tolkeoppdrag',
      // Service types
      video_call: 'Skjermtolk via Hero Tolk',
      video_call_tip: 'Hero Tolks innebygde videoløsning',
      conference_call: 'Skjermtolk via annen løsning',
      phone_call: 'Telefontolk',
      phone_call_tip: 'Tolking via telefon',
      presence_notice: 'Telefonbeskjed',
      announcement: 'Telefonbeskjed',
      select_notice: 'Skriv kort melding som skal tolkes over telefon',
      // Form labels
      prebooking_details: 'Bestillingsinformasjon',
      patient_name: 'Habilitetsjekk',
      patient_name_placeholder: 'Klientens navn',
      feedback: 'Avvik',
      deviation: 'Avvik',
      billing: 'Utførte tolkeoppdrag',
      // Feedback/deviation related
      feedback_not_open_yet: 'Siden tolkingen ikke har funnet sted ennå, kan du ikke opprette et avvik på dette tidspunktet.',
      stars_rating_subtitle: 'Avviket ditt hjelper oss med å forbedre tjenesten vår.',
      leave_open_feedback: 'Beskriv avviket',
      thank_you_for_your_feedback: 'Takk for at du tok deg tid!',
      feedback_already_exist: 'Avvik er allerede opprettet',
      feedback_need_to_leave: 'Avviket er åpent',
      chatroom_not_exist: 'Du har ikke tilgang til å registrere avvik på en annen bestillers tolkeoppdrag',
      termsOfUse: 'Vilkår og personvern',
      cost_center: 'Referanse',
      female_interpreter: 'Kvinne',
      male_interpreter: 'Mann',
      interpreter_level_label: 'Nivå',
      estimated_duration: 'Varighet',
      user_home_group_header: 'Oppdragsgiver',
      email: 'Mail',
      url_for_video_meeting_label: 'URL/lenke',
      other: 'Annen',
      reports: 'Statistikk',
      customer: 'Bestiller',
      interpreter: 'Tolk',
      prebooking_page_title: 'Forhåndsbestilt tolking',
      reservation_number: 'Oppdragsnummer',
      preferences_fallback_cancel: 'Avlys bestilling',
      edit_or_create_deviation: 'Rediger eller opprett avvik',
      billing_page_main_sub_header: 'Rediger informasjon på oppdraget eller opprett avvik',
      edit_prebooking_details: 'Rediger oppdraget',
      update_prebook: 'Oppdater oppdraget',
      verify: 'Godkjenn for fakturering',
      // List column headers (TUL-5010)
      invoice_user_group: 'Enhet',
      customerInvoiceNotes: 'Referanse',
      call_type_title: 'Oppdragstype',
      interpreter_phone_number: 'Tolk telefon',
      interpreter_name: 'Tolk navn',
      interpreter_reported_duration: 'Rapportert tid',
      deviation_resolution: 'Status',
      translation_order_number: 'Oppdragsnummer',
      translation_order_date: 'Bestillingsdato',
      translation_delivery: 'Ønsket lev dato',
      translation_user_group: 'Enhet',
      translation_from: 'Fra',
      translation_to: 'Til',
      translation_username: 'Oversetter',
      translation_customer: 'Bestiller',
      // Localization fixes (TUL-5304)
      preferences_remote_backup_connection_type: 'Alternativ oppdragstype',
      preferences_remote_backup_phone: 'Telefontolk',
      preferences_remote_backup_conference: 'Skjermtolk',
      preferences_onsite_fallback: 'Hvordan ønsker du oppdraget utført dersom fremmøtetolk ikke er tilgjengelig?',
      change_reservation_description: 'Endre oppdrag',
      copy_reservation_description: 'Kopier oppdrag',
      cancel_prebook_description: 'Avlys oppdrag',
      translation_order_order_number: 'Oppdragsnummer',
      translation_order_ordering_unit: 'Oppdragsgiver',
      cost_allocation: 'Oppdragsgiver',
      url_for_video_meeting: 'Kopier inn URL/lenke til skjermoppdrag',
      content_data_tooltip: 'Telefonbeskjed er en muntlig melding som gis til tolkebruker av tolk.',
      content_data_second_tooltip: 'Tolk vil ringe det oppgitte telefonnummeret inntil 5 ganger. Oppdraget anses som fullført etter 5 forsøk, uavhengig av om tolkebruker nås eller ikke.',
      // Prebooking competence level help text (TUL-5923)
      competence_level_helper_text: 'Systemet søker automatisk etter tolken med høyest mulig kompetansenivå. La valgene stå uendret, med mindre du ønsker å ekskludere bestemte nivåer. Merk at utvalget av tilgjengelige tolker kan reduseres dersom du velger bort kompetansenivåer, og at enkelte språk ikke tilbys på alle nivåer.',
    },
    fi: {
      feedback: 'Palaute',
      billing: 'Laskutus',
      feedback_not_open_yet: 'Koska tulkkaus ei ole vielä tapahtunut, palautteen anto ei ole vielä mahdollista.',
      stars_rating_subtitle: 'Palautteesi auttaa meitä parantamaan palvelua.',
      leave_open_feedback: 'Jätä avointa palautetta',
      thank_you_for_your_feedback: 'Kiitos palautteesta!',
      feedback_already_exist: 'Palaute annettu',
      feedback_need_to_leave: 'Palaute antamatta',
      chatroom_not_exist: 'Palautteen anto ei vielä mahdollista',
      termsOfUse: 'Käyttöehdot ja tietosuoja',
    },
    en: {
      my_bookings: 'Interpretation orders',
      patient_name: 'Conflict of interest check',
      patient_name_placeholder: 'Clients name',
      feedback: 'Deviation',
      deviation: 'Deviation',
      billing: 'Past interpretations',
      feedback_not_open_yet: 'As the interpretation hasn\'t taken place yet, you are unable to create a deviation at this time.',
      stars_rating_subtitle: 'Your deviation helps us improve our service.',
      leave_open_feedback: 'Describe the deviation',
      thank_you_for_your_feedback: 'Thank you for taking the time!',
      feedback_already_exist: 'Deviation is already created',
      feedback_need_to_leave: 'You can now describe the deviation',
      chatroom_not_exist: 'Deviation not yet created',
      termsOfUse: 'Terms and privacy',
      billing_page_main_sub_header: 'Edit prebooking information for invoicing or create a deviation from an interpretation.',
      // List column headers (TUL-5010)
      call_type_title: 'Call type',
      interpreter_phone_number: 'Interpreter phone',
      interpreter_name: 'Interpreter name',
      interpreter_reported_duration: 'Reported duration',
      deviation_resolution: 'Deviation resolution',
      translation_order_number: 'Order number',
      translation_order_date: 'Order date',
      translation_delivery: 'Delivery date',
      translation_user_group: 'User group',
      translation_from: 'From',
      translation_to: 'To',
      translation_username: 'Translator',
      translation_customer: 'Customer',
    },
    da: {
      feedback: 'Afvigelser',
      billing: 'Fakturering',
      feedback_not_open_yet: 'Da tolkningen endnu ikke har fundet sted, er du ikke i stand til at oprette en afvigelse på dette tidspunkt.',
      stars_rating_subtitle: 'Din afvigelse hjælper os med at forbedre vores service.',
      leave_open_feedback: 'Beskriv afvigelsen',
      thank_you_for_your_feedback: 'Tak for at du tog dig tid!',
      feedback_already_exist: 'Afvigelse er allerede oprettet',
      feedback_need_to_leave: 'Du kan nu beskrive afvigelsen',
      chatroom_not_exist: 'Afvigelse er ikke oprettet endnu',
      termsOfUse: 'Brugsbetingelser og privatlivspolitik',
    },
    de: {
      feedback: 'Abweichungen',
      billing: 'Abrechnung',
      feedback_not_open_yet: 'Da die Dolmetschung noch nicht stattgefunden hat, können Sie zu diesem Zeitpunkt keine Abweichung erstellen.',
      stars_rating_subtitle: 'Ihre Abweichung hilft uns, unseren Service zu verbessern.',
      leave_open_feedback: 'Beschreiben Sie die Abweichung',
      thank_you_for_your_feedback: 'Vielen Dank, dass Sie sich die Zeit genommen haben!',
      feedback_already_exist: 'Abweichung wurde bereits erstellt',
      feedback_need_to_leave: 'Sie können nun die Abweichung beschreiben',
      chatroom_not_exist: 'Abweichung wurde noch nicht erstellt',
      termsOfUse: 'Nutzungsbedingungen & Datenschutzrichtlinie',
    },
    fr: {
      feedback: 'Commentaires',
      billing: 'Facturation',
      feedback_not_open_yet: 'L\'interprétation n\'ayant pas encore eu lieu, vous ne pouvez pas nous laisser de commentaire pour le moment.',
      stars_rating_subtitle: 'Vos commentaires nous aident à améliorer notre service.',
      leave_open_feedback: 'Donner un commentaire en texte libre',
      thank_you_for_your_feedback: 'Merci pour vos commentaires !',
      feedback_already_exist: 'Les commentaires sont fermés',
      feedback_need_to_leave: 'Les commentaires sont ouverts',
      chatroom_not_exist: 'Commentaires pas encore ouverts',
      termsOfUse: 'Conditions d\'utilisation et politique de confidentialité',
    },
    sv: {
      my_bookings: 'Tolkningsuppdrag',
      // Service types
      video_call: 'Skärmtolk via Hero Tolk',
      video_call_tip: 'Hero Tolks inbyggda videolösning',
      conference_call: 'Skärmtolk via annan lösning',
      phone_call: 'Telefontolk',
      phone_call_tip: 'Tolkning via telefon',
      presence_notice: 'Telefonmeddelande',
      announcement: 'Telefonmeddelande',
      select_notice: 'Skriv ett kort meddelande som ska tolkas via telefon',
      // Form labels
      prebooking_details: 'Beställningsinformation',
      patient_name: 'Jävskontroll',
      patient_name_placeholder: 'Kundens namn',
      feedback: 'Avvikelse',
      deviation: 'Avvikelse',
      billing: 'Utförda tolkningsuppdrag',
      // Feedback/deviation related
      feedback_not_open_yet: 'Eftersom tolkningen inte har ägt rum än kan du inte skapa en avvikelse just nu.',
      stars_rating_subtitle: 'Din avvikelse hjälper oss att förbättra vår service.',
      leave_open_feedback: 'Beskriv avvikelsen',
      thank_you_for_your_feedback: 'Tack för att du tog dig tid!',
      feedback_already_exist: 'Avvikelsen har redan skapats',
      feedback_need_to_leave: 'Du kan nu beskriva avvikelsen',
      chatroom_not_exist: 'Du har inte tillgång att registrera avvik på en annan beställares tolkuppdrag',
      termsOfUse: 'Villkor och integritetspolicy',
      cost_center: 'Referens',
      female_interpreter: 'Kvinna',
      male_interpreter: 'Man',
      interpreter_level_label: 'Nivå',
      estimated_duration: 'Varaktighet',
      user_home_group_header: 'Uppdragsgivare',
      email: 'Mail',
      url_for_video_meeting_label: 'URL/länk',
      other: 'Annan',
      reports: 'Statistik',
      customer: 'Beställare',
      interpreter: 'Tolk',
      prebooking_page_title: 'Förhandsbokad tolkning',
      reservation_number: 'Uppdragsnummer',
      preferences_fallback_cancel: 'Avboka beställning',
      edit_prebooking_details: 'Redigera uppdraget',
      update_prebook: 'Uppdatera uppdraget',
      edit_or_create_deviation: 'Redigera eller skapa avvikelse',
      billing_page_main_sub_header: 'Redigera information om uppdraget eller skapa avvikelser',
      verify: 'Godkänn för fakturering',
      // List column headers (TUL-5010)
      invoice_user_group: 'Enhet',
      customerInvoiceNotes: 'Referens',
      call_type_title: 'Uppdragstyp',
      interpreter_phone_number: 'Tolkens telefon',
      interpreter_name: 'Tolkens namn',
      interpreter_reported_duration: 'Rapporterad tid',
      deviation_resolution: 'Status avvik',
      translation_order_number: 'Uppdragsnummer',
      translation_order_date: 'Beställningsdatum',
      translation_delivery: 'Önskat leveransdatum',
      translation_user_group: 'Enhet',
      translation_from: 'Från',
      translation_to: 'Till',
      translation_username: 'Översättare',
      translation_customer: 'Beställare',
      // Localization fixes (TUL-5304)
      preferences_remote_backup_connection_type: 'Alternativ uppdragstyp',
      preferences_remote_backup_phone: 'Telefontolk',
      preferences_remote_backup_conference: 'Videotolk',
      preferences_onsite_fallback: 'Hur önskar du att uppdraget ska utföras om platstolk inte är tillgänglig?',
      change_reservation_description: 'Ändra uppdrag',
      copy_reservation_description: 'Kopiera uppdrag',
      cancel_prebook_description: 'Avbeställ uppdrag',
      translation_order_order_number: 'Uppdragsnummer',
      translation_order_ordering_unit: 'Uppdragsgivare',
      translation_order_ordered_by: 'Beställare',
      cost_allocation: 'Uppdragsgivare',
      url_for_video_meeting: 'Lägg in URL/länk till videotolkning',
      content_data_tooltip: 'Telefonmeddelande är ett muntligt meddelande som lämnas till tolkanvändaren av tolken.',
      content_data_second_tooltip: 'Tolken kommer att ringa det angivna telefonnumret upp till 5 gånger. Uppdraget anses som slutfört efter 5 försök, oavsett om tolkanvändaren nås eller inte.',
    }
  },
  'herotolk-sweden': {
    sv: {
      my_bookings: 'Tolkningsuppdrag',
      // Service types
      video_call: 'Skärmtolk via Hero Tolk',
      video_call_tip: 'Hero Tolks inbyggda videolösning',
      conference_call: 'Skärmtolk via annan lösning',
      phone_call: 'Telefontolk',
      phone_call_tip: 'Tolkning via telefon',
      presence_notice: 'Telefonmeddelande',
      announcement: 'Telefonmeddelande',
      select_notice: 'Skriv ett kort meddelande som ska tolkas via telefon',
      // Form labels
      prebooking_details: 'Beställningsinformation',
      patient_name: 'Jävskontroll',
      patient_name_placeholder: 'Kundens namn',
      feedback: 'Avvikelse',
      deviation: 'Avvikelse',
      billing: 'Utförda tolkningsuppdrag',
      // Feedback/deviation related
      feedback_not_open_yet: 'Eftersom tolkningen inte har ägt rum än kan du inte skapa en avvikelse just nu.',
      stars_rating_subtitle: 'Din avvikelse hjälper oss att förbättra vår service.',
      leave_open_feedback: 'Beskriv avvikelsen',
      thank_you_for_your_feedback: 'Tack för att du tog dig tid!',
      feedback_already_exist: 'Avvikelsen har redan skapats',
      feedback_need_to_leave: 'Du kan nu beskriva avvikelsen',
      chatroom_not_exist: 'Du har inte tillgång att registrera avvik på en annan beställares tolkuppdrag',
      termsOfUse: 'Villkor och integritetspolicy',
      cost_center: 'Referens',
      female_interpreter: 'Kvinna',
      male_interpreter: 'Man',
      interpreter_level_label: 'Nivå',
      estimated_duration: 'Varaktighet',
      user_home_group_header: 'Uppdragsgivare',
      email: 'Mail',
      url_for_video_meeting_label: 'URL/länk',
      other: 'Annan',
      reports: 'Statistik',
      customer: 'Beställare',
      interpreter: 'Tolk',
      prebooking_page_title: 'Förhandsbokad tolkning',
      reservation_number: 'Uppdragsnummer',
      preferences_fallback_cancel: 'Avboka beställning',
      edit_or_create_deviation: 'Redigera eller skapa avvikelse',
      billing_page_main_sub_header: 'Redigera information om uppdraget eller skapa avvikelser',
      // List column headers (TUL-5010)
      invoice_user_group: 'Enhet',
      customerInvoiceNotes: 'Referens',
      call_type_title: 'Uppdragstyp',
      interpreter_phone_number: 'Tolkens telefon',
      interpreter_name: 'Tolkens namn',
      interpreter_reported_duration: 'Rapporterad tid',
      deviation_resolution: 'Status avvik',
      translation_order_number: 'Uppdragsnummer',
      translation_order_date: 'Beställningsdatum',
      translation_delivery: 'Önskat leveransdatum',
      translation_user_group: 'Enhet',
      translation_from: 'Från',
      translation_to: 'Till',
      translation_username: 'Översättare',
      translation_customer: 'Beställare',
      // Localization fixes (TUL-5304)
      preferences_remote_backup_connection_type: 'Alternativ uppdragstyp',
      preferences_remote_backup_phone: 'Telefontolk',
      preferences_remote_backup_conference: 'Videotolk',
      preferences_onsite_fallback: 'Hur önskar du att uppdraget ska utföras om platstolk inte är tillgänglig?',
      change_reservation_description: 'Ändra uppdrag',
      copy_reservation_description: 'Kopiera uppdrag',
      cancel_prebook_description: 'Avbeställ uppdrag',
      translation_order_order_number: 'Uppdragsnummer',
      translation_order_ordering_unit: 'Uppdragsgivare',
      translation_order_ordered_by: 'Beställare',
      cost_allocation: 'Uppdragsgivare',
      url_for_video_meeting: 'Lägg in URL/länk till videotolkning',
      content_data_tooltip: 'Telefonmeddelande är ett muntligt meddelande som lämnas till tolkanvändaren av tolken.',
      content_data_second_tooltip: 'Tolken kommer att ringa det angivna telefonnumret upp till 5 gånger. Uppdraget anses som slutfört efter 5 försök, oavsett om tolkanvändaren nås eller inte.',
    },
    fi: {
      feedback: 'Palaute',
      billing: 'Laskutus',
      feedback_not_open_yet: 'Koska tulkkaus ei ole vielä tapahtunut, palautteen anto ei ole vielä mahdollista.',
      stars_rating_subtitle: 'Palautteesi auttaa meitä parantamaan palvelua.',
      leave_open_feedback: 'Jätä avointa palautetta',
      thank_you_for_your_feedback: 'Kiitos palautteesta!',
      feedback_already_exist: 'Palaute annettu',
      feedback_need_to_leave: 'Palaute antamatta',
      chatroom_not_exist: 'Palautteen anto ei vielä mahdollista',
      termsOfUse: 'Käyttöehdot ja tietosuoja',
    },
    en: {
      my_bookings: 'Interpretation orders',
      patient_name: 'Conflict of interest check',
      patient_name_placeholder: 'Clients name',
      feedback: 'Deviation',
      deviation: 'Deviation',
      billing: 'Past interpretations',
      feedback_not_open_yet: 'As the interpretation hasn\'t taken place yet, you are unable to create a deviation at this time.',
      stars_rating_subtitle: 'Your deviation helps us improve our service.',
      leave_open_feedback: 'Describe the deviation',
      thank_you_for_your_feedback: 'Thank you for taking the time!',
      feedback_already_exist: 'Deviation is already created',
      feedback_need_to_leave: 'You can now describe the deviation',
      chatroom_not_exist: 'Deviation not yet created',
      termsOfUse: 'Terms and privacy',
      billing_page_main_sub_header: 'Edit prebooking information for invoicing or create a deviation from an interpretation.',
      // List column headers (TUL-5010)
      call_type_title: 'Call type',
      interpreter_phone_number: 'Interpreter phone',
      interpreter_name: 'Interpreter name',
      interpreter_reported_duration: 'Reported duration',
      deviation_resolution: 'Deviation resolution',
      translation_order_number: 'Order number',
      translation_order_date: 'Order date',
      translation_delivery: 'Delivery date',
      translation_user_group: 'User group',
      translation_from: 'From',
      translation_to: 'To',
      translation_username: 'Translator',
      translation_customer: 'Customer',
    },
    da: {
      feedback: 'Afvigelser',
      billing: 'Fakturering',
      feedback_not_open_yet: 'Da tolkningen endnu ikke har fundet sted, er du ikke i stand til at oprette en afvigelse på dette tidspunkt.',
      stars_rating_subtitle: 'Din afvigelse hjælper os med at forbedre vores service.',
      leave_open_feedback: 'Beskriv afvigelsen',
      thank_you_for_your_feedback: 'Tak for at du tog dig tid!',
      feedback_already_exist: 'Afvigelse er allerede oprettet',
      feedback_need_to_leave: 'Du kan nu beskrive afvigelsen',
      chatroom_not_exist: 'Afvigelse er ikke oprettet endnu',
      termsOfUse: 'Brugsbetingelser og privatlivspolitik',
    },
    no: {
      my_bookings: 'Tolkeoppdrag',
      // Service types
      video_call: 'Skjermtolk via Hero Tolk',
      video_call_tip: 'Hero Tolks innebygde videoløsning',
      conference_call: 'Skjermtolk via annen løsning',
      phone_call: 'Telefontolk',
      phone_call_tip: 'Tolking via telefon',
      presence_notice: 'Telefonbeskjed',
      announcement: 'Telefonbeskjed',
      select_notice: 'Skriv kort melding som skal tolkes over telefon',
      // Form labels
      prebooking_details: 'Bestillingsinformasjon',
      patient_name: 'Habilitetsjekk',
      patient_name_placeholder: 'Klientens navn',
      feedback: 'Avvik',
      deviation: 'Avvik',
      billing: 'Utførte tolkeoppdrag',
      // Feedback/deviation related
      feedback_not_open_yet: 'Siden tolkingen ikke har funnet sted ennå, kan du ikke opprette et avvik på dette tidspunktet.',
      stars_rating_subtitle: 'Avviket ditt hjelper oss med å forbedre tjenesten vår.',
      leave_open_feedback: 'Beskriv avviket',
      thank_you_for_your_feedback: 'Takk for at du tok deg tid!',
      feedback_already_exist: 'Avvik er allerede opprettet',
      feedback_need_to_leave: 'Avviket er åpent',
      chatroom_not_exist: 'Du har ikke tilgang til å registrere avvik på en annen bestillers tolkeoppdrag',
      termsOfUse: 'Vilkår og personvern',
      cost_center: 'Referanse',
      female_interpreter: 'Kvinne',
      male_interpreter: 'Mann',
      interpreter_level_label: 'Nivå',
      estimated_duration: 'Varighet',
      user_home_group_header: 'Oppdragsgiver',
      email: 'Mail',
      url_for_video_meeting_label: 'URL/lenke',
      other: 'Annen',
      reports: 'Statistikk',
      customer: 'Bestiller',
      interpreter: 'Tolk',
      prebooking_page_title: 'Forhåndsbestilt tolking',
      reservation_number: 'Oppdragsnummer',
      preferences_fallback_cancel: 'Avlys bestilling',
      billing_page_main_sub_header: 'Rediger informasjon på oppdraget eller opprett avvik',
      // List column headers (TUL-5010)
      invoice_user_group: 'Enhet',
      customerInvoiceNotes: 'Referanse',
      call_type_title: 'Oppdragstype',
      interpreter_phone_number: 'Tolk telefon',
      interpreter_name: 'Tolk navn',
      interpreter_reported_duration: 'Rapportert tid',
      deviation_resolution: 'Status',
      translation_order_number: 'Oppdragsnummer',
      translation_order_date: 'Bestillingsdato',
      translation_delivery: 'Ønsket lev dato',
      translation_user_group: 'Enhet',
      translation_from: 'Fra',
      translation_to: 'Til',
      translation_username: 'Oversetter',
      translation_customer: 'Bestiller',
      // Localization fixes (TUL-5304)
      preferences_remote_backup_connection_type: 'Alternativ oppdragstype',
      preferences_remote_backup_phone: 'Telefontolk',
      preferences_remote_backup_conference: 'Skjermtolk',
      preferences_onsite_fallback: 'Hvordan ønsker du oppdraget utført dersom fremmøtetolk ikke er tilgjengelig?',
      change_reservation_description: 'Endre oppdrag',
      copy_reservation_description: 'Kopier oppdrag',
      cancel_prebook_description: 'Avlys oppdrag',
      translation_order_order_number: 'Oppdragsnummer',
      translation_order_ordering_unit: 'Oppdragsgiver',
      cost_allocation: 'Oppdragsgiver',
      url_for_video_meeting: 'Kopier inn URL/lenke til skjermoppdrag',
      content_data_tooltip: 'Telefonbeskjed er en muntlig melding som gis til tolkebruker av tolk.',
      content_data_second_tooltip: 'Tolk vil ringe det oppgitte telefonnummeret inntil 5 ganger. Oppdraget anses som fullført etter 5 forsøk, uavhengig av om tolkebruker nås eller ikke.',
    },
    de: {
      feedback: 'Abweichungen',
      billing: 'Abrechnung',
      feedback_not_open_yet: 'Da die Dolmetschung noch nicht stattgefunden hat, können Sie zu diesem Zeitpunkt keine Abweichung erstellen.',
      stars_rating_subtitle: 'Ihre Abweichung hilft uns, unseren Service zu verbessern.',
      leave_open_feedback: 'Beschreiben Sie die Abweichung',
      thank_you_for_your_feedback: 'Vielen Dank, dass Sie sich die Zeit genommen haben!',
      feedback_already_exist: 'Abweichung wurde bereits erstellt',
      feedback_need_to_leave: 'Sie können nun die Abweichung beschreiben',
      chatroom_not_exist: 'Abweichung wurde noch nicht erstellt',
      termsOfUse: 'Nutzungsbedingungen & Datenschutzrichtlinie',
    },
    fr: {
      feedback: 'Commentaires',
      billing: 'Facturation',
      feedback_not_open_yet: 'L\'interprétation n\'ayant pas encore eu lieu, vous ne pouvez pas nous laisser de commentaire pour le moment.',
      stars_rating_subtitle: 'Vos commentaires nous aident à améliorer notre service.',
      leave_open_feedback: 'Donner un commentaire en texte libre',
      thank_you_for_your_feedback: 'Merci pour vos commentaires !',
      feedback_already_exist: 'Les commentaires sont fermés',
      feedback_need_to_leave: 'Les commentaires sont ouverts',
      chatroom_not_exist: 'Commentaires pas encore ouverts',
      termsOfUse: 'Conditions d\'utilisation et politique de confidentialité',
    }
  }
};

// Norwegian browsers report the written standard, nb-NO (Bokmål) or nn-NO (Nynorsk), rather than
// the macrolanguage 'no' this app names it by. Without these, a Norwegian device fell through to
// defaultLang and both the UI and the locale sent to the backend became English (TUL-5684).
const browserLanguageAliases = {
  'nb': 'no',
  'nn': 'no',
};

const getLanguageFromBrowser = () => {
  let langCode = (
    ('languages' in navigator ? navigator.languages[0] : null) ||
    navigator.language
  ).substring(0, 2);
  return browserLanguageAliases[langCode] || langCode;
};

export const tulkaLanguages = process.env.TULKA_LANGUAGES ? process.env.TULKA_LANGUAGES.split(',') : ['en', 'fi', 'sv', 'da', 'no', 'de', 'fr'];
export const tulkaCountries = process.env.TULKA_COUNTRIES ? process.env.TULKA_COUNTRIES.split(',') : ['EN', 'FI', 'SE', 'DK', 'NO', 'DE', 'FR'];

export const defaultLang = 'en';
export const defaultCountry = 'FI';

export const localeMap = {
  'en': 'eng',
  'fi': 'fin',
  'sv': 'swe',
  'da': 'dan',
  'no': 'nor',
  'de': 'deu',
  'fr': 'fra',
};

export const getLang = () => {
  let currentLang = localStorage.getItem('lang');
  if (selectableLanguages.includes(currentLang)) {
    return currentLang;
  }
  currentLang = getLanguageFromBrowser();
  if (selectableLanguages.includes(currentLang)) {
    return currentLang;
  }
  localStorage.setItem('lang', defaultLang);
  return defaultLang;
};

export const getCountry = () => {
  let currentCountry = localStorage.getItem('country');
  if (tulkaCountries.includes(currentCountry)) {
    return currentCountry;
  }
  // if we really needed "true" country code we probably have to get it based on IP or some other service
  currentCountry = getLanguageFromBrowser().toUpperCase();
  if (tulkaCountries.includes(currentCountry)) {
    return currentCountry;
  }
  localStorage.setItem('country', defaultCountry);
  return defaultCountry;
};

const getSelectableLanguages = () => {
  return tulkaLanguages;
};

// Set when the language comes from the user rather than from their device: a pick in the language
// menu or settings, a language in the link they followed, or the one stored on their account. The
// login page keeps a language marked this way instead of resetting to the device's (TUL-5684).
const CHOSEN_LANGUAGE_KEY = 'langChosenByUser';

export const setLanguage = (lang, chosenByUser = false) => {
  document.documentElement.lang = lang;
  if (lang && tulkaLanguages.some(l => l === lang)) {
    localStorage.setItem('lang', lang);
    // The marker always describes the language stored beside it, so an automatic update must clear
    // a marker an earlier choice left behind -- otherwise the device's language reports as chosen.
    if (chosenByUser) {
      localStorage.setItem(CHOSEN_LANGUAGE_KEY, 'true');
    } else {
      localStorage.removeItem(CHOSEN_LANGUAGE_KEY);
    }
    return;
  }
  localStorage.removeItem('lang');
  localStorage.removeItem(CHOSEN_LANGUAGE_KEY);
};

// Logout and the fatal-error handler wipe localStorage but keep the language the customer reads.
// The marker has to travel with it: with the language alone, the login page would see no choice and
// replace the language that was deliberately preserved with the device's.
export const clearStorageKeepingLanguage = () => {
  const preserved = ['lang', CHOSEN_LANGUAGE_KEY].map(key => [key, localStorage.getItem(key)]);

  localStorage.clear();

  preserved.forEach(([key, value]) => {
    if (value) {
      localStorage.setItem(key, value);
    }
  });
};

// Where the language this app reports to the backend comes from. 'user' means the customer picked
// it (or it is the one stored on their account), 'device' means it was read off their browser. The
// backend needs the difference for the messages it writes before there is a session: a build that
// does not send this at all is an old one, whose login page overwrote a chosen language with the
// device's, so the language it reports says nothing about the customer.
export const getLanguageSource = () => {
  const storedLang = localStorage.getItem('lang');
  return localStorage.getItem(CHOSEN_LANGUAGE_KEY) && tulkaLanguages.includes(storedLang) ? 'user' : 'device';
};

export const setCountry = (country) => {
  if (country && tulkaCountries.some(c => c === country)) {
    localStorage.setItem('country', country);
    return;
  }
  localStorage.removeItem('country');
};

export const selectableLanguages = getSelectableLanguages();

export const langCode = getLang();

export const getIsRightToLeft = () => {
  const upToDateLangCode = getLang();
  return upToDateLangCode === 'ar' || upToDateLangCode === 'ku';
};

// The login page used to reset the language to the device's on every visit. That threw away a
// language the user had picked, and it is also the language the backend is told to write in: a
// Hero Tolk customer on a Finnish device asked for credentials from a Norwegian UI and was sent
// Finnish ones (TUL-5684). A language the user chose is kept; otherwise the device still decides.
export const setLangOnLoginPage = () => {
  const chosenLang = localStorage.getItem('lang');
  if (localStorage.getItem(CHOSEN_LANGUAGE_KEY) && tulkaLanguages.includes(chosenLang)) {
    setLanguage(chosenLang, true);
    return;
  }

  const browserLang = getLanguageFromBrowser();
  if (tulkaLanguages.includes(browserLang)) {
    setLanguage(browserLang);
    return;
  }
  setLanguage(defaultLang);
};

const localize = (key, fallback) => {
  const upToDateLangCode = getLang();
  const currentLangCode = upToDateLangCode === 'ua' ? 'uk' : upToDateLangCode;

  // Check business type specific  first
  const businessType = getBusinessTypeTag();
  if (businessType && translations[businessType] && translations[businessType][currentLangCode]) {
    const btTranslation = translations[businessType][currentLangCode][key];
    if (btTranslation) {
      return btTranslation;
    }
  }

  // Fallback to default translations
  const upToDateLocalizations = translations[currentLangCode];
  return upToDateLocalizations[key] || fallback || `${key}`;
};

export default localize;
